"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4242],{

/***/ 31084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ FORM_VALIDATIONS; }
/* harmony export */ });
var FORM_VALIDATIONS = {
  email: {
    pattern: {
      value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
      message: '올바른 이메일 형식을 입력해주세요.'
    },
    required: '이메일을 입력해주세요.'
  },
  hyperLink: {
    pattern: {
      value: /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\\+.~#?&\\/=]*)$/,
      message: '올바른 URL 형식이 아닙니다. http:// 또는 https:// 로 시작하는 링크를 입력하세요.'
    },
    required: '링크를 입력해주세요.'
  }
};

/***/ }),

/***/ 14242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VR": function() { return /* reexport */ Viewer_Desktop; },
  "XQ": function() { return /* reexport */ PageWrapper_Desktop; },
  "lq": function() { return /* reexport */ DefaultViewerLayer_Desktop; },
  "BC": function() { return /* reexport */ EmbedLayer_EmbedVideo; },
  "Wn": function() { return /* reexport */ _common_PdfPageImage; },
  "It": function() { return /* reexport */ _common_PdfThumbImage; },
  "oh": function() { return /* reexport */ v2_V2BulkPreview; },
  "WA": function() { return /* reexport */ v2_V2OneToOnePreview; },
  "xI": function() { return /* reexport */ normalizeEmbedOptions; },
  "$4": function() { return /* reexport */ parseVideoUrl; },
  "nO": function() { return /* reexport */ index_atom/* zoomLevelAtom */.nO; }
});

// UNUSED EXPORTS: BulkDesktopPdfPreview, BulkMobilePdfPreview, BulkRedirectViewer, DesktopPdfPreview, EmbedLayer, Enter, Loading, MessageBoxLayer, MobilePdfPreview, Redirect, ViewerRouteProvider, getEmbedIframeSrc, getViewerHistoryStorageKey, useViewerRoute

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
// EXTERNAL MODULE: ../../node_modules/jotai/esm/react.mjs
var react = __webpack_require__(752);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var node_modules_react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(12524);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/react-hooks/index.ts + 10 modules
var react_hooks = __webpack_require__(90114);
// EXTERNAL MODULE: ../../packages/next-pdf-viewer/src/store/index.atom.ts
var index_atom = __webpack_require__(86437);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/useUpdateViewerPageState.ts




var useUpdateViewerPageState_useUpdateViewerPageState = function useUpdateViewerPageState() {
  var _useAtom = (0,react/* useAtom */.KO)(index_atom/* currentPageAtom */.ef),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      currentPage = _useAtom2[0],
      setCurrentPage = _useAtom2[1];

  var _useAtom3 = (0,react/* useAtom */.KO)(index_atom/* prevPageAtom */.Nv),
      _useAtom4 = (0,slicedToArray/* default */.Z)(_useAtom3, 2),
      prevPage = _useAtom4[0],
      setPrevPage = _useAtom4[1];

  var initPageState = function initPageState() {
    setCurrentPage(1);
    setPrevPage(1);
  };

  var updateCurrentPage = function updateCurrentPage(page) {
    /*이전 페이지를 prev page에 업데이트 해준 이후에 새로운 페이지로 이동시킨다 */
    setCurrentPage(function (prev) {
      setPrevPage(prev);
      return page;
    });
  };

  return {
    initPageState: initPageState,
    updateCurrentPage: updateCurrentPage,
    currentPage: currentPage,
    prevPage: prevPage
  };
};

/* harmony default export */ var hooks_useUpdateViewerPageState = (useUpdateViewerPageState_useUpdateViewerPageState);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/constant/googleEventId.ts
var googleEventId_GOOGLE_EVENT_ID = {
  form: 'form_submit_button',
  cta: 'cta_button',
  download: 'download_button',
  share: 'share_button',
  hyperLink: 'pdf_hyperlink',
  messageBoxDot: 'message_box',
  messageBoxButton: 'message_button'
};
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/utils/queryString.ts
/**
 * Next.js의 useRouter() 훅의 query 객체 내의 키에 대한 값으로 플러스 부호가 빈 여백으로 변환되는 문제를 해결하기 위한 함수
 */
var parseQueryString = function parseQueryString(str) {
  if (!str) {
    return '';
  }

  return str.replace(/\s+/g, '+');
};
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/sheard/constants/index.ts + 2 modules
var constants = __webpack_require__(89608);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/utils/shareLink.ts
// TODO: 패키지끼리 공유하는 유틸 함수를 공통 패키지로 빼는 작업이 필요합니다.

var getFileShareLink = function getFileShareLink(_ref) {
  var hashId = _ref.hashId,
      historyId = _ref.historyId,
      isBulk = _ref.isBulk,
      domain = _ref.domain;
  var hostname = window.location.hostname; // CASE 1. localhost 환경에서 개발할 때

  if (hostname.includes(constants/* DOMAIN.VIEWER.local */.y.a.local)) {
    var _shareLink = isBulk ? "http://localhost:3002/share/bulk/file/".concat(hashId, "?sh=").concat(historyId) : "http://localhost:3002/share/file/".concat(hashId, "?sh=").concat(historyId);

    return _shareLink;
  } //CASE 2. dev.sclu.io인 경우 (=dev)


  if (hostname.includes(constants/* DOMAIN.VIEWER.dev */.y.a.dev)) {
    var _shareLink2 = isBulk ? "https://".concat(constants/* DOMAIN.VIEWER.dev */.y.a.dev, "/share/bulk/file/").concat(hashId, "?sh=").concat(historyId) : "https://".concat(constants/* DOMAIN.VIEWER.dev */.y.a.dev, "/share/file/").concat(hashId, "?sh=").concat(historyId);

    return _shareLink2;
  } // CASE 3. alpha.sclu.io인 경우 (= release test )


  if (hostname.includes(constants/* DOMAIN.VIEWER.release */.y.a.release)) {
    var _shareLink3 = isBulk ? "https://".concat(constants/* DOMAIN.VIEWER.release */.y.a.release, "/share/bulk/file/").concat(hashId, "?sh=").concat(historyId) : "https://".concat(constants/* DOMAIN.VIEWER.release */.y.a.release, "/share/file/").concat(hashId, "?sh=").concat(historyId);

    return _shareLink3;
  } // CASE 4. sclu.io 인 경우 (=prod)


  if (hostname.includes(constants/* DOMAIN.VIEWER.main */.y.a.main)) {
    var _shareLink4 = isBulk ? "https://".concat(constants/* DOMAIN.VIEWER.main */.y.a.main, "/share/bulk/file/").concat(hashId, "?sh=").concat(historyId) : "https://".concat(constants/* DOMAIN.VIEWER.main */.y.a.main, "/share/file/").concat(hashId, "?sh=").concat(historyId);

    return _shareLink4;
  } // CASE 5. 유저가 등록한 커스텀 도메인이 있는 경우


  if (domain && domain !== null) {
    var _shareLink5 = isBulk ? "https://".concat(domain, "/share/bulk/file/").concat(hashId, "?sh=").concat(historyId) : "https://".concat(domain, "/share/file/").concat(hashId, "?sh=").concat(historyId);

    return _shareLink5;
  }

  var shareLink = isBulk ? "https://".concat(hostname, "/share/bulk/file/").concat(hashId, "?sh=").concat(historyId) : "https://".concat(hostname, "/share/file/").concat(hashId, "?sh=").concat(historyId);
  return shareLink;
};
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/contexts/ViewerRoute/index.tsx




var ViewerRouteContext = /*#__PURE__*/(0,node_modules_react.createContext)(null);

/**
 * 뷰어가 라우트에서 추론하던 값(hashId, historyId, bulk 여부 등)을 밖에서 주입한다.
 *
 * 단축 링크 `/s/{token}` 은 주소창을 그대로 둔 채 뷰어를 렌더하므로 router에서
 * 이 값들을 읽을 수 없다. Provider가 없으면 아래 useViewerRoute가 기존 표현식
 * 그대로 폴백하므로 `/share/...` 경로와 client 앱의 미리보기 화면은 영향이 없다.
 */
var ViewerRouteProvider = function ViewerRouteProvider(_ref) {
  var value = _ref.value,
      children = _ref.children;
  return _jsx(ViewerRouteContext.Provider, {
    value: value,
    children: children
  });
};
var ViewerRoute_useViewerRoute = function useViewerRoute() {
  var _override$hashId, _override$historyId, _override$isBulk, _override$isShareRout;

  var router = (0,next_router.useRouter)();
  var override = (0,node_modules_react.useContext)(ViewerRouteContext);
  var hashId = (_override$hashId = override === null || override === void 0 ? void 0 : override.hashId) !== null && _override$hashId !== void 0 ? _override$hashId : router.query.hashId;
  var historyId = (_override$historyId = override === null || override === void 0 ? void 0 : override.historyId) !== null && _override$historyId !== void 0 ? _override$historyId : router.query.historyId;
  var isBulk = (_override$isBulk = override === null || override === void 0 ? void 0 : override.isBulk) !== null && _override$isBulk !== void 0 ? _override$isBulk : router.pathname.includes('bulk');
  var isShareRoute = (_override$isShareRout = override === null || override === void 0 ? void 0 : override.isShareRoute) !== null && _override$isShareRout !== void 0 ? _override$isShareRout : router.pathname.startsWith('/share');
  return (0,node_modules_react.useMemo)(function () {
    var _override$getShareUrl, _override$resumeViewe;

    return {
      hashId: hashId,
      historyId: historyId,
      isBulk: isBulk,
      isShareRoute: isShareRoute,
      shortToken: override === null || override === void 0 ? void 0 : override.shortToken,
      getShareUrl: (_override$getShareUrl = override === null || override === void 0 ? void 0 : override.getShareUrl) !== null && _override$getShareUrl !== void 0 ? _override$getShareUrl : function (_ref2) {
        var domain = _ref2.domain,
            isBulkTarget = _ref2.isBulk;
        return getFileShareLink({
          hashId: hashId,
          isBulk: isBulkTarget,
          domain: domain,
          historyId: encodeURIComponent(historyId)
        });
      },
      resumeViewer: (_override$resumeViewe = override === null || override === void 0 ? void 0 : override.resumeViewer) !== null && _override$resumeViewe !== void 0 ? _override$resumeViewe : function (resumedHistoryId) {
        router.push({
          pathname: "/share/bulk/file/redirect",
          query: {
            hashId: hashId,
            historyId: resumedHistoryId
          }
        });
      }
    };
  }, [hashId, historyId, isBulk, isShareRoute, override, router]);
};
/* harmony default export */ var ViewerRoute = ((/* unused pure expression or super */ null && (ViewerRouteContext)));
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var lib_useMutation = __webpack_require__(62350);
// EXTERNAL MODULE: ../../node_modules/axios/index.js
var node_modules_axios = __webpack_require__(89644);
var axios_default = /*#__PURE__*/__webpack_require__.n(node_modules_axios);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/utils/api.ts
var _globalThis$window;


var API = {
  REVERSE_PROXY_API: 'http://localhost:3002/api',
  PRODUCTION_API: 'https://api.salesclue.io',
  DEVELOPMENT_API: 'https://api-dev.salesclue.io'
};
var SCLU_HOST = {
  MAIN: 'sclu.io',
  DEV: 'dev.sclu.io'
};

var reverseProxy = function reverseProxy(host) {
  return "".concat(getHttpOrHttps(host)).concat(host, "/api");
};

var getBaseUrl = function getBaseUrl(host) {
  if ( true && host === SCLU_HOST.MAIN) {
    return API.PRODUCTION_API;
  }

  if ( true && host === SCLU_HOST.DEV) {
    return API.DEVELOPMENT_API;
  }

  return reverseProxy(host);
};

var getHttpOrHttps = function getHttpOrHttps(host) {
  return host !== null && host !== void 0 && host.includes('localhost') ? 'http://' : 'https://';
};

var api_api = axios_default().create({
  baseURL: getBaseUrl(globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$window = globalThis.window) === null || _globalThis$window === void 0 ? void 0 : _globalThis$window.location.host),
  withCredentials: true
});
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/mutation/messageBox/useMessageBoxClick.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var messageBoxClick = function messageBoxClick(_ref) {
  var messageBoxId = _ref.messageBoxId,
      historyId = _ref.historyId,
      isBulk = _ref.isBulk;

  if (isBulk) {
    return api_api.post('/v2/viewer/submit/messageBox', {
      historyId: historyId,
      messageBoxId: messageBoxId
    });
  }

  return api_api.post('/file/action/messagebox', {
    messageBoxId: messageBoxId,
    historyId: historyId,
    isBulk: isBulk
  });
};

var useMessageBoxClick = function useMessageBoxClick(options) {
  return (0,lib_useMutation/* useMutation */.D)(messageBoxClick, _objectSpread({}, options));
};

/* harmony default export */ var messageBox_useMessageBoxClick = (useMessageBoxClick);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/useHandleMessageBoxClick.ts




var useHandleMessageBoxClick = function useHandleMessageBoxClick() {
  var _useViewerRoute = ViewerRoute_useViewerRoute(),
      historyId = _useViewerRoute.historyId,
      isBulk = _useViewerRoute.isBulk;

  var _useMessageBoxClick = messageBox_useMessageBoxClick(),
      mutateMessageBoxClick = _useMessageBoxClick.mutate;

  var handleUserMessageBoxClick = function handleUserMessageBoxClick(messageBoxId) {
    mutateMessageBoxClick({
      messageBoxId: messageBoxId,
      historyId: parseQueryString(historyId),
      isBulk: isBulk
    });
  };

  return {
    handleUserMessageBoxClick: handleUserMessageBoxClick
  };
};

/* harmony default export */ var hooks_useHandleMessageBoxClick = (useHandleMessageBoxClick);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/useClickOutside.ts
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



var useClickOutside = function useClickOutside(refs, handler) {
  node_modules_react.useEffect(function () {
    var listener = function listener(event) {
      if (!refs) {
        return;
      }

      var containedToAnyRefs = false;

      var _iterator = _createForOfIteratorHelper(refs),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var ref = _step.value;

          if (ref && ref.current && ref.current.contains(event.target)) {
            containedToAnyRefs = true;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (!containedToAnyRefs) {
        handler(event);
      }
    };

    window.addEventListener('mousedown', listener);
    return function () {
      window.removeEventListener('mousedown', listener);
    };
  }, [refs, handler]);
};

/* harmony default export */ var hooks_useClickOutside = (useClickOutside);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/MessageBoxLayer/index.styles.ts



var _templateObject, _templateObject2;

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var plusRising = (0,emotion_react_browser_esm/* keyframes */.F4)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  0% {\n    outline-width: 0;\n    transform: scale(0.5, 0.5);\n    opacity: 0;\n  }\n\n  40% {\n    transform: scale(1, 1);\n    outline-width: 6px;\n    opacity: 1;\n  }\n \n  100% {\n    transform: scale(1.5,1.5);\n    outline-width: 0;\n    opacity: 0;\n  }\n"])));
var plusDot = (0,emotion_react_browser_esm/* keyframes */.F4)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  0% {\n    transform: scale(1);\n    outline-width: 6px;\n    opacity: 0;\n  }\n\n  40% {\n    transform: scale(0.8);\n    outline-width: 2px;\n    opacity: 1;\n  }\n \n  100% {\n    transform: scale(1);\n    outline-width: 6px;\n    opacity: 1;\n  }\n\n"])));
/* 좁은 페이지에서 dot이 콘텐츠를 덮지 않도록 모바일에서는 축소한다 */

var DOT_SCALE = {
  "default": 1,
  sm: 0.75
};
var Dot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ezwrcvc1"
} : 0)("position:absolute;z-index:", constants/* VIEWER_Z_INDEX.dotButton */.G.dotButton, ";width:", function (_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size;
  return 21 * DOT_SCALE[size];
}, "px;height:", function (_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'default' : _ref2$size;
  return 21 * DOT_SCALE[size];
}, "px;background-color:transparent;&::before{position:relative;display:block;width:200%;height:200%;box-sizing:border-box;margin-top:-33%;margin-left:-33%;animation:", plusRising, " 1.5s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;animation-delay:0s;border-radius:50%;content:'';outline:1px solid ", function (_ref3) {
  var color = _ref3.color;
  return color;
}, ";}&::after{position:absolute;top:0;left:0;display:block;width:", function (_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 'default' : _ref4$size;
  return 28 * DOT_SCALE[size];
}, "px;height:", function (_ref5) {
  var _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? 'default' : _ref5$size;
  return 28 * DOT_SCALE[size];
}, "px;animation:", plusDot, " 1.5s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;animation-delay:0s;border-radius:50%;content:'';outline:", function (_ref6) {
  var _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? 'default' : _ref6$size;
  return 6 * DOT_SCALE[size];
}, "px solid ", function (_ref7) {
  var color = _ref7.color;
  return color;
}, ";}" + ( true ? "" : 0));
var DotContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ezwrcvc0"
} : 0)( true ? {
  name: "q600il",
  styles: "position:absolute;cursor:pointer;&.disabledLayer{position:static;}"
} : 0);
// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../packages/styles/index.ts + 3 modules
var styles = __webpack_require__(97223);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/MessageBoxLayer/MessageBox/index.styles.ts


function index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e1l81yic2"
} : 0)("position:absolute;z-index:", constants/* VIEWER_Z_INDEX.messageBox */.G.messageBox, ";width:fit-content;border-radius:8px;box-shadow:", styles/* theme.elevation.xs */.rS.elevation.xs, ";" + ( true ? "" : 0));
/**
 * 바깥은 가운데, 안쪽 블록은 왼쪽 정렬이다.
 * 한 줄이면 안쪽 블록이 글자 폭만큼만 차지해 가운데로 오고(버튼 이름이 더 길어
 * 박스가 넓어진 경우에도 균형이 잡힌다), 줄이 넘어가거나 엔터로 나눈 문구는
 * 블록이 폭을 채우면서 각 줄이 왼쪽에 남아 가독성이 유지된다.
 */

var MessageText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1l81yic1"
} : 0)( true ? {
  name: "rid4zx",
  styles: "display:inline-block;max-width:100%;text-align:left;white-space:pre-wrap;word-break:break-word"
} : 0);
var MessageBoxButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "e1l81yic0"
} : 0)( true ? {
  name: "6isekk",
  styles: "&:hover{opacity:0.5;}"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/MessageBoxLayer/MessageBox/index.tsx






// pdf viewer와 message box 설정창에서 공통으로 사용될 message box
var MessageBox = /*#__PURE__*/(0,node_modules_react.forwardRef)(function (_ref, ref) {
  var text = _ref.text,
      boxColor = _ref.boxColor,
      textColor = _ref.textColor,
      buttonText = _ref.buttonText,
      top = _ref.top,
      left = _ref.left,
      handleButtonClick = _ref.handleButtonClick,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size,
      maxWidth = _ref.maxWidth,
      _ref$isHidden = _ref.isHidden,
      isHidden = _ref$isHidden === void 0 ? false : _ref$isHidden;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
    ref: ref,
    gap: size === 'default' ? 16 : 12,
    direction: "column",
    padding: size === 'default' ? 32 : 20,
    style: {
      backgroundColor: "".concat(boxColor),
      top: "".concat(top),
      left: "".concat(left),
      maxWidth: "".concat(maxWidth !== null && maxWidth !== void 0 ? maxWidth : size === 'default' ? 360 : 280, "px"),
      visibility: isHidden ? 'hidden' : undefined
    }
    /* 박스 여백 탭이 뷰어 셸의 컨트롤 토글로 전파되지 않게 한다 */
    ,
    onClick: function onClick(e) {
      e.stopPropagation();
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: size === 'default' ? 'lg-medium' : 'md-medium',
      textAlign: "center",
      style: {
        color: "".concat(textColor)
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MessageText, {
        children: text
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MessageBoxButton, {
      id: googleEventId_GOOGLE_EVENT_ID.messageBoxButton,
      style: {
        backgroundColor: "".concat(textColor)
      },
      width: "100%",
      paddingX: 16,
      paddingY: 12,
      radius: 9999,
      onClick: handleButtonClick,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        id: googleEventId_GOOGLE_EVENT_ID.messageBoxButton,
        variant: "md-medium",
        textAlign: "center",
        style: {
          color: "".concat(boxColor)
        },
        children: buttonText
      })
    })]
  });
});
MessageBox.displayName = 'MessageBox';
/* harmony default export */ var MessageBoxLayer_MessageBox = (MessageBox);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/MessageBoxLayer/utils/index.ts
/**
 * 아래 값들은 박스가 DOM에 올라가기 전 "첫 프레임 추정치"일 뿐이다.
 * 실제 배치는 MessageBoxLayer에서 렌더된 박스를 실측해 화면 경계로 클램프한다.
 */
var MESSAGE_BOX_MAX_WIDTH = {
  "default": 360,
  sm: 280
};
/**
 * 가용 폭이 좁아도 이 아래로는 줄이지 않는다.
 * 폭에 맞춰 무한정 좁히면 박스가 좁고 길쭉해져 오히려 읽기 어려워진다.
 */

var MESSAGE_BOX_MIN_WIDTH = 200;

/* sm 변형은 padding(32→20)과 폰트(16→14)가 줄어든 만큼 작게 잡는다 */
var SIZE_RATIO = {
  "default": 1,
  sm: 0.78
};
var getBoxWidth = function getBoxWidth(nowMessageBoxTextLength) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  var ratio = SIZE_RATIO[size];

  if (nowMessageBoxTextLength > 21) {
    return MESSAGE_BOX_MAX_WIDTH[size];
  } else if (nowMessageBoxTextLength >= 15) {
    return (120 + nowMessageBoxTextLength * 10) * ratio;
  } else if (nowMessageBoxTextLength >= 10) {
    return (120 + nowMessageBoxTextLength * 8) * ratio;
  } else if (nowMessageBoxTextLength >= 5) {
    return (60 + 60 + nowMessageBoxTextLength * 4) * ratio;
  } else {
    return (60 + 50) * ratio;
  }
};
var getDivideLineIncludeBoxWidth = function getDivideLineIncludeBoxWidth(text) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  var lines = text.split('\n');
  var longestLine = lines.reduce(function (a, b) {
    return a.length > b.length ? a : b;
  });
  return getBoxWidth(longestLine.length, size);
};
var getBoxHeight = function getBoxHeight(nowMessageBoxTextLength) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  var MIN_TEXT_LENGTH = 21;
  var TEXT_LENGTH_STANDARD = 20;
  var BASIC_BOX_HEIGHT = 160;
  var ratio = SIZE_RATIO[size];

  if (nowMessageBoxTextLength > 0 && nowMessageBoxTextLength <= 21) {
    return BASIC_BOX_HEIGHT * ratio;
  } else if (nowMessageBoxTextLength > 210) {
    return 360 * ratio;
  } else {
    return (Math.floor(nowMessageBoxTextLength / MIN_TEXT_LENGTH) * TEXT_LENGTH_STANDARD + BASIC_BOX_HEIGHT) * ratio;
  }
};
var getDivideLineIncludeBoxHeight = function getDivideLineIncludeBoxHeight(text) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  var lines = text.split('\n');
  var longestLine = lines.reduce(function (a, b) {
    return a.length > b.length ? a : b;
  });
  var ratio = SIZE_RATIO[size];

  if (longestLine.length > 21) {
    return getBoxHeight(longestLine.length, size) + (lines.length - 1) * 20 * ratio;
  } else {
    return (160 + lines.length * 20) * ratio;
  }
};
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/MessageBoxLayer/index.tsx













/* 박스가 화면 가장자리에 닿지 않도록 남기는 여백 */



var EDGE_MARGIN = 8;

var clamp = function clamp(value, min, max) {
  return Math.min(Math.max(value, min), Math.max(min, max));
};
/**
 * 열린 박스를 배치하는 데 필요한 실측값.
 * 박스 크기와, 페이지 박스가 화면 어디에 있는지(origin), 그리고 화면 크기를 함께 잡는다.
 */


var isSameLayout = function isSameLayout(a, b) {
  return a.boxWidth === b.boxWidth && a.boxHeight === b.boxHeight && a.originX === b.originX && a.originY === b.originY && a.viewportWidth === b.viewportWidth && a.viewportHeight === b.viewportHeight;
};

var MessageBoxLayer_MessageBoxLayer = function MessageBoxLayer(_ref) {
  var _ref$isPreview = _ref.isPreview,
      isPreview = _ref$isPreview === void 0 ? false : _ref$isPreview,
      messageBoxItems = _ref.messageBoxItems,
      resizedImageSize = _ref.resizedImageSize,
      getFormNotSubmitPage = _ref.getFormNotSubmitPage,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size,
      page = _ref.page;

  var _useAtom = (0,react/* useAtom */.KO)(index_atom/* currentMessageBoxIdAtom */.Qd),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      currentMessageBoxId = _useAtom2[0],
      setCurrentMessageBoxId = _useAtom2[1];

  var _useUpdateViewerPageS = hooks_useUpdateViewerPageState(),
      updateCurrentPage = _useUpdateViewerPageS.updateCurrentPage,
      currentPage = _useUpdateViewerPageS.currentPage;

  var messageBoxRef = (0,node_modules_react.useRef)(null);
  var dotContainerRef = (0,node_modules_react.useRef)(null);
  var oldMessageBoxId = (0,node_modules_react.useRef)(null);

  var _useState = (0,node_modules_react.useState)(null),
      layout = _useState[0],
      setLayout = _useState[1];

  var _useHandleMessageBoxC = hooks_useHandleMessageBoxClick(),
      handleUserMessageBoxClick = _useHandleMessageBoxC.handleUserMessageBoxClick;

  hooks_useClickOutside([messageBoxRef], function () {
    oldMessageBoxId.current = currentMessageBoxId;
    setCurrentMessageBoxId(null);
  });
  /* message box는 조회시 전체페이지 값이 오기 때문에 현재 페이지의 메세지박스를 filter해주어야 한다 */

  var currentMessageBoxItems = (0,node_modules_react.useMemo)(function () {
    if (messageBoxItems) {
      var _messageBoxItems$find;

      return messageBoxItems === null || messageBoxItems === void 0 ? void 0 : (_messageBoxItems$find = messageBoxItems.find(function (item) {
        return item.page == (page !== null && page !== void 0 ? page : currentPage);
      })) === null || _messageBoxItems$find === void 0 ? void 0 : _messageBoxItems$find.messageBox;
    }
  }, [messageBoxItems, currentPage, page]);
  /**
   * 박스는 페이지에 얹힌 팝오버라 "화면"에만 들어오면 된다.
   * 슬라이드 폭에 맞춰 좁히면 슬라이드가 작을 때(모바일 축소·가로모드) 박스가
   * 좁고 길쭉해져 오히려 읽기 어려워지므로, 화면 폭을 기준으로 잡고 최소 폭을 보장한다.
   */

  var boxMaxWidth = layout ? Math.max(MESSAGE_BOX_MIN_WIDTH, Math.min(MESSAGE_BOX_MAX_WIDTH[size], layout.viewportWidth - EDGE_MARGIN * 2)) : MESSAGE_BOX_MAX_WIDTH[size];
  var openedMessageBox = currentMessageBoxItems === null || currentMessageBoxItems === void 0 ? void 0 : currentMessageBoxItems.find(function (item) {
    return item.id === currentMessageBoxId;
  });
  /**
   * 열린 박스가 바뀌거나 페이지/화면 크기가 바뀌면 실제 렌더 크기를 다시 잰다.
   * layout effect라 페인트 전에 반영되어 위치가 튀지 않는다.
   */

  (0,react_hooks/* useIsomorphicLayoutEffect */.LI)(function () {
    var boxElement = messageBoxRef.current;
    var containerElement = dotContainerRef.current;

    if (!boxElement || !containerElement) {
      setLayout(null);
      return;
    }

    var containerRect = containerElement.getBoundingClientRect();
    var next = {
      boxWidth: boxElement.offsetWidth,
      boxHeight: boxElement.offsetHeight,
      originX: containerRect.left,
      originY: containerRect.top,
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight
    };
    setLayout(function (prev) {
      return prev && isSameLayout(prev, next) ? prev : next;
    });
  }, [currentMessageBoxId, openedMessageBox === null || openedMessageBox === void 0 ? void 0 : openedMessageBox.message, resizedImageSize.width, resizedImageSize.height, boxMaxWidth, size]);

  var getMessageBoxWidth = function getMessageBoxWidth(text) {
    if (text.includes('\n')) {
      return getDivideLineIncludeBoxWidth(text, size);
    }

    return getBoxWidth(text.length, size);
  };

  var getMessageBoxHeight = function getMessageBoxHeight(text) {
    if (text.includes('\n')) {
      return getDivideLineIncludeBoxHeight(text, size);
    }

    return getBoxHeight(text.length, size);
  };

  var getMessageBoxPosition = function getMessageBoxPosition(_ref2) {
    var _layout$boxWidth, _layout$boxHeight;

    var x = _ref2.x,
        y = _ref2.y,
        text = _ref2.text;
    var xLine = resizedImageSize.width / 2;
    var yLine = resizedImageSize.height / 2;
    var dotLeft = x * resizedImageSize.width;
    var dotTop = y * resizedImageSize.height;
    /* 실측값이 있으면 그것을, 첫 프레임에는 추정치를 쓴다 */

    var boxWidth = Math.min((_layout$boxWidth = layout === null || layout === void 0 ? void 0 : layout.boxWidth) !== null && _layout$boxWidth !== void 0 ? _layout$boxWidth : getMessageBoxWidth(text), boxMaxWidth);
    var boxHeight = (_layout$boxHeight = layout === null || layout === void 0 ? void 0 : layout.boxHeight) !== null && _layout$boxHeight !== void 0 ? _layout$boxHeight : getMessageBoxHeight(text);
    /* 어느 방향으로 펼칠지는 dot이 속한 사분면으로 정한다 */

    var isRightHalf = dotLeft > xLine;
    var isBottomHalf = dotTop >= yLine;
    var rawLeft = isRightHalf ? dotLeft - boxWidth : dotLeft + 10;
    var rawTop = isBottomHalf ? dotTop - boxHeight : dotTop + 40;

    if (!layout) {
      return {
        left: rawLeft,
        top: rawTop
      };
    }
    /**
     * 페이지 기준 좌표를 화면 경계로 클램프한다.
     * 슬라이드가 화면보다 작으면 박스가 슬라이드 밖으로 나가더라도 화면 안에는 남고,
     * 슬라이드가 화면보다 크면(확대) 보이는 영역 안으로 들어온다.
     */


    return {
      left: clamp(rawLeft, EDGE_MARGIN - layout.originX, layout.viewportWidth - EDGE_MARGIN - boxWidth - layout.originX),
      top: clamp(rawTop, EDGE_MARGIN - layout.originY, layout.viewportHeight - EDGE_MARGIN - boxHeight - layout.originY)
    };
  };
  /*현재 활성화되는 message box로 상태를 업데이트 해준다 */


  var handleDotClick = function handleDotClick(messageBoxId) {
    if (messageBoxId === currentMessageBoxId) {
      setCurrentMessageBoxId(null);
    } else {
      /* 새 박스를 열 때는 이전 실측값을 버려 잘못된 위치로 잡히지 않게 한다 */
      setLayout(null);
      setCurrentMessageBoxId(messageBoxId);
    }
  };

  var handleMessageBoxButtonClick = function handleMessageBoxButtonClick(messageBoxItem) {
    /*메세지 박스 버튼을 클릭했을 경우에는 활성화된 메세지박스가 해제된다(메세지 박스가 닫힌다) */
    setCurrentMessageBoxId(null);
    /*CASE1 특정 페이지로 이동하는 메세지박스일 경우 */

    if (messageBoxItem.type === 'page') {
      if (!isPreview && messageBoxItem.id && handleUserMessageBoxClick) {
        handleUserMessageBoxClick(messageBoxItem.id);
      }
      /*1:1인 경우에는 해당 분기를 진행하지 않는다 */


      if (getFormNotSubmitPage) {
        var notSubmitPage = getFormNotSubmitPage(Number(messageBoxItem.reference));

        if (notSubmitPage !== null) {
          updateCurrentPage(notSubmitPage);
          return;
        }
      }

      updateCurrentPage(Number(messageBoxItem.reference));
    } else if (messageBoxItem.type === 'link') {
      window.open(messageBoxItem.reference, '_blank', 'noreferrer noopener');

      if (!isPreview && messageBoxItem.id) {
        handleUserMessageBoxClick(messageBoxItem.id);
      }
    }
  };

  if (!currentMessageBoxItems || (currentMessageBoxItems === null || currentMessageBoxItems === void 0 ? void 0 : currentMessageBoxItems.length) < 1) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DotContainer, {
    ref: dotContainerRef,
    className: classnames_default()({// NOTE: 확대되면 스크롤이 되어야하므로, 레이어 제한
      // disabledLayer: zoomLevel > 1,
    }),
    style: {
      top: "".concat(resizedImageSize.yMargin, "px"),
      left: "".concat(resizedImageSize.xMargin, "px"),
      right: "".concat(resizedImageSize.xMargin, "px"),
      bottom: "".concat(resizedImageSize.yMargin, "px")
    },
    children: currentMessageBoxItems.map(function (item) {
      var boxPosition = getMessageBoxPosition({
        x: item.rect_x,
        y: item.rect_y,
        text: item.message
      });
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dot, {
          id: googleEventId_GOOGLE_EVENT_ID.messageBoxDot,
          color: item.color,
          size: size,
          style: {
            position: 'absolute',
            left: "".concat(item.rect_x * resizedImageSize.width, "px"),
            top: "".concat(item.rect_y * resizedImageSize.height, "px"),
            transform: 'translate(-50%, -50%)'
          },
          onClick: function onClick(e) {
            e.stopPropagation();
            e.preventDefault();

            if (oldMessageBoxId.current === item.id) {
              return;
            }

            handleDotClick(item.id);
          }
        }), currentMessageBoxId === item.id && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MessageBoxLayer_MessageBox, {
          ref: messageBoxRef,
          top: "".concat(boxPosition.top, "px"),
          left: "".concat(boxPosition.left, "px"),
          text: item.message,
          textColor: item.textColor,
          boxColor: item.color,
          buttonText: item.buttonName,
          maxWidth: boxMaxWidth,
          isHidden: layout === null,
          handleButtonClick: function handleButtonClick(e) {
            e.preventDefault();
            e.stopPropagation();
            handleMessageBoxButtonClick(item);
          },
          size: size
        })]
      }, item.id);
    })
  });
};

/* harmony default export */ var Layer_MessageBoxLayer = (MessageBoxLayer_MessageBoxLayer);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/EmbedLayer/index.styles.ts



var index_styles_templateObject;




var index_styles_Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gy5quq5"
} : 0)("position:absolute;z-index:", constants/* VIEWER_Z_INDEX.embed */.G.embed, ";pointer-events:none;" + ( true ? "" : 0));
var EmbedWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gy5quq4"
} : 0)("position:absolute;pointer-events:auto;overflow:hidden;border-radius:4px;background-color:", styles/* theme.colors.zinc_900 */.rS.colors.zinc_900, ";iframe{display:block;width:100%;height:100%;border:0;}" + ( true ? "" : 0));
var Facade = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e1gy5quq3"
} : 0)("position:relative;display:block;width:100%;height:100%;padding:0;border:0;background-color:", styles/* theme.colors.zinc_900 */.rS.colors.zinc_900, ";cursor:pointer;img{width:100%;height:100%;object-fit:cover;user-select:none;-webkit-user-drag:none;}&.is-covered{cursor:default;filter:blur(8px);pointer-events:none;}" + ( true ? "" : 0));
/* iframe 로딩 동안 검은 화면 대신 썸네일을 유지하다가 로드 완료 시 서서히 사라진다 */

var LoadingCover = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gy5quq2"
} : 0)("position:absolute;display:flex;align-items:center;justify-content:center;background-color:", styles/* theme.colors.zinc_900 */.rS.colors.zinc_900, ";inset:0;opacity:1;pointer-events:none;transition:opacity 0.3s ease-in-out;img{width:100%;height:100%;object-fit:cover;user-select:none;-webkit-user-drag:none;}&.is-hidden{opacity:0;}" + ( true ? "" : 0));
var spin = (0,emotion_react_browser_esm/* keyframes */.F4)(index_styles_templateObject || (index_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"])));
/* 로딩 커버 중앙의 스피너 — 영상이 로딩 중임을 인지시킨다 */

var LoadingSpinner = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gy5quq1"
} : 0)("position:absolute;top:50%;left:50%;display:flex;width:48px;height:48px;align-items:center;justify-content:center;border-radius:50%;margin:-24px 0 0 -24px;background-color:rgb(0 0 0 / 60%);color:", styles/* theme.colors.white */.rS.colors.white, ";svg{animation:", spin, " 1s linear infinite;}" + ( true ? "" : 0));
var PlayButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gy5quq0"
} : 0)("position:absolute;top:50%;left:50%;display:flex;width:48px;height:48px;align-items:center;justify-content:center;border-radius:50%;background-color:rgb(0 0 0 / 60%);color:", styles/* theme.colors.white */.rS.colors.white, ";transform:translate(-50%, -50%);transition:0.15s ease-in-out;", Facade, ":hover &{background-color:rgb(0 0 0 / 80%);}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/utils/embed.ts
// NOTE: autoplay는 음소거 상태에서만 브라우저가 허용하므로 mute를 강제한다
var normalizeEmbedOptions = function normalizeEmbedOptions(options) {
  var _options$autoplay, _options$mute, _options$loop, _options$controls;

  var autoplay = (_options$autoplay = options === null || options === void 0 ? void 0 : options.autoplay) !== null && _options$autoplay !== void 0 ? _options$autoplay : false;
  return {
    autoplay: autoplay,
    mute: autoplay ? true : (_options$mute = options === null || options === void 0 ? void 0 : options.mute) !== null && _options$mute !== void 0 ? _options$mute : false,
    loop: (_options$loop = options === null || options === void 0 ? void 0 : options.loop) !== null && _options$loop !== void 0 ? _options$loop : false,
    controls: (_options$controls = options === null || options === void 0 ? void 0 : options.controls) !== null && _options$controls !== void 0 ? _options$controls : true
  };
};
var getEmbedIframeSrc = function getEmbedIframeSrc(_ref) {
  var provider = _ref.provider,
      videoId = _ref.videoId,
      options = _ref.options;
  var params = new URLSearchParams();

  if (provider === 'youtube') {
    /* postMessage로 재생 상태를 수신하기 위해 필요하다 (로딩 커버 해제 타이밍) */
    params.set('enablejsapi', '1');

    if (options.autoplay) {
      params.set('autoplay', '1');
    }

    if (options.mute) {
      params.set('mute', '1');
    }

    if (options.loop) {
      // NOTE: youtube loop는 playlist 파라미터가 함께 있어야 동작한다
      params.set('loop', '1');
      params.set('playlist', videoId);
    }

    if (!options.controls) {
      params.set('controls', '0');
    }

    return "https://www.youtube.com/embed/".concat(videoId, "?").concat(params.toString());
  }

  if (options.autoplay) {
    params.set('autoplay', '1');
  }

  if (options.mute) {
    params.set('muted', '1');
  }

  if (options.loop) {
    params.set('loop', '1');
  }

  if (!options.controls) {
    params.set('controls', '0');
  }

  var query = params.toString();
  return "https://player.vimeo.com/video/".concat(videoId).concat(query ? "?".concat(query) : '');
};
var YOUTUBE_URL_REGEX = /^(?:https?:\/\/)?(?:www\.|m\.)?(?:youtube\.com\/(?:watch\?(?:.*&)?v=|shorts\/|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{11})(?:[?&#].*)?$/;
var VIMEO_URL_REGEX = /^(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com\/|player\.vimeo\.com\/video\/)(\d+)(?:[?&#].*)?$/;
var parseVideoUrl = function parseVideoUrl(url) {
  var trimmedUrl = url.trim();
  var youtubeMatch = trimmedUrl.match(YOUTUBE_URL_REGEX);

  if (youtubeMatch) {
    return {
      provider: 'youtube',
      videoId: youtubeMatch[1]
    };
  }

  var vimeoMatch = trimmedUrl.match(VIMEO_URL_REGEX);

  if (vimeoMatch) {
    return {
      provider: 'vimeo',
      videoId: vimeoMatch[1]
    };
  }

  return null;
};
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/EmbedLayer/EmbedVideo/index.tsx


function EmbedVideo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function EmbedVideo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EmbedVideo_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EmbedVideo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










/* 재생 이벤트가 오지 않는 경우(자동재생 차단 등)에 대비한 커버 해제 폴백 시간 */
var REVEAL_FALLBACK_MS = 3000;

var EmbedVideo = function EmbedVideo(_ref) {
  var _embed$title2;

  var embed = _ref.embed,
      _ref$isCovered = _ref.isCovered,
      isCovered = _ref$isCovered === void 0 ? false : _ref$isCovered;
  var options = normalizeEmbedOptions(embed.options);

  var _useState = (0,node_modules_react.useState)(options.autoplay && !isCovered),
      isActivated = _useState[0],
      setIsActivated = _useState[1];

  var _useState2 = (0,node_modules_react.useState)(false),
      isActivatedByClick = _useState2[0],
      setIsActivatedByClick = _useState2[1];

  var _useState3 = (0,node_modules_react.useState)(false),
      isPlayerReady = _useState3[0],
      setIsPlayerReady = _useState3[1];

  var iframeRef = (0,node_modules_react.useRef)(null);
  var fallbackTimerRef = (0,node_modules_react.useRef)(null);
  /* 가림막이 해제되면 그때 자동재생을 시작한다 */

  (0,node_modules_react.useEffect)(function () {
    if (!isCovered && options.autoplay && !isActivated) {
      setIsActivated(true);
    }
  }, [isCovered, options.autoplay, isActivated]);
  /**
   * 플레이어 로딩 화면까지 썸네일로 가리기 위해, iframe 로드 시점이 아닌
   * 실제 재생 시작(postMessage 이벤트) 시점에 커버를 걷어낸다.
   * - YouTube: enablejsapi=1 + listening 등록 → infoDelivery의 playerState 1(재생)
   * - Vimeo: addEventListener 등록 → play 이벤트
   */

  (0,node_modules_react.useEffect)(function () {
    if (!isActivated || isPlayerReady) {
      return;
    }

    var handleMessage = function handleMessage(e) {
      var _iframeRef$current, _data, _data$info, _data2;

      if (e.source !== ((_iframeRef$current = iframeRef.current) === null || _iframeRef$current === void 0 ? void 0 : _iframeRef$current.contentWindow)) {
        return;
      }

      var data = e.data;

      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (_unused) {
          return;
        }
      }

      if (((_data = data) === null || _data === void 0 ? void 0 : (_data$info = _data.info) === null || _data$info === void 0 ? void 0 : _data$info.playerState) === 1 || ((_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.event) === 'play') {
        setIsPlayerReady(true);
      }
    };

    window.addEventListener('message', handleMessage);
    return function () {
      window.removeEventListener('message', handleMessage);

      if (fallbackTimerRef.current !== null) {
        window.clearTimeout(fallbackTimerRef.current);
      }
    };
  }, [isActivated, isPlayerReady]);

  var handleIframeLoad = function handleIframeLoad() {
    var _iframeRef$current2;

    var contentWindow = (_iframeRef$current2 = iframeRef.current) === null || _iframeRef$current2 === void 0 ? void 0 : _iframeRef$current2.contentWindow;

    if (contentWindow) {
      if (embed.provider === 'youtube') {
        contentWindow.postMessage(JSON.stringify({
          event: 'listening',
          id: embed.id,
          channel: 'widget'
        }), '*');
      } else {
        contentWindow.postMessage(JSON.stringify({
          method: 'addEventListener',
          value: 'play'
        }), '*');
      }
    }

    fallbackTimerRef.current = window.setTimeout(function () {
      setIsPlayerReady(true);
    }, REVEAL_FALLBACK_MS);
  };

  var handlePlayButtonClick = function handlePlayButtonClick(e) {
    e.stopPropagation();
    e.preventDefault();
    setIsActivatedByClick(true);
    setIsActivated(true);
  };

  if (isCovered || !isActivated) {
    var _embed$title;

    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Facade, {
      type: "button",
      "aria-label": (_embed$title = embed.title) !== null && _embed$title !== void 0 ? _embed$title : '동영상 재생',
      className: classnames_default()({
        'is-covered': isCovered
      }),
      onClick: handlePlayButtonClick,
      disabled: isCovered,
      children: [embed.thumbnailUrl && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
        src: embed.thumbnailUrl,
        alt: "",
        draggable: false
      }), !isCovered && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayButton, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:play-fill",
          size: 24
        })
      })]
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
      ref: iframeRef,
      src: getEmbedIframeSrc({
        provider: embed.provider,
        videoId: embed.videoId,
        // NOTE: 클릭으로 활성화된 경우 바로 재생을 시작한다 (사용자 제스처라 mute 강제 불필요)
        options: isActivatedByClick ? EmbedVideo_objectSpread(EmbedVideo_objectSpread({}, options), {}, {
          autoplay: true
        }) : options
      }),
      title: (_embed$title2 = embed.title) !== null && _embed$title2 !== void 0 ? _embed$title2 : 'video player',
      allow: "autoplay; fullscreen; encrypted-media; picture-in-picture",
      allowFullScreen: true,
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      onLoad: handleIframeLoad
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LoadingCover, {
      className: classnames_default()({
        'is-hidden': isPlayerReady
      }),
      children: [embed.thumbnailUrl && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
        src: embed.thumbnailUrl,
        alt: "",
        draggable: false
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingSpinner, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:circle-notch",
          size: 24
        })
      })]
    })]
  });
};

/* harmony default export */ var EmbedLayer_EmbedVideo = (EmbedVideo);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/EmbedLayer/index.tsx






var EmbedLayer = function EmbedLayer(_ref) {
  var embedItems = _ref.embedItems,
      resizedImageSize = _ref.resizedImageSize,
      page = _ref.page,
      _ref$isCovered = _ref.isCovered,
      isCovered = _ref$isCovered === void 0 ? false : _ref$isCovered;

  var _useUpdateViewerPageS = hooks_useUpdateViewerPageState(),
      currentPage = _useUpdateViewerPageS.currentPage;
  /* embed는 조회시 전체페이지 값이 오기 때문에 현재 페이지의 임베드를 filter해주어야 한다 */


  var currentEmbedItems = (0,node_modules_react.useMemo)(function () {
    var _embedItems$find;

    return embedItems === null || embedItems === void 0 ? void 0 : (_embedItems$find = embedItems.find(function (item) {
      return item.page == (page !== null && page !== void 0 ? page : currentPage);
    })) === null || _embedItems$find === void 0 ? void 0 : _embedItems$find.embed;
  }, [embedItems, currentPage, page]);

  if (!currentEmbedItems || currentEmbedItems.length < 1) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_styles_Container, {
    style: {
      top: "".concat(resizedImageSize.yMargin, "px"),
      left: "".concat(resizedImageSize.xMargin, "px"),
      right: "".concat(resizedImageSize.xMargin, "px"),
      bottom: "".concat(resizedImageSize.yMargin, "px")
    },
    children: currentEmbedItems.map(function (item) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbedWrapper, {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        style: {
          left: "".concat(item.rect_x * resizedImageSize.width, "px"),
          top: "".concat(item.rect_y * resizedImageSize.height, "px"),
          width: "".concat(item.rect_w * resizedImageSize.width, "px"),
          height: "".concat(item.rect_h * resizedImageSize.height, "px")
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbedLayer_EmbedVideo, {
          embed: item,
          isCovered: isCovered
        })
      }, item.id);
    })
  });
};

/* harmony default export */ var Layer_EmbedLayer = (EmbedLayer);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/PdfViewer/localStorageKey.ts
var localStorageKey = {
  isPdfViewerFirstVisit: 'isPdfViewerFirstVisit',
  emailFormSubmitHistoryId: 'efshi',
  pdfViewerVersion: 'pdfViewerVersion'
};
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/useGetFirstVisit.ts




var useGetFirstVisit = function useGetFirstVisit() {
  var _useLocalStorage = (0,react_hooks/* useLocalStorage */._)(localStorageKey.isPdfViewerFirstVisit),
      _useLocalStorage2 = (0,slicedToArray/* default */.Z)(_useLocalStorage, 2),
      isPdfViewerFirstVisit = _useLocalStorage2[0],
      setIsPdfViewerFirstVisit = _useLocalStorage2[1];

  (0,react_hooks/* useIsomorphicLayoutEffect */.LI)(function () {
    // 로컬 스토리지에 값이 없으면 첫 방문으로 간주
    if (isPdfViewerFirstVisit === undefined) {
      setIsPdfViewerFirstVisit(true);
    }
  }, [isPdfViewerFirstVisit]);
  return [isPdfViewerFirstVisit, setIsPdfViewerFirstVisit];
};

/* harmony default export */ var hooks_useGetFirstVisit = (useGetFirstVisit);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Intro/Desktop/index.styles.ts


function Desktop_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var FlexWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e1idd5yi1"
} : 0)("position:absolute;z-index:", constants/* VIEWER_Z_INDEX.previewLayer */.G.previewLayer, ";width:100vw;height:100vh;background:rgb(79 88 96 / 50%);" + ( true ? "" : 0));
var index_styles_Text = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Text */.xv,  true ? {
  target: "e1idd5yi0"
} : 0)( true ? {
  name: "82a6rk",
  styles: "flex:1"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Intro/Desktop/index.tsx








var Desktop_DesktopIntro = function DesktopIntro(_ref) {
  var translateKoToEn = _ref.translateKoToEn;

  var _useGetFirstVisit = hooks_useGetFirstVisit(),
      _useGetFirstVisit2 = (0,slicedToArray/* default */.Z)(_useGetFirstVisit, 2),
      isUserFirstVisit = _useGetFirstVisit2[0],
      setIsUserFirstVisit = _useGetFirstVisit2[1];

  var isPressPageMoveKeys = (0,react_hooks/* useKeyPress */.Kr)('ArrowLeft, ArrowUp, ArrowRight, ArrowDown, PageUp, PageDown');
  (0,node_modules_react.useEffect)(function () {
    if (isPressPageMoveKeys) {
      setIsUserFirstVisit(false);
    }
  }, [isPressPageMoveKeys]);

  if (!isUserFirstVisit) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlexWrapper, {
    alignItems: "center",
    justifyContent: "center",
    onClick: function onClick() {
      setIsUserFirstVisit(false);
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Desktop_Text, {
      children: [translateKoToEn('initMessage-first'), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), translateKoToEn('initMessage-second')]
    })
  });
};

/* harmony default export */ var Desktop = (Desktop_DesktopIntro);

var Desktop_Text = function Text(_ref2) {
  var children = _ref2.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_styles_Text, {
    variant: "2xl-semibold",
    color: "white",
    textAlign: "center",
    children: children
  });
};
// EXTERNAL MODULE: ../../node_modules/@react-hook/resize-observer/dist/module/index.js + 26 modules
var dist_module = __webpack_require__(38127);
// EXTERNAL MODULE: ../../node_modules/lodash.throttle/index.js
var lodash_throttle = __webpack_require__(98357);
var lodash_throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/useWheel.ts




var useWheel = function useWheel(_ref) {
  var totalPage = _ref.totalPage,
      updateNextThumbnails = _ref.updateNextThumbnails,
      updatePrevThumbnails = _ref.updatePrevThumbnails;

  var _useUpdateViewerPageS = hooks_useUpdateViewerPageState(),
      currentPage = _useUpdateViewerPageS.currentPage,
      updateCurrentPage = _useUpdateViewerPageS.updateCurrentPage;

  var _useState = (0,node_modules_react.useState)(null),
      value = _useState[0],
      setValue = _useState[1];

  var handleWheel = lodash_throttle_default()(function (e) {
    if (value) {
      return;
    }

    var deltaY = e.deltaY,
        deltaX = e.deltaX;

    if (Math.abs(deltaY) <= 10 && Math.abs(deltaX) <= 10) {
      return;
    }

    var isPrev = deltaY < 0 || deltaX < 0;
    var isNext = deltaY > 0 || deltaX > 0;

    if (isPrev) {
      setValue('prev');
    }

    if (isNext) {
      setValue('next');
    }
  }, 500);
  (0,node_modules_react.useEffect)(function () {
    if (!value) {
      return;
    }

    var timeout = setTimeout(function () {
      if (value) {
        setValue(null);
      }
    }, 500);
    return function () {
      clearTimeout(timeout);
    };
  }, [value]);
  (0,node_modules_react.useEffect)(function () {
    if (!value) {
      return;
    }

    if (value === 'next') {
      if (currentPage === totalPage) {
        return;
      }

      updateCurrentPage(currentPage + 1);
      updateNextThumbnails === null || updateNextThumbnails === void 0 ? void 0 : updateNextThumbnails(currentPage + 1);
    } else if (value === 'prev') {
      if (currentPage === 1) {
        return;
      }

      updatePrevThumbnails === null || updatePrevThumbnails === void 0 ? void 0 : updatePrevThumbnails(currentPage - 1);
      updateCurrentPage(currentPage - 1);
    }
  }, [value]);
  return handleWheel;
};

/* harmony default export */ var hooks_useWheel = (useWheel);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageWrapper/Desktop/index.styles.ts


var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1oio7130"
} : 0)("position:relative;z-index:", constants/* VIEWER_Z_INDEX.root */.G.root, ";width:100%;height:100vh;overflow-x:hidden;overflow-y:hidden;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageWrapper/Desktop/index.tsx








var Desktop_DesktopPageWrapper = function DesktopPageWrapper(_ref) {
  var totalPage = _ref.totalPage,
      isWheelDisabled = _ref.isWheelDisabled,
      updateNextThumbnails = _ref.updateNextThumbnails,
      updatePrevThumbnails = _ref.updatePrevThumbnails,
      children = _ref.children;
  var setPageWrapperSize = (0,react/* useSetAtom */.b9)(index_atom/* pageWrapperSizeAtom */.p5);
  /* pdf 이미지가 렌더링될 영역을 계산 */

  var wrapperRef = (0,node_modules_react.useRef)(null);
  (0,dist_module/* default */.Z)(wrapperRef, function (_ref2) {
    var _ref2$contentRect = _ref2.contentRect,
        width = _ref2$contentRect.width,
        height = _ref2$contentRect.height;
    return setPageWrapperSize({
      width: width,
      height: height
    });
  });
  /* 데스크탑 뷰어에서 스크롤시 페이지를 이동할 수 있도록 한다  */

  var handleWheel = hooks_useWheel({
    totalPage: totalPage,
    updateNextThumbnails: updateNextThumbnails,
    updatePrevThumbnails: updatePrevThumbnails
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    ref: wrapperRef,
    onWheel: function onWheel(e) {
      if (isWheelDisabled) {
        return;
      }

      handleWheel(e);
    },
    onContextMenu: function onContextMenu(e) {
      return e.preventDefault();
    },
    onDragStart: function onDragStart(e) {
      return e.preventDefault();
    },
    children: children
  });
};

/* harmony default export */ var PageWrapper_Desktop = (Desktop_DesktopPageWrapper);
// EXTERNAL MODULE: ../../node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js
var bodyScrollLock_esm = __webpack_require__(83096);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/RootLayout/index.styles.ts




var FlexMain = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "etbs2110"
} : 0)("z-index:", constants/* VIEWER_Z_INDEX.root */.G.root, ";overflow:hidden;width:100vw;height:var(--doc-height);background-color:", styles/* theme.colors.zinc_50 */.rS.colors.zinc_50, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/RootLayout/index.tsx








var Root = function Root(_ref) {
  var isActiveHelpers = _ref.isActiveHelpers,
      mode = _ref.mode,
      children = _ref.children;
  var setPdfViewerMode = useSetAtom(pdfViewerModeAtom);
  var setIsDisableHelpers = useSetAtom(isDisableHelpersAtom);
  useIsomorphicLayoutEffect(function () {
    setPdfViewerMode(mode);
    var _document = document,
        body = _document.body;
    disableBodyScroll(body, {
      allowTouchMove: function allowTouchMove() {
        return true;
      }
    });
    return function () {
      enableBodyScroll(body);
    };
  }, [mode, setPdfViewerMode]);
  /*doc-height로 브라우저의 높이 값을 등록해서 
  FlexMain 스타일 컴포넌트에서 height를 doc-height로 주고 있음*/

  useIsomorphicLayoutEffect(function () {
    var documentHeight = function documentHeight() {
      var doc = document.documentElement;
      doc.style.setProperty('--doc-height', "".concat(window.innerHeight, "px"));
    };

    if (mode === 'mobile') {
      documentHeight();
    }

    window.addEventListener('resize', documentHeight);
    return function () {
      window.removeEventListener('resize', documentHeight);
    };
  }, [mode]);
  return _jsx(Styled.FlexMain, {
    as: "main",
    direction: mode === 'mobile' ? 'column' : 'row',
    onClick: function onClick() {
      if (isActiveHelpers) {
        setIsDisableHelpers(false);
        return;
      }

      setIsDisableHelpers(function (prev) {
        return !prev;
      });
    },
    children: children
  });
};

/* harmony default export */ var _common_RootLayout = ((/* unused pure expression or super */ null && (Root)));
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PdfThumbImage/index.styles.ts

var ThumbImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "ewb6kyb0"
} : 0)("display:block;object-fit:", function (_ref) {
  var imageObjectFit = _ref.imageObjectFit;
  return imageObjectFit;
}, ";-webkit-user-drag:none;user-select:none;", function (_ref2) {
  var layoutMode = _ref2.layoutMode;
  return layoutMode === 'fluid' && "\n    width: 100%;\n    height: auto;\n  ";
}, " ", function (_ref3) {
  var layoutMode = _ref3.layoutMode;
  return layoutMode === 'fill' && "\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  ";
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PdfThumbImage/index.tsx





var getLayoutMode = function getLayoutMode(_ref) {
  var fill = _ref.fill,
      width = _ref.width,
      height = _ref.height;

  if (fill) {
    return 'fill';
  }

  if (typeof width !== 'undefined' || typeof height !== 'undefined') {
    return 'fixed';
  }

  return 'fluid';
};

var PdfThumbImage = function PdfThumbImage(_ref2) {
  var thumb = _ref2.thumb,
      alt = _ref2.alt,
      fill = _ref2.fill,
      width = _ref2.width,
      height = _ref2.height,
      _ref2$objectFit = _ref2.objectFit,
      objectFit = _ref2$objectFit === void 0 ? 'contain' : _ref2$objectFit,
      className = _ref2.className;

  var _useState = (0,node_modules_react.useState)(false),
      isSourceFailed = _useState[0],
      setIsSourceFailed = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [!isSourceFailed && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: thumb.webpUrl
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ThumbImage, {
      className: className,
      src: thumb.fallbackUrl,
      alt: alt,
      width: width,
      height: height,
      layoutMode: getLayoutMode({
        fill: fill,
        width: width,
        height: height
      }),
      imageObjectFit: objectFit,
      loading: "lazy",
      decoding: "async",
      draggable: false,
      onError: function onError() {
        return setIsSourceFailed(true);
      }
    })]
  });
};

/* harmony default export */ var _common_PdfThumbImage = (PdfThumbImage);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationDrawer/Desktop/index.styles.ts



var Desktop_index_styles_templateObject, index_styles_templateObject2;

function PageNavigationDrawer_Desktop_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var fadeIn = function fadeIn() {
  var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return (0,emotion_react_browser_esm/* keyframes */.F4)(Desktop_index_styles_templateObject || (Desktop_index_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  from {\n    opacity: ", ";\n  }\n\n  to {\n    opacity: 1;\n  }\n"])), from);
};

var fadeOut = function fadeOut() {
  var to = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return (0,emotion_react_browser_esm/* keyframes */.F4)(index_styles_templateObject2 || (index_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: ", ";\n  }\n"])), to);
};

var index_styles_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1flozes8"
} : 0)("position:relative;height:100vh;flex:0 0 360px;border:1px solid ", styles/* theme.colors.zinc_300 */.rS.colors.zinc_300, ";margin-top:auto;background-color:", styles/* theme.colors.white */.rS.colors.white, ";box-shadow:", styles/* theme.elevation.md */.rS.elevation.md, ";opacity:0;overflow-x:hidden;overflow-y:scroll;&.visible{z-index:", constants/* VIEWER_Z_INDEX.pageListButton */.G.pageListButton, ";animation:", fadeIn(), " 0.3s ease-in-out;animation-fill-mode:forwards;animation-play-state:running;}&.hidden{z-index:", constants/* VIEWER_Z_INDEX.root */.G.root, ";display:none;animation:", fadeOut(), " 0.3s ease-in-out;animation-fill-mode:forwards;animation-play-state:running;}" + ( true ? "" : 0));
var FlexCloseButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e1flozes7"
} : 0)("position:fixed;width:358px;padding:16px 32px;background-color:", styles/* theme.colors.white */.rS.colors.white, ";border-radius:0 8px 0 0;&.visible{z-index:", constants/* VIEWER_Z_INDEX.pageListButton */.G.pageListButton, ";}&.hidden{z-index:", constants/* VIEWER_Z_INDEX.root */.G.root, ";}" + ( true ? "" : 0));
var StackPageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e1flozes6"
} : 0)( true ? {
  name: "drr05r",
  styles: "padding:69px 0 32px"
} : 0);
var Page = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1flozes5"
} : 0)( true ? {
  name: "irk34x",
  styles: "display:flex;width:240px;flex-direction:column;align-items:flex-start;gap:24px;opacity:0.5;transition:opacity 0.15s ease-in-out;&.current-page{opacity:1;}&:hover{opacity:1;}"
} : 0);
var PageInnerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1flozes4"
} : 0)("position:relative;width:360px;padding:16px 32px;background:", styles/* theme.colors.white */.rS.colors.white, ";border-radius:4px;cursor:pointer;&.current-page{background:", styles/* theme.colors.skyblue_50 */.rS.colors.skyblue_50, ";}&>span{position:unset!important;img{position:relative!important;height:auto!important;}}" + ( true ? "" : 0));
var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1flozes3"
} : 0)("position:absolute;z-index:", constants/* VIEWER_Z_INDEX.pageListButton */.G.pageListButton, ";top:32px;left:48px;opacity:1;transition:opacity 0.15s ease-in-out;&.disable{opacity:0.25;}" + ( true ? "" : 0));
var ButtonOpenDrawer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "e1flozes2"
} : 0)("position:relative;height:59px;border-radius:9999px;&.visible{z-index:", constants/* VIEWER_Z_INDEX.pageListButton */.G.pageListButton, ";animation:", fadeIn(0.25), " 0.3s ease-in-out;animation-fill-mode:forwards;animation-play-state:running;}&.hidden{z-index:", constants/* VIEWER_Z_INDEX.root */.G.root, ";animation:", fadeOut(0.25), " 0.3s ease-in-out;animation-fill-mode:forwards;animation-play-state:running;}" + ( true ? "" : 0));
var BlindImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)((image_default()),  true ? {
  target: "e1flozes1"
} : 0)("border:1px solid ", styles/* theme.colors.zinc_300 */.rS.colors.zinc_300, "!important;border-radius:8px;-webkit-user-drag:none;user-select:none;&.is-blind{filter:blur(8px);}" + ( true ? "" : 0));
var BlindPictureImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(_common_PdfThumbImage,  true ? {
  target: "e1flozes0"
} : 0)("border:1px solid ", styles/* theme.colors.zinc_300 */.rS.colors.zinc_300, "!important;border-radius:8px;&.is-blind{filter:blur(8px);}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationDrawer/Desktop/index.tsx













var Desktop_DesktopPageNavigation = function DesktopPageNavigation(_ref) {
  var fileName = _ref.fileName,
      pages = _ref.pages,
      blindPages = _ref.blindPages,
      translateKoToEn = _ref.translateKoToEn;
  var wrapperRef = useRef(null);

  var _useAtom = useAtom(isDisableHelpersAtom),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      isDisableHelpers = _useAtom2[0],
      setIsDisableHelpers = _useAtom2[1];

  var _useAtom3 = useAtom(isOpenDrawerAtom),
      _useAtom4 = _slicedToArray(_useAtom3, 2),
      isOpenDrawer = _useAtom4[0],
      setIsOpenDrawer = _useAtom4[1];

  var _useUpdateViewerPageS = useUpdateViewerPageState(),
      updateCurrentPage = _useUpdateViewerPageS.updateCurrentPage,
      currentPage = _useUpdateViewerPageS.currentPage;

  useIsomorphicLayoutEffect(function () {
    if (!wrapperRef.current) {
      return;
    }

    var currentPageElement = document.querySelector("[data-current-page=\"true\"]");

    if (!(currentPageElement instanceof HTMLDivElement)) {
      return;
    }

    wrapperRef.current.scrollTo({
      top: currentPageElement.offsetTop - 80
    });
  }, [wrapperRef.current, currentPage]);

  var handleClick = function handleClick(page) {
    updateCurrentPage(page);
  };

  var handleClickOpenDrawerButton = function handleClickOpenDrawerButton(e) {
    e.stopPropagation();

    if (isDisableHelpers) {
      setIsDisableHelpers(false);
      return;
    }

    setIsOpenDrawer(true);
  };

  var handleClickWrapper = function handleClickWrapper(e) {
    e.stopPropagation();
  };

  var isFirstPageImageLoaded = useAtomValue(isFirstPageImageLoadedAtom);

  if (!isFirstPageImageLoaded) {
    return null;
  }

  return _jsxs(_Fragment, {
    children: [_jsx(Styled.ButtonWrapper, {
      className: isDisableHelpers ? 'disable' : '',
      onClick: handleClickOpenDrawerButton,
      children: _jsx(Styled.ButtonOpenDrawer, {
        className: isOpenDrawer ? 'hidden' : 'visible',
        variant: "zinc_500",
        textVariant: "lg-medium",
        paddingY: 16,
        rightIcon: _jsx(Icon, {
          icon: "ph:caret-double-right",
          size: 19
        }),
        children: translateKoToEn('pageList')
      })
    }), _jsxs(Styled.Wrapper, {
      ref: wrapperRef,
      className: isOpenDrawer ? 'visible' : 'hidden',
      onClick: handleClickWrapper,
      onContextMenu: function onContextMenu(e) {
        return e.preventDefault();
      },
      onDragStart: function onDragStart(e) {
        return e.preventDefault();
      },
      children: [_jsxs(Styled.FlexCloseButton, {
        className: isOpenDrawer ? 'visible' : 'hidden',
        alignItems: "center",
        justifyContent: "space-between",
        children: [_jsx(Text, {
          variant: "lg-medium",
          marginRight: 8,
          children: fileName
        }), _jsxs(Button, {
          width: "auto",
          onClick: function onClick() {
            return setIsOpenDrawer(false);
          },
          paddingX: 0,
          maxContentWidth: true,
          children: [_jsx(Icon, {
            icon: "ph:caret-double-left",
            size: 19,
            color: "zinc_400"
          }), _jsx(Text, {
            variant: "lg-medium",
            color: "zinc_400",
            children: translateKoToEn('desktop-pageList-close')
          })]
        })]
      }), _jsx(Styled.StackPageWrapper, {
        direction: "column",
        children: pages === null || pages === void 0 ? void 0 : pages.map(function (_ref2) {
          var page = _ref2.page,
              thumnail = _ref2.thumnail,
              imageSources = _ref2.imageSources;
          return _jsx(Styled.Page, {
            className: currentPage === page ? 'current-page' : '',
            "data-current-page": currentPage === page,
            onClick: function onClick() {
              /* NOTE: 첫 Blind Page는 Drawer로 이동이 가능하도록 */
              if ((blindPages === null || blindPages === void 0 ? void 0 : blindPages[0]) !== page && blindPages !== null && blindPages !== void 0 && blindPages.includes(page)) {
                return;
              }

              handleClick(page);
            },
            children: _jsxs(Styled.PageInnerWrapper, {
              className: currentPage === page ? 'current-page' : '',
              children: [_jsxs(Text, {
                as: "p",
                variant: "md-medium",
                textAlign: "start",
                marginBottom: 8,
                color: currentPage === page ? 'skyblue_500' : 'zinc_400',
                children: [translateKoToEn('page'), " ", page]
              }), imageSources ? _jsx(Styled.BlindPictureImage, {
                className: cn({
                  'is-blind': blindPages === null || blindPages === void 0 ? void 0 : blindPages.includes(page)
                }),
                alt: "".concat(page, "\uD398\uC774\uC9C0 \uC774\uBBF8\uC9C0"),
                thumb: imageSources.thumb
              }) : _jsx(Styled.BlindImage, {
                className: cn({
                  'is-blind': blindPages === null || blindPages === void 0 ? void 0 : blindPages.includes(page)
                }),
                alt: "".concat(page, "\uD398\uC774\uC9C0 \uC774\uBBF8\uC9C0"),
                src: thumnail,
                layout: "fill",
                sizes: "296px",
                quality: 50,
                draggable: false
              })]
            })
          }, page);
        })
      })]
    })]
  });
};

/* harmony default export */ var PageNavigationDrawer_Desktop = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(Desktop_DesktopPageNavigation))));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/utils/toBase64.ts
var toBase64_toBase64 = function toBase64(str) {
  return  false ? 0 : window.btoa(str);
};
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PdfPageImage/index.styles.ts


function PdfPageImage_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/* next/image layout="fill" + objectFit="contain"과 동일한 렌더 박스를 재현한다 */
var PageImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e13rxhcf0"
} : 0)( true ? {
  name: "13tj34s",
  styles: "position:absolute;top:0;left:0;width:100%;height:100%;object-fit:contain;-webkit-user-drag:none;user-select:none;&.is-blind{filter:blur(8px);}"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PdfPageImage/index.tsx






var PdfPageImage_PdfPageImage = function PdfPageImage(_ref) {
  var viewer = _ref.viewer,
      alt = _ref.alt,
      _ref$sizes = _ref.sizes,
      sizes = _ref$sizes === void 0 ? '100vw' : _ref$sizes,
      isBlind = _ref.isBlind,
      onLoad = _ref.onLoad,
      loading = _ref.loading;

  var _useState = (0,node_modules_react.useState)(false),
      isSourceFailed = _useState[0],
      setIsSourceFailed = _useState[1];

  var isLoadEmittedRef = (0,node_modules_react.useRef)(false);
  var emitLoad = (0,node_modules_react.useCallback)(function () {
    if (isLoadEmittedRef.current) {
      return;
    }

    isLoadEmittedRef.current = true;
    onLoad === null || onLoad === void 0 ? void 0 : onLoad();
  }, [onLoad]);
  /* 캐시된 이미지는 onLoad 이벤트가 발생하기 전에 로드가 끝날 수 있어 complete 상태를 직접 확인한다 */

  var handleImageRef = (0,node_modules_react.useCallback)(function (image) {
    if (image !== null && image !== void 0 && image.complete && image.naturalWidth > 0) {
      emitLoad();
    }
  }, [emitLoad]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [!isSourceFailed && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat(viewer.webp1600Url, " 1600w, ").concat(viewer.webp2400Url, " 2400w, ").concat(viewer.webp3200Url, " 3200w"),
      sizes: sizes
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageImage, {
      ref: handleImageRef,
      className: classnames_default()({
        'is-blind': isBlind
      }),
      src: viewer.fallbackUrl,
      alt: alt,
      decoding: "async",
      loading: loading,
      draggable: false,
      onLoad: emitLoad,
      onError: function onError() {
        return setIsSourceFailed(true);
      }
    })]
  });
};

/* harmony default export */ var _common_PdfPageImage = (PdfPageImage_PdfPageImage);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Viewer/Desktop/index.styles.ts


function Viewer_Desktop_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var ImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ppm8620"
} : 0)( true ? {
  name: "17h4eel",
  styles: "&.visible{visibility:visible;}&.hidden{visibility:hidden;}&>span{overflow:scroll!important;}"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Viewer/Desktop/index.tsx











var Desktop_DesktopPage = function DesktopPage(_ref) {
  var thumnails = _ref.thumnails,
      blindPages = _ref.blindPages;
  var currentPage = (0,react/* useAtomValue */.Dv)(index_atom/* currentPageAtom */.ef);
  var zoomLevel = (0,react/* useAtomValue */.Dv)(index_atom/* zoomLevelAtom */.nO);
  /* 첫 번째 이미지가 렌더링 된 이후에, 이후의 페이지들을 렌더링한다 */

  var _useAtom = (0,react/* useAtom */.KO)(index_atom/* isFirstPageImageLoadedAtom */.bw),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      isFirstPageImageLoaded = _useAtom2[0],
      setIsFirstPageImageLoaded = _useAtom2[1];

  var firstItem = thumnails === null || thumnails === void 0 ? void 0 : thumnails[0];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: isFirstPageImageLoaded ? thumnails === null || thumnails === void 0 ? void 0 : thumnails.map(function (item, index) {
      return (item === null || item === void 0 ? void 0 : item.src) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
        className: classnames_default()({
          visible: currentPage === index + 1,
          hidden: currentPage !== index + 1
        }),
        onContextMenu: function onContextMenu(e) {
          return e.preventDefault();
        },
        children: item.imageSources ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_common_PdfPageImage, {
          viewer: item.imageSources.viewer,
          alt: "pdf".concat(currentPage, "page"),
          isBlind: blindPages === null || blindPages === void 0 ? void 0 : blindPages.includes(index + 1)
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
          src: item.src,
          alt: "pdf".concat(currentPage, "page"),
          layout: "fill",
          objectFit: "contain",
          priority: true,
          placeholder: "blur",
          blurDataURL: "data:image/svg+xml;base64,".concat(toBase64_toBase64(item.src)),
          draggable: false,
          style: {
            userSelect: 'none',
            filter: blindPages !== null && blindPages !== void 0 && blindPages.includes(index + 1) ? 'blur(8px)' : 'none'
          }
        }, zoomLevel)
      }, item.src);
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
      className: classnames_default()({
        visible: currentPage === 1,
        hidden: currentPage !== 1
      }),
      onContextMenu: function onContextMenu(e) {
        return e.preventDefault();
      },
      children: (firstItem === null || firstItem === void 0 ? void 0 : firstItem.src) && (firstItem.imageSources ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_common_PdfPageImage, {
        viewer: firstItem.imageSources.viewer,
        alt: "pdf".concat(currentPage, "page"),
        isBlind: blindPages === null || blindPages === void 0 ? void 0 : blindPages.includes(1),
        onLoad: function onLoad() {
          setIsFirstPageImageLoaded(true);
        }
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
        src: firstItem.src,
        alt: "pdf".concat(currentPage, "page"),
        layout: "fill",
        objectFit: "contain",
        placeholder: "blur",
        blurDataURL: "data:image/svg+xml;base64,".concat(toBase64_toBase64(firstItem.src)),
        priority: true,
        onLoadingComplete: function onLoadingComplete() {
          setIsFirstPageImageLoaded(true);
        },
        style: {
          userSelect: 'none',
          filter: blindPages !== null && blindPages !== void 0 && blindPages.includes(1) ? 'blur(8px)' : 'none'
        }
      }, zoomLevel))
    })
  });
};

/* harmony default export */ var Viewer_Desktop = (Desktop_DesktopPage);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/useHandleResizedImage.ts




var useHandleResizedImage_useHandleResizedImage = function useHandleResizedImage(_ref) {
  var originalHeight = _ref.originalHeight,
      originalWidth = _ref.originalWidth;
  var pageWrapperSize = useAtomValue(pageWrapperSizeAtom);
  /*반응형에 따른 이미지 사이즈 구하기 위한 로직 */

  var resizedImageSize = useMemo(function () {
    var pageWrapperAspectRatio = pageWrapperSize.width / pageWrapperSize.height;
    var imageAspectRatio = originalWidth / originalHeight;
    /*CASE1: pdf 이미지의 방향이 가로일 때  */

    if (imageAspectRatio > pageWrapperAspectRatio) {
      var _width = pageWrapperSize.width;

      var _height = pageWrapperSize.width / imageAspectRatio;

      return {
        widthRatio: _width / originalWidth,
        heightRatio: _height / originalHeight,
        xMargin: 0,
        yMargin: (pageWrapperSize.height - _height) / 2,
        width: _width,
        height: _height
      };
    }
    /*CASE2: pdf이미지 방향이 세로일 때 */


    var width = pageWrapperSize.height * imageAspectRatio;
    var height = pageWrapperSize.height;
    return {
      widthRatio: width / originalWidth,
      heightRatio: height / originalHeight,
      xMargin: (pageWrapperSize.width - width) / 2,
      yMargin: 0,
      width: width,
      height: height
    };
  }, [pageWrapperSize, originalWidth, originalHeight]);
  return {
    resizedImageSize: resizedImageSize
  };
};

/* harmony default export */ var hooks_useHandleResizedImage = ((/* unused pure expression or super */ null && (useHandleResizedImage_useHandleResizedImage)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/utils/hyperLink.ts
/* mailto: · tel: · sms:는 새 탭이 아니라 OS 핸들러로 넘겨야 한다.
 window.open을 쓰면 데스크톱에 빈 탭이 남고, iOS Safari에서는 팝업 차단에 걸린다 */
var DEVICE_SCHEMES = ['mailto:', 'tel:', 'sms:'];
/* 백필이 없어 기존 파일은 type: 'url' + url: 'mailto:...' 형태로 남아 있다.
 타입과 url 스킴을 함께 보고 레거시 데이터까지 같이 처리한다 */

var hyperLink_isDeviceLink = function isDeviceLink(type, url) {
  return type === 'email' || type === 'phone' || type === 'sms' || DEVICE_SCHEMES.some(function (scheme) {
    return url.toLowerCase().startsWith(scheme);
  });
};
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/mutation/link/useHyperLinkClick.ts


function useHyperLinkClick_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useHyperLinkClick_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useHyperLinkClick_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useHyperLinkClick_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var hyperLinkClick = function hyperLinkClick(_ref) {
  var hyperlinkId = _ref.hyperlinkId,
      historyId = _ref.historyId,
      _ref$isBulk = _ref.isBulk,
      isBulk = _ref$isBulk === void 0 ? false : _ref$isBulk;

  if (isBulk) {
    return api_api.post('/v2/viewer/submit/hyperlink', {
      hyperlinkId: hyperlinkId,
      historyId: historyId
    });
  }

  return api_api.post('/file/action/hyperlink', {
    hyperlinkId: hyperlinkId,
    historyId: historyId
  });
};

var useHyperLinkClick = function useHyperLinkClick(options) {
  return (0,lib_useMutation/* useMutation */.D)(hyperLinkClick, useHyperLinkClick_objectSpread({}, options));
};

/* harmony default export */ var link_useHyperLinkClick = (useHyperLinkClick);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/useHandleHyperLinkClick.ts




var useHandleHyperLinkClick_useHandleHyperLinkClick = function useHandleHyperLinkClick() {
  var _useViewerRoute = ViewerRoute_useViewerRoute(),
      historyId = _useViewerRoute.historyId,
      isBulk = _useViewerRoute.isBulk;

  var _useHyperLinkClick = link_useHyperLinkClick(),
      mutateHyperLinkClick = _useHyperLinkClick.mutate;

  var handleUserHyperLinkClick = function handleUserHyperLinkClick(hyperlinkId) {
    mutateHyperLinkClick({
      hyperlinkId: hyperlinkId,
      historyId: parseQueryString(historyId),
      isBulk: isBulk
    });
  };

  return {
    handleUserHyperLinkClick: handleUserHyperLinkClick
  };
};

/* harmony default export */ var hooks_useHandleHyperLinkClick = (useHandleHyperLinkClick_useHandleHyperLinkClick);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/HyperLinkLayer/Desktop/index.styles.ts


var LinkWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ljttti0"
} : 0)("position:absolute;z-index:", constants/* VIEWER_Z_INDEX.link */.G.link, ";display:block;&:hover{cursor:pointer;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/HyperLinkLayer/Desktop/index.tsx








var Desktop_DesktopHyperLinkLayer = function DesktopHyperLinkLayer(_ref) {
  var hyperlinkList = _ref.hyperlinkList,
      resizedImageSize = _ref.resizedImageSize,
      isPreview = _ref.isPreview,
      getFormNotSubmitPage = _ref.getFormNotSubmitPage;

  var _useHandleHyperLinkCl = hooks_useHandleHyperLinkClick(),
      handleUserHyperLinkClick = _useHandleHyperLinkCl.handleUserHyperLinkClick;

  var _useUpdateViewerPageS = hooks_useUpdateViewerPageState(),
      updateCurrentPage = _useUpdateViewerPageS.updateCurrentPage;

  if (hyperlinkList.length === 0) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: hyperlinkList.map(function (_ref2) {
      var id = _ref2.id,
          rect_x1 = _ref2.rect_x1,
          rect_x2 = _ref2.rect_x2,
          rect_y1 = _ref2.rect_y1,
          rect_y2 = _ref2.rect_y2,
          type = _ref2.type,
          url = _ref2.url,
          pageNumber = _ref2.pageNumber;
      var bottom = rect_y1 * resizedImageSize.heightRatio + resizedImageSize.yMargin;
      var left = rect_x1 * resizedImageSize.widthRatio + resizedImageSize.xMargin;
      var width = rect_x2 * resizedImageSize.widthRatio - rect_x1 * resizedImageSize.widthRatio;
      var height = rect_y2 * resizedImageSize.heightRatio - rect_y1 * resizedImageSize.heightRatio;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrapper, {
        id: googleEventId_GOOGLE_EVENT_ID.hyperLink,
        onClick: function onClick(e) {
          e.stopPropagation();
          e.preventDefault();

          if (!isPreview) {
            handleUserHyperLinkClick(id);
          }

          if (type === 'page' && pageNumber) {
            updateCurrentPage(pageNumber);

            if (getFormNotSubmitPage) {
              var notSubmitPage = getFormNotSubmitPage(Number(pageNumber));

              if (notSubmitPage !== null) {
                updateCurrentPage(notSubmitPage);
                return;
              }
            }

            updateCurrentPage(pageNumber);
            return;
          }

          if (!url) {
            return;
          }

          if (hyperLink_isDeviceLink(type, url)) {
            window.location.href = url;
            return;
          }

          if (window) {
            window.open(url, '_blank');
          }
        },
        style: {
          bottom: "".concat(bottom, "px"),
          left: "".concat(left, "px"),
          width: "".concat(width, "px"),
          height: "".concat(height, "px")
        }
      }, id);
    })
  });
};

/* harmony default export */ var HyperLinkLayer_Desktop = (Desktop_DesktopHyperLinkLayer);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/OneOnOneAnnotationLayer/Desktop/index.tsx









var Desktop_DesktopAnnotationLayer = function DesktopAnnotationLayer(_ref) {
  var thumnail = _ref.thumnail,
      _ref$isPreview = _ref.isPreview,
      isPreview = _ref$isPreview === void 0 ? false : _ref$isPreview,
      messageBoxItems = _ref.messageBoxItems;
  var currentPage = useAtomValue(currentPageAtom);
  var _thumnail = thumnail[currentPage - 1],
      hyperlink = _thumnail.hyperlink,
      originalWidth = _thumnail.originalWidth,
      originalHeight = _thumnail.originalHeight;

  var _useHandleResizedImag = useHandleResizedImage({
    originalHeight: originalHeight,
    originalWidth: originalWidth
  }),
      resizedImageSize = _useHandleResizedImag.resizedImageSize;

  if (!thumnail) {
    return null;
  }

  return _jsxs(_Fragment, {
    children: [_jsx(MessageBoxLayer, {
      resizedImageSize: resizedImageSize,
      isPreview: isPreview,
      messageBoxItems: messageBoxItems
    }), _jsx(DesktopHyperLinkLayer, {
      hyperlinkList: hyperlink,
      resizedImageSize: resizedImageSize,
      isPreview: isPreview
    })]
  });
};

/* harmony default export */ var OneOnOneAnnotationLayer_Desktop = ((/* unused pure expression or super */ null && (Desktop_DesktopAnnotationLayer)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/KeyPressLayer/index.tsx






var KeyPressLayer_KeyPressLayer = function KeyPressLayer(_ref) {
  var children = _ref.children,
      totalPage = _ref.totalPage,
      isNextPageButtonDisabled = _ref.isNextPageButtonDisabled,
      updateNextThumbnails = _ref.updateNextThumbnails,
      updatePrevThumbnails = _ref.updatePrevThumbnails;

  var _useUpdateViewerPageS = useUpdateViewerPageState(),
      currentPage = _useUpdateViewerPageS.currentPage,
      updateCurrentPage = _useUpdateViewerPageS.updateCurrentPage;

  var isPressPrevPage = useKeyPress('ArrowLeft, PageUp, ArrowUp');
  var isPressNextPage = useKeyPress('ArrowRight, ArrowDown, PageDown');
  var isFirstPage = currentPage === 1;
  var isLastPage = totalPage === currentPage;
  useEffect(function () {
    if (isPressPrevPage && !isFirstPage) {
      updateCurrentPage(currentPage - 1);
      updatePrevThumbnails === null || updatePrevThumbnails === void 0 ? void 0 : updatePrevThumbnails(currentPage - 1);
    }

    if (isPressNextPage && !isLastPage && !isNextPageButtonDisabled) {
      updateCurrentPage(currentPage + 1);
      updateNextThumbnails === null || updateNextThumbnails === void 0 ? void 0 : updateNextThumbnails(currentPage + 1);
    }
  }, [isPressNextPage, isPressPrevPage]);
  return _jsx(_Fragment, {
    children: children
  });
};

/* harmony default export */ var Layer_KeyPressLayer = ((/* unused pure expression or super */ null && (KeyPressLayer_KeyPressLayer)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationButton/Desktop/DesktopPageIndicator/index.styles.ts


function DesktopPageIndicator_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var StackWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e1jc34u12"
} : 0)( true ? {
  name: "g8at3s",
  styles: "width:auto;height:65px;flex:0 0 0px;padding:16px 0;background-color:transparent;opacity:1;transition:opacity 0.15s ease-in-out"
} : 0);
var FlexCurrentPageTextWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e1jc34u11"
} : 0)("width:auto;min-width:48px;height:33px;padding:8px;background:", styles/* theme.colors.zinc_100 */.rS.colors.zinc_100, ";border-radius:4px;color:", styles/* theme.colors.black */.rS.colors.black, ";" + ( true ? "" : 0));
var Input = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("input",  true ? {
  target: "e1jc34u10"
} : 0)("width:48px;height:33px;padding:4px 8px;appearance:textfield;background:", styles/* theme.colors.zinc_100 */.rS.colors.zinc_100, ";color:", styles/* theme.colors.black */.rS.colors.black, ";outline:none;text-align:center;&::-webkit-outer-spin-button,&::-webkit-inner-spin-button{margin:0;appearance:none;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationButton/Desktop/DesktopPageIndicator/index.tsx



function DesktopPageIndicator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DesktopPageIndicator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DesktopPageIndicator_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DesktopPageIndicator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var DesktopPageIndicator_DesktopPageIndicator = function DesktopPageIndicator(_ref) {
  var totalPage = _ref.totalPage,
      ctaFormPage = _ref.ctaFormPage,
      isMoveCtaFormPageRequirements = _ref.isMoveCtaFormPageRequirements;

  var _useAtom = useAtom(isDisableHelpersAtom),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      isDisableHelpers = _useAtom2[0],
      setIsDisableHelpers = _useAtom2[1];

  var _useUpdateViewerPageS = useUpdateViewerPageState(),
      updateCurrentPage = _useUpdateViewerPageS.updateCurrentPage,
      currentPage = _useUpdateViewerPageS.currentPage;

  var handleClickWrapper = function handleClickWrapper(e) {
    e.stopPropagation();

    if (isDisableHelpers) {
      setIsDisableHelpers(false);
      return;
    }
  };

  var _useState = useState(false),
      isEditable = _useState[0],
      setIsEditable = _useState[1];

  var _useForm = useForm(),
      handleSubmit = _useForm.handleSubmit,
      register = _useForm.register,
      setFocus = _useForm.setFocus,
      setValue = _useForm.setValue,
      getValues = _useForm.getValues;

  useEffect(function () {
    if (!isEditable) {
      setValue('currentPage', currentPage);
    }
  }, [currentPage, isEditable, setValue]);

  var changeCurrentPage = function changeCurrentPage() {
    var value = getValues('currentPage');

    if (totalPage && value >= 1 && value <= totalPage) {
      /*만일 폼을 제출해야만 뷰어의 내용을 보도록 설정한 상태에서 
      다른 페이지로 유저가 이동하려 한 경우에 폼 페이지로 이동시킨다 */
      if (ctaFormPage && isMoveCtaFormPageRequirements && Number(value) >= ctaFormPage) {
        updateCurrentPage(ctaFormPage);
      } else {
        updateCurrentPage(Number(value));
      }
    }

    setIsEditable(false);
  };

  var onSubmit = function onSubmit() {
    changeCurrentPage();
  };

  useEffect(function () {
    setIsEditable(false);
  }, [isDisableHelpers, setIsEditable]);
  useEffect(function () {
    if (isDisableHelpers) {
      changeCurrentPage();
    }
  }, [isDisableHelpers]);
  useEffect(function () {
    if (isEditable) {
      setFocus('currentPage');
    }
  }, [isEditable, setFocus]);
  return _jsx(Styled.StackWrapper, {
    className: isDisableHelpers ? 'disable' : '',
    alignItems: "center",
    gap: 8,
    onClick: handleClickWrapper,
    children: isEditable ? _jsx("form", {
      onSubmit: handleSubmit(onSubmit),
      children: _jsx(Styled.Input, DesktopPageIndicator_objectSpread({
        type: "number"
      }, register('currentPage', {
        value: currentPage
      })))
    }) : _jsx(Styled.FlexCurrentPageTextWrapper, {
      alignContent: "center",
      justifyContent: "center",
      onClick: function onClick(e) {
        e.stopPropagation();
        setIsDisableHelpers(false);
        setIsEditable(true);
      },
      children: _jsx(Text, {
        variant: "md-medium",
        color: "black",
        children: currentPage
      })
    })
  });
};

/* harmony default export */ var Desktop_DesktopPageIndicator = ((/* unused pure expression or super */ null && (DesktopPageIndicator_DesktopPageIndicator)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationButton/Desktop/DesktopPageMoveButton/index.styles.ts


function DesktopPageMoveButton_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var ArrowButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "e3fd25h0"
} : 0)( true ? {
  name: "ooo76c",
  styles: "width:auto;height:auto;&.disable{cursor:initial;opacity:0.25;}transition:opacity 0.15s ease-in-out"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationButton/Desktop/DesktopPageMoveButton/index.tsx








var DesktopPageMoveButton_DesktopPageMoveButton = function DesktopPageMoveButton(_ref) {
  var variant = _ref.variant,
      totalPage = _ref.totalPage,
      isNextPageButtonDisabled = _ref.isNextPageButtonDisabled,
      updatePrevThumbnails = _ref.updatePrevThumbnails,
      updateNextThumbnails = _ref.updateNextThumbnails;

  var _useAtom = useAtom(isDisableHelpersAtom),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      isDisableHelpers = _useAtom2[0],
      setIsDisableHelpers = _useAtom2[1];

  var _useUpdateViewerPageS = useUpdateViewerPageState(),
      updateCurrentPage = _useUpdateViewerPageS.updateCurrentPage,
      currentPage = _useUpdateViewerPageS.currentPage;

  var handleClickPrevButton = function handleClickPrevButton(e) {
    e.stopPropagation();

    if (isDisableHelpers) {
      setIsDisableHelpers(false);
      return;
    }

    if (currentPage === 1) {
      return;
    }

    updatePrevThumbnails === null || updatePrevThumbnails === void 0 ? void 0 : updatePrevThumbnails(currentPage - 1);
    updateCurrentPage(currentPage - 1);
  };

  var handleClickNextButton = function handleClickNextButton(e) {
    e.stopPropagation();

    if (isDisableHelpers) {
      setIsDisableHelpers(false);
      return;
    }

    if (currentPage === totalPage) {
      return;
    }

    if (isNextPageButtonDisabled) {
      return;
    }

    updateNextThumbnails === null || updateNextThumbnails === void 0 ? void 0 : updateNextThumbnails(currentPage + 1);
    updateCurrentPage(currentPage + 1);
  };

  var getIsDisable = function getIsDisable() {
    if (variant === 'prev' && currentPage === 1) {
      return 'disable';
    }

    if (variant === 'next' && currentPage === totalPage || isNextPageButtonDisabled) {
      return 'disable';
    }

    return '';
  };

  return _jsx(Styled.ArrowButton, {
    className: [getIsDisable(), variant].join(' '),
    onClick: variant === 'prev' ? handleClickPrevButton : handleClickNextButton,
    children: _jsx(Icon, {
      icon: "ph:caret-".concat(variant === 'next' ? 'right' : 'left'),
      size: 24,
      color: "black"
    })
  });
};

/* harmony default export */ var Desktop_DesktopPageMoveButton = ((/* unused pure expression or super */ null && (DesktopPageMoveButton_DesktopPageMoveButton)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationButton/Desktop/index.styles.ts




var PageNavigationButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "ecgck650"
} : 0)("position:fixed;z-index:", constants/* VIEWER_Z_INDEX.desktopLayer */.G.desktopLayer, ";bottom:32px;left:50%;width:auto;border:1px solid ", styles/* theme.colors.zinc_500 */.rS.colors.zinc_500, ";backdrop-filter:blur(8px);background:rgb(255 255 255 / 50%);border-radius:9999px;transform:translateX(-50%);transition:opacity 0.15s ease-in-out;&.disabled{cursor:initial;opacity:0.5;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationButton/Desktop/index.tsx











var Desktop_DesktopPageNavigationButton = function DesktopPageNavigationButton(_ref) {
  var updatePrevThumbnails = _ref.updatePrevThumbnails,
      updateNextThumbnails = _ref.updateNextThumbnails,
      totalPage = _ref.totalPage,
      ctaFormPage = _ref.ctaFormPage,
      isMoveCtaFormPageRequirements = _ref.isMoveCtaFormPageRequirements,
      isNextPageButtonDisabled = _ref.isNextPageButtonDisabled;

  var _useAtom = useAtom(isDisableHelpersAtom),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      isDisableHelpers = _useAtom2[0],
      setIsDisableHelpers = _useAtom2[1];

  return _jsx(KeyPressLayer, {
    totalPage: totalPage,
    updateNextThumbnails: updateNextThumbnails,
    updatePrevThumbnails: updatePrevThumbnails,
    isNextPageButtonDisabled: isNextPageButtonDisabled,
    children: _jsxs(Styled.PageNavigationButton, {
      className: cn({
        disabled: isDisableHelpers
      }),
      onClick: function onClick() {
        if (isDisableHelpers) {
          setIsDisableHelpers(false);
          return;
        }
      },
      children: [_jsx(DesktopPageMoveButton, {
        variant: "prev",
        totalPage: totalPage,
        updatePrevThumbnails: updatePrevThumbnails
      }), _jsx(DesktopPageIndicator, {
        totalPage: totalPage,
        ctaFormPage: ctaFormPage,
        isMoveCtaFormPageRequirements: isMoveCtaFormPageRequirements
      }), _jsx(DesktopPageMoveButton, {
        variant: "next",
        totalPage: totalPage,
        isNextPageButtonDisabled: isNextPageButtonDisabled,
        updateNextThumbnails: updateNextThumbnails
      })]
    })
  });
};

/* harmony default export */ var PageNavigationButton_Desktop = ((/* unused pure expression or super */ null && (Desktop_DesktopPageNavigationButton)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/PdfPreview/Desktop/index.tsx










var DesktopPdfPreview = function DesktopPdfPreview(_ref) {
  var translateKoToEn = _ref.translateKoToEn,
      file = _ref.file,
      messageBoxItems = _ref.messageBoxItems;
  var name = file.name,
      thumnail = file.thumnail,
      pages = file.pages;
  return _jsxs(RootLayout, {
    mode: "desktop",
    children: [_jsx(DesktopPageNavigation, {
      translateKoToEn: translateKoToEn,
      fileName: name,
      pages: thumnail
    }), _jsx(DesktopIntro, {
      translateKoToEn: translateKoToEn
    }), _jsx(DesktopPageWrapper, {
      totalPage: pages,
      children: _jsx(DesktopPage, {
        thumnails: thumnail === null || thumnail === void 0 ? void 0 : thumnail.map(function (value) {
          if (value !== null && value !== void 0 && value.thumnail) {
            return {
              src: value.thumnail,
              imageSources: value.imageSources
            };
          }

          return null;
        })
      })
    }), _jsx(DesktopPageNavigationButton, {
      totalPage: Number(pages),
      isMoveCtaFormPageRequirements: true
    }), thumnail && _jsx(DesktopAnnotationLayer, {
      thumnail: thumnail,
      messageBoxItems: messageBoxItems,
      isPreview: true
    })]
  });
};

/* harmony default export */ var PdfPreview_Desktop = ((/* unused pure expression or super */ null && (DesktopPdfPreview)));
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/mutation/file/useFileDownloadLink.ts


function useFileDownloadLink_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useFileDownloadLink_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useFileDownloadLink_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useFileDownloadLink_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var getDownloadLink = function getDownloadLink(_ref) {
  var hash = _ref.hash,
      _ref$isBulk = _ref.isBulk,
      isBulk = _ref$isBulk === void 0 ? false : _ref$isBulk;
  return api_api.get('/v2/viewer/download', {
    params: {
      hash: hash,
      isBulk: isBulk
    }
  });
};

var useFileDownloadLink = function useFileDownloadLink(options) {
  return (0,lib_useMutation/* useMutation */.D)(getDownloadLink, useFileDownloadLink_objectSpread({}, options));
};

/* harmony default export */ var file_useFileDownloadLink = (useFileDownloadLink);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/useGetFileDownloadLink.ts





var useGetFileDownloadLink = function useGetFileDownloadLink(_ref) {
  var handleGetDownloadSuccess = _ref.handleGetDownloadSuccess;

  var _useViewerRoute = ViewerRoute_useViewerRoute(),
      hashId = _useViewerRoute.hashId,
      isBulk = _useViewerRoute.isBulk;

  var _useFileDownloadLink = file_useFileDownloadLink({
    onSuccess: function () {
      var _onSuccess = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return handleGetDownloadSuccess(data.data.data.url);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onSuccess(_x) {
        return _onSuccess.apply(this, arguments);
      }

      return onSuccess;
    }()
  }),
      mutate = _useFileDownloadLink.mutate;

  var getDownloadLink = function getDownloadLink() {
    if (hashId) {
      mutate({
        hash: hashId,
        isBulk: isBulk
      });
    }
  };

  return {
    getDownloadLink: getDownloadLink
  };
};

/* harmony default export */ var hooks_useGetFileDownloadLink = (useGetFileDownloadLink);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/mutation/file/useFileDownload.ts


function useFileDownload_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useFileDownload_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useFileDownload_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useFileDownload_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var updateFileHistoryDownload = function updateFileHistoryDownload(_ref) {
  var historyId = _ref.historyId;
  return api_api.put('/file/history/download', {
    historyId: historyId
  });
};
var updateBulkFileHistoryDownload = function updateBulkFileHistoryDownload(_ref2) {
  var historyId = _ref2.historyId;
  return api_api.post('/v2/viewer/submit/download', {
    historyId: historyId
  });
};

var useFileDownload = function useFileDownload() {
  var isBulk = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var options = arguments.length > 1 ? arguments[1] : undefined;
  return (0,lib_useMutation/* useMutation */.D)(isBulk ? updateBulkFileHistoryDownload : updateFileHistoryDownload, useFileDownload_objectSpread({}, options));
};

/* harmony default export */ var file_useFileDownload = (useFileDownload);
// EXTERNAL MODULE: ../../node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__(46782);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/PdfViewer/queryString.ts
/**
 * Next.js의 useRouter() 훅의 query 객체 내의 키에 대한 값으로 플러스 부호가 빈 여백으로 변환되는 문제를 해결하기 위한 함수
 */
var queryString_parseQueryString = function parseQueryString(str) {
  if (!str) {
    return '';
  }

  return str.replace(/\s+/g, '+');
};
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/useDownloadPdfFile.ts







var useDownloadPdfFile = function useDownloadPdfFile() {
  var _useViewerRoute = ViewerRoute_useViewerRoute(),
      historyId = _useViewerRoute.historyId;

  var _useState = (0,node_modules_react.useState)(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var downloadPdfFile = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(downloadUrl, fileName, mutateFileDownload) {
      var response;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              setIsLoading(true);
              _context2.next = 4;
              return fetch(downloadUrl);

            case 4:
              response = _context2.sent;

              if (response.ok) {
                _context2.next = 9;
                break;
              }

              alert('다운로드에 실패했습니다.');
              setIsLoading(false);
              return _context2.abrupt("return");

            case 9:
              if (typeof historyId === 'string') {
                mutateFileDownload({
                  historyId: queryString_parseQueryString(historyId)
                }, {
                  onSuccess: function () {
                    var _onSuccess = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
                      var blob, ua, isFacebookWebView;
                      return regenerator_default().wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _context.next = 2;
                              return response.blob();

                            case 2:
                              blob = _context.sent;
                              ua = navigator.userAgent || '';
                              isFacebookWebView = /FBAN|FBAV|Instagram/.test(ua);

                              if (!isFacebookWebView) {
                                _context.next = 9;
                                break;
                              }

                              alert('앱에서 다운로드가 차단되어 있습니다. Safari나 Chrome에서 다시 시도해 주세요.');
                              setIsLoading(false);
                              return _context.abrupt("return");

                            case 9:
                              try {
                                (0,FileSaver_min.saveAs)(blob, "".concat(fileName, ".pdf"));
                              } catch (e) {
                                alert('다운로드가 차단되었습니다. Safari나 Chrome에서 다시 시도해 주세요.');
                              }

                            case 10:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    function onSuccess() {
                      return _onSuccess.apply(this, arguments);
                    }

                    return onSuccess;
                  }(),
                  onError: function onError() {
                    alert('다운로드에 실패했습니다. Safari나 Chrome에서 다시 시도해 주세요.');
                  },
                  onSettled: function onSettled() {
                    setIsLoading(false);
                  }
                });
              }

              _context2.next = 16;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](0);
              alert('다운로드에 실패했습니다. Safari나 Chrome에서 다시 시도해 주세요.');
              setIsLoading(false);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 12]]);
    }));

    return function downloadPdfFile(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    isLoading: isLoading,
    downloadPdfFile: downloadPdfFile
  };
};

/* harmony default export */ var hooks_useDownloadPdfFile = (useDownloadPdfFile);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/DefaultViewerLayer/PdfDownloadButton/index.styles.ts



var PdfDownloadButton_index_styles_templateObject;





var spinAnimation = (0,emotion_react_browser_esm/* keyframes */.F4)(PdfDownloadButton_index_styles_templateObject || (PdfDownloadButton_index_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
var Spinner = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Icon */.JO,  true ? {
  target: "e1y0w5uq2"
} : 0)("animation:", function (_ref) {
  var isLoading = _ref.isLoading;
  return isLoading ? /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(spinAnimation, " 1s linear infinite;" + ( true ? "" : 0),  true ? "" : 0) : 'none';
}, ";" + ( true ? "" : 0));
var DesktopButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "e1y0w5uq1"
} : 0)("width:59px;height:59px;opacity:", constants/* VIEWER_Z_INDEX.desktopLayer */.G.desktopLayer, ";transition:opacity 0.15s ease-in-out,width 0.15s ease-in-out;&.disable{cursor:initial;opacity:0.25;&:hover{border-color:", styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, ";background-color:", styles/* theme.colors.white */.rS.colors.white, ";color:", styles/* theme.colors.zinc_400 */.rS.colors.zinc_400, ";}}&:hover{width:fit-content;}&.isLoading{width:fit-content;}" + ( true ? "" : 0));
var MobileButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "e1y0w5uq0"
} : 0)("z-index:", constants/* VIEWER_Z_INDEX.desktopLayer */.G.desktopLayer, ";width:43px;height:43px;padding:8px;box-shadow:none;transition:opacity 0.15s ease-in-out;&.disable{cursor:initial;opacity:0;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/DefaultViewerLayer/PdfDownloadButton/Desktop/index.tsx


















var DesktopPdfDownloadButton = function DesktopPdfDownloadButton(_ref) {
  var fileName = _ref.fileName,
      translateKoToEn = _ref.translateKoToEn,
      _ref$isBulk = _ref.isBulk,
      isBulk = _ref$isBulk === void 0 ? false : _ref$isBulk,
      _ref$isDownloadEnable = _ref.isDownloadEnabled,
      isDownloadEnabled = _ref$isDownloadEnable === void 0 ? false : _ref$isDownloadEnable,
      ctaFormPage = _ref.ctaFormPage,
      _ref$isRedirectCtaFor = _ref.isRedirectCtaFormAppropriate,
      isRedirectCtaFormAppropriate = _ref$isRedirectCtaFor === void 0 ? false : _ref$isRedirectCtaFor;
  var toast = (0,src/* useToast */.pm)();

  var _useAtom = (0,react/* useAtom */.KO)(index_atom/* isDisableHelpersAtom */.Tn),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      isDisableHelpers = _useAtom2[0],
      setIsDisableHelpers = _useAtom2[1];

  var _useState = (0,node_modules_react.useState)(false),
      isHovering = _useState[0],
      setIsHovering = _useState[1];

  var _useUpdateViewerPageS = hooks_useUpdateViewerPageState(),
      updateCurrentPage = _useUpdateViewerPageS.updateCurrentPage;

  var handleMouseOver = function handleMouseOver() {
    setIsHovering(true);
  };

  var handleMouseOut = function handleMouseOut() {
    setIsHovering(false);
  };

  var _useDownloadPdfFile = hooks_useDownloadPdfFile(),
      isLoading = _useDownloadPdfFile.isLoading,
      downloadPdfFile = _useDownloadPdfFile.downloadPdfFile;

  var _useFileDownload = file_useFileDownload(isBulk),
      mutateFileDownload = _useFileDownload.mutate;

  var _useGetFileDownloadLi = hooks_useGetFileDownloadLink({
    handleGetDownloadSuccess: function () {
      var _handleGetDownloadSuccess = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(downloadUrl) {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return downloadPdfFile(downloadUrl, fileName, mutateFileDownload);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function handleGetDownloadSuccess(_x) {
        return _handleGetDownloadSuccess.apply(this, arguments);
      }

      return handleGetDownloadSuccess;
    }()
  }),
      getDownloadLink = _useGetFileDownloadLi.getDownloadLink;

  var handleClick = function handleClick(e) {
    e.stopPropagation();

    if (isDisableHelpers) {
      setIsDisableHelpers(false);
      return;
    }
    /*문의 양식 제출 전에 다운로드 버튼을 클릭했을 경우에, 경고 메세지와 함께 폼이 있는 페이지로 이동시킨다*/


    if (isRedirectCtaFormAppropriate && ctaFormPage) {
      toast("".concat(translateKoToEn('download-alert')));
      updateCurrentPage(ctaFormPage);
      return;
    }

    getDownloadLink();
  };

  if (!isDownloadEnabled) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DesktopButton, {
      id: googleEventId_GOOGLE_EVENT_ID.download,
      className: classnames_default()({
        disable: isDisableHelpers,
        isLoading: isLoading
      }),
      variant: "zinc_500",
      radius: 9999,
      paddingX: 16,
      onClick: handleClick,
      onMouseOver: handleMouseOver,
      onMouseOut: handleMouseOut,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Spinner, {
        isLoading: isLoading,
        icon: isLoading ? 'ph:circle-notch' : 'ph:download-simple',
        size: 19,
        color: isLoading ? 'zinc_400' : 'black'
      }), (isHovering || isLoading) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        id: googleEventId_GOOGLE_EVENT_ID.download,
        variant: "lg-medium",
        marginLeft: 8,
        color: isLoading ? 'zinc_400' : 'black',
        style: {
          whiteSpace: 'nowrap'
        },
        children: translateKoToEn('download')
      })]
    })
  });
};

/* harmony default export */ var PdfDownloadButton_Desktop = (DesktopPdfDownloadButton);
// EXTERNAL MODULE: ../../node_modules/copy-to-clipboard/index.js
var copy_to_clipboard = __webpack_require__(50381);
var copy_to_clipboard_default = /*#__PURE__*/__webpack_require__.n(copy_to_clipboard);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/mutation/file/useFileHistoryShare.ts


function useFileHistoryShare_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useFileHistoryShare_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useFileHistoryShare_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useFileHistoryShare_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var fileHistoryShare = function fileHistoryShare(_ref) {
  var historyId = _ref.historyId;
  return api_api.put('/file/history/share', {
    historyId: historyId
  });
};

var fileBulkHistoryShare = function fileBulkHistoryShare(_ref2) {
  var historyId = _ref2.historyId;
  return api_api.post('/v2/viewer/submit/share', {
    historyId: historyId
  });
};

var useFileHistoryShare = function useFileHistoryShare() {
  var isBulk = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var options = arguments.length > 1 ? arguments[1] : undefined;
  return (0,lib_useMutation/* useMutation */.D)(isBulk ? fileBulkHistoryShare : fileHistoryShare, useFileHistoryShare_objectSpread({}, options));
};

/* harmony default export */ var file_useFileHistoryShare = (useFileHistoryShare);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/DefaultViewerLayer/ShareButton/Desktop/index.styles.ts




var index_styles_Button = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "e1ardlyl0"
} : 0)("width:59px;height:59px;opacity:", constants/* VIEWER_Z_INDEX.desktopLayer */.G.desktopLayer, ";transition:opacity 0.15s ease-in-out,width 0.15s ease-in-out;&.disable{cursor:initial;opacity:0.25;&:hover{border-color:", styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, ";background-color:", styles/* theme.colors.white */.rS.colors.white, ";color:", styles/* theme.colors.zinc_400 */.rS.colors.zinc_400, ";}}&:hover{width:fit-content;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/DefaultViewerLayer/ShareButton/Desktop/index.tsx












var DesktopShareButton = function DesktopShareButton(_ref) {
  var domain = _ref.domain,
      translateKoToEn = _ref.translateKoToEn,
      _ref$isBulk = _ref.isBulk,
      isBulk = _ref$isBulk === void 0 ? false : _ref$isBulk;

  var _useViewerRoute = ViewerRoute_useViewerRoute(),
      historyId = _useViewerRoute.historyId,
      getShareUrl = _useViewerRoute.getShareUrl;

  var toast = (0,src/* useToast */.pm)();

  var _useState = (0,node_modules_react.useState)(false),
      isHovering = _useState[0],
      setIsHovering = _useState[1];

  var handleMouseOver = function handleMouseOver() {
    setIsHovering(true);
  };

  var handleMouseOut = function handleMouseOut() {
    setIsHovering(false);
  };

  var _useAtom = (0,react/* useAtom */.KO)(index_atom/* isDisableHelpersAtom */.Tn),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      isDisableHelpers = _useAtom2[0],
      setIsDisableHelpers = _useAtom2[1];

  var _useFileHistoryShare = file_useFileHistoryShare(isBulk),
      mutateFileHistoryShare = _useFileHistoryShare.mutate;

  var handleClickLinkCopyButton = function handleClickLinkCopyButton(e) {
    e.stopPropagation();

    if (isDisableHelpers) {
      setIsDisableHelpers(false);
      return;
    }

    copy_to_clipboard_default()(getShareUrl({
      domain: domain,
      isBulk: isBulk
    }));
    mutateFileHistoryShare({
      historyId: historyId
    });
    toast("".concat(translateKoToEn('link-copy')));
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_styles_Button, {
    id: googleEventId_GOOGLE_EVENT_ID.share,
    className: isDisableHelpers ? 'disable' : '',
    variant: "zinc_500",
    textVariant: "xl-medium",
    radius: 9999,
    paddingY: 16,
    onClick: handleClickLinkCopyButton,
    onMouseOver: handleMouseOver,
    onMouseOut: handleMouseOut,
    leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
      icon: "ph:share-network",
      size: 19,
      color: "black"
    }),
    children: isHovering && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      id: googleEventId_GOOGLE_EVENT_ID.share,
      variant: "lg-medium",
      marginLeft: 8,
      style: {
        whiteSpace: 'nowrap'
      },
      children: translateKoToEn('share')
    })
  });
};

/* harmony default export */ var ShareButton_Desktop = (DesktopShareButton);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/DefaultViewerLayer/ZoomButton/Desktop/index.styles.ts


function ZoomButton_Desktop_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var Desktop_index_styles_Button = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "e19hjwni1"
} : 0)("width:auto;height:59px;opacity:", constants/* VIEWER_Z_INDEX.desktopLayer */.G.desktopLayer, ";transition:opacity 0.15s ease-in-out,width 0.15s ease-in-out;&.disable{cursor:initial;opacity:0.25;&:hover{border-color:", styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, ";background-color:", styles/* theme.colors.white */.rS.colors.white, ";color:", styles/* theme.colors.zinc_400 */.rS.colors.zinc_400, ";}}" + ( true ? "" : 0));
var index_styles_Icon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Icon */.JO,  true ? {
  target: "e19hjwni0"
} : 0)( true ? {
  name: "137pcyc",
  styles: "margin:4px"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/DefaultViewerLayer/ZoomButton/Desktop/index.tsx








var DesktopZoomButton = function DesktopZoomButton() {
  var _useAtom = (0,react/* useAtom */.KO)(index_atom/* zoomLevelAtom */.nO),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      zoomLevel = _useAtom2[0],
      setZoomLevel = _useAtom2[1];

  var _useAtom3 = (0,react/* useAtom */.KO)(index_atom/* isDisableHelpersAtom */.Tn),
      _useAtom4 = (0,slicedToArray/* default */.Z)(_useAtom3, 2),
      isDisableHelpers = _useAtom4[0],
      setIsDisableHelpers = _useAtom4[1];

  var handleZoom = function handleZoom(amount) {
    if (isDisableHelpers) {
      setIsDisableHelpers(false);
      return;
    }

    var newZoomLevel = zoomLevel + amount;

    if (newZoomLevel >= 0.5 && newZoomLevel <= 1.5) {
      setZoomLevel(newZoomLevel);
    }
  };

  var handleClickZoomIn = function handleClickZoomIn() {
    handleZoom(0.25);
  };

  var handleClickZoomOut = function handleClickZoomOut() {
    handleZoom(-0.25);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Desktop_index_styles_Button, {
    className: isDisableHelpers ? 'disable' : '',
    variant: "zinc_500",
    radius: 9999,
    paddingY: 16,
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();

      if (isDisableHelpers) {
        setIsDisableHelpers(false);
        return;
      }
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      direction: "row",
      gap: 16,
      justifyContent: "center",
      alignItems: "center",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_styles_Icon, {
        icon: "ph:magnifying-glass-plus",
        size: 19,
        color: zoomLevel === 1.5 ? 'zinc_400' : 'black',
        onClick: handleClickZoomIn
      }), zoomLevel !== 1 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
        variant: "lg-medium",
        color: "black",
        children: [zoomLevel * 100, "%"]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_styles_Icon, {
        icon: "ph:magnifying-glass-minus",
        size: 19,
        color: zoomLevel === 0.5 ? 'zinc_400' : 'black',
        onClick: handleClickZoomOut
      })]
    })
  });
};

/* harmony default export */ var ZoomButton_Desktop = (DesktopZoomButton);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/DefaultViewerLayer/LanguageButton/Desktop/index.styles.ts


function LanguageButton_Desktop_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var LanguageButton_Desktop_index_styles_Button = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "e1lfszju3"
} : 0)("min-width:59px;width:59px;height:59px;opacity:", constants/* VIEWER_Z_INDEX.desktopLayer */.G.desktopLayer, ";transition:opacity 0.15s ease-in-out,width 0.15s ease-in-out;&.disable{cursor:initial;opacity:0.25;&:hover{border-color:", styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, ";background-color:", styles/* theme.colors.white */.rS.colors.white, ";color:", styles/* theme.colors.zinc_400 */.rS.colors.zinc_400, ";}}&:hover{width:fit-content;}" + ( true ? "" : 0));
var Desktop_index_styles_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1lfszju2"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);
var Dropdown = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e1lfszju1"
} : 0)("position:absolute;top:calc(100% + 8px);right:0;background-color:", styles/* theme.colors.white */.rS.colors.white, ";border:1px solid ", styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, ";border-radius:12px;padding:8px;min-width:160px;max-height:320px;overflow-y:auto;box-shadow:0 4px 16px rgba(0, 0, 0, 0.12);z-index:", constants/* VIEWER_Z_INDEX.desktopLayer */.G.desktopLayer, ";" + ( true ? "" : 0));
var LanguageItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e1lfszju0"
} : 0)("width:100%;padding:8px 12px;border:none;border-radius:8px;background-color:", function (_ref) {
  var isActive = _ref.isActive;
  return isActive ? styles/* theme.colors.zinc_100 */.rS.colors.zinc_100 : 'transparent';
}, ";color:", function (_ref2) {
  var isActive = _ref2.isActive;
  return isActive ? styles/* theme.colors.zinc_900 */.rS.colors.zinc_900 : styles/* theme.colors.zinc_600 */.rS.colors.zinc_600;
}, ";font-size:14px;font-weight:", function (_ref3) {
  var isActive = _ref3.isActive;
  return isActive ? 600 : 400;
}, ";cursor:pointer;text-align:left;white-space:nowrap;transition:background-color 0.1s ease-in-out;&:hover{background-color:", styles/* theme.colors.zinc_100 */.rS.colors.zinc_100, ";color:", styles/* theme.colors.zinc_900 */.rS.colors.zinc_900, ";}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/DefaultViewerLayer/LanguageButton/Desktop/index.tsx









var LOCALE_NAMES = {
  ko: '한국어',
  en: 'English',
  ja: '日本語',
  'zh-CN': '中文(简体)',
  'zh-TW': '中文(繁體)',
  'zh-HK': '中文(香港)',
  de: 'Deutsch',
  es: 'Español',
  fr: 'Français',
  pt: 'Português',
  ru: 'Русский',
  hi: 'हिन्दी',
  id: 'Indonesia',
  ms: 'Melayu',
  th: 'ภาษาไทย',
  tr: 'Türkçe',
  vi: 'Tiếng Việt'
};

var DesktopLanguageButton = function DesktopLanguageButton() {
  var _router$locales, _router$locale, _LOCALE_NAMES$current;

  var router = (0,next_router.useRouter)();
  var isDisableHelpers = (0,react/* useAtomValue */.Dv)(index_atom/* isDisableHelpersAtom */.Tn);

  var _useAtom = (0,react/* useAtom */.KO)(index_atom/* isLanguageDropdownOpenAtom */.ZL),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      isOpen = _useAtom2[0],
      setIsOpen = _useAtom2[1];

  var _useState = (0,node_modules_react.useState)(false),
      isHovering = _useState[0],
      setIsHovering = _useState[1];

  var wrapperRef = (0,node_modules_react.useRef)(null);
  var locales = (_router$locales = router.locales) !== null && _router$locales !== void 0 ? _router$locales : [];
  var currentLocale = (_router$locale = router.locale) !== null && _router$locale !== void 0 ? _router$locale : 'ko';
  (0,node_modules_react.useEffect)(function () {
    var handleClickOutside = function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      return document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  (0,node_modules_react.useEffect)(function () {
    if (isDisableHelpers) {
      setIsOpen(false);
    }
  }, [isDisableHelpers]);

  var handleButtonClick = function handleButtonClick(e) {
    e.stopPropagation();

    if (isDisableHelpers) {
      return;
    }

    setIsOpen(function (prev) {
      return !prev;
    });
  };

  var handleLocaleSelect = function handleLocaleSelect(e, locale) {
    e.stopPropagation();
    var basePath = router.asPath;
    var newPath = locale === router.defaultLocale ? basePath : "/".concat(locale).concat(basePath);
    window.location.href = newPath;
    setIsOpen(false);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Desktop_index_styles_Wrapper, {
    ref: wrapperRef,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LanguageButton_Desktop_index_styles_Button, {
      className: isDisableHelpers ? 'disable' : '',
      variant: "zinc_500",
      textVariant: "xl-medium",
      radius: 9999,
      paddingY: 16,
      onClick: handleButtonClick,
      onMouseOver: function onMouseOver() {
        return setIsHovering(true);
      },
      onMouseOut: function onMouseOut() {
        return setIsHovering(false);
      },
      leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
        icon: "ph:globe",
        size: 19,
        color: "black"
      }),
      children: isHovering && !isOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "lg-medium",
        marginLeft: 8,
        style: {
          whiteSpace: 'nowrap'
        },
        children: (_LOCALE_NAMES$current = LOCALE_NAMES[currentLocale]) !== null && _LOCALE_NAMES$current !== void 0 ? _LOCALE_NAMES$current : currentLocale
      })
    }), isOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown, {
      direction: "column",
      gap: 2,
      children: locales.map(function (locale) {
        var _LOCALE_NAMES$locale;

        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LanguageItem, {
          isActive: locale === currentLocale,
          onClick: function onClick(e) {
            return handleLocaleSelect(e, locale);
          },
          children: (_LOCALE_NAMES$locale = LOCALE_NAMES[locale]) !== null && _LOCALE_NAMES$locale !== void 0 ? _LOCALE_NAMES$locale : locale
        }, locale);
      })
    })]
  });
};

/* harmony default export */ var LanguageButton_Desktop = (DesktopLanguageButton);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/DefaultViewerLayer/Desktop/index.styles.ts



var StackTopRightWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e5fiokz0"
} : 0)("position:fixed;z-index:", constants/* VIEWER_Z_INDEX.desktopLayer */.G.desktopLayer, ";right:", function (_ref) {
  var rightOffset = _ref.rightOffset;
  return rightOffset !== null && rightOffset !== void 0 ? rightOffset : 0;
}, "px;display:flex;width:auto;padding:32px 48px;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/DefaultViewerLayer/Desktop/index.tsx








var Desktop_DesktopViewerLayer = function DesktopViewerLayer(_ref) {
  var translateKoToEn = _ref.translateKoToEn,
      fileName = _ref.fileName,
      domain = _ref.domain,
      isBulk = _ref.isBulk,
      isDownloadEnabled = _ref.isDownloadEnabled,
      ctaFormPage = _ref.ctaFormPage,
      isRedirectCtaFormAppropriate = _ref.isRedirectCtaFormAppropriate,
      isShareable = _ref.isShareable,
      rightOffset = _ref.rightOffset,
      _ref$isZoomEnabled = _ref.isZoomEnabled,
      isZoomEnabled = _ref$isZoomEnabled === void 0 ? true : _ref$isZoomEnabled;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StackTopRightWrapper, {
    gap: 16,
    rightOffset: rightOffset,
    children: [isZoomEnabled && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ZoomButton_Desktop, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LanguageButton_Desktop, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PdfDownloadButton_Desktop, {
      translateKoToEn: translateKoToEn,
      fileName: fileName,
      isDownloadEnabled: isDownloadEnabled,
      ctaFormPage: ctaFormPage,
      isRedirectCtaFormAppropriate: isRedirectCtaFormAppropriate,
      isBulk: isBulk
    }), isShareable && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShareButton_Desktop, {
      translateKoToEn: translateKoToEn,
      domain: domain,
      isBulk: isBulk
    })]
  });
};

/* harmony default export */ var DefaultViewerLayer_Desktop = (Desktop_DesktopViewerLayer);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/MobilePageChangeEffectLayer/LeftMoveEffect/index.styles.ts


function LeftMoveEffect_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var LeftMoveEffect_index_styles_Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e13dg57a0"
} : 0)( true ? {
  name: "12obqcl",
  styles: "width:60px;height:120px;background-color:rgb(79 88 96 / 25%);border-radius:0 9999px 9999px 0;opacity:0;transition:all 0.15s ease-in-out;visibility:hidden;&.is-active{opacity:1;visibility:visible;}"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/MobilePageChangeEffectLayer/LeftMoveEffect/index.tsx






var LeftMoveEffect_LeftMoveEffect = function LeftMoveEffect() {
  var isLeftClick = useAtomValue(isLeftClickAtom);
  return _jsx(Styled.Container, {
    justifyContent: "center",
    alignItems: "center",
    className: isLeftClick ? 'is-active' : undefined,
    children: _jsx(Icon, {
      icon: "ph:caret-left",
      size: 44,
      color: "white"
    })
  });
};

/* harmony default export */ var MobilePageChangeEffectLayer_LeftMoveEffect = ((/* unused pure expression or super */ null && (LeftMoveEffect_LeftMoveEffect)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/MobilePageChangeEffectLayer/RightMoveEffect/index.styles.ts


function RightMoveEffect_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var RightMoveEffect_index_styles_Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e1xhub6y0"
} : 0)( true ? {
  name: "1bnkxkr",
  styles: "width:60px;height:120px;background-color:rgb(79 88 96 / 25%);border-radius:9999px 0 0 9999px;opacity:0;transition:all 0.15s ease-in-out;visibility:hidden;&.is-active{opacity:1;visibility:visible;}"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/MobilePageChangeEffectLayer/RightMoveEffect/index.tsx






var RightMoveEffect_RightMoveEffect = function RightMoveEffect() {
  var isRightClick = useAtomValue(isRightClickAtom);
  return _jsx(Styled.Container, {
    justifyContent: "center",
    alignItems: "center",
    className: isRightClick ? 'is-active' : undefined,
    children: _jsx(Icon, {
      icon: "ph:caret-right",
      size: 44,
      color: "white"
    })
  });
};

/* harmony default export */ var MobilePageChangeEffectLayer_RightMoveEffect = ((/* unused pure expression or super */ null && (RightMoveEffect_RightMoveEffect)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/MobilePageChangeEffectLayer/index.styles.ts


function MobilePageChangeEffectLayer_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var FlexPageMoveButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "eww5skb0"
} : 0)( true ? {
  name: "1445c9p",
  styles: "position:static;height:100%"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/MobilePageChangeEffectLayer/index.tsx






var MobilePageChangeEffectLayer_MobilePageChangeEffectLayer = function MobilePageChangeEffectLayer() {
  return _jsxs(Styled.FlexPageMoveButtonWrapper, {
    alignItems: "center",
    justifyContent: "space-between",
    children: [_jsx(LeftMoveEffect, {}), _jsx(RightMoveEffect, {})]
  });
};

/* harmony default export */ var Layer_MobilePageChangeEffectLayer = ((/* unused pure expression or super */ null && (MobilePageChangeEffectLayer_MobilePageChangeEffectLayer)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationButton/Mobile/index.styles.ts




var index_styles_PageNavigationButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e15dpjns0"
} : 0)("position:fixed;z-index:", constants/* VIEWER_Z_INDEX.mobileLayer */.G.mobileLayer, ";bottom:16px;left:50%;width:auto;height:auto;border:1px solid ", styles/* theme.colors.zinc_500 */.rS.colors.zinc_500, ";backdrop-filter:blur(8px);background-color:rgb(255 255 255 / 50%);border-radius:9999px;transform:translate(-50%, 0);transition:opacity 0.15s ease-in-out;&.disabled{cursor:initial;opacity:0;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationButton/Mobile/MobilePageMoveButton/index.styles.ts



var index_styles_ArrowButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "exebzir0"
} : 0)("z-index:", constants/* VIEWER_Z_INDEX.mobileLayer */.G.mobileLayer, ";width:auto;height:auto;&.disable{cursor:initial;opacity:0.25;}transition:opacity 0.15s ease-in-out;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationButton/Mobile/MobilePageMoveButton/index.tsx









var MobilePageMoveButton_MobilePageMoveButton = function MobilePageMoveButton(_ref) {
  var variant = _ref.variant,
      totalPage = _ref.totalPage,
      isNextPageButtonDisabled = _ref.isNextPageButtonDisabled,
      updatePrevThumbnails = _ref.updatePrevThumbnails,
      updateNextThumbnails = _ref.updateNextThumbnails;

  var _useAtom = useAtom(isDisableHelpersAtom),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      isDisableHelpers = _useAtom2[0],
      setIsDisableHelpers = _useAtom2[1];

  var _useUpdateViewerPageS = useUpdateViewerPageState(),
      updateCurrentPage = _useUpdateViewerPageS.updateCurrentPage,
      currentPage = _useUpdateViewerPageS.currentPage;

  var handleClickPrevButton = function handleClickPrevButton(e) {
    e.stopPropagation();

    if (isDisableHelpers) {
      setIsDisableHelpers(false);
      return;
    }

    if (currentPage === 1) {
      return;
    }

    updatePrevThumbnails === null || updatePrevThumbnails === void 0 ? void 0 : updatePrevThumbnails(currentPage - 1);
    updateCurrentPage(currentPage - 1);
  };

  var handleClickNextButton = function handleClickNextButton(e) {
    e.stopPropagation();

    if (isDisableHelpers) {
      setIsDisableHelpers(false);
      return;
    }

    if (currentPage === totalPage) {
      return;
    }

    if (isNextPageButtonDisabled) {
      return;
    }

    updateNextThumbnails === null || updateNextThumbnails === void 0 ? void 0 : updateNextThumbnails(currentPage + 1);
    updateCurrentPage(currentPage + 1);
  };

  var getIsDisable = function getIsDisable() {
    if (variant === 'prev' && currentPage === 1) {
      return 'disable';
    }

    if (variant === 'next' && currentPage === totalPage || isNextPageButtonDisabled) {
      return 'disable';
    }

    return '';
  };

  return _jsx(Styled.ArrowButton, {
    className: [getIsDisable(), variant].join(' '),
    onClick: variant === 'prev' ? handleClickPrevButton : handleClickNextButton,
    paddingX: 8,
    children: _jsx(Icon, {
      icon: "ph:caret-".concat(variant === 'next' ? 'right' : 'left'),
      size: 19,
      color: "black"
    })
  });
};

/* harmony default export */ var Mobile_MobilePageMoveButton = ((/* unused pure expression or super */ null && (MobilePageMoveButton_MobilePageMoveButton)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationButton/Mobile/MobilePageIndicator/index.styles.ts




var index_styles_StackWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e1n0o5td2"
} : 0)("z-index:", constants/* VIEWER_Z_INDEX.mobileLayer */.G.mobileLayer, ";width:auto;height:43px;flex:0 0 0px;background-color:", function (_ref) {
  var isMobileLandscape = _ref.isMobileLandscape;
  return isMobileLandscape ? 'transparent' : '';
}, ";opacity:1;transition:opacity 0.15s ease-in-out;" + ( true ? "" : 0));
var index_styles_FlexCurrentPageTextWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e1n0o5td1"
} : 0)("width:auto;min-width:32px;height:23px;padding:4px;background:", styles/* theme.colors.zinc_100 */.rS.colors.zinc_100, ";border-radius:4px;color:", styles/* theme.colors.black */.rS.colors.black, ";" + ( true ? "" : 0));
var index_styles_Input = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("input",  true ? {
  target: "e1n0o5td0"
} : 0)("width:32px;height:23px;padding:4px;appearance:textfield;background:", styles/* theme.colors.zinc_100 */.rS.colors.zinc_100, ";border-radius:4px;color:", styles/* theme.colors.black */.rS.colors.black, ";font-size:12px;font-weight:500;line-height:15px;outline:none;text-align:center;&::-webkit-outer-spin-button,&::-webkit-inner-spin-button{margin:0;appearance:none;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationButton/Mobile/MobilePageIndicator/index.tsx



function MobilePageIndicator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MobilePageIndicator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MobilePageIndicator_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MobilePageIndicator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var MobilePageIndicator = function MobilePageIndicator(_ref) {
  var totalPage = _ref.totalPage,
      ctaFormPage = _ref.ctaFormPage,
      openDrawer = _ref.openDrawer,
      isMoveCtaFormPageRequirements = _ref.isMoveCtaFormPageRequirements,
      isMobileLandscape = _ref.isMobileLandscape;

  var _useAtom = useAtom(isDisableHelpersAtom),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      isDisableHelpers = _useAtom2[0],
      setIsDisableHelpers = _useAtom2[1];

  var _useUpdateViewerPageS = useUpdateViewerPageState(),
      updateCurrentPage = _useUpdateViewerPageS.updateCurrentPage,
      currentPage = _useUpdateViewerPageS.currentPage;

  var _useState = useState(false),
      isEditable = _useState[0],
      setIsEditable = _useState[1];

  var _useForm = useForm(),
      handleSubmit = _useForm.handleSubmit,
      register = _useForm.register,
      setFocus = _useForm.setFocus,
      setValue = _useForm.setValue,
      getValues = _useForm.getValues;

  useEffect(function () {
    if (!isEditable) {
      setValue('currentPage', currentPage);
    }
  }, [currentPage, isEditable, setValue]);

  var changeCurrentPage = function changeCurrentPage() {
    var value = getValues('currentPage');
    /*유저가 폼을 제출하지 않은 채 다른 페이지로 이동하려고 할 때 
    폼이 있는 페이지로 이동 시킨다 */

    if (totalPage && value >= 1 && value <= totalPage) {
      if (ctaFormPage && isMoveCtaFormPageRequirements && Number(value) >= ctaFormPage) {
        updateCurrentPage(ctaFormPage);
      } else {
        updateCurrentPage(Number(value));
      }
    }

    setIsEditable(false);
  };

  var onSubmit = function onSubmit() {
    changeCurrentPage();
  };

  useEffect(function () {
    setIsEditable(false);
  }, [isDisableHelpers, setIsEditable]);
  useEffect(function () {
    if (isDisableHelpers) {
      changeCurrentPage();
    }
  }, [isDisableHelpers]);
  useEffect(function () {
    if (isEditable) {
      setFocus('currentPage');
    }
  }, [isEditable, setFocus]);
  return _jsxs(Styled.StackWrapper, {
    className: isDisableHelpers ? 'disable' : '',
    alignItems: "center",
    gap: 8,
    isMobileLandscape: isMobileLandscape,
    children: [_jsx(Icon, {
      icon: "ph:list-dashes",
      size: 19,
      onClick: function onClick(e) {
        e.stopPropagation();

        if (isDisableHelpers) {
          setIsDisableHelpers(false);
          return;
        }

        openDrawer();
      },
      color: "black"
    }), isEditable ? _jsx("form", {
      onSubmit: handleSubmit(onSubmit),
      children: _jsx(Styled.Input, MobilePageIndicator_objectSpread({
        type: "number"
      }, register('currentPage', {
        value: currentPage
      })))
    }) : _jsx(Styled.FlexCurrentPageTextWrapper, {
      alignContent: "center",
      justifyContent: "center",
      onClick: function onClick(e) {
        e.stopPropagation();
        setIsDisableHelpers(false);
        setIsEditable(true);
      },
      children: _jsx(Text, {
        variant: "sm-medium",
        color: "black",
        lineHeight: "15px",
        children: currentPage
      })
    })]
  });
};

/* harmony default export */ var Mobile_MobilePageIndicator = ((/* unused pure expression or super */ null && (MobilePageIndicator)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationButton/Mobile/index.tsx











var Mobile_MobilePageNavigationButton = function MobilePageNavigationButton(_ref) {
  var updatePrevThumbnails = _ref.updatePrevThumbnails,
      updateNextThumbnails = _ref.updateNextThumbnails,
      openDrawer = _ref.openDrawer,
      totalPage = _ref.totalPage,
      ctaFormPage = _ref.ctaFormPage,
      isMoveCtaFormPageRequirements = _ref.isMoveCtaFormPageRequirements,
      isNextPageButtonDisabled = _ref.isNextPageButtonDisabled,
      isMobileLandscape = _ref.isMobileLandscape;

  var _useAtom = useAtom(isDisableHelpersAtom),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      isDisableHelpers = _useAtom2[0],
      setIsDisableHelpers = _useAtom2[1];

  return _jsx(KeyPressLayer, {
    updateNextThumbnails: updateNextThumbnails,
    updatePrevThumbnails: updatePrevThumbnails,
    totalPage: totalPage,
    isNextPageButtonDisabled: isNextPageButtonDisabled,
    children: _jsxs(Styled.PageNavigationButton, {
      className: cn({
        disabled: isDisableHelpers
      }),
      onClick: function onClick() {
        if (isDisableHelpers) {
          setIsDisableHelpers(false);
          return;
        }
      },
      children: [_jsx(MobilePageMoveButton, {
        variant: "prev",
        totalPage: totalPage,
        updatePrevThumbnails: updatePrevThumbnails
      }), _jsx(MobliePageIndicator, {
        totalPage: totalPage,
        openDrawer: openDrawer,
        ctaFormPage: ctaFormPage,
        isMoveCtaFormPageRequirements: isMoveCtaFormPageRequirements,
        isMobileLandscape: isMobileLandscape
      }), _jsx(MobilePageMoveButton, {
        variant: "next",
        totalPage: totalPage,
        isNextPageButtonDisabled: isNextPageButtonDisabled,
        updateNextThumbnails: updateNextThumbnails
      })]
    })
  });
};

/* harmony default export */ var Mobile = ((/* unused pure expression or super */ null && (Mobile_MobilePageNavigationButton)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Intro/Mobile/index.styles.ts



var Mobile_index_styles_templateObject;

function Mobile_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var index_styles_FlexWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "eth9unr3"
} : 0)("position:absolute;z-index:", constants/* VIEWER_Z_INDEX.previewLayer */.G.previewLayer, ";width:100vw;height:100vh;background:rgb(79 88 96 / 50%);" + ( true ? "" : 0));
var Mobile_index_styles_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eth9unr2"
} : 0)( true ? {
  name: "qekg0t",
  styles: "position:absolute;display:flex;flex-direction:column;gap:8px"
} : 0);
var slide = (0,emotion_react_browser_esm/* keyframes */.F4)(Mobile_index_styles_templateObject || (Mobile_index_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  0% {left: 0;}\n  50% {left: calc(100% - 50px)}\n  100% {left:0}\n"])));
var HandAnimation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eth9unr1"
} : 0)("position:absolute;top:100%;width:50px;height:50px;animation:", slide, " 1.5s ease-in-out infinite;" + ( true ? "" : 0));
var DescriptionWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eth9unr0"
} : 0)( true ? {
  name: "hs125",
  styles: "padding-top:250px"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Intro/Mobile/index.tsx







var Mobile_MobileIntro = function MobileIntro(_ref) {
  var translateKoToEn = _ref.translateKoToEn;

  var _useGetFirstVisit = hooks_useGetFirstVisit(),
      _useGetFirstVisit2 = (0,slicedToArray/* default */.Z)(_useGetFirstVisit, 2),
      isPdfViewerFirstVisit = _useGetFirstVisit2[0],
      setIsPdfViewerFirstVisit = _useGetFirstVisit2[1];

  var handleUserVisit = function handleUserVisit() {
    setIsPdfViewerFirstVisit(false);
  };

  if (!isPdfViewerFirstVisit) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_styles_FlexWrapper, {
    alignItems: "center",
    justifyContent: "center",
    onClick: handleUserVisit,
    onTouchStart: handleUserVisit,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Mobile_index_styles_Wrapper, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
        variant: "2xl-semibold",
        color: "white",
        children: [translateKoToEn('initMessage-mobile-first'), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), translateKoToEn('initMessage-mobile-second')]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HandAnimation, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:hand-pointing",
          size: 48,
          color: "white"
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "md-semibold",
        color: "white",
        children: translateKoToEn('initMessage-mobile-third')
      })
    })]
  });
};

/* harmony default export */ var Intro_Mobile = (Mobile_MobileIntro);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/useSwipe.ts





var useSwipe = function useSwipe(_ref) {
  var totalPage = _ref.totalPage,
      isNextSwipeDisabled = _ref.isNextSwipeDisabled,
      updateNextThumbnails = _ref.updateNextThumbnails,
      updatePrevThumbnails = _ref.updatePrevThumbnails;
  var zoomLevel = (0,react/* useAtomValue */.Dv)(index_atom/* zoomLevelAtom */.nO);

  var _useUpdateViewerPageS = hooks_useUpdateViewerPageState(),
      updateCurrentPage = _useUpdateViewerPageS.updateCurrentPage,
      currentPage = _useUpdateViewerPageS.currentPage;

  var setIsLeftClick = (0,react/* useSetAtom */.b9)(index_atom/* isLeftClickAtom */.nD);
  var setIsRightClick = (0,react/* useSetAtom */.b9)(index_atom/* isRightClickAtom */.oj);
  var isCtaModalOpen = (0,react/* useAtomValue */.Dv)(index_atom/* isCtaModalOpenAtom */.D5);
  var touchStartRef = (0,node_modules_react.useRef)(0);

  var _useState = (0,node_modules_react.useState)(null),
      value = _useState[0],
      setValue = _useState[1];

  var handleTouchStart = function handleTouchStart(event) {
    touchStartRef.current = event.touches[0].clientX;
  };

  var handleTouchMove = function handleTouchMove(event) {
    var touchEnd = event.touches[0].clientX;
    var touchDiff = touchEnd - touchStartRef.current;

    if (isCtaModalOpen) {
      return;
    }

    if (zoomLevel > 1) {
      return;
    }

    if (touchDiff > 10) {
      setValue('prev');
    } else if (touchDiff < -10) {
      setValue('next');
    }
  };

  var handleTouchEnd = function handleTouchEnd() {
    if (!value) {
      return;
    }

    if (isCtaModalOpen) {
      return;
    }

    if (value === 'next') {
      setValue(null);

      if (currentPage === totalPage || isNextSwipeDisabled) {
        return;
      }

      setIsRightClick(true);
      setTimeout(function () {
        return setIsRightClick(false);
      }, 500);
      updateCurrentPage(currentPage + 1);
      updateNextThumbnails === null || updateNextThumbnails === void 0 ? void 0 : updateNextThumbnails(currentPage + 1);
    } else if (value === 'prev') {
      setValue(null);

      if (currentPage === 1) {
        return;
      }

      setIsLeftClick(true);
      setTimeout(function () {
        return setIsLeftClick(false);
      }, 500);
      updateCurrentPage(currentPage - 1);
      updatePrevThumbnails === null || updatePrevThumbnails === void 0 ? void 0 : updatePrevThumbnails(currentPage - 1);
    }
  };

  return {
    handleTouchStart: handleTouchStart,
    handleTouchMove: handleTouchMove,
    handleTouchEnd: handleTouchEnd
  };
};

/* harmony default export */ var hooks_useSwipe = (useSwipe);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageWrapper/Mobile/index.styles.ts


function PageWrapper_Mobile_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var PageWrapper_Mobile_index_styles_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "emidu1r0"
} : 0)( true ? {
  name: "l4xhyg",
  styles: "position:relative;display:flex;width:100%;height:100%;align-items:center;justify-content:flex-end;overflow-x:hidden;overflow-y:auto"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageWrapper/Mobile/index.tsx








var Mobile_MobilePageWrapper = function MobilePageWrapper(_ref) {
  var totalPage = _ref.totalPage,
      isNextPageButtonDisabled = _ref.isNextPageButtonDisabled,
      updateNextThumbnails = _ref.updateNextThumbnails,
      updatePrevThumbnails = _ref.updatePrevThumbnails,
      children = _ref.children;
  var setPageWrapperSize = (0,react/* useSetAtom */.b9)(index_atom/* pageWrapperSizeAtom */.p5);
  var wrapperRef = node_modules_react.useRef(null);
  (0,dist_module/* default */.Z)(wrapperRef, function (_ref2) {
    var _ref2$contentRect = _ref2.contentRect,
        width = _ref2$contentRect.width,
        height = _ref2$contentRect.height;
    return setPageWrapperSize({
      width: width,
      height: height
    });
  });

  var _useSwipe = hooks_useSwipe({
    totalPage: totalPage,
    isNextSwipeDisabled: isNextPageButtonDisabled,
    updateNextThumbnails: updateNextThumbnails,
    updatePrevThumbnails: updatePrevThumbnails
  }),
      handleTouchEnd = _useSwipe.handleTouchEnd,
      handleTouchMove = _useSwipe.handleTouchMove,
      handleTouchStart = _useSwipe.handleTouchStart;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageWrapper_Mobile_index_styles_Wrapper, {
    ref: wrapperRef,
    onTouchStart: handleTouchStart,
    onTouchMove: handleTouchMove,
    onTouchEnd: handleTouchEnd,
    onContextMenu: function onContextMenu(e) {
      return e.preventDefault();
    },
    onDragStart: function onDragStart(e) {
      return e.preventDefault();
    },
    children: children
  });
};

/* harmony default export */ var PageWrapper_Mobile = (Mobile_MobilePageWrapper);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationDrawer/Mobile/CloseButton/index.styles.ts


var CloseWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "euoplr40"
} : 0)("position:fixed;z-index:", constants/* VIEWER_Z_INDEX.mobileCloseButton */.G.mobileCloseButton, ";bottom:16px;left:50%;transform:translate(-50%, 0);" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationDrawer/Mobile/CloseButton/index.tsx




var CloseButton_CloseButton = function CloseButton(_ref) {
  var setIsMobileDrawerOpen = _ref.setIsMobileDrawerOpen,
      translateKoToEn = _ref.translateKoToEn;
  return _jsx(Styled.CloseWrapper, {
    children: _jsx(Button, {
      radius: 9999,
      paddingX: 12,
      paddingY: 12,
      textVariant: "sm-semibold",
      color: "black",
      variant: "zinc_500",
      rightIcon: _jsx(Icon, {
        icon: "ph:caret-down",
        size: 19,
        color: "black"
      }),
      onClick: function onClick(e) {
        e.stopPropagation();
        setIsMobileDrawerOpen(false);
      },
      children: translateKoToEn('mobile-pageList-close')
    })
  });
};

/* harmony default export */ var Mobile_CloseButton = ((/* unused pure expression or super */ null && (CloseButton_CloseButton)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationDrawer/Mobile/Portrait/index.styles.ts



var Portrait_index_styles_templateObject, Portrait_index_styles_templateObject2;

function Portrait_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var index_styles_fadeIn = (0,emotion_react_browser_esm/* keyframes */.F4)(Portrait_index_styles_templateObject || (Portrait_index_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"])));
var index_styles_fadeOut = (0,emotion_react_browser_esm/* keyframes */.F4)(Portrait_index_styles_templateObject2 || (Portrait_index_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n"])));
var Portrait_index_styles_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dxc7707"
} : 0)("position:fixed;width:100%;height:100%;flex:0 0 auto;margin-top:auto;opacity:0;overflow-x:hidden;overflow-y:scroll;&.visible{z-index:", constants/* VIEWER_Z_INDEX.mobileDrawer */.G.mobileDrawer, ";animation:", index_styles_fadeIn, " 0.3s ease-in-out;animation-fill-mode:forwards;animation-play-state:running;}&.hidden{display:none;animation:", index_styles_fadeOut, " 0.3s ease-in-out;animation-fill-mode:forwards;animation-play-state:running;}&::-webkit-scrollbar{display:none;}" + ( true ? "" : 0));
var index_styles_StackPageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e1dxc7706"
} : 0)( true ? {
  name: "wq4neo",
  styles: "width:auto;height:auto;padding:32px 0;overflow-x:scroll;overflow-y:scroll"
} : 0);
var index_styles_Page = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "e1dxc7705"
} : 0)( true ? {
  name: "1m64fji",
  styles: "display:flex;width:288px;flex-direction:column;align-items:flex-start;gap:24px;transition:opacity 0.15s ease-in-out;&.current-page{opacity:1;}&:hover{opacity:1;}"
} : 0);
var index_styles_PageInnerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dxc7704"
} : 0)("position:relative;width:288px;padding:16px;border:1px solid ", styles/* theme.colors.zinc_400 */.rS.colors.zinc_400, "!important;background:", styles/* theme.colors.white */.rS.colors.white, ";border-radius:8px;cursor:pointer;&.current-page{border:1px solid ", styles/* theme.colors.skyblue_500 */.rS.colors.skyblue_500, "!important;background:", styles/* theme.colors.skyblue_50 */.rS.colors.skyblue_50, ";}&>span{position:unset!important;img{position:relative!important;height:auto!important;}}" + ( true ? "" : 0));
var index_styles_ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dxc7703"
} : 0)( true ? {
  name: "o8a8jf",
  styles: "position:fixed;bottom:0;width:100%"
} : 0);
var index_styles_BlindImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)((image_default()),  true ? {
  target: "e1dxc7702"
} : 0)("border:1px solid ", styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, "!important;border-radius:8px;&.is-blind{filter:blur(8px);}" + ( true ? "" : 0));
var index_styles_BlindPictureImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(_common_PdfThumbImage,  true ? {
  target: "e1dxc7701"
} : 0)("border:1px solid ", styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, "!important;border-radius:8px;&.is-blind{filter:blur(8px);}" + ( true ? "" : 0));
var Dimmer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dxc7700"
} : 0)("position:absolute;z-index:", constants/* VIEWER_Z_INDEX.mobileDrawerDimmer */.G.mobileDrawerDimmer, ";top:0;left:0;width:100%;height:100%;backdrop-filter:blur(0.5rem);" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationDrawer/Mobile/Portrait/index.tsx













var MobilePagePortraitNavigation = function MobilePagePortraitNavigation(_ref) {
  var isMobileDrawerOpen = _ref.isMobileDrawerOpen,
      setIsMobileDrawerOpen = _ref.setIsMobileDrawerOpen,
      pages = _ref.pages,
      translateKoToEn = _ref.translateKoToEn,
      blindPages = _ref.blindPages;
  var wrapperRef = useRef(null);

  var _useUpdateViewerPageS = useUpdateViewerPageState(),
      updateCurrentPage = _useUpdateViewerPageS.updateCurrentPage,
      currentPage = _useUpdateViewerPageS.currentPage;

  useIsomorphicLayoutEffect(function () {
    if (!wrapperRef.current) {
      return;
    }

    var currentPageElement = document.querySelector("[data-current-page=\"true\"]");

    if (!(currentPageElement instanceof HTMLLIElement)) {
      return;
    }

    wrapperRef.current.scrollTo({
      left: currentPageElement.offsetLeft
    });
  }, [wrapperRef.current, currentPage]);
  var isFirstPageImageLoaded = useAtomValue(isFirstPageImageLoadedAtom);

  if (!isFirstPageImageLoaded) {
    return null;
  }

  return _jsxs(_Fragment, {
    children: [_jsx(Styled.Wrapper, {
      ref: wrapperRef,
      className: isMobileDrawerOpen ? 'visible' : 'hidden',
      onContextMenu: function onContextMenu(e) {
        return e.preventDefault();
      },
      onDragStart: function onDragStart(e) {
        return e.preventDefault();
      },
      children: _jsxs(Styled.StackPageWrapper, {
        as: "ul",
        gap: 16,
        direction: "column",
        alignItems: "center",
        children: [pages === null || pages === void 0 ? void 0 : pages.map(function (_ref2) {
          var page = _ref2.page,
              thumnail = _ref2.thumnail,
              imageSources = _ref2.imageSources;
          var isCurrentPage = currentPage === page;
          return _jsx(Styled.Page, {
            className: isCurrentPage ? 'current-page' : '',
            "data-current-page": isCurrentPage,
            onClick: function onClick() {
              /* NOTE: 첫 Blind Page는 Drawer로 이동이 가능하도록 */
              if ((blindPages === null || blindPages === void 0 ? void 0 : blindPages[0]) !== page && blindPages !== null && blindPages !== void 0 && blindPages.includes(page)) {
                return;
              }

              updateCurrentPage(page);
              setIsMobileDrawerOpen(false);
            },
            children: _jsxs(Styled.PageInnerWrapper, {
              className: isCurrentPage ? 'current-page' : '',
              children: [_jsxs(Text, {
                as: "p",
                variant: "md-medium",
                textAlign: "center",
                marginBottom: 8,
                color: isCurrentPage ? 'skyblue_500' : 'zinc_400',
                children: [page, " ", translateKoToEn('page')]
              }), imageSources ? _jsx(Styled.BlindPictureImage, {
                className: cn({
                  'is-blind': blindPages === null || blindPages === void 0 ? void 0 : blindPages.includes(page)
                }),
                alt: "".concat(page, "\uD398\uC774\uC9C0 \uC774\uBBF8\uC9C0"),
                thumb: imageSources.thumb
              }) : _jsx(Styled.BlindImage, {
                className: cn({
                  'is-blind': blindPages === null || blindPages === void 0 ? void 0 : blindPages.includes(page)
                }),
                alt: "".concat(page, "\uD398\uC774\uC9C0 \uC774\uBBF8\uC9C0"),
                src: thumnail,
                layout: "fill",
                sizes: "208px",
                quality: 50,
                draggable: false
              })]
            })
          }, page);
        }), _jsx(CloseButton, {
          setIsMobileDrawerOpen: setIsMobileDrawerOpen,
          translateKoToEn: translateKoToEn
        })]
      })
    }), isMobileDrawerOpen && _jsx(Styled.Dimmer, {})]
  });
};

/* harmony default export */ var Portrait = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(MobilePagePortraitNavigation))));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationDrawer/Mobile/Landscape/index.styles.ts



var Landscape_index_styles_templateObject, Landscape_index_styles_templateObject2;

function Landscape_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var Landscape_index_styles_fadeIn = (0,emotion_react_browser_esm/* keyframes */.F4)(Landscape_index_styles_templateObject || (Landscape_index_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"])));
var Landscape_index_styles_fadeOut = (0,emotion_react_browser_esm/* keyframes */.F4)(Landscape_index_styles_templateObject2 || (Landscape_index_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n"])));
var Landscape_index_styles_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "etimy408"
} : 0)("position:fixed;width:100%;height:100%;flex:0 0 auto;margin-top:auto;opacity:0;overflow-x:scroll;overflow-y:hidden;&.visible{z-index:", constants/* VIEWER_Z_INDEX.mobileDrawer */.G.mobileDrawer, ";animation:", Landscape_index_styles_fadeIn, " 0.3s ease-in-out;animation-fill-mode:forwards;animation-play-state:running;}&.hidden{display:none;animation:", Landscape_index_styles_fadeOut, " 0.3s ease-in-out;animation-fill-mode:forwards;animation-play-state:running;}&::-webkit-scrollbar{display:none;}" + ( true ? "" : 0));
var InnerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "etimy407"
} : 0)( true ? {
  name: "13udsys",
  styles: "height:100%"
} : 0);
var Landscape_index_styles_StackPageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "etimy406"
} : 0)( true ? {
  name: "10j24tb",
  styles: "width:auto;height:100%;padding:0 16px"
} : 0);
var Landscape_index_styles_Page = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "etimy405"
} : 0)( true ? {
  name: "19e47zm",
  styles: "display:flex;min-width:312px;flex-direction:column;align-items:flex-start;gap:24px;transition:opacity 0.15s ease-in-out;&.current-page{opacity:1;}&:hover{opacity:1;}"
} : 0);
var Landscape_index_styles_PageInnerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "etimy404"
} : 0)("position:relative;overflow:hidden;min-width:312px;padding:16px;border:1px solid ", styles/* theme.colors.zinc_400 */.rS.colors.zinc_400, "!important;background:", styles/* theme.colors.white */.rS.colors.white, ";border-radius:8px;cursor:pointer;&.current-page{border:1px solid ", styles/* theme.colors.skyblue_500 */.rS.colors.skyblue_500, "!important;background:", styles/* theme.colors.skyblue_50 */.rS.colors.skyblue_50, ";}" + ( true ? "" : 0));
var Landscape_index_styles_ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "etimy403"
} : 0)( true ? {
  name: "o8a8jf",
  styles: "position:fixed;bottom:0;width:100%"
} : 0);
var Landscape_index_styles_BlindImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)((image_default()),  true ? {
  target: "etimy402"
} : 0)("border:1px solid ", styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, "!important;background-color:", styles/* theme.colors.zinc_100 */.rS.colors.zinc_100, ";border-radius:8px;&.is-blind{filter:blur(8px);}&.current-page{border:1px solid ", styles/* theme.colors.skyblue_300 */.rS.colors.skyblue_300, "!important;background-color:", styles/* theme.colors.skyblue_100 */.rS.colors.skyblue_100, ";}" + ( true ? "" : 0));
var Landscape_index_styles_BlindPictureImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(_common_PdfThumbImage,  true ? {
  target: "etimy401"
} : 0)("border:1px solid ", styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, "!important;background-color:", styles/* theme.colors.zinc_100 */.rS.colors.zinc_100, ";border-radius:8px;&.is-blind{filter:blur(8px);}&.current-page{border:1px solid ", styles/* theme.colors.skyblue_300 */.rS.colors.skyblue_300, "!important;background-color:", styles/* theme.colors.skyblue_100 */.rS.colors.skyblue_100, ";}" + ( true ? "" : 0));
var index_styles_Dimmer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "etimy400"
} : 0)("position:absolute;z-index:", constants/* VIEWER_Z_INDEX.mobileDrawerDimmer */.G.mobileDrawerDimmer, ";top:0;left:0;width:100%;height:100%;backdrop-filter:blur(0.5rem);" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationDrawer/Mobile/Landscape/index.tsx













var MobilePageLandscapeNavigation = function MobilePageLandscapeNavigation(_ref) {
  var isMobileDrawerOpen = _ref.isMobileDrawerOpen,
      setIsMobileDrawerOpen = _ref.setIsMobileDrawerOpen,
      pages = _ref.pages,
      translateKoToEn = _ref.translateKoToEn,
      blindPages = _ref.blindPages;
  var wrapperRef = useRef(null);

  var _useUpdateViewerPageS = useUpdateViewerPageState(),
      updateCurrentPage = _useUpdateViewerPageS.updateCurrentPage,
      currentPage = _useUpdateViewerPageS.currentPage;

  useIsomorphicLayoutEffect(function () {
    if (!wrapperRef.current) {
      return;
    }

    var currentPageElement = document.querySelector("[data-current-page=\"true\"]");

    if (!(currentPageElement instanceof HTMLLIElement)) {
      return;
    }

    wrapperRef.current.scrollTo({
      left: currentPageElement.offsetLeft
    });
  }, [wrapperRef.current, currentPage]);
  var isFirstPageImageLoaded = useAtomValue(isFirstPageImageLoadedAtom);

  if (!isFirstPageImageLoaded) {
    return null;
  }

  return _jsxs(_Fragment, {
    children: [_jsx(Styled.Wrapper, {
      ref: wrapperRef,
      className: isMobileDrawerOpen ? 'visible' : 'hidden',
      onContextMenu: function onContextMenu(e) {
        return e.preventDefault();
      },
      onDragStart: function onDragStart(e) {
        return e.preventDefault();
      },
      children: _jsxs(Styled.InnerWrapper, {
        direction: "column",
        gap: 32,
        children: [_jsx(Styled.StackPageWrapper, {
          as: "ul",
          gap: 16,
          alignItems: "center",
          children: pages === null || pages === void 0 ? void 0 : pages.map(function (_ref2) {
            var page = _ref2.page,
                thumnail = _ref2.thumnail,
                imageSources = _ref2.imageSources;
            var isCurrentPage = currentPage === page;
            return _jsx(Styled.Page, {
              className: isCurrentPage ? 'current-page' : '',
              "data-current-page": isCurrentPage,
              onClick: function onClick() {
                /* NOTE: 첫 Blind Page는 Drawer로 이동이 가능하도록 */
                if ((blindPages === null || blindPages === void 0 ? void 0 : blindPages[0]) !== page && blindPages !== null && blindPages !== void 0 && blindPages.includes(page)) {
                  return;
                }

                updateCurrentPage(page);
                setIsMobileDrawerOpen(false);
              },
              children: _jsxs(Styled.PageInnerWrapper, {
                className: isCurrentPage ? 'current-page' : '',
                children: [_jsxs(Text, {
                  as: "p",
                  variant: "md-medium",
                  textAlign: "center",
                  marginBottom: 8,
                  color: isCurrentPage ? 'skyblue_500' : 'zinc_400',
                  children: [page, " ", translateKoToEn('page')]
                }), imageSources ? _jsx(Styled.BlindPictureImage, {
                  className: cn({
                    'is-blind': blindPages === null || blindPages === void 0 ? void 0 : blindPages.includes(page),
                    'current-page': isCurrentPage
                  }),
                  alt: "".concat(page, "\uD398\uC774\uC9C0 \uC774\uBBF8\uC9C0"),
                  thumb: imageSources.thumb,
                  width: 280,
                  height: 160,
                  objectFit: "contain"
                }) : _jsx(Styled.BlindImage, {
                  className: cn({
                    'is-blind': blindPages === null || blindPages === void 0 ? void 0 : blindPages.includes(page),
                    'current-page': isCurrentPage
                  }),
                  alt: "".concat(page, "\uD398\uC774\uC9C0 \uC774\uBBF8\uC9C0"),
                  src: thumnail,
                  width: 280,
                  height: 160,
                  quality: 50,
                  objectFit: "contain",
                  draggable: false
                })]
              })
            }, page);
          })
        }), _jsx(CloseButton, {
          setIsMobileDrawerOpen: setIsMobileDrawerOpen,
          translateKoToEn: translateKoToEn
        })]
      })
    }), isMobileDrawerOpen && _jsx(Styled.Dimmer, {})]
  });
};

/* harmony default export */ var Landscape = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(MobilePageLandscapeNavigation))));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/PageNavigationDrawer/Mobile/index.tsx





var Mobile_MobilePageNavigation = function MobilePageNavigation(_ref) {
  var isMobileDrawerOpen = _ref.isMobileDrawerOpen,
      setIsMobileDrawerOpen = _ref.setIsMobileDrawerOpen,
      pages = _ref.pages,
      translateKoToEn = _ref.translateKoToEn,
      blindPages = _ref.blindPages,
      _ref$isMobileLandscap = _ref.isMobileLandscape,
      isMobileLandscape = _ref$isMobileLandscap === void 0 ? false : _ref$isMobileLandscap;
  return isMobileLandscape ? _jsx(MpbileLandScapeDrawer, {
    isMobileDrawerOpen: isMobileDrawerOpen,
    setIsMobileDrawerOpen: setIsMobileDrawerOpen,
    pages: pages,
    translateKoToEn: translateKoToEn,
    blindPages: blindPages
  }) : _jsx(MobilePortraitDrawer, {
    isMobileDrawerOpen: isMobileDrawerOpen,
    setIsMobileDrawerOpen: setIsMobileDrawerOpen,
    pages: pages,
    translateKoToEn: translateKoToEn,
    blindPages: blindPages
  });
};

/* harmony default export */ var PageNavigationDrawer_Mobile = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(Mobile_MobilePageNavigation))));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Viewer/Mobile/index.styles.ts


function Viewer_Mobile_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var index_styles_ImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1jx345m0"
} : 0)( true ? {
  name: "1lr91fv",
  styles: "&.visible{visibility:visible;}&.hidden{visibility:hidden;}&>span{overflow:scroll!important;}&.disabledScrollY{&>span{overflow-y:hidden!important;}}"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Viewer/Mobile/index.tsx











var Mobile_MobilePage = function MobilePage(_ref) {
  var thumnails = _ref.thumnails,
      isMobileLandscape = _ref.isMobileLandscape;
  var currentPage = useAtomValue(currentPageAtom);
  var zoomLevel = useAtomValue(zoomLevelAtom);
  /* 첫 번째 이미지가 렌더링 된 이후에, 이후의 페이지들을 렌더링한다 */

  var _useAtom = useAtom(isFirstPageImageLoadedAtom),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      isFirstPageImageLoaded = _useAtom2[0],
      setIsFirstPageImageLoaded = _useAtom2[1];

  var firstItem = thumnails === null || thumnails === void 0 ? void 0 : thumnails[0];
  return _jsx(_Fragment, {
    children: isFirstPageImageLoaded ? thumnails === null || thumnails === void 0 ? void 0 : thumnails.map(function (item, index) {
      return (item === null || item === void 0 ? void 0 : item.src) && _jsx(Styled.ImageWrapper, {
        className: cn({
          visible: currentPage === index + 1,
          hidden: currentPage !== index + 1,
          disabledScrollY: !isMobileLandscape
        }),
        onContextMenu: function onContextMenu(e) {
          return e.preventDefault();
        },
        children: item.imageSources ? _jsx(PdfPageImage, {
          viewer: item.imageSources.viewer,
          alt: "pdf".concat(currentPage, "page"),
          sizes: "100vw"
        }) : _jsx(Image, {
          src: item.src,
          alt: "pdf".concat(currentPage, "page"),
          layout: "fill",
          objectFit: "contain",
          priority: true,
          placeholder: "blur",
          blurDataURL: "data:image/svg+xml;base64,".concat(toBase64(item.src)),
          draggable: false,
          style: {
            userSelect: 'none'
          },
          sizes: "100vw"
        }, zoomLevel)
      }, item.src);
    }) : _jsx(Styled.ImageWrapper, {
      className: cn({
        visible: currentPage === 1,
        hidden: currentPage !== 1,
        disabledScrollY: !isMobileLandscape
      }),
      onContextMenu: function onContextMenu(e) {
        return e.preventDefault();
      },
      children: (firstItem === null || firstItem === void 0 ? void 0 : firstItem.src) && (firstItem.imageSources ? _jsx(PdfPageImage, {
        viewer: firstItem.imageSources.viewer,
        alt: "pdf".concat(currentPage, "page"),
        sizes: "100vw",
        onLoad: function onLoad() {
          setIsFirstPageImageLoaded(true);
        }
      }) : _jsx(Image, {
        src: firstItem.src,
        alt: "pdf".concat(currentPage, "page"),
        layout: "fill",
        objectFit: "contain",
        placeholder: "blur",
        blurDataURL: "data:image/svg+xml;base64,".concat(toBase64(firstItem.src)),
        priority: true,
        onLoadingComplete: function onLoadingComplete() {
          setIsFirstPageImageLoaded(true);
        },
        style: {
          userSelect: 'none'
        },
        sizes: "100vw"
      }, zoomLevel))
    })
  });
};

/* harmony default export */ var Viewer_Mobile = ((/* unused pure expression or super */ null && (Mobile_MobilePage)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/HyperLinkLayer/Mobile/index.styles.ts


function HyperLinkLayer_Mobile_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var index_styles_LinkWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1mzqqmu0"
} : 0)( true ? {
  name: "7rlxf3",
  styles: "position:absolute;display:block"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/HyperLinkLayer/Mobile/index.tsx








var Mobile_MobileHyperLinkLayer = function MobileHyperLinkLayer(_ref) {
  var hyperlinkList = _ref.hyperlinkList,
      resizedImageSize = _ref.resizedImageSize,
      isPreview = _ref.isPreview,
      getFormNotSubmitPage = _ref.getFormNotSubmitPage;

  var _useHandleHyperLinkCl = useHandleHyperLinkClick(),
      handleUserHyperLinkClick = _useHandleHyperLinkCl.handleUserHyperLinkClick;

  var _useUpdateViewerPageS = useUpdateViewerPageState(),
      updateCurrentPage = _useUpdateViewerPageS.updateCurrentPage;

  if (hyperlinkList.length === 0) {
    return null;
  }

  return _jsx(_Fragment, {
    children: hyperlinkList.map(function (_ref2) {
      var id = _ref2.id,
          rect_x1 = _ref2.rect_x1,
          rect_x2 = _ref2.rect_x2,
          rect_y1 = _ref2.rect_y1,
          rect_y2 = _ref2.rect_y2,
          type = _ref2.type,
          url = _ref2.url,
          pageNumber = _ref2.pageNumber;
      var bottom = rect_y1 * resizedImageSize.heightRatio + resizedImageSize.yMargin;
      var left = rect_x1 * resizedImageSize.widthRatio + resizedImageSize.xMargin;
      var width = rect_x2 * resizedImageSize.widthRatio - rect_x1 * resizedImageSize.widthRatio;
      var height = rect_y2 * resizedImageSize.heightRatio - rect_y1 * resizedImageSize.heightRatio;
      return _jsx(Styled.LinkWrapper, {
        id: GOOGLE_EVENT_ID.hyperLink,
        onClick: function onClick(e) {
          e.stopPropagation();
          e.preventDefault();

          if (!isPreview) {
            handleUserHyperLinkClick(id);
          }

          if (type === 'page' && pageNumber) {
            updateCurrentPage(pageNumber);

            if (getFormNotSubmitPage) {
              var notSubmitPage = getFormNotSubmitPage(Number(pageNumber));

              if (notSubmitPage !== null) {
                updateCurrentPage(notSubmitPage);
                return;
              }
            }

            updateCurrentPage(pageNumber);
            return;
          }

          if (!url) {
            return;
          }

          if (isDeviceLink(type, url)) {
            window.location.href = url;
            return;
          }

          if (window) {
            window.open(url, '_blank');
          }
        },
        style: {
          bottom: "".concat(bottom, "px"),
          left: "".concat(left, "px"),
          width: "".concat(width, "px"),
          height: "".concat(height, "px")
        }
      }, id);
    })
  });
};

/* harmony default export */ var HyperLinkLayer_Mobile = ((/* unused pure expression or super */ null && (Mobile_MobileHyperLinkLayer)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/OneOnOneAnnotationLayer/Mobile/index.tsx







var Mobile_MobileAnnotationLayer = function MobileAnnotationLayer(_ref) {
  var thumnail = _ref.thumnail,
      _ref$isPreview = _ref.isPreview,
      isPreview = _ref$isPreview === void 0 ? false : _ref$isPreview;
  var currentPage = useAtomValue(currentPageAtom);
  var _thumnail = thumnail[currentPage - 1],
      hyperlink = _thumnail.hyperlink,
      originalWidth = _thumnail.originalWidth,
      originalHeight = _thumnail.originalHeight;

  var _useHandleResizedImag = useHandleResizedImage({
    originalHeight: originalHeight,
    originalWidth: originalWidth
  }),
      resizedImageSize = _useHandleResizedImag.resizedImageSize;

  return _jsx(_Fragment, {
    children: _jsx(MobileHyperLinkLayer, {
      hyperlinkList: hyperlink,
      resizedImageSize: resizedImageSize,
      isPreview: isPreview
    })
  });
};

/* harmony default export */ var OneOnOneAnnotationLayer_Mobile = ((/* unused pure expression or super */ null && (Mobile_MobileAnnotationLayer)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/PdfPreview/Mobile/index.tsx















var MobilePdfPreview = function MobilePdfPreview(_ref) {
  var translateKoToEn = _ref.translateKoToEn,
      file = _ref.file;
  var currentPage = useAtomValue(currentPageAtom);

  var _useState = useState(false),
      isMobileDrawerOpen = _useState[0],
      setIsMobileDrawerOpen = _useState[1];

  var thumnail = file.thumnail,
      pages = file.pages;
  var isNextPageButtonDisabled = currentPage >= (thumnail === null || thumnail === void 0 ? void 0 : thumnail.length);
  /** NOTE: 렌더링하는 곳에서 user agent 체킹하므로 landscape만 체크 */

  var isMobileLandscape = useMediaQuery({
    query: '(orientation: landscape)'
  });
  return _jsxs(RootLayout, {
    mode: "mobile",
    children: [_jsx(MobileIntro, {
      translateKoToEn: translateKoToEn
    }), _jsxs(MobilePageWrapper, {
      totalPage: pages,
      children: [_jsx(MobilePage, {
        thumnails: thumnail === null || thumnail === void 0 ? void 0 : thumnail.map(function (value) {
          if (value !== null && value !== void 0 && value.thumnail) {
            return {
              src: value.thumnail,
              imageSources: value.imageSources
            };
          }

          return null;
        }),
        isMobileLandscape: isMobileLandscape
      }), _jsx(MobilePageChangeEffectLayer, {}), _jsx(MobilePageNavigationButton, {
        totalPage: Number(pages),
        isNextPageButtonDisabled: isNextPageButtonDisabled,
        isMoveCtaFormPageRequirements: true,
        openDrawer: function openDrawer() {
          return setIsMobileDrawerOpen(true);
        },
        isMobileLandscape: isMobileLandscape
      }), thumnail && _jsx(MobileAnnotationLayer, {
        thumnail: thumnail
      })]
    }), _jsx(MobilePageNavigation, {
      translateKoToEn: translateKoToEn,
      pages: thumnail,
      setIsMobileDrawerOpen: setIsMobileDrawerOpen,
      isMobileDrawerOpen: isMobileDrawerOpen,
      isMobileLandscape: isMobileLandscape
    })]
  });
};

/* harmony default export */ var PdfPreview_Mobile = ((/* unused pure expression or super */ null && (MobilePdfPreview)));
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Loading/index.styles.ts



var Loading_index_styles_FlexWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "ewjlvnv0"
} : 0)("width:100vw;height:100vh;background-color:", styles/* theme.colors.zinc_50 */.rS.colors.zinc_50, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Loading/index.tsx








var Loading_Loading = function Loading(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'loading' : _ref$name,
      _ref$thumnail = _ref.thumnail,
      thumnail = _ref$thumnail === void 0 ? 'https://assets.vercel.com/image/upload/front/nextjs/twitter-card.png' : _ref$thumnail,
      alertModalOpen = _ref.alertModalOpen,
      setAlertModalOpen = _ref.setAlertModalOpen,
      isKakaoInAppBrowser = _ref.isKakaoInAppBrowser,
      translateKoToEn = _ref.translateKoToEn;
  var isMobile = useMediaQuery({
    maxWidth: 375
  });
  return _jsxs(_Fragment, {
    children: [_jsxs(Head, {
      children: [_jsx("title", {
        children: name
      }, "title"), _jsx("meta", {
        name: "title",
        content: name
      }, "metaTitle"), _jsx("meta", {
        property: "og:title",
        content: name
      }, "ogTitle"), _jsx("meta", {
        property: "og:image",
        content: thumnail
      }, "ogImage"), _jsx("meta", {
        name: "description",
        lang: "ko",
        content: name
      }, "description"), _jsx("meta", {
        property: "og:description",
        content: name
      }, "ogDescription")]
    }), _jsx(Styled.FlexWrapper, {
      justifyContent: "center",
      alignItems: "center",
      children: _jsx(Text, {
        variant: isMobile ? 'lg-medium' : 'xl-medium',
        color: "skyblue_500",
        children: isKakaoInAppBrowser ? '외부 브라우저로 확인해주세요.' : translateKoToEn('loading')
      })
    }), _jsx(AlertModal, {
      isOpen: alertModalOpen,
      setIsOpen: setAlertModalOpen,
      title: translateKoToEn('not-found-title'),
      closeButtonText: translateKoToEn('not-found-modal-close'),
      confirmButtonText: translateKoToEn('not-found-modal-button'),
      handleModalCloseAction: function handleModalCloseAction() {
        window.location.href = 'https://app.salesclue.io/404';
      },
      children: _jsx(Text, {
        as: "p",
        variant: "md-medium",
        color: "black",
        children: translateKoToEn('not-found-content')
      })
    })]
  });
};

/* harmony default export */ var _common_Loading = ((/* unused pure expression or super */ null && (Loading_Loading)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/PdfViewer/Enter/index.tsx



function Enter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Enter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Enter_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Enter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var UTM_MAPPING = {
  utm_source: 'utmSource',
  utm_medium: 'utmMedium',
  utm_campaign: 'utmCampaign',
  utm_term: 'utmTerm',
  utm_content: 'utmContent',
  utm_id: 'utmId',
  gclid: 'gclid',
  fbclid: 'fbclid',
  msclkid: 'msclkid',
  ttclid: 'ttclid',
  li_fat_id: 'liFatId',
  gbraid: 'gbraid',
  wbraid: 'wbraid',
  gad_source: 'gadSource'
};

function extractCampaignParams() {
  var params = new URLSearchParams(window.location.search);
  var result = {};

  for (var _i = 0, _Object$entries = Object.entries(UTM_MAPPING); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        urlKey = _Object$entries$_i[0],
        bodyKey = _Object$entries$_i[1];

    var value = params.get(urlKey);

    if (value) {
      result[bodyKey] = value;
    }
  }

  return result;
}

var Enter = function Enter(_ref) {
  var name = _ref.name,
      thumnail = _ref.thumnail,
      _ref$isDeleted = _ref.isDeleted,
      isDeleted = _ref$isDeleted === void 0 ? false : _ref$isDeleted,
      _ref$ipAddress = _ref.ipAddress,
      ipAddress = _ref$ipAddress === void 0 ? '0.0.0.0' : _ref$ipAddress,
      mutateBulk = _ref.mutateBulk,
      mutateOneToOne = _ref.mutateOneToOne,
      translateKoToEn = _ref.translateKoToEn;
  var router = useRouter();

  var _useViewerRoute = useViewerRoute(),
      hashId = _useViewerRoute.hashId,
      resumeViewer = _useViewerRoute.resumeViewer;

  var _useState = useState(isDeleted),
      alertModalOpen = _useState[0],
      setAlertModalOpen = _useState[1]; //enter시 공유된 열람으로 부터 온 링크인지 여부를 sh query로 판단한다


  var sharedHistoryId = router.query.sh;

  var onError = function onError(err) {
    var _err$response;

    if (axios.isAxiosError(err) && (_err$response = err.response) !== null && _err$response !== void 0 && _err$response.data) {
      setAlertModalOpen(true);
    }
  };

  var _useState2 = useState(false),
      isKakaoInAppBrowser = _useState2[0],
      setIsKakaoInAppBrowser = _useState2[1];

  useEffect(function () {
    if (isKakaoInAppBrowser) {
      return;
    }

    var userAgent = navigator.userAgent.toLowerCase();
    var target_url = location.href;
    var referrer = document.referrer || undefined;

    if (userAgent.match(/kakaotalk/i)) {
      setIsKakaoInAppBrowser(true);
      location.href = 'kakaotalk://web/openExternal?url=' + encodeURIComponent(target_url);
      return;
    }

    if (!hashId) {
      setAlertModalOpen(true);
      return;
    }

    var savedHistoryId = sessionStorage.getItem(getViewerHistoryStorageKey({
      hashId: hashId,
      isBulk: Boolean(mutateBulk)
    }));

    if (savedHistoryId) {
      resumeViewer(savedHistoryId);
      return;
    }

    if (hashId) {
      if (mutateBulk) {
        var email = router.query.email;
        var isValidEmail = emailValidRegex.test(email);
        mutateBulk(Enter_objectSpread({
          hash: hashId,
          deviceInfo: getUserAgent(navigator.userAgent),
          ipAddress: ipAddress,
          browserInfo: getBrowserInfo(navigator.userAgent).name,
          email: isValidEmail ? email : undefined,
          sharedFrom: typeof sharedHistoryId === 'string' ? sharedHistoryId : undefined,
          referrer: referrer
        }, extractCampaignParams()), {
          onError: onError
        });
        return;
      } else if (mutateOneToOne) {
        mutateOneToOne(Enter_objectSpread({
          hashId: hashId,
          deviceInfo: getUserAgent(navigator.userAgent),
          ipAddress: ipAddress,
          browserInfo: getBrowserInfo(navigator.userAgent).name,
          sharedFrom: typeof sharedHistoryId === 'string' ? sharedHistoryId : undefined,
          referrer: referrer
        }, extractCampaignParams()), {
          onError: onError
        });
      }
    } else {
      setAlertModalOpen(true);
    }
  }, [router, hashId, isKakaoInAppBrowser]);
  return _jsx(Loading, {
    alertModalOpen: alertModalOpen,
    setAlertModalOpen: setAlertModalOpen,
    name: name,
    thumnail: thumnail,
    translateKoToEn: translateKoToEn,
    isKakaoInAppBrowser: isKakaoInAppBrowser
  });
};

/* harmony default export */ var PdfViewer_Enter = ((/* unused pure expression or super */ null && (Enter)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/mutation/file/useFileActionInterval.ts



function useFileActionInterval_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useFileActionInterval_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useFileActionInterval_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useFileActionInterval_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var fileActionInterval = function fileActionInterval(_ref) {
  var historyId = _ref.historyId,
      records = _ref.records;
  var pages = Object.entries(records).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    return {
      page: Number(key),
      stayed_time: value
    };
  });
  return api.post('/file/action/interval', {
    historyId: historyId,
    pages: pages
  });
};
var fileBulkActionInterval = function fileBulkActionInterval(_ref4) {
  var historyId = _ref4.historyId,
      records = _ref4.records;
  return api.post('/v2/viewer/interval', {
    historyId: historyId,
    records: records
  });
};

var useFileActionInterval_useFileActionInterval = function useFileActionInterval() {
  var isBulk = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var options = arguments.length > 1 ? arguments[1] : undefined;
  return useMutation(isBulk ? fileBulkActionInterval : fileActionInterval, useFileActionInterval_objectSpread({}, options));
};

/* harmony default export */ var file_useFileActionInterval = ((/* unused pure expression or super */ null && (useFileActionInterval_useFileActionInterval)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/useSetPageStayTime.ts


function useSetPageStayTime_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useSetPageStayTime_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useSetPageStayTime_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useSetPageStayTime_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




/*페이지가 변경 될 때마다 현재 페이지에서 체류한 페이지의 타임을 업데이트 */

var useSetPageStayTime_useSetPageStayTime = function useSetPageStayTime(_ref) {
  var resetStart = _ref.resetStart,
      getStayTime = _ref.getStayTime;
  var setPageTime = useSetAtom(pageTimeAtom);
  var currentPage = useAtomValue(currentPageAtom);
  var prevPage = useAtomValue(prevPageAtom);
  /*페이지 전환 시 마다, 직전 페이지의 체류 시간을 업데이트 한다 
  타이머는 초기화 하여 새로운 페이지에서 타이머를 새롭게 시작할 수 있도록 한다 */

  useEffect(function () {
    setPageTime(function (prev) {
      var stayTime = getStayTime();

      if (prev === null) {
        return _defineProperty({}, prevPage, stayTime);
      }

      return useSetPageStayTime_objectSpread(useSetPageStayTime_objectSpread({}, prev), {}, _defineProperty({}, prevPage, stayTime));
    });
    resetStart();
  }, [currentPage, prevPage]);
};

/* harmony default export */ var hooks_useSetPageStayTime = ((/* unused pure expression or super */ null && (useSetPageStayTime_useSetPageStayTime)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/useTimer.ts


var useTimer_useTimer = function useTimer() {
  var _useState = useState(0),
      startTime = _useState[0],
      setStartTime = _useState[1];

  var resetStart = useCallback(function () {
    setStartTime(Date.now());
  }, [startTime, setStartTime]);
  var getStayTime = useCallback(function () {
    var time = Date.now() - startTime;
    return time;
  }, [startTime, setStartTime]);
  return {
    resetStart: resetStart,
    getStayTime: getStayTime
  };
};

/* harmony default export */ var hooks_useTimer = ((/* unused pure expression or super */ null && (useTimer_useTimer)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/useGetPageVisible.ts


var getDocumentVisibilityState = function getDocumentVisibilityState() {
  if (typeof document === 'undefined') {
    return false;
  }

  return document.visibilityState === 'visible';
};

var useGetPageVisible_useGetPageVisible = function useGetPageVisible() {
  var _useState = useState(getDocumentVisibilityState()),
      isDocVisible = _useState[0],
      setIsDocVisible = _useState[1];

  var _useState2 = useState(false),
      isMouseIn = _useState2[0],
      setIsMouseIn = _useState2[1];

  useEffect(function () {
    var handleMouseEnter = function handleMouseEnter() {
      setIsMouseIn(true);
    };

    var handleMouseLeave = function handleMouseLeave() {
      setIsMouseIn(false);
    };

    var handleUpdateDocVisible = function handleUpdateDocVisible() {
      setIsDocVisible(getDocumentVisibilityState());
    };

    document.addEventListener('visibilitychange', handleUpdateDocVisible);
    document.addEventListener('mouseenter', handleMouseEnter);
    document.addEventListener('mouseleave', handleMouseLeave);
    return function () {
      document.removeEventListener('visibilitychange', handleUpdateDocVisible);
      document.removeEventListener('mouseenter', handleMouseEnter);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);
  return {
    isDocVisible: isDocVisible,
    isMouseIn: isMouseIn
  };
};

/* harmony default export */ var hooks_useGetPageVisible = ((/* unused pure expression or super */ null && (useGetPageVisible_useGetPageVisible)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/usePageInOutIntervalRequest.ts



var usePageInOutIntervalRequest_usePageInOutIntervalRequest = function usePageInOutIntervalRequest(_ref) {
  var isMobile = _ref.isMobile,
      handleInvisibleState = _ref.handleInvisibleState,
      handleVisibleState = _ref.handleVisibleState;

  var _useGetPageVisible = useGetPageVisible(),
      isDocVisible = _useGetPageVisible.isDocVisible,
      isMouseIn = _useGetPageVisible.isMouseIn;

  var isVisible = useMemo(function () {
    return isMobile ? isDocVisible : isDocVisible && isMouseIn;
  }, [isMobile, isDocVisible, isMouseIn]);
  useEffect(function () {
    if (isVisible) {
      handleVisibleState();
    }

    if (!isVisible) {
      handleInvisibleState();
    }
  }, [isVisible]);
};

/* harmony default export */ var hooks_usePageInOutIntervalRequest = ((/* unused pure expression or super */ null && (usePageInOutIntervalRequest_usePageInOutIntervalRequest)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/useIntervalAction.ts


var useIntervalAction_useIntervalAction = function useIntervalAction(_ref) {
  var intervalCallbackAction = _ref.intervalCallbackAction,
      _ref$time = _ref.time,
      time = _ref$time === void 0 ? 3000 : _ref$time;
  var intervalId = useRef(null);
  var callbackRef = useRef(function () {});
  useEffect(function () {
    callbackRef.current = intervalCallbackAction;
  }, [intervalCallbackAction]);
  var startInterval = useCallback(function () {
    if (intervalId.current) {
      clearInterval(intervalId.current);
    }

    if (callbackRef.current) {
      intervalId.current = setInterval(function () {
        return callbackRef.current();
      }, time);
    }
  }, [intervalCallbackAction]);
  var clearIntervalAction = useCallback(function () {
    if (intervalId.current) {
      clearInterval(intervalId.current);
      intervalId.current = null;
    }
  }, [intervalId]);
  return {
    startInterval: startInterval,
    clearIntervalAction: clearIntervalAction
  };
};

/* harmony default export */ var hooks_useIntervalAction = ((/* unused pure expression or super */ null && (useIntervalAction_useIntervalAction)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/useViewerIntervalRequest.ts



function useViewerIntervalRequest_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useViewerIntervalRequest_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useViewerIntervalRequest_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useViewerIntervalRequest_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var useViewerIntervalRequest_useViewerIntervalRequest = function useViewerIntervalRequest(_ref) {
  var isMobile = _ref.isMobile;

  var _useViewerRoute = useViewerRoute(),
      historyId = _useViewerRoute.historyId,
      isBulk = _useViewerRoute.isBulk;

  var _useFileActionInterva = useFileActionInterval(isBulk),
      mutate = _useFileActionInterva.mutate;

  var currentPage = useAtomValue(currentPageAtom);

  var _useAtom = useAtom(pageTimeAtom),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      pageTime = _useAtom2[0],
      setPageTime = _useAtom2[1];

  var _useTimer = useTimer(),
      resetStart = _useTimer.resetStart,
      getStayTime = _useTimer.getStayTime;

  useSetPageStayTime({
    resetStart: resetStart,
    getStayTime: getStayTime
  });
  var handleIntervalRequest = useCallback(function () {
    /*pageTime이 null인 경우는,
    유저가 페이지 이동을 하지 않았다는 의미로 
    현재 페이지에 대한 체류값을 추가해서 request를 보낸다
     null이 아닌 경우,
    유저가 페이지를 이동했다는 의미로 
    현재 페이지에 대한 체류시간을 추가해서 request를 보낸다 */
    var records = pageTime === null ? _defineProperty({}, currentPage, getStayTime()) : useViewerIntervalRequest_objectSpread(useViewerIntervalRequest_objectSpread({}, pageTime), {}, _defineProperty({}, currentPage, getStayTime()));
    mutate({
      historyId: historyId,
      records: records
    }, {
      onSuccess: function onSuccess() {
        resetStart();
        setPageTime(null);
      }
    });
  }, [pageTime, mutate, currentPage, getStayTime, resetStart, setPageTime]);
  /*3초마다 request 요청을 보낸다 */

  var _useIntervalAction = useIntervalAction({
    intervalCallbackAction: handleIntervalRequest
  }),
      startInterval = _useIntervalAction.startInterval,
      clearIntervalAction = _useIntervalAction.clearIntervalAction;
  /*유저가 페이지를 벗어났을 때 지금까지의 페이지 체류시간을 담아 request를 보낸다 
  다시 활성화가 되었을 때 타이머를 시작한다 */


  usePageInOutIntervalRequest({
    isMobile: isMobile,
    handleInvisibleState: function handleInvisibleState() {
      handleIntervalRequest();
      clearIntervalAction();
    },
    handleVisibleState: function handleVisibleState() {
      startInterval();
      resetStart();
    }
  });
};

/* harmony default export */ var hooks_useViewerIntervalRequest = ((/* unused pure expression or super */ null && (useViewerIntervalRequest_useViewerIntervalRequest)));
// EXTERNAL MODULE: ../../node_modules/jotai/esm/vanilla.mjs
var vanilla = __webpack_require__(65058);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/PdfViewer/Redirect/index.atom.ts


/* 1:1 Thumbnail을 저장하고 렌더링하는 상태값 */
var index_atom_thumbnailsAtom = (0,vanilla/* atom */.cn)(null);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/useUpdateOneToOneRenderThumbnails.ts







var useUpdateOneToOneRenderThumbnails_useUpdateOneToOneRenderThumbnails = function useUpdateOneToOneRenderThumbnails(_ref) {
  var defaultThumbnails = _ref.defaultThumbnails;

  var _useAtom = useAtom(thumbnailsAtom),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      thumbnails = _useAtom2[0],
      setThumbnails = _useAtom2[1];

  var currentPage = useAtomValue(currentPageAtom);

  var updateThumbnails = function updateThumbnails(page, startIndex, endIndex) {
    if (!thumbnails || !defaultThumbnails) {
      return;
    }

    var renderThumbnails = _toConsumableArray(thumbnails);

    for (var i = startIndex; i <= endIndex; i++) {
      renderThumbnails[page + i] = defaultThumbnails[page + i];
    }

    setThumbnails(renderThumbnails);
  };

  var updatePrevThumbnails = function updatePrevThumbnails(page) {
    if (currentPage - 1 < 0) {
      return;
    }

    updateThumbnails(page, -5, -1);
  };

  var updateNextThumbnails = function updateNextThumbnails(page) {
    if (defaultThumbnails && currentPage + 1 > defaultThumbnails.length) {
      return;
    }

    updateThumbnails(page, 1, 8);
  };

  useEffect(function () {
    if (defaultThumbnails) {
      var _thumbnails = defaultThumbnails.map(function (_, index) {
        return {
          page: index + 1,
          thumnail: '',
          originalWidth: 0,
          originalHeight: 0,
          hyperlink: []
        };
      });

      _thumbnails[0] = defaultThumbnails[0];
      _thumbnails[1] = defaultThumbnails[1];
      _thumbnails[2] = defaultThumbnails[2];
      setThumbnails(_thumbnails);
    }
  }, []);
  useEffect(function () {
    if (!thumbnails || !defaultThumbnails) {
      return;
    }

    updateThumbnails(currentPage, -3, 1);
  }, [currentPage]);
  return {
    updatePrevThumbnails: updatePrevThumbnails,
    updateNextThumbnails: updateNextThumbnails
  };
};

/* harmony default export */ var hooks_useUpdateOneToOneRenderThumbnails = ((/* unused pure expression or super */ null && (useUpdateOneToOneRenderThumbnails_useUpdateOneToOneRenderThumbnails)));
// EXTERNAL MODULE: ../../node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(17160);
// EXTERNAL MODULE: ../../node_modules/jotai/esm/vanilla/utils.mjs
var utils = __webpack_require__(87809);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/store/v2/viewer.atom.ts



/** V2 보기 모드(페이지 단위 / 연속 스크롤). localStorage에 지속된다. */
var v2ViewModeAtom = (0,utils/* atomWithStorage */.O4)('pdfViewerV2ViewMode', 'paged');
/** V2 줌 배율. fit-page 기준 1 = 100%. */

var v2ZoomAtom = (0,vanilla/* atom */.cn)(1);
/** V2 줌 fit 모드. custom이 아니면 컨테이너 리사이즈 시 fit 배율을 유지한다. */

var v2ZoomFitModeAtom = (0,vanilla/* atom */.cn)('fitPage');
/** V2 콘텐츠 영역(툴바/패널 제외) 크기 */

var v2ContainerSizeAtom = (0,vanilla/* atom */.cn)({
  width: 0,
  height: 0
});
/** V2 썸네일 패널 열림 상태 */

var v2IsThumbnailPanelOpenAtom = (0,vanilla/* atom */.cn)(false);
/** 브라우저 Fullscreen API 활성 상태 */

var v2IsFullscreenAtom = (0,vanilla/* atom */.cn)(false);
/** iOS 등 Fullscreen 미지원 환경의 몰입 모드(툴바 숨김) 상태 */

var v2IsImmersiveAtom = (0,vanilla/* atom */.cn)(false);
/** 스크롤 모드에서 특정 페이지로 이동 요청(썸네일 클릭, 페이지 입력 등). 처리 후 null로 복귀 */

var v2ScrollTargetPageAtom = (0,vanilla/* atom */.cn)(null);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/v2/useFitZoom.ts



var FIT_PADDING = 32;

/**
 * fit-page 기준 페이지 렌더 크기를 계산한다.
 * zoom=1이 fit-page(100%)가 되도록 픽셀 폭 기반으로 페이지 크기를 산출한다.
 */
var useFitZoom = function useFitZoom(_ref) {
  var originalWidth = _ref.originalWidth,
      originalHeight = _ref.originalHeight;
  var containerSize = (0,react/* useAtomValue */.Dv)(v2ContainerSizeAtom);
  var zoom = (0,react/* useAtomValue */.Dv)(v2ZoomAtom);
  return (0,node_modules_react.useMemo)(function () {
    var aspect = originalWidth / originalHeight || 1;
    var availableWidth = Math.max(containerSize.width - FIT_PADDING, 0);
    var availableHeight = Math.max(containerSize.height - FIT_PADDING, 0);
    var fitPageWidth = Math.min(availableWidth, availableHeight * aspect) || 0;
    var fitWidthZoom = fitPageWidth > 0 ? availableWidth / fitPageWidth : 1;
    var renderedWidth = fitPageWidth * zoom;
    var renderedHeight = aspect > 0 ? renderedWidth / aspect : 0;
    return {
      fitPageWidth: fitPageWidth,
      fitWidthZoom: fitWidthZoom,
      renderedWidth: renderedWidth,
      renderedHeight: renderedHeight,
      aspect: aspect
    };
  }, [containerSize, originalWidth, originalHeight, zoom]);
};

/* harmony default export */ var v2_useFitZoom = (useFitZoom);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/zoom.constants.ts
var V2_ZOOM_MIN = 0.5;
var V2_ZOOM_MAX = 3;
/** 줌 프리셋(fit-page 기준 배율) */

var V2_ZOOM_PRESETS = [0.5, 0.75, 1, 1.25, 1.5, 2, 3];
/**
 * 가로 맞춤 힌트 노출 임계값.
 * fit-page 렌더 폭이 가용 폭의 이 비율 미만이면 "세로로 긴 페이지"로 보고
 * 가로 맞춤 힌트 칩을 노출한다. 뷰어가 자동으로 배율을 바꾸지는 않는다.
 */

var V2_FIT_WIDTH_HINT_THRESHOLD = 0.6;
/**
 * 힌트 노출 기준 fit-width 배율.
 * fitPageWidth < 임계비율 × availableWidth ⇔ fitWidthZoom > 1 / 임계비율
 */

var V2_FIT_WIDTH_HINT_MIN_ZOOM = 1 / V2_FIT_WIDTH_HINT_THRESHOLD;
/** Ctrl/Cmd + 휠 연속 줌 감도 */

var V2_WHEEL_ZOOM_INTENSITY = 0.0022;
/** 모바일 더블 탭 줌인 목표 배율(fit 기준). 재차 더블 탭 시 100%로 복귀 */

var V2_DOUBLE_TAP_ZOOM = 2;
var clampV2Zoom = function clampV2Zoom(zoom) {
  return Math.min(V2_ZOOM_MAX, Math.max(V2_ZOOM_MIN, zoom));
};
/**
 * 핀치 종료 시 배율 스냅. 제스처 중에는 연속 배율로 부드럽게 움직이되,
 * 손을 뗄 때 5% 단위로 정리하고 100% 근접(±3%) 시 100%로 복귀시킨다.
 */

var snapV2PinchZoom = function snapV2PinchZoom(zoom) {
  if (Math.abs(zoom - 1) <= 0.03) {
    return 1;
  }

  return clampV2Zoom(Math.round(zoom * 20) / 20);
};
/**
 * 이미지 sizes 힌트를 160px 단위로 양자화한다.
 * 연속 줌 중 srcset 후보가 매 프레임 재선택되는 스래싱을 막는다.
 */

var quantizeImageSizes = function quantizeImageSizes(renderedWidth) {
  return "".concat(Math.max(160, Math.ceil(renderedWidth / 160) * 160), "px");
};
/** ± 버튼 스텝: 2.0까지는 0.25, 그 이상은 0.5 */

var getNextZoomStep = function getNextZoomStep(zoom, direction) {
  var step = (direction === 'in' ? zoom : zoom - 0.01) >= 2 ? 0.5 : 0.25;
  var next = direction === 'in' ? zoom + step : zoom - step;
  return clampV2Zoom(Math.round(next * 100) / 100);
};
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/v2/useFitWidthHint.ts






/**
 * 세로로 긴 페이지에서 가로 맞춤 전환을 권유하는 힌트 칩의 노출/해제 상태.
 * 뷰어는 자동으로 배율을 바꾸지 않고, 사용자가 칩을 눌렀을 때만 fit-width를 적용한다.
 *
 * 해제 조건(한 번 해제하면 뷰어가 언마운트될 때까지 다시 뜨지 않는다.
 * 페이지를 넘겨도 재노출하지 않으며 localStorage에는 남기지 않는다):
 * - 칩 클릭(가로 맞춤 적용) / X 버튼
 * - 사용자의 직접 줌 조작 → fitMode가 'fitPage'를 벗어나는 순간.
 *   자동 줌을 제거한 뒤로 'fitPage' 이탈 경로는 모두 사용자 조작뿐이다
 *   (툴바 ±·프리셋·드롭다운, 모바일 ±, 휠/핀치/더블탭 → useAnchoredZoom).
 *   리사이즈는 zoom만 바꾸고 fitMode는 유지하므로 오탐이 없다.
 */
var useFitWidthHint = function useFitWidthHint(_ref) {
  var fitWidthZoom = _ref.fitWidthZoom;
  var containerSize = (0,react/* useAtomValue */.Dv)(v2ContainerSizeAtom);

  var _useAtom = (0,react/* useAtom */.KO)(v2ZoomFitModeAtom),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      fitMode = _useAtom2[0],
      setFitMode = _useAtom2[1];

  var setZoom = (0,react/* useSetAtom */.b9)(v2ZoomAtom);
  /*
   * 드롭다운에서 '페이지 맞춤'을 다시 고르면 fitMode가 fitPage로 복귀한다.
   * 파생값만 쓰면 칩이 되살아나므로 해제 상태를 따로 고정한다.
   */

  var _useState = (0,node_modules_react.useState)(false),
      isDismissed = _useState[0],
      setIsDismissed = _useState[1];

  (0,node_modules_react.useEffect)(function () {
    if (fitMode !== 'fitPage') {
      setIsDismissed(true);
    }
  }, [fitMode]);
  var dismissHint = (0,node_modules_react.useCallback)(function () {
    return setIsDismissed(true);
  }, []);
  /* ZoomControls의 applyFitWidth와 동일 경로 */

  var applyFitWidth = (0,node_modules_react.useCallback)(function () {
    setZoom(clampV2Zoom(fitWidthZoom));
    setFitMode('fitWidth');
    setIsDismissed(true);
  }, [fitWidthZoom, setZoom, setFitMode]);
  /* 컨테이너 측정 전에는 fitWidthZoom이 1로 고정돼 깜빡임이 생긴다 */

  var isMeasured = containerSize.width > 0 && containerSize.height > 0;
  var isLongPage = fitWidthZoom >= V2_FIT_WIDTH_HINT_MIN_ZOOM;
  return {
    isHintVisible: isMeasured && !isDismissed && fitMode === 'fitPage' && isLongPage,
    applyFitWidth: applyFitWidth,
    dismissHint: dismissHint
  };
};

/* harmony default export */ var v2_useFitWidthHint = (useFitWidthHint);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/v2/useFullscreen.ts





var isFullscreenSupported = function isFullscreenSupported() {
  if (typeof document === 'undefined') {
    return false;
  }

  return document.fullscreenEnabled || 'webkitRequestFullscreen' in document.documentElement;
};
/**
 * 브라우저 Fullscreen API 래퍼.
 * iPhone Safari처럼 요소 전체화면을 지원하지 않는 환경에서는
 * 몰입 모드(v2IsImmersiveAtom)로 폴백한다.
 */


var useFullscreen = function useFullscreen(targetRef) {
  var _useAtom = (0,react/* useAtom */.KO)(v2IsFullscreenAtom),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      isFullscreen = _useAtom2[0],
      setIsFullscreen = _useAtom2[1];

  var _useAtom3 = (0,react/* useAtom */.KO)(v2IsImmersiveAtom),
      _useAtom4 = (0,slicedToArray/* default */.Z)(_useAtom3, 2),
      isImmersive = _useAtom4[0],
      setIsImmersive = _useAtom4[1];

  (0,node_modules_react.useEffect)(function () {
    var doc = document;

    var handleFullscreenChange = function handleFullscreenChange() {
      var _doc$fullscreenElemen;

      var fullscreenElement = (_doc$fullscreenElemen = doc.fullscreenElement) !== null && _doc$fullscreenElemen !== void 0 ? _doc$fullscreenElemen : doc.webkitFullscreenElement;
      setIsFullscreen(Boolean(fullscreenElement));
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    return function () {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
    };
  }, [setIsFullscreen]);
  var toggleFullscreen = (0,node_modules_react.useCallback)(function () {
    var _doc$fullscreenElemen2;

    if (!isFullscreenSupported()) {
      setIsImmersive(function (prev) {
        return !prev;
      });
      return;
    }

    var doc = document;
    var isActive = Boolean((_doc$fullscreenElemen2 = doc.fullscreenElement) !== null && _doc$fullscreenElemen2 !== void 0 ? _doc$fullscreenElemen2 : doc.webkitFullscreenElement);

    if (isActive) {
      if (doc.exitFullscreen) {
        doc.exitFullscreen();
      } else {
        var _doc$webkitExitFullsc;

        (_doc$webkitExitFullsc = doc.webkitExitFullscreen) === null || _doc$webkitExitFullsc === void 0 ? void 0 : _doc$webkitExitFullsc.call(doc);
      }

      return;
    }

    var target = targetRef.current;

    if (!target) {
      return;
    }

    if (target.requestFullscreen) {
      target.requestFullscreen();
    } else {
      var _target$webkitRequest;

      (_target$webkitRequest = target.webkitRequestFullscreen) === null || _target$webkitRequest === void 0 ? void 0 : _target$webkitRequest.call(target);
    }
  }, [setIsImmersive, targetRef]);
  return {
    isFullscreenActive: isFullscreen || isImmersive,
    isImmersive: isImmersive,
    toggleFullscreen: toggleFullscreen
  };
};

/* harmony default export */ var v2_useFullscreen = (useFullscreen);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/v2/useV2KeyPress.ts





/**
 * V2 페이지 모드 키보드 내비게이션(V1 KeyPressLayer와 동일한 키 바인딩).
 * 스크롤 모드에서는 네이티브 스크롤에 맡긴다.
 */
var useV2KeyPress = function useV2KeyPress(_ref) {
  var goToPrevPage = _ref.goToPrevPage,
      goToNextPage = _ref.goToNextPage;
  var viewMode = (0,react/* useAtomValue */.Dv)(v2ViewModeAtom);
  var isPressPrevPage = (0,react_hooks/* useKeyPress */.Kr)('ArrowLeft, PageUp, ArrowUp');
  var isPressNextPage = (0,react_hooks/* useKeyPress */.Kr)('ArrowRight, ArrowDown, PageDown');
  (0,node_modules_react.useEffect)(function () {
    if (viewMode !== 'paged') {
      return;
    }

    if (isPressPrevPage) {
      goToPrevPage();
    }

    if (isPressNextPage) {
      goToNextPage();
    }
  }, [isPressPrevPage, isPressNextPage]);
};

/* harmony default export */ var v2_useV2KeyPress = (useV2KeyPress);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/v2/useV2PageNavigation.ts





/**
 * V2 공통 페이지 이동 로직.
 * - 1..totalPages 클램프
 * - startFrom 게이트 활성 시 게이트 페이지 너머 이동을 게이트 페이지로 강제
 * - 스크롤 모드에서는 v2ScrollTargetPageAtom으로 스크롤 이동을 요청
 * 모든 이동이 updateCurrentPage를 경유하므로 체류시간 분석 계약이 유지된다.
 */
var useV2PageNavigation = function useV2PageNavigation(_ref) {
  var totalPages = _ref.totalPages,
      ctaFormPage = _ref.ctaFormPage,
      isGateActive = _ref.isGateActive;

  var _useUpdateViewerPageS = hooks_useUpdateViewerPageState(),
      currentPage = _useUpdateViewerPageS.currentPage,
      updateCurrentPage = _useUpdateViewerPageS.updateCurrentPage;

  var viewMode = (0,react/* useAtomValue */.Dv)(v2ViewModeAtom);
  var setScrollTargetPage = (0,react/* useSetAtom */.b9)(v2ScrollTargetPageAtom);
  var isNextPageDisabled = isGateActive && ctaFormPage !== undefined && currentPage >= ctaFormPage;
  var goToPage = (0,node_modules_react.useCallback)(function (targetPage) {
    var page = Math.min(Math.max(Math.round(targetPage), 1), totalPages);

    if (isGateActive && ctaFormPage !== undefined && page >= ctaFormPage) {
      page = ctaFormPage;
    }

    if (page === currentPage) {
      return;
    }

    updateCurrentPage(page);

    if (viewMode === 'scroll') {
      setScrollTargetPage(page);
    }
  }, [totalPages, isGateActive, ctaFormPage, currentPage, updateCurrentPage, viewMode, setScrollTargetPage]);
  var goToPrevPage = (0,node_modules_react.useCallback)(function () {
    return goToPage(currentPage - 1);
  }, [goToPage, currentPage]);
  var goToNextPage = (0,node_modules_react.useCallback)(function () {
    if (isNextPageDisabled) {
      return;
    }

    goToPage(currentPage + 1);
  }, [goToPage, currentPage, isNextPageDisabled]);
  return {
    currentPage: currentPage,
    goToPage: goToPage,
    goToPrevPage: goToPrevPage,
    goToNextPage: goToNextPage,
    isNextPageDisabled: isNextPageDisabled
  };
};

/* harmony default export */ var v2_useV2PageNavigation = (useV2PageNavigation);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/index.util.ts
var index_util_getBlindPages = function getBlindPages(_ref) {
  var blindStatus = _ref.blindStatus,
      blindPage = _ref.blindPage,
      totalPages = _ref.totalPages;

  if (!blindStatus || !blindPage || !totalPages) {
    return null;
  }

  if (blindStatus === 'none') {
    return null;
  }

  if (blindStatus === 'specific') {
    return [blindPage];
  }

  if (blindStatus === 'startFrom') {
    return Array.from({
      length: totalPages - blindPage + 1
    }, function (_, i) {
      return blindPage + i;
    });
  }

  return null;
};
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkPdfPreview/index.atom.ts

var index_atom_isPreviewFormSubmittedAtom = (0,vanilla/* atom */.cn)(false);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 5 modules
var AnimatePresence = __webpack_require__(65239);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion.mjs + 112 modules
var dom_motion = __webpack_require__(85806);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/utils/handleFreeBadgeLinkOpen.ts
// TODO : app.salesclue.io 배포 후 분기 문 처리해서 수정하기
var handleFreeBadgeLinkOpen_handleFreeBadgeLinkOpen = function handleFreeBadgeLinkOpen() {
  if (window) {
    var hostname = window.location.hostname;

    if (hostname.includes('app.salesclue') || hostname.includes('dev.salesclue.io')) {
      window.open('https://app.salesclue.io', '_blank', 'noreferrer noopener');
      return;
    }

    window.open('https://www.salesclue.io', '_blank', 'noreferrer noopener');
  }
};

/* harmony default export */ var utils_handleFreeBadgeLinkOpen = (handleFreeBadgeLinkOpen_handleFreeBadgeLinkOpen);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/FormFreeBadge/Desktop/index.styles.ts


function FormFreeBadge_Desktop_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var Desktop_index_styles_Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "eghuo8l0"
} : 0)( true ? {
  name: "1iqx47y",
  styles: "display:none;width:100%;border-radius:8px;opacity:0;transition:all ease-in-out 150ms;visibility:hidden;&:hover{cursor:pointer;}&.is-visible{display:flex;opacity:0.8;visibility:visible;&:hover{opacity:1;}}"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/FormFreeBadge/Desktop/index.tsx







var DesktopFormFreeBadge = function DesktopFormFreeBadge(_ref) {
  var userSubscriptionPlan = _ref.userSubscriptionPlan;

  var isFreeBadgeVisible = function isFreeBadgeVisible() {
    return userSubscriptionPlan === 'Free';
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Desktop_index_styles_Container, {
    gap: 8,
    className: isFreeBadgeVisible() ? 'is-visible' : '',
    alignItems: "center",
    justifyContent: "center",
    width: "fit-content",
    onClick: function onClick() {
      utils_handleFreeBadgeLinkOpen();
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: "md-semibold",
      color: "skyblue_600",
      children: "Powered by"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
      src: "/images/salesclue_logo_default.png",
      width: 94,
      height: 21,
      alt: 'SalesClue',
      unoptimized: true
    })]
  });
};

/* harmony default export */ var FormFreeBadge_Desktop = (DesktopFormFreeBadge);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/mutation/cta/useFormEmailAuth.ts


var postFormEmailAuth = function postFormEmailAuth(request) {
  return api_api.post('/v2/viewer/submit/form-email-auth', request);
};

var usePostFormEmailAuth = function usePostFormEmailAuth(options) {
  return (0,lib_useMutation/* useMutation */.D)(postFormEmailAuth, options);
};

/* harmony default export */ var useFormEmailAuth = (usePostFormEmailAuth);
// EXTERNAL MODULE: ../../packages/next-pdf-viewer/src/constant/formValidations.ts
var formValidations = __webpack_require__(31084);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(55830);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/mutation/cta/usePostCtaForm.ts


function usePostCtaForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function usePostCtaForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? usePostCtaForm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : usePostCtaForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var postCtaForm = function postCtaForm(request) {
  return api_api.post('/v2/viewer/submit/form', usePostCtaForm_objectSpread({}, request));
};

var usePostCtaForm = function usePostCtaForm(options) {
  return (0,lib_useMutation/* useMutation */.D)(postCtaForm, options);
};

var usePostCtaFormWithInvalidation = function usePostCtaFormWithInvalidation() {
  var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();

  var _usePostCtaForm = usePostCtaForm(),
      postCtaFormMutate = _usePostCtaForm.mutate;

  var deleteFormHandler = function deleteFormHandler(_ref) {
    var historyId = _ref.historyId,
        formRecord = _ref.formRecord,
        code = _ref.code,
        _onSuccess = _ref.onSuccess,
        _onError = _ref.onError;
    postCtaFormMutate({
      historyId: historyId,
      formRecord: formRecord,
      code: code
    }, {
      onSuccess: function onSuccess() {
        void queryClient.invalidateQueries({
          queryKey: ['getBulkFileRedirect']
        });
        _onSuccess && _onSuccess();
      },
      onError: function onError() {
        _onError && _onError();
      }
    });
  };

  return {
    mutate: deleteFormHandler
  };
};

/* harmony default export */ var cta_usePostCtaForm = (usePostCtaFormWithInvalidation);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/CtaFormModalContents/index.styles.ts


function CtaFormModalContents_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var MinWidthWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e77vm382"
} : 0)("min-width:", function (_ref) {
  var width = _ref.width;
  return width;
}, "px;", function (_ref2) {
  var height = _ref2.height;
  return height && "height: ".concat(height, "px;");
}, ";" + ( true ? "" : 0));
var CheckBoxInput = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("input",  true ? {
  target: "e77vm381"
} : 0)( true ? {
  name: "1eg0rk6",
  styles: "width:18px;height:18px"
} : 0);
var KeepAllText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Text */.xv,  true ? {
  target: "e77vm380"
} : 0)( true ? {
  name: "255c6r",
  styles: "word-break:keep-all"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/CtaFormModalContents/RequiredMark/index.tsx





var RequiredMark = function RequiredMark(_ref) {
  var translateKoToEn = _ref.translateKoToEn;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MinWidthWrapper, {
    width: 32,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
      variant: "sm-medium",
      color: "skyblue_500",
      children: ["*", translateKoToEn('required')]
    })
  });
};

/* harmony default export */ var CtaFormModalContents_RequiredMark = (RequiredMark);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/CtaFormModalContents/FormInput/index.tsx







var FormInput = function FormInput(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      title = _ref.title,
      id = _ref.id,
      description = _ref.description,
      placeholder = _ref.placeholder,
      isRequired = _ref.isRequired,
      translateKoToEn = _ref.translateKoToEn,
      handleChangeWithId = _ref.handleChangeWithId,
      value = _ref.value,
      actionButton = _ref.actionButton,
      readOnly = _ref.readOnly;
  var isEmpty = isRequired && (value === null || value === void 0 ? void 0 : value.trim()) === '';
  var isInvalidEmail = type === 'email' && !formValidations/* FORM_VALIDATIONS.email.pattern.value.test */.R.email.pattern.value.test(value) && Boolean(value);

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.stopPropagation();
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
    direction: "column",
    gap: 4,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      gap: 4,
      alignItems: "center",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeepAllText, {
        variant: "md-semibold",
        color: "black",
        children: title
      }), isRequired && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaFormModalContents_RequiredMark, {
        translateKoToEn: translateKoToEn
      })]
    }), description && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeepAllText, {
      variant: "sm-medium",
      color: "zinc_400",
      children: description
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      direction: "row",
      gap: 8,
      alignItems: "center",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, {
        width: "100%",
        type: type,
        placeholder: placeholder,
        isError: type === 'email' ? isInvalidEmail || isEmpty : isEmpty,
        onChange: function onChange(e) {
          handleChangeWithId(id, e.target.value);
        },
        onKeyDown: handleKeyDown,
        value: value,
        readOnly: readOnly
      }), actionButton && actionButton(type === 'email' ? isInvalidEmail || isEmpty : isEmpty)]
    }), type === 'email' && isInvalidEmail && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: "sm-medium",
      color: "cerise_500",
      children: translateKoToEn('invalid-email-message')
    }), isEmpty && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: "sm-medium",
      color: "cerise_500",
      children: translateKoToEn('required-field')
    })]
  });
};

/* harmony default export */ var CtaFormModalContents_FormInput = (FormInput);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/CtaFormModalContents/PersonalInformation/index.tsx






var PersonalInformation = function PersonalInformation(_ref) {
  var id = _ref.id,
      title = _ref.title,
      description = _ref.description,
      handleChangeWithId = _ref.handleChangeWithId,
      translateKoToEn = _ref.translateKoToEn,
      value = _ref.value,
      ctaField = _ref.ctaField,
      template = _ref.template;
  var requiredFields = ctaField === null || ctaField === void 0 ? void 0 : ctaField.filter(function (field) {
    return field.isRequired;
  });

  var openWindow = function openWindow() {
    window.open(template.link, '_blank');
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
    gap: 4,
    direction: "column",
    justifyContent: "flex-start",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: "sm-semibold",
      as: "label",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        gap: 4,
        alignItems: "center",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MinWidthWrapper, {
          width: 24,
          height: 24,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckBoxInput, {
            type: "checkbox",
            onChange: function onChange() {
              handleChangeWithId(id, !value);
            },
            checked: value
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MinWidthWrapper, {
          width: 35,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
            variant: "md-semibold",
            color: "skyblue_500",
            children: ["(", translateKoToEn('required'), ")"]
          })
        }), (template === null || template === void 0 ? void 0 : template.type) === 'default' ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
          href: {
            pathname: '/personal-information-consent',
            query: {
              company: template.companyName,
              content: requiredFields === null || requiredFields === void 0 ? void 0 : requiredFields.map(function (field) {
                return field.name;
              }).join('-')
            }
          },
          passHref: true,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            target: "_blank",
            rel: "noopener noreferrer",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeepAllText, {
              variant: "md-semibold",
              children: title
            })
          })
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
          onClick: openWindow,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeepAllText, {
            variant: "md-semibold",
            children: title
          })
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeepAllText, {
      as: "div",
      variant: "sm-medium",
      color: "zinc_400",
      children: description
    })]
  });
};

/* harmony default export */ var CtaFormModalContents_PersonalInformation = (PersonalInformation);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/CtaFormModalContents/NumberInput/index.tsx






var NumberInput = function NumberInput(_ref) {
  var id = _ref.id,
      title = _ref.title,
      description = _ref.description,
      isRequired = _ref.isRequired,
      placeholder = _ref.placeholder,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 200 : _ref$max,
      value = _ref.value,
      translateKoToEn = _ref.translateKoToEn,
      handleChangeWithId = _ref.handleChangeWithId;
  var isBelowMinValue = value < min && Boolean(value);
  var invalidFeedback = "".concat(min, "\uBCF4\uB2E4 \uD070 \uAC12\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.");

  var handleChange = function handleChange(e) {
    if (Number(e.target.value) > max) {
      handleChangeWithId(id, max);
      return;
    }

    handleChangeWithId(id, Number(e.target.value));
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.stopPropagation();
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
    direction: "column",
    gap: 4,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      gap: 4,
      alignItems: "center",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeepAllText, {
        variant: "md-semibold",
        color: "black",
        children: title
      }), isRequired && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaFormModalContents_RequiredMark, {
        translateKoToEn: translateKoToEn
      })]
    }), description && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeepAllText, {
      children: description
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, {
      width: "100%",
      type: "number",
      max: max,
      min: min,
      placeholder: placeholder,
      isError: isBelowMinValue,
      onChange: handleChange,
      onKeyDown: handleKeyDown,
      value: String(value)
    }), isBelowMinValue && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: "sm-medium",
      color: "cerise_500",
      children: invalidFeedback
    })]
  });
};

/* harmony default export */ var CtaFormModalContents_NumberInput = (NumberInput);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/CtaFormModalContents/CheckBox/index.tsx





var CheckBox = function CheckBox(_ref) {
  var id = _ref.id,
      isRequired = _ref.isRequired,
      title = _ref.title,
      description = _ref.description,
      handleChangeWithId = _ref.handleChangeWithId,
      translateKoToEn = _ref.translateKoToEn,
      value = _ref.value;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
    gap: 4,
    direction: "column",
    justifyContent: "flex-start",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: "sm-semibold",
      as: "label",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        gap: 4,
        alignItems: "center",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MinWidthWrapper, {
          width: 24,
          height: 24,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckBoxInput, {
            type: "checkbox",
            onChange: function onChange() {
              handleChangeWithId(id, !value);
            },
            checked: value
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MinWidthWrapper, {
          width: 35,
          children: isRequired ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
            variant: "md-semibold",
            color: "skyblue_500",
            children: ["(", translateKoToEn('required'), ")"]
          }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
            variant: "md-semibold",
            children: ["(", translateKoToEn('optional'), ")"]
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeepAllText, {
          variant: "md-semibold",
          children: title
        })]
      })
    }), description && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeepAllText, {
      as: "div",
      variant: "sm-medium",
      color: "zinc_400",
      children: description
    })]
  });
};

/* harmony default export */ var CtaFormModalContents_CheckBox = (CheckBox);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(52746);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/CtaFormModalContents/Select/index.styles.ts


function Select_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var SelectButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "e1hsthol1"
} : 0)("&.is-active{background-color:", styles/* theme.colors.black */.rS.colors.black, ";color:", styles/* theme.colors.white */.rS.colors.white, ";}&>div{word-break:keep-all;}" + ( true ? "" : 0));
var index_styles_KeepAllText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Text */.xv,  true ? {
  target: "e1hsthol0"
} : 0)( true ? {
  name: "255c6r",
  styles: "word-break:keep-all"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/CtaFormModalContents/Select/index.tsx








var Select = function Select(_ref) {
  var id = _ref.id,
      options = _ref.options,
      name = _ref.name,
      isRequired = _ref.isRequired,
      description = _ref.description,
      handleChangeWithId = _ref.handleChangeWithId,
      translateKoToEn = _ref.translateKoToEn,
      value = _ref.value,
      range = _ref.range;
  var max = range.max,
      min = range.min;
  var isBelowMinValue = (value === null || value === void 0 ? void 0 : value.length) < min && Boolean(value);
  var invalidFeedback = "\uCD5C\uC18C ".concat(min, "\uAC1C \uC774\uC0C1 \uC120\uD0DD\uD574\uC8FC\uC138\uC694.");
  var selectedValue = value || [];

  var handleOnClick = function handleOnClick(option) {
    if (selectedValue !== null && selectedValue !== void 0 && selectedValue.find(function (v) {
      return v.id === option.id;
    })) {
      handleChangeWithId(id, selectedValue.filter(function (v) {
        return v.id !== option.id;
      }));
      return;
    }

    if ((selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.length) === max) {
      selectedValue.shift();
      handleChangeWithId(id, [].concat((0,toConsumableArray/* default */.Z)(selectedValue), [option]));
      return;
    }

    handleChangeWithId(id, [].concat((0,toConsumableArray/* default */.Z)(selectedValue), [option]));
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
    gap: 8,
    direction: "column",
    justifyContent: "flex-start",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      gap: 4,
      direction: "column",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        gap: 4,
        alignItems: "center",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_styles_KeepAllText, {
          variant: "md-semibold",
          color: "black",
          children: name
        }), isRequired && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaFormModalContents_RequiredMark, {
          translateKoToEn: translateKoToEn
        })]
      }), description && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_styles_KeepAllText, {
        as: "div",
        variant: "sm-medium",
        color: "zinc_400",
        children: description
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Stack */.Kq, {
      gap: 8,
      direction: "row",
      wrap: "wrap",
      children: options.map(function (option) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectButton, {
          className: classnames_default()({
            'is-active': selectedValue.find(function (v) {
              return v.id === option.id;
            })
          }),
          variant: "zinc_500",
          radius: 9999,
          paddingX: 16,
          paddingY: 8,
          onClick: function onClick() {
            return handleOnClick(option);
          },
          children: option.name
        }, option.id);
      })
    }), isBelowMinValue && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: "sm-medium",
      color: "cerise_500",
      children: invalidFeedback
    })]
  });
};

/* harmony default export */ var CtaFormModalContents_Select = (Select);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/CtaFormModalContents/Legal/index.tsx





var Legal = function Legal(_ref) {
  var id = _ref.id,
      isRequired = _ref.isRequired,
      title = _ref.title,
      description = _ref.description,
      link = _ref.link,
      handleChangeWithId = _ref.handleChangeWithId,
      translateKoToEn = _ref.translateKoToEn,
      value = _ref.value;

  var openWindow = function openWindow() {
    window.open(link, '_blank');
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
    gap: 4,
    direction: "column",
    justifyContent: "flex-start",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: "sm-semibold",
      as: "label",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        gap: 4,
        alignItems: "center",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MinWidthWrapper, {
          width: 24,
          height: 24,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckBoxInput, {
            type: "checkbox",
            onChange: function onChange() {
              handleChangeWithId(id, !value);
            },
            checked: value
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MinWidthWrapper, {
          width: 35,
          children: isRequired ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
            variant: "md-semibold",
            color: "skyblue_500",
            children: ["(", translateKoToEn('required'), ")"]
          }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
            variant: "md-semibold",
            children: ["(", translateKoToEn('optional'), ")"]
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
          onClick: openWindow,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeepAllText, {
            variant: "md-semibold",
            children: title
          })
        })]
      })
    }), description && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeepAllText, {
      as: "div",
      variant: "sm-medium",
      color: "zinc_400",
      children: description
    })]
  });
};

/* harmony default export */ var CtaFormModalContents_Legal = (Legal);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/CtaFormModalContents/index.tsx












var CtaFormModalContents = function CtaFormModalContents(_ref) {
  var _fields$filter, _fields$findIndex;

  var formFields = _ref.formFields,
      handleChangeWithId = _ref.handleChangeWithId,
      translateKoToEn = _ref.translateKoToEn,
      fields = _ref.fields,
      isEmailVerificationEnabled = _ref.isEmailVerificationEnabled,
      _ref$isCodeSent = _ref.isCodeSent,
      isCodeSent = _ref$isCodeSent === void 0 ? false : _ref$isCodeSent,
      _ref$isVerified = _ref.isVerified,
      isVerified = _ref$isVerified === void 0 ? false : _ref$isVerified,
      _ref$verificationCode = _ref.verificationCode,
      verificationCode = _ref$verificationCode === void 0 ? '' : _ref$verificationCode,
      _ref$onSendVerificati = _ref.onSendVerificationCode,
      onSendVerificationCode = _ref$onSendVerificati === void 0 ? function () {} : _ref$onSendVerificati,
      _ref$onVerifyCode = _ref.onVerifyCode,
      onVerifyCode = _ref$onVerifyCode === void 0 ? function () {} : _ref$onVerifyCode,
      _ref$onChangeVerifica = _ref.onChangeVerificationCode,
      onChangeVerificationCode = _ref$onChangeVerifica === void 0 ? function () {} : _ref$onChangeVerifica;
  var consentFields = (_fields$filter = fields === null || fields === void 0 ? void 0 : fields.filter(function (f) {
    return f.type === 'legal' || f.type === 'private';
  })) !== null && _fields$filter !== void 0 ? _fields$filter : [];
  var consentFieldIds = consentFields.map(function (f) {
    return f.id;
  });
  var firstConsentIndex = (_fields$findIndex = fields === null || fields === void 0 ? void 0 : fields.findIndex(function (f) {
    return f.type === 'legal' || f.type === 'private';
  })) !== null && _fields$findIndex !== void 0 ? _fields$findIndex : -1;
  var showAgreeAll = consentFieldIds.length >= 2;
  var allChecked = showAgreeAll && consentFieldIds.every(function (id) {
    var _formFields$find;

    return Boolean((_formFields$find = formFields.find(function (f) {
      return f.id === id;
    })) === null || _formFields$find === void 0 ? void 0 : _formFields$find.value);
  });

  var handleAgreeAll = function handleAgreeAll() {
    consentFieldIds.forEach(function (id) {
      return handleChangeWithId(id, !allChecked);
    });
  };

  var renderConsentGroup = function renderConsentGroup() {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      direction: "column",
      gap: 16,
      children: [showAgreeAll && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "sm-semibold",
          as: "label",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
            gap: 4,
            alignItems: "center",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MinWidthWrapper, {
              width: 24,
              height: 24,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckBoxInput, {
                type: "checkbox",
                onChange: handleAgreeAll,
                checked: allChecked
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeepAllText, {
              variant: "md-semibold",
              children: translateKoToEn('agree-all')
            })]
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {
          style: {
            border: 'none',
            borderTop: '1px solid #e5e7eb',
            margin: 0
          }
        })]
      }), consentFields.map(function (field) {
        if (field.type === 'legal') {
          var _formFields$find2;

          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaFormModalContents_Legal, {
            id: field.id,
            title: field.name,
            description: field.description,
            isRequired: field.isRequired,
            link: field.link,
            handleChangeWithId: handleChangeWithId,
            translateKoToEn: translateKoToEn,
            value: (_formFields$find2 = formFields.find(function (f) {
              return f.id === field.id;
            })) === null || _formFields$find2 === void 0 ? void 0 : _formFields$find2.value
          }, field.id);
        }

        if (field.type === 'private') {
          var _formFields$find3;

          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaFormModalContents_PersonalInformation, {
            id: field.id,
            title: field.name,
            description: field.description,
            ctaField: fields,
            template: field === null || field === void 0 ? void 0 : field.template,
            handleChangeWithId: handleChangeWithId,
            translateKoToEn: translateKoToEn,
            value: (_formFields$find3 = formFields.find(function (f) {
              return f.id === field.id;
            })) === null || _formFields$find3 === void 0 ? void 0 : _formFields$find3.value
          }, field.id);
        }
      })]
    }, "consent-group");
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: fields === null || fields === void 0 ? void 0 : fields.flatMap(function (field, index) {
      var _formFields$find8;

      var isConsent = field.type === 'legal' || field.type === 'private';

      if (isConsent && index !== firstConsentIndex) {
        return [];
      }

      if (isConsent && index === firstConsentIndex) {
        return [renderConsentGroup()];
      }

      if (field.type === 'checkBox') {
        var _formFields$find4;

        var _id = field.id;
        return [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaFormModalContents_CheckBox, {
          id: _id,
          title: field.name,
          description: field.description,
          isRequired: field.isRequired,
          handleChangeWithId: handleChangeWithId,
          translateKoToEn: translateKoToEn,
          value: (_formFields$find4 = formFields.find(function (f) {
            return f.id === _id;
          })) === null || _formFields$find4 === void 0 ? void 0 : _formFields$find4.value
        }, _id)];
      }

      if (field.type === 'number') {
        var _field$range, _field$range2, _formFields$find5;

        var _id2 = field.id;
        return [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaFormModalContents_NumberInput, {
          id: field.id,
          title: field.name,
          isRequired: field.isRequired,
          description: field.description,
          placeholder: field.placeholder,
          max: (_field$range = field.range) === null || _field$range === void 0 ? void 0 : _field$range.max,
          min: (_field$range2 = field.range) === null || _field$range2 === void 0 ? void 0 : _field$range2.min,
          handleChangeWithId: handleChangeWithId,
          translateKoToEn: translateKoToEn,
          value: (_formFields$find5 = formFields.find(function (f) {
            return f.id === _id2;
          })) === null || _formFields$find5 === void 0 ? void 0 : _formFields$find5.value
        }, field.id)];
      }

      if (field.type === 'select') {
        var _formFields$find6;

        var _id3 = field.id;
        return [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaFormModalContents_Select, {
          id: field.id,
          name: field.name,
          description: field.description,
          isRequired: field.isRequired,
          range: field.range,
          options: field.options,
          handleChangeWithId: handleChangeWithId,
          translateKoToEn: translateKoToEn,
          value: (_formFields$find6 = formFields.find(function (f) {
            return f.id === _id3;
          })) === null || _formFields$find6 === void 0 ? void 0 : _formFields$find6.value
        }, field.id)];
      }

      if (field.type === 'email') {
        var _formFields$find7;

        var _id4 = field.id;
        var emailValue = (_formFields$find7 = formFields.find(function (f) {
          return f.id === _id4;
        })) === null || _formFields$find7 === void 0 ? void 0 : _formFields$find7.value;
        return [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
          direction: "column",
          gap: 4,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            style: {
              display: 'flex',
              gap: 8,
              alignItems: 'flex-end'
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaFormModalContents_FormInput, {
              id: _id4,
              title: field.name,
              placeholder: field.placeholder,
              isRequired: field.isRequired,
              description: field.description,
              type: "email",
              handleChangeWithId: handleChangeWithId,
              translateKoToEn: translateKoToEn,
              value: emailValue,
              readOnly: isVerified,
              actionButton: function actionButton(isInvalid) {
                return isEmailVerificationEnabled ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
                  variant: 'skyblue_400_fill',
                  onClick: function onClick() {
                    return onSendVerificationCode(emailValue);
                  },
                  disabled: !emailValue || isVerified || isInvalid,
                  style: {
                    width: 100,
                    height: 37
                  },
                  children: isVerified ? translateKoToEn('verified') : isCodeSent ? translateKoToEn('resend') : translateKoToEn('send')
                }) : null;
              }
            })
          }), isEmailVerificationEnabled && isCodeSent && !isVerified && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
            direction: "row",
            gap: 8,
            alignItems: "center",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, {
              type: 'number',
              placeholder: translateKoToEn('enter-verification-code'),
              width: '100%',
              onChange: function onChange(e) {
                return onChangeVerificationCode === null || onChangeVerificationCode === void 0 ? void 0 : onChangeVerificationCode(e.target.value);
              },
              value: verificationCode,
              onKeyDown: function onKeyDown(event) {
                if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
                  event.stopPropagation();
                }
              }
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
              variant: 'skyblue_400_fill',
              onClick: function onClick() {
                return onVerifyCode === null || onVerifyCode === void 0 ? void 0 : onVerifyCode(verificationCode !== null && verificationCode !== void 0 ? verificationCode : '');
              },
              disabled: !verificationCode,
              style: {
                width: 72,
                height: 37
              },
              children: translateKoToEn('confirm')
            })]
          })]
        }, _id4)];
      }

      var id = field.id;
      return [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaFormModalContents_FormInput, {
        id: id,
        title: field.name,
        placeholder: 'placeholder' in field ? field.placeholder : '',
        isRequired: field.isRequired,
        description: field.description,
        handleChangeWithId: handleChangeWithId,
        translateKoToEn: translateKoToEn,
        value: (_formFields$find8 = formFields.find(function (f) {
          return f.id === id;
        })) === null || _formFields$find8 === void 0 ? void 0 : _formFields$find8.value
      }, id)];
    })
  });
};

/* harmony default export */ var BulkViewer_CtaFormModalContents = (CtaFormModalContents);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/mutation/cta/useVerifyFormEmailAuth.ts


var verifyFormEmailAuth = function verifyFormEmailAuth(request) {
  return api_api.post('/v2/viewer/submit/form-email-auth-verify', request);
};

var useVerifyFormEmailAuth = function useVerifyFormEmailAuth(options) {
  return (0,lib_useMutation/* useMutation */.D)(verifyFormEmailAuth, options);
};

/* harmony default export */ var cta_useVerifyFormEmailAuth = (useVerifyFormEmailAuth);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/Desktop/CtaFormLayer/CtaFormModal/index.styles.ts


function CtaFormModal_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var index_styles_CloseButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "eye36g26"
} : 0)( true ? {
  name: "hpgsro",
  styles: "min-width:25px"
} : 0);
var Modal = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "eye36g25"
} : 0)("position:absolute;z-index:", constants/* VIEWER_Z_INDEX.ctaFormLayer */.G.ctaFormLayer, ";top:50%;left:50%;transform:translate(-50%, -50%);" + ( true ? "" : 0));
var ModalBody = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "eye36g24"
} : 0)("padding:2rem;background-color:", styles/* theme.colors.white */.rS.colors.white, ";border-radius:0.5rem;" + ( true ? "" : 0));
var ModalContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "eye36g23"
} : 0)( true ? {
  name: "1ic5orw",
  styles: "overflow:scroll;max-height:calc(100vh - 512px);overscroll-behavior:contain;&::-webkit-scrollbar{display:none;}"
} : 0);
var Dim = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eye36g22"
} : 0)("position:absolute;z-index:", constants/* VIEWER_Z_INDEX.ctaFormDimmer */.G.ctaFormDimmer, ";top:0;left:0;width:100%;height:100%;backdrop-filter:blur(0.5rem);background-color:rgb(0 0 0 / 50%);" + ( true ? "" : 0));
var index_styles_Spinner = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eye36g21"
} : 0)( true ? {
  name: "4q2ohf",
  styles: "@keyframes spin{from{transform:rotate(0deg);}to{transform:rotate(360deg);}}display:flex;animation:spin 1s linear infinite"
} : 0);
var FlexBottomCTAButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eye36g20"
} : 0)( true ? {
  name: "budh8k",
  styles: "display:flex;flex-direction:column;gap:16px"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/Desktop/CtaFormLayer/CtaFormModal/index.tsx


function CtaFormModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CtaFormModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CtaFormModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CtaFormModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





















var CtaFormModal = function CtaFormModal(_ref) {
  var ctaForm = _ref.ctaForm,
      isEmailVerificationEnabled = _ref.isEmailVerificationEnabled,
      isPreview = _ref.isPreview,
      closeModal = _ref.closeModal,
      translateKoToEn = _ref.translateKoToEn,
      userSubscriptionPlan = _ref.userSubscriptionPlan;

  var _useState = (0,node_modules_react.useState)([]),
      formFields = _useState[0],
      setFormFields = _useState[1];

  var _useViewerRoute = ViewerRoute_useViewerRoute(),
      historyId = _useViewerRoute.historyId;

  var scrollRef = (0,node_modules_react.useRef)(null);
  var toast = (0,src/* useToast */.pm)();

  var _useState2 = (0,node_modules_react.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = (0,node_modules_react.useState)(false),
      isCodeSent = _useState3[0],
      setIsCodeSent = _useState3[1];

  var _useState4 = (0,node_modules_react.useState)(''),
      verificationCode = _useState4[0],
      setVerificationCode = _useState4[1];

  var _useState5 = (0,node_modules_react.useState)(false),
      isVerified = _useState5[0],
      setIsVerified = _useState5[1];

  var setPreviewFormSubmitted = (0,react/* useSetAtom */.b9)(index_atom_isPreviewFormSubmittedAtom);
  var isBlind = (ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.blind) === 'none';

  var _usePostCtaFormWithIn = cta_usePostCtaForm(),
      postCtaFormMutate = _usePostCtaFormWithIn.mutate;

  var _usePostFormEmailAuth = useFormEmailAuth({
    onSuccess: function onSuccess() {
      setIsCodeSent(true);
      toast("".concat(translateKoToEn('verification-code-sent')));
    },
    onError: function onError() {
      toast("".concat(translateKoToEn('verification-code-failed')));
    }
  }),
      sendAuthEmail = _usePostFormEmailAuth.mutate;

  var _useVerifyFormEmailAu = cta_useVerifyFormEmailAuth({
    onSuccess: function onSuccess() {
      setIsVerified(true);
      toast("".concat(translateKoToEn('verification-success')));
    },
    onError: function onError() {
      setIsVerified(false);
      toast("".concat(translateKoToEn('verification-failed')));
    }
  }),
      verifyEmail = _useVerifyFormEmailAu.mutate;

  var _useScrollEndDetectio = (0,react_hooks/* useScrollEndDetection */.rC)(scrollRef),
      isEndDetection = _useScrollEndDetectio.isEndDetection,
      handleScroll = _useScrollEndDetectio.handleScroll,
      scrollToBottom = _useScrollEndDetectio.scrollToBottom;

  var forwardWheelToContents = function forwardWheelToContents(e) {
    var scrollEl = scrollRef.current;

    if (!scrollEl) {
      return;
    }

    var deltaY = e.deltaY;
    var scrollTop = scrollEl.scrollTop,
        scrollHeight = scrollEl.scrollHeight,
        clientHeight = scrollEl.clientHeight;
    var isScrollable = scrollHeight > clientHeight;

    if (!isScrollable) {
      return;
    }

    var isScrollingDown = deltaY > 0;
    var isScrollingUp = deltaY < 0;
    var isAtTop = scrollTop <= 0;
    var isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;
    var canScrollDown = isScrollingDown && !isAtBottom;
    var canScrollUp = isScrollingUp && !isAtTop;

    if (canScrollDown || canScrollUp) {
      e.preventDefault();
      e.stopPropagation();
      scrollEl.scrollTop += deltaY;
      handleScroll();
    }
  };

  var handleSubmit = function handleSubmit() {
    if (isLoading) {
      return;
    }

    if (typeof historyId === 'string') {
      setIsLoading(true);
      postCtaFormMutate({
        historyId: historyId,
        formRecord: formFields,
        code: verificationCode === '' ? undefined : verificationCode,
        onSuccess: function onSuccess() {
          setIsLoading(false);
          closeModal();
          toast("".concat(translateKoToEn('form-submit')));
        },
        onError: function onError() {
          setIsLoading(false);
        }
      });
    }
  };

  var handleChangeWithId = function handleChangeWithId(id, value) {
    setFormFields(function (prev) {
      return prev === null || prev === void 0 ? void 0 : prev.map(function (field) {
        if (field.id === id) {
          return CtaFormModal_objectSpread(CtaFormModal_objectSpread({}, field), {}, {
            value: value
          });
        }

        return field;
      });
    });
  };

  (0,node_modules_react.useEffect)(function () {
    if (ctaForm !== null && ctaForm !== void 0 && ctaForm.fields) {
      setFormFields(ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.fields.map(function (field) {
        if (field.type === 'email') {
          var _field$initialValue;

          return {
            id: field.id,
            name: field.name,
            type: field.type,
            value: (_field$initialValue = field.initialValue) !== null && _field$initialValue !== void 0 ? _field$initialValue : null
          };
        }

        return {
          id: field.id,
          name: field.name,
          type: field.type,
          value: null
        };
      }));
    }
  }, []);
  var buttonDisabled = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.fields.some(function (field) {
    if (field.isRequired) {
      var _formFields$find;

      var currentValue = formFields === null || formFields === void 0 ? void 0 : (_formFields$find = formFields.find(function (f) {
        return f.id === field.id;
      })) === null || _formFields$find === void 0 ? void 0 : _formFields$find.value;

      if (!currentValue) {
        return true;
      }

      if (field.type === 'number') {
        var numberValue = currentValue;
        return !(numberValue <= field.range.max && numberValue >= field.range.min);
      }

      if (field.type === 'select') {
        var selectedValue = currentValue;
        return !(selectedValue.length >= field.range.min && selectedValue.length <= field.range.max);
      }

      if (field.type === 'email') {
        var emailValue = currentValue;
        var isInvalidEmail = !formValidations/* FORM_VALIDATIONS.email.pattern.value.test */.R.email.pattern.value.test(emailValue) && Boolean(emailValue);
        return isInvalidEmail || isEmailVerificationEnabled && !isVerified;
      }

      if (field.type === 'string' || field.type === 'name') {
        var stringValue = currentValue;
        return !stringValue || stringValue.trim() === '';
      }

      return !currentValue;
    }
  });

  var handleSendCode = function handleSendCode() {
    var _formFields$find2;

    if (isPreview) {
      setIsCodeSent(true);
      toast("\uBBF8\uB9AC\uBCF4\uAE30 \uBAA8\uB4DC\uC785\uB2C8\uB2E4. \uC544\uBB34 \uCF54\uB4DC\uB098 \uC785\uB825\uD558\uC154\uB3C4 \uC778\uC99D\uC774 \uC644\uB8CC\uB429\uB2C8\uB2E4.");
      return;
    }

    sendAuthEmail({
      email: (_formFields$find2 = formFields.find(function (f) {
        return f.type === 'email';
      })) === null || _formFields$find2 === void 0 ? void 0 : _formFields$find2.value,
      historyId: historyId
    });
  };

  var handleVerify = function handleVerify() {
    var _formFields$find3;

    if (isPreview) {
      setIsVerified(true);
      toast("".concat(translateKoToEn('verification-success')));
      return;
    }

    verifyEmail({
      email: (_formFields$find3 = formFields.find(function (f) {
        return f.type === 'email';
      })) === null || _formFields$find3 === void 0 ? void 0 : _formFields$find3.value,
      code: verificationCode,
      historyId: historyId
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dom_motion/* motion.div */.E.div, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.3,
      ease: 'easeInOut'
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal, {
      direction: "column",
      gap: 32,
      width: "375px",
      justifyContent: "center",
      onWheel: forwardWheelToContents,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "xl-semibold",
        color: "white",
        textAlign: "center",
        children: ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.description
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ModalBody, {
        direction: "column",
        gap: 24,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 16,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "lg-semibold",
            color: "black",
            children: ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.name
          }), isBlind && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_styles_CloseButton, {
            type: "button",
            onClick: closeModal,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "md-medium",
              color: "zinc_400",
              children: translateKoToEn('close')
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ModalContents, {
          direction: "column",
          gap: 16,
          onScroll: handleScroll,
          ref: scrollRef,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BulkViewer_CtaFormModalContents, {
            formFields: formFields,
            handleChangeWithId: handleChangeWithId,
            translateKoToEn: translateKoToEn,
            fields: ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.fields,
            isCodeSent: isCodeSent,
            isVerified: isVerified,
            verificationCode: verificationCode,
            onSendVerificationCode: handleSendCode,
            onVerifyCode: handleVerify,
            onChangeVerificationCode: setVerificationCode,
            isEmailVerificationEnabled: isEmailVerificationEnabled
          }), !isEndDetection && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* FixedAnimationIcon */._Y, {
            size: 24,
            icon: "ph:caret-double-down",
            bottom: userSubscriptionPlan === 'Free' ? 120 : 90,
            onClick: scrollToBottom
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FlexBottomCTAButtonWrapper, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Button */.zx, {
            id: googleEventId_GOOGLE_EVENT_ID.form,
            variant: "black_fill",
            radius: 9999,
            paddingY: 12,
            textVariant: "lg-semibold",
            disabled: buttonDisabled || isLoading,
            onClick: function onClick(e) {
              e.stopPropagation();
              e.preventDefault();

              if (isPreview) {
                setPreviewFormSubmitted(true);
                closeModal();
                return;
              }

              handleSubmit();
            },
            children: [isLoading && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_styles_Spinner, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
                  icon: "ph:circle-notch",
                  size: 20,
                  color: "zinc_400"
                })
              }), ' ']
            }), ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.button]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFreeBadge_Desktop, {
            userSubscriptionPlan: userSubscriptionPlan
          })]
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dim, {})]
  });
};

/* harmony default export */ var CtaFormLayer_CtaFormModal = (CtaFormModal);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/animation/hooks/use-animation.mjs + 1 modules
var use_animation = __webpack_require__(28066);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/useCtaButtonAnimation.ts






var useCtaButtonAnimation = function useCtaButtonAnimation() {
  var buttonAnimationControls = (0,use_animation/* useAnimation */._)();
  var textWrapperAnimationControls = (0,use_animation/* useAnimation */._)();
  var textAnimationControls = (0,use_animation/* useAnimation */._)();

  var _useAtom = (0,react/* useAtom */.KO)(index_atom/* isAnimationPlayedAtom */.To),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      isAnimationPlayed = _useAtom2[0],
      setIsAnimationPlayed = _useAtom2[1];

  (0,node_modules_react.useEffect)(function () {
    if (!isAnimationPlayed) {
      textWrapperAnimationControls.set({
        width: 50,
        height: 50
      });
      buttonAnimationControls.set({
        y: 100,
        opacity: 0
      });
      textAnimationControls.set({
        opacity: 0
      });
      buttonAnimationControls.start({
        y: 0,
        opacity: 1
      }).then(function () {
        textWrapperAnimationControls.start({
          width: 'fit-content',
          height: 50
        }).then(function () {
          textAnimationControls.start({
            opacity: 1
          });
          setIsAnimationPlayed(true);
        });
      });
    }
  }, [isAnimationPlayed]);
  return {
    buttonAnimationControls: buttonAnimationControls,
    textWrapperAnimationControls: textWrapperAnimationControls,
    textAnimationControls: textAnimationControls
  };
};

/* harmony default export */ var hooks_useCtaButtonAnimation = (useCtaButtonAnimation);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/ctaButton.styles.ts


function ctaButton_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var AnimationWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dom_motion/* motion.div */.E.div,  true ? {
  target: "e10klclv2"
} : 0)( true ? {
  name: "uipqd4",
  styles: "display:flex;width:100%;align-items:center;justify-content:center"
} : 0);
var CtaAnimationButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dom_motion/* motion.button */.E.button,  true ? {
  target: "e10klclv1"
} : 0)("z-index:", constants/* VIEWER_Z_INDEX.ctaButton */.G.ctaButton, ";width:fit-content;min-width:50px;padding:16px;border:1px solid ", styles/* theme.colors.zinc_400 */.rS.colors.zinc_400, ";animation:", styles/* animation.pulse */.oQ.pulse('79, 88, 96', 1), " 2.5s infinite;background-color:", styles/* theme.colors.zinc_700 */.rS.colors.zinc_700, ";border-radius:8px;box-shadow:", styles/* theme.elevation.sm */.rS.elevation.sm, ";pointer-events:auto;" + ( true ? "" : 0));
var CtaButtonDot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10klclv0"
} : 0)("width:16px;height:16px;padding:16px;border:1px solid ", styles/* theme.colors.zinc_400 */.rS.colors.zinc_400, ";background-color:", styles/* theme.colors.zinc_700 */.rS.colors.zinc_700, ";border-radius:8px;pointer-events:auto;" + ( true ? "" : 0));
var CtaButtonText = (0,dom_motion/* motion */.E)(src/* Text */.xv);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/Desktop/CtaFormLayer/FormOpenButton/index.tsx





var FormOpenButton = function FormOpenButton(_ref) {
  var openModal = _ref.openModal,
      buttonText = _ref.buttonText;

  var _useCtaButtonAnimatio = hooks_useCtaButtonAnimation(),
      buttonAnimationControls = _useCtaButtonAnimatio.buttonAnimationControls,
      textAnimationControls = _useCtaButtonAnimatio.textAnimationControls,
      textWrapperAnimationControls = _useCtaButtonAnimatio.textWrapperAnimationControls;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
    mode: "wait",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimationWrapper, {
      animate: buttonAnimationControls,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaAnimationButton, {
        animate: textWrapperAnimationControls,
        transition: {
          duration: 0.2,
          ease: 'easeInOut'
        },
        onClick: openModal,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaButtonText, {
          animate: textAnimationControls,
          variant: "lg-semibold",
          color: "white",
          transition: {
            duration: 0.05,
            ease: 'easeInOut'
          },
          children: buttonText
        })
      })
    })
  });
};

/* harmony default export */ var CtaFormLayer_FormOpenButton = (FormOpenButton);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/Desktop/CtaFormLayer/index.styles.ts


function CtaFormLayer_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var FlexBottomWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e5azgpm0"
} : 0)( true ? {
  name: "2i1uf1",
  styles: "position:absolute;bottom:108px;pointer-events:none"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/Desktop/CtaFormLayer/index.tsx












var CtaFormLayer_CtaFormLayer = function CtaFormLayer(_ref) {
  var _ctaForm$name;

  var ctaForm = _ref.ctaForm,
      isPreview = _ref.isPreview,
      isEmailVerificationEnabled = _ref.isEmailVerificationEnabled,
      isFormSubmitted = _ref.isFormSubmitted,
      translateKoToEn = _ref.translateKoToEn,
      userSubscriptionPlan = _ref.userSubscriptionPlan;

  var _useAtom = (0,react/* useAtom */.KO)(index_atom/* isCtaModalOpenAtom */.D5),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      isOpenModal = _useAtom2[0],
      setIsOpenModal = _useAtom2[1];

  var currentPage = (0,react/* useAtomValue */.Dv)(index_atom/* currentPageAtom */.ef);
  var isPreviewFormSubmitted = (0,react/* useAtomValue */.Dv)(index_atom_isPreviewFormSubmittedAtom);
  var ctaFormPage = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.page;
  var blindMode = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.blind;
  var isNoneBlindMode = blindMode === 'none';
  var isCtaFormPageAndNoneBlindMode = ctaFormPage === currentPage && isNoneBlindMode && !isFormSubmitted;
  (0,node_modules_react.useEffect)(function () {
    if (isNoneBlindMode) {
      setIsOpenModal(false);
    } else {
      var isOpen = ctaFormPage === currentPage && !isFormSubmitted;
      setIsOpenModal(isOpen);
    }
  }, [isNoneBlindMode, currentPage, ctaFormPage]);

  var closeModal = function closeModal() {
    setIsOpenModal(false);
  };

  var openModal = function openModal() {
    setIsOpenModal(true);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AnimatePresence/* AnimatePresence */.M, {
    mode: "wait",
    children: [isOpenModal && !isPreviewFormSubmitted && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaFormLayer_CtaFormModal, {
      ctaForm: ctaForm,
      isEmailVerificationEnabled: isEmailVerificationEnabled,
      isPreview: isPreview,
      closeModal: closeModal,
      translateKoToEn: translateKoToEn,
      userSubscriptionPlan: userSubscriptionPlan
    }), isCtaFormPageAndNoneBlindMode && !isFormSubmitted && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlexBottomWrapper, {
      direction: "column",
      gap: 8,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaFormLayer_FormOpenButton, {
        openModal: openModal,
        buttonText: (_ctaForm$name = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.name) !== null && _ctaForm$name !== void 0 ? _ctaForm$name : ''
      })
    })]
  });
};

/* harmony default export */ var Desktop_CtaFormLayer = (CtaFormLayer_CtaFormLayer);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/mutation/cta/useBulkCtaButtonSubmit.ts


function useBulkCtaButtonSubmit_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useBulkCtaButtonSubmit_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useBulkCtaButtonSubmit_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useBulkCtaButtonSubmit_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var postBulkCtaButton = function postBulkCtaButton(_ref) {
  var historyId = _ref.historyId,
      linkRecord = _ref.linkRecord;
  return api_api.post('/v2/viewer/submit/link', {
    historyId: historyId,
    linkRecord: linkRecord
  });
};

var useBulkCtaButtonSubmit = function useBulkCtaButtonSubmit(options) {
  return (0,lib_useMutation/* useMutation */.D)(postBulkCtaButton, useBulkCtaButtonSubmit_objectSpread({}, options));
};

/* harmony default export */ var cta_useBulkCtaButtonSubmit = (useBulkCtaButtonSubmit);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/Desktop/CtaButton/index.tsx








var CtaButton = function CtaButton(_ref) {
  var id = _ref.id,
      button = _ref.button,
      url = _ref.url,
      page = _ref.page,
      _ref$isPreview = _ref.isPreview,
      isPreview = _ref$isPreview === void 0 ? false : _ref$isPreview;

  var _useViewerRoute = ViewerRoute_useViewerRoute(),
      historyId = _useViewerRoute.historyId;

  var _useBulkCtaButtonSubm = cta_useBulkCtaButtonSubmit(),
      submitBulkCtaButtonAction = _useBulkCtaButtonSubm.mutate;

  var _useCtaButtonAnimatio = hooks_useCtaButtonAnimation(),
      buttonAnimationControls = _useCtaButtonAnimatio.buttonAnimationControls,
      textAnimationControls = _useCtaButtonAnimatio.textAnimationControls,
      textWrapperAnimationControls = _useCtaButtonAnimatio.textWrapperAnimationControls;

  var handleCtaButtonClick = function handleCtaButtonClick() {
    window.open(url, '_blank');

    if (isPreview) {
      return;
    }

    if (typeof historyId === 'string') {
      submitBulkCtaButtonAction({
        historyId: historyId,
        linkRecord: {
          id: id,
          page: page,
          url: url
        }
      });
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
    mode: "wait",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimationWrapper, {
      animate: buttonAnimationControls,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaAnimationButton, {
        id: googleEventId_GOOGLE_EVENT_ID.cta,
        animate: textWrapperAnimationControls,
        transition: {
          duration: 0.2,
          ease: 'easeInOut'
        },
        onClick: handleCtaButtonClick,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaButtonText, {
          id: googleEventId_GOOGLE_EVENT_ID.cta,
          animate: textAnimationControls,
          variant: "lg-semibold",
          color: "white",
          transition: {
            duration: 0.05,
            ease: 'easeInOut'
          },
          children: button
        })
      })
    })
  });
};

/* harmony default export */ var Desktop_CtaButton = (CtaButton);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/Desktop/CtaButtonLayer/index.styles.ts


function CtaButtonLayer_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var index_styles_FlexBottomWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eiiytnp0"
} : 0)( true ? {
  name: "vygcz",
  styles: "position:absolute;bottom:108px;display:flex;width:100%;align-items:center;pointer-events:none"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/Desktop/CtaButtonLayer/index.tsx






var CtaButtonLayer_CtaButtonLayer = function CtaButtonLayer(_ref) {
  var ctaButtonList = _ref.ctaButtonList,
      isPreview = _ref.isPreview;
  var currentPage = (0,react/* useAtomValue */.Dv)(index_atom/* currentPageAtom */.ef);
  var currentCtaButton = ctaButtonList === null || ctaButtonList === void 0 ? void 0 : ctaButtonList.find(function (item) {
    return item.page === currentPage;
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_styles_FlexBottomWrapper, {
    children: currentCtaButton && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Desktop_CtaButton, {
      id: currentCtaButton.id,
      button: currentCtaButton.button,
      url: currentCtaButton.url,
      page: currentCtaButton.page,
      isPreview: isPreview
    })
  });
};

/* harmony default export */ var Desktop_CtaButtonLayer = (CtaButtonLayer_CtaButtonLayer);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-portal/dist/index.mjs
var dist = __webpack_require__(78773);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/Mobile/CtaFormLayer/index.styles.ts



var CtaFormLayer_index_styles_templateObject;

function Mobile_CtaFormLayer_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var slideUp = (0,emotion_react_browser_esm/* keyframes */.F4)(CtaFormLayer_index_styles_templateObject || (CtaFormLayer_index_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  0% {\n    transform: translateY(100%);\n  }\n\n  100% {\n    transform: translateY(0%);\n  }\n"])));
var CtaFormLayer_index_styles_StackWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "etqjqkz2"
} : 0)("position:fixed;z-index:", constants/* VIEWER_Z_INDEX.ctaFormLayer */.G.ctaFormLayer, ";top:60px;width:100%;height:calc(100% - 40px);animation:", slideUp, " 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;" + ( true ? "" : 0));
var FlexFixedBottomCTAButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "etqjqkz1"
} : 0)( true ? {
  name: "z5y6t6",
  styles: "position:fixed;bottom:0;left:0;background:linear-gradient(0deg, #fff 30.73%, rgb(255 255 255 / 0%) 100%)"
} : 0);
var CtaFormLayer_index_styles_FlexBottomWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "etqjqkz0"
} : 0)("position:fixed;bottom:", function (_ref) {
  var isDrawerOpen = _ref.isDrawerOpen,
      isDisableHelpers = _ref.isDisableHelpers,
      isMobileLandscape = _ref.isMobileLandscape;
  return isDrawerOpen && isDisableHelpers ? '160px' : isDrawerOpen && !isDisableHelpers ? '220px' : isDisableHelpers ? '30px' : isMobileLandscape ? '100px' : '70px';
}, ";display:flex;width:100%;align-items:center;pointer-events:none;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/FormFreeBadge/Mobile/index.styles.ts


function FormFreeBadge_Mobile_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var Mobile_index_styles_Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e10f1uy40"
} : 0)( true ? {
  name: "1vbxs2d",
  styles: "display:none;width:100%;border-radius:8px;opacity:0;transition:all ease-in-out 150ms;visibility:hidden;&:hover{cursor:pointer;}&.is-visible{display:flex;opacity:0.8;visibility:visible;}"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/FormFreeBadge/Mobile/index.tsx







var MobileFormFreeBadge = function MobileFormFreeBadge(_ref) {
  var userSubscriptionPlan = _ref.userSubscriptionPlan;

  var isFreeBadgeVisible = function isFreeBadgeVisible() {
    return userSubscriptionPlan === 'Free';
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Mobile_index_styles_Container, {
    gap: 8,
    padding: {
      x: 16,
      y: 12
    },
    className: isFreeBadgeVisible() ? 'is-visible' : '',
    alignItems: "center",
    justifyContent: "center",
    width: "fit-content",
    onClick: function onClick() {
      utils_handleFreeBadgeLinkOpen();
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: "sm-semibold",
      color: "skyblue_600",
      children: "Powered by"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
      src: "/images/salesclue_logo_default.png",
      width: 75,
      height: 17,
      alt: 'SalesClue',
      unoptimized: true
    })]
  });
};

/* harmony default export */ var FormFreeBadge_Mobile = (MobileFormFreeBadge);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/Mobile/CtaFormLayer/CtaFormModal/index.styles.ts


function CtaFormLayer_CtaFormModal_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var CtaFormModal_index_styles_CloseButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "elc0f1n6"
} : 0)( true ? {
  name: "hpgsro",
  styles: "min-width:25px"
} : 0);
var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Text */.xv,  true ? {
  target: "elc0f1n5"
} : 0)( true ? {
  name: "17qwk4",
  styles: "padding:0 32px"
} : 0);
var index_styles_Modal = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "elc0f1n4"
} : 0)( true ? {
  name: "a4hmbt",
  styles: "position:absolute"
} : 0);
var index_styles_ModalBody = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "elc0f1n3"
} : 0)("z-index:", constants/* VIEWER_Z_INDEX.ctaFormLayer */.G.ctaFormLayer, ";width:100%;height:100dvh;padding:32px 32px calc(32px + env(safe-area-inset-bottom));background-color:", styles/* theme.colors.white */.rS.colors.white, ";border-radius:8px 8px 0 0;" + ( true ? "" : 0));
var index_styles_ModalContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "elc0f1n2"
} : 0)( true ? {
  name: "1k1he32",
  styles: "overflow-y:auto;overflow-x:hidden;-webkit-overflow-scrolling:touch;height:100dvh;max-height:calc(100dvh - 324px);&::-webkit-scrollbar{display:none;}"
} : 0);
var index_styles_Dim = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "elc0f1n1"
} : 0)("position:fixed;z-index:", constants/* VIEWER_Z_INDEX.layer */.G.layer, ";top:0;left:0;width:100%;height:100%;backdrop-filter:blur(0.5rem);background-color:rgb(0 0 0 / 50%);" + ( true ? "" : 0));
var index_styles_FlexFixedBottomCTAButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "elc0f1n0"
} : 0)( true ? {
  name: "131g3gd",
  styles: "position:fixed;bottom:0;left:0;background:linear-gradient(0deg, #fff 30.73%, rgb(255 255 255 / 0%) 100%);gap:8px"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/Mobile/CtaFormLayer/CtaFormModal/index.tsx



function CtaFormLayer_CtaFormModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CtaFormLayer_CtaFormModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CtaFormLayer_CtaFormModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CtaFormLayer_CtaFormModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





















var CtaFormModal_CtaFormModal = function CtaFormModal(_ref) {
  var ctaForm = _ref.ctaForm,
      isEmailVerificationEnabled = _ref.isEmailVerificationEnabled,
      isPreview = _ref.isPreview,
      closeModal = _ref.closeModal,
      translateKoToEn = _ref.translateKoToEn,
      userSubscriptionPlan = _ref.userSubscriptionPlan;
  var currentPage = (0,react/* useAtomValue */.Dv)(index_atom/* currentPageAtom */.ef);

  var _useState = (0,node_modules_react.useState)([]),
      formFields = _useState[0],
      setFormFields = _useState[1];

  var _useViewerRoute = ViewerRoute_useViewerRoute(),
      historyId = _useViewerRoute.historyId;

  var scrollRef = (0,node_modules_react.useRef)(null);
  var toast = (0,src/* useToast */.pm)();

  var _useState2 = (0,node_modules_react.useState)(false),
      isCodeSent = _useState2[0],
      setIsCodeSent = _useState2[1];

  var _useState3 = (0,node_modules_react.useState)(''),
      verificationCode = _useState3[0],
      setVerificationCode = _useState3[1];

  var _useState4 = (0,node_modules_react.useState)(false),
      isVerified = _useState4[0],
      setIsVerified = _useState4[1];

  var _useAtom = (0,react/* useAtom */.KO)(index_atom_isPreviewFormSubmittedAtom),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      isPreviewFormSubmitted = _useAtom2[0],
      setPreviewFormSubmitted = _useAtom2[1];

  if (isPreviewFormSubmitted) {
    return null;
  }

  var isDisabledCloseButton = (ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.blind) === 'startFrom' && currentPage === 1;

  var _usePostCtaFormWithIn = cta_usePostCtaForm(),
      postCtaFormMutate = _usePostCtaFormWithIn.mutate;

  var _usePostFormEmailAuth = useFormEmailAuth({
    onSuccess: function onSuccess() {
      setIsCodeSent(true);
      toast("".concat(translateKoToEn('verification-code-sent')));
    },
    onError: function onError() {
      toast("".concat(translateKoToEn('verification-code-failed')));
    }
  }),
      sendAuthEmail = _usePostFormEmailAuth.mutate;

  var _useVerifyFormEmailAu = cta_useVerifyFormEmailAuth({
    onSuccess: function onSuccess() {
      setIsVerified(true);
      toast("".concat(translateKoToEn('verification-success')));
    },
    onError: function onError() {
      setIsVerified(false);
      toast("".concat(translateKoToEn('verification-failed')));
    }
  }),
      verifyEmail = _useVerifyFormEmailAu.mutate;

  var _useScrollEndDetectio = (0,react_hooks/* useScrollEndDetection */.rC)(scrollRef),
      handleScroll = _useScrollEndDetectio.handleScroll;

  var handleSubmit = function handleSubmit() {
    if (typeof historyId === 'string') {
      postCtaFormMutate({
        historyId: historyId,
        formRecord: formFields,
        code: verificationCode === '' ? undefined : verificationCode,
        onSuccess: function onSuccess() {
          closeModal(true);
          toast("".concat(translateKoToEn('form-submit')));
        }
      });
    }
  };

  var handleChangeWithId = function handleChangeWithId(id, value) {
    setFormFields(function (prev) {
      return prev === null || prev === void 0 ? void 0 : prev.map(function (field) {
        if (field.id === id) {
          return CtaFormLayer_CtaFormModal_objectSpread(CtaFormLayer_CtaFormModal_objectSpread({}, field), {}, {
            value: value
          });
        }

        return field;
      });
    });
  };

  (0,node_modules_react.useEffect)(function () {
    if (ctaForm !== null && ctaForm !== void 0 && ctaForm.fields) {
      setFormFields(ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.fields.map(function (field) {
        if (field.type === 'email') {
          var _field$initialValue;

          return {
            id: field.id,
            name: field.name,
            type: field.type,
            value: (_field$initialValue = field.initialValue) !== null && _field$initialValue !== void 0 ? _field$initialValue : null
          };
        }

        return {
          id: field.id,
          name: field.name,
          type: field.type,
          value: null
        };
      }));
    }
  }, []);
  var buttonDisabled = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.fields.some(function (field) {
    if (field.isRequired) {
      var _formFields$find;

      var currentValue = formFields === null || formFields === void 0 ? void 0 : (_formFields$find = formFields.find(function (f) {
        return f.id === field.id;
      })) === null || _formFields$find === void 0 ? void 0 : _formFields$find.value;

      if (!currentValue) {
        return true;
      }

      if (field.type === 'number') {
        var numberValue = currentValue;
        return !(numberValue <= field.range.max && numberValue >= field.range.min);
      }

      if (field.type === 'select') {
        var selectedValue = currentValue;
        return !(selectedValue.length >= field.range.min && selectedValue.length <= field.range.max);
      }

      if (field.type === 'email') {
        var emailValue = currentValue;
        var isInvalidEmail = !formValidations/* FORM_VALIDATIONS.email.pattern.value.test */.R.email.pattern.value.test(emailValue) && Boolean(emailValue);
        return isInvalidEmail || isEmailVerificationEnabled && !isVerified;
      }

      if (field.type === 'string' || field.type === 'name') {
        var stringValue = currentValue;
        return !stringValue || stringValue.trim() === '';
      }

      return !currentValue;
    }
  });

  var handleSendCode = function handleSendCode() {
    var _formFields$find2;

    if (isPreview) {
      setIsCodeSent(true);
      toast("\uBBF8\uB9AC\uBCF4\uAE30 \uBAA8\uB4DC\uC785\uB2C8\uB2E4. \uC544\uBB34 \uCF54\uB4DC\uB098 \uC785\uB825\uD558\uC154\uB3C4 \uC778\uC99D\uC774 \uC644\uB8CC\uB429\uB2C8\uB2E4.");
      return;
    }

    sendAuthEmail({
      email: (_formFields$find2 = formFields.find(function (f) {
        return f.type === 'email';
      })) === null || _formFields$find2 === void 0 ? void 0 : _formFields$find2.value,
      historyId: historyId
    });
  };

  var handleVerify = function handleVerify() {
    var _formFields$find3;

    if (isPreview) {
      setIsVerified(true);
      toast("".concat(translateKoToEn('verification-success')));
      return;
    }

    verifyEmail({
      email: (_formFields$find3 = formFields.find(function (f) {
        return f.type === 'email';
      })) === null || _formFields$find3 === void 0 ? void 0 : _formFields$find3.value,
      code: verificationCode,
      historyId: historyId
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_styles_Modal, {
      direction: "column",
      gap: 16,
      justifyContent: "center",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
        variant: "lg-semibold",
        color: "white",
        textAlign: "center",
        children: ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.description
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_styles_ModalBody, {
        direction: "column",
        gap: 24,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 16,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "lg-semibold",
            color: "black",
            children: ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.name
          }), !isDisabledCloseButton && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaFormModal_index_styles_CloseButton, {
            type: "button",
            onClick: function onClick() {
              closeModal();
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "md-medium",
              color: "zinc_400",
              children: "\uB2EB\uAE30"
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_styles_ModalContents, {
          direction: "column",
          gap: 16,
          onScroll: handleScroll,
          padding: {
            bottom: 106
          },
          ref: scrollRef,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BulkViewer_CtaFormModalContents, {
            formFields: formFields,
            handleChangeWithId: handleChangeWithId,
            fields: ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.fields,
            translateKoToEn: translateKoToEn,
            isCodeSent: isCodeSent,
            isVerified: isVerified,
            verificationCode: verificationCode,
            onSendVerificationCode: handleSendCode,
            onVerifyCode: handleVerify,
            onChangeVerificationCode: setVerificationCode,
            isEmailVerificationEnabled: isEmailVerificationEnabled
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_styles_FlexFixedBottomCTAButtonWrapper, {
          direction: "column",
          alignItems: "stretch",
          padding: {
            x: 32,
            y: 30.5
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
            id: googleEventId_GOOGLE_EVENT_ID.form,
            variant: "black_fill",
            radius: 9999,
            paddingY: 12,
            textVariant: "lg-semibold",
            disabled: buttonDisabled,
            onClick: function onClick(e) {
              e.stopPropagation();
              e.preventDefault();

              if (isPreview) {
                closeModal();
                setPreviewFormSubmitted(true);
                return;
              }

              handleSubmit();
            },
            children: ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.button
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFreeBadge_Mobile, {
            userSubscriptionPlan: userSubscriptionPlan
          })]
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Root */.f, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_styles_Dim, {})
    })]
  });
};

/* harmony default export */ var Mobile_CtaFormLayer_CtaFormModal = (CtaFormModal_CtaFormModal);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/Mobile/CtaFormLayer/FormOpenButton/index.tsx





var FormOpenButton_FormOpenButton = function FormOpenButton(_ref) {
  var openModal = _ref.openModal,
      buttonText = _ref.buttonText;

  var _useCtaButtonAnimatio = hooks_useCtaButtonAnimation(),
      buttonAnimationControls = _useCtaButtonAnimatio.buttonAnimationControls,
      textAnimationControls = _useCtaButtonAnimatio.textAnimationControls,
      textWrapperAnimationControls = _useCtaButtonAnimatio.textWrapperAnimationControls;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
    mode: "wait",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimationWrapper, {
      animate: buttonAnimationControls,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaAnimationButton, {
        animate: textWrapperAnimationControls,
        transition: {
          duration: 0.2,
          ease: 'easeInOut'
        },
        onClick: openModal,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaButtonText, {
          animate: textAnimationControls,
          variant: "lg-semibold",
          color: "white",
          transition: {
            duration: 0.05,
            ease: 'easeInOut'
          },
          children: buttonText
        })
      })
    })
  });
};

/* harmony default export */ var Mobile_CtaFormLayer_FormOpenButton = (FormOpenButton_FormOpenButton);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/Mobile/CtaFormLayer/index.tsx















var Mobile_CtaFormLayer_CtaFormLayer = function CtaFormLayer(_ref) {
  var _ctaForm$name;

  var ctaForm = _ref.ctaForm,
      isPreview = _ref.isPreview,
      totalPage = _ref.totalPage,
      isNextPageButtonDisabled = _ref.isNextPageButtonDisabled,
      isEmailVerificationEnabled = _ref.isEmailVerificationEnabled,
      isFormSubmitted = _ref.isFormSubmitted,
      translateKoToEn = _ref.translateKoToEn,
      userSubscriptionPlan = _ref.userSubscriptionPlan,
      _ref$isMobileLandscap = _ref.isMobileLandscape,
      isMobileLandscape = _ref$isMobileLandscap === void 0 ? false : _ref$isMobileLandscap;

  var _useAtom = (0,react/* useAtom */.KO)(index_atom/* isCtaModalOpenAtom */.D5),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      isOpenModal = _useAtom2[0],
      setIsOpenModal = _useAtom2[1];

  var isDisableHelpers = (0,react/* useAtomValue */.Dv)(index_atom/* isDisableHelpersAtom */.Tn);
  var isDrawerOpen = (0,react/* useAtomValue */.Dv)(v2IsThumbnailPanelOpenAtom);

  var _useUpdateViewerPageS = hooks_useUpdateViewerPageState(),
      updateCurrentPage = _useUpdateViewerPageS.updateCurrentPage,
      currentPage = _useUpdateViewerPageS.currentPage;

  var ctaFormPage = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.page;
  var blindMode = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.blind;
  var isNoneBlindMode = blindMode === 'none';
  var isCtaFormPageAndNoneBlindMode = ctaFormPage === currentPage && isNoneBlindMode;
  (0,node_modules_react.useEffect)(function () {
    if (isNoneBlindMode) {
      setIsOpenModal(false);
    } else {
      var isOpen = ctaFormPage === currentPage && !isFormSubmitted;
      setIsOpenModal(isOpen);
    }
  }, [isNoneBlindMode, currentPage, ctaFormPage, isFormSubmitted]);
  /*폼을 입력해야하는 상태에서 폼 모달을 닫았을 때  */

  var closeModal = function closeModal() {
    var isMutateSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (!isFormSubmitted && !isMutateSuccess) {
      /*특정 페이지만 가리고 마지막 페이지 인 경우 , 이전 페이지로 이동 */
      if (blindMode === 'specific' && totalPage === currentPage) {
        updateCurrentPage(currentPage - 1);
        /*특정 페이지만 가리고 마지막 페이지가 아닌 경우, 다음 페이지로 이동 */
      } else if (blindMode === 'specific') {
        updateCurrentPage(currentPage + 1);
        /*특정 페이지 이후 모두 가리는 경우, 이전 페이지로 이동 */
      } else if (blindMode === 'startFrom') {
        updateCurrentPage(currentPage - 1);
      }
    }

    setIsOpenModal(false);
  };

  var openModal = function openModal() {
    setIsOpenModal(true);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [isOpenModal && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Root */.f, {
      onTouchStart: function onTouchStart(e) {
        return e.stopPropagation();
      },
      onTouchMove: function onTouchMove(e) {
        return e.stopPropagation();
      },
      onTouchEnd: function onTouchEnd(e) {
        return e.stopPropagation();
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageWrapper_Mobile, {
        totalPage: totalPage,
        isNextPageButtonDisabled: isNextPageButtonDisabled,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaFormLayer_index_styles_StackWrapper, {
          direction: "column",
          padding: {
            top: 0,
            bottom: 107.5
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mobile_CtaFormLayer_CtaFormModal, {
            ctaForm: ctaForm,
            isEmailVerificationEnabled: isEmailVerificationEnabled,
            isPreview: isPreview,
            closeModal: closeModal,
            translateKoToEn: translateKoToEn,
            userSubscriptionPlan: userSubscriptionPlan
          })
        })
      })
    }), isCtaFormPageAndNoneBlindMode && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaFormLayer_index_styles_FlexBottomWrapper, {
      isMobileLandscape: isMobileLandscape,
      isDisableHelpers: isDisableHelpers,
      isDrawerOpen: isDrawerOpen,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mobile_CtaFormLayer_FormOpenButton, {
        openModal: openModal,
        buttonText: (_ctaForm$name = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.name) !== null && _ctaForm$name !== void 0 ? _ctaForm$name : ''
      })
    })]
  });
};

/* harmony default export */ var Mobile_CtaFormLayer = (Mobile_CtaFormLayer_CtaFormLayer);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/Mobile/CtaButton/index.tsx








var CtaButton_CtaButton = function CtaButton(_ref) {
  var id = _ref.id,
      button = _ref.button,
      url = _ref.url,
      page = _ref.page,
      isPreview = _ref.isPreview;

  var _useViewerRoute = ViewerRoute_useViewerRoute(),
      historyId = _useViewerRoute.historyId;

  var _useBulkCtaButtonSubm = cta_useBulkCtaButtonSubmit(),
      submitBulkCtaButtonAction = _useBulkCtaButtonSubm.mutate;

  var _useCtaButtonAnimatio = hooks_useCtaButtonAnimation(),
      buttonAnimationControls = _useCtaButtonAnimatio.buttonAnimationControls,
      textAnimationControls = _useCtaButtonAnimatio.textAnimationControls,
      textWrapperAnimationControls = _useCtaButtonAnimatio.textWrapperAnimationControls;

  var handleCtaButtonClick = function handleCtaButtonClick() {
    window.open(url, '_blank');

    if (isPreview) {
      return;
    }

    if (typeof historyId === 'string') {
      submitBulkCtaButtonAction({
        historyId: historyId,
        linkRecord: {
          id: id,
          page: page,
          url: url
        }
      });
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
    mode: "wait",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimationWrapper, {
      animate: buttonAnimationControls,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaAnimationButton, {
        id: googleEventId_GOOGLE_EVENT_ID.cta,
        animate: textWrapperAnimationControls,
        transition: {
          duration: 0.2,
          ease: 'easeInOut'
        },
        onClick: handleCtaButtonClick,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaButtonText, {
          id: googleEventId_GOOGLE_EVENT_ID.cta,
          animate: textAnimationControls,
          variant: "lg-semibold",
          color: "white",
          transition: {
            duration: 0.05,
            ease: 'easeInOut'
          },
          children: button
        })
      })
    })
  });
};

/* harmony default export */ var Mobile_CtaButton = (CtaButton_CtaButton);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/Mobile/CtaButtonLayer/index.styles.ts

var CtaButtonLayer_index_styles_FlexBottomWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ons9by0"
} : 0)("position:fixed;bottom:", function (_ref) {
  var isDrawerOpen = _ref.isDrawerOpen,
      isDisableHelpers = _ref.isDisableHelpers,
      isMobileLandscape = _ref.isMobileLandscape;
  return isDrawerOpen && isDisableHelpers ? '160px' : isDrawerOpen && !isDisableHelpers ? '200px' : isDisableHelpers ? '30px' : isMobileLandscape ? '100px' : '70px';
}, ";display:flex;width:100%;align-items:center;pointer-events:none;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/Mobile/CtaButtonLayer/index.tsx







var Mobile_CtaButtonLayer_CtaButtonLayer = function CtaButtonLayer(_ref) {
  var ctaButtonList = _ref.ctaButtonList,
      isPreview = _ref.isPreview,
      isMobileLandscape = _ref.isMobileLandscape;
  var currentPage = (0,react/* useAtomValue */.Dv)(index_atom/* currentPageAtom */.ef);
  var isDisableHelpers = (0,react/* useAtomValue */.Dv)(index_atom/* isDisableHelpersAtom */.Tn);
  var isDrawerOpen = (0,react/* useAtomValue */.Dv)(v2IsThumbnailPanelOpenAtom);
  var currentCtaButton = ctaButtonList === null || ctaButtonList === void 0 ? void 0 : ctaButtonList.find(function (item) {
    return item.page === currentPage;
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaButtonLayer_index_styles_FlexBottomWrapper, {
    isMobileLandscape: isMobileLandscape,
    isDisableHelpers: isDisableHelpers,
    isDrawerOpen: isDrawerOpen,
    children: currentCtaButton && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mobile_CtaButton, {
      id: currentCtaButton.id,
      button: currentCtaButton.button,
      url: currentCtaButton.url,
      page: currentCtaButton.page,
      isPreview: isPreview
    })
  });
};

/* harmony default export */ var Mobile_CtaButtonLayer = (Mobile_CtaButtonLayer_CtaButtonLayer);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/Toolbar/PageIndicator/index.styles.ts


function PageIndicator_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



/* V1 DesktopPageIndicator와 동일한 높이/여백 */

var PageIndicator_index_styles_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e1tcnoqu2"
} : 0)( true ? {
  name: "1q8cod3",
  styles: "width:max-content;height:65px;padding:16px 0;background-color:transparent"
} : 0);
/* V1 DesktopPageIndicator와 동일한 현재 페이지 박스 */

var CurrentPageButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e1tcnoqu1"
} : 0)("min-width:48px;height:33px;padding:4px 8px;border:none;background:", styles/* theme.colors.zinc_100 */.rS.colors.zinc_100, ";border-radius:4px;cursor:pointer;transition:0.15s ease-in-out;&:hover{background:", styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, ";}" + ( true ? "" : 0));
var PageInput = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("input",  true ? {
  target: "e1tcnoqu0"
} : 0)("width:48px;padding:4px 8px;border:1px solid ", styles/* theme.colors.skyblue_400 */.rS.colors.skyblue_400, ";appearance:textfield;border-radius:6px;font-size:", styles/* theme.fontSize.md */.rS.fontSize.md, ";outline:none;text-align:center;&::-webkit-outer-spin-button,&::-webkit-inner-spin-button{margin:0;appearance:none;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/Toolbar/PageIndicator/index.tsx






/** "n / N" 페이지 표시. 클릭하면 입력 모드로 전환해 페이지 점프가 가능하다. */
var PageIndicator = function PageIndicator(_ref) {
  var currentPage = _ref.currentPage,
      totalPages = _ref.totalPages,
      goToPage = _ref.goToPage,
      translateKoToEn = _ref.translateKoToEn;

  var _useState = (0,node_modules_react.useState)(false),
      isEditable = _useState[0],
      setIsEditable = _useState[1];

  var _useState2 = (0,node_modules_react.useState)(String(currentPage)),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var inputRef = (0,node_modules_react.useRef)(null);
  (0,node_modules_react.useEffect)(function () {
    if (!isEditable) {
      setInputValue(String(currentPage));
    }
  }, [currentPage, isEditable]);
  (0,node_modules_react.useEffect)(function () {
    if (isEditable) {
      var _inputRef$current, _inputRef$current2;

      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
      (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.select();
    }
  }, [isEditable]);

  var submitPage = function submitPage() {
    var page = Number(inputValue);

    if (!Number.isNaN(page) && page >= 1 && page <= totalPages) {
      goToPage(page);
    }

    setIsEditable(false);
  };

  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    submitPage();
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PageIndicator_index_styles_Wrapper, {
    alignItems: "center",
    gap: 4,
    children: [isEditable ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("form", {
      onSubmit: handleSubmit,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageInput, {
        ref: inputRef,
        type: "number",
        min: 1,
        max: totalPages,
        value: inputValue,
        "aria-label": translateKoToEn('go-to-page'),
        onChange: function onChange(e) {
          return setInputValue(e.target.value);
        },
        onBlur: submitPage
      })
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CurrentPageButton, {
      type: "button",
      "aria-label": translateKoToEn('go-to-page'),
      title: translateKoToEn('go-to-page'),
      onClick: function onClick(e) {
        e.stopPropagation();
        setIsEditable(true);
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "md-medium",
        color: "black",
        children: currentPage
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
      variant: "md-medium",
      color: "black",
      children: ["/ ", totalPages]
    })]
  });
};

/* harmony default export */ var Toolbar_PageIndicator = (PageIndicator);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/Toolbar/ZoomControls/index.styles.ts


function ZoomControls_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



/* 드롭다운 앵커 + 호버 노출 기준 래퍼 */

var PillWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e2vloxy8"
} : 0)( true ? {
  name: "irdpqc",
  styles: "position:relative;&:hover .zoom-percent-area,&.is-menu-open .zoom-percent-area{max-width:120px;opacity:1;}"
} : 0);
/* V1 ZoomButton과 동일한 pds Button 기반 알약형 컨테이너 */

var PillButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "e2vloxy7"
} : 0)( true ? {
  name: "gkkj0e",
  styles: "width:auto;height:59px;transition:opacity 0.15s ease-in-out,width 0.15s ease-in-out;&.disable{cursor:initial;opacity:0.25;}"
} : 0);
/* V1과 동일한 아이콘 여백 */

var PillIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Icon */.JO,  true ? {
  target: "e2vloxy6"
} : 0)( true ? {
  name: "1rlfazj",
  styles: "margin:4px;cursor:pointer"
} : 0);
var PercentArea = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e2vloxy5"
} : 0)( true ? {
  name: "1e8i78p",
  styles: "display:flex;overflow:hidden;max-width:0;align-items:center;opacity:0;transition:max-width 0.15s ease-in-out,opacity 0.15s ease-in-out"
} : 0);
var PercentTrigger = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e2vloxy4"
} : 0)( true ? {
  name: "o82hv3",
  styles: "display:flex;align-items:center;cursor:pointer;gap:4px;white-space:nowrap"
} : 0);
var index_styles_Dropdown = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e2vloxy3"
} : 0)("position:absolute;top:calc(100% + 12px);left:50%;min-width:148px;padding:4px;border:1px solid ", styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, ";background:", styles/* theme.colors.white */.rS.colors.white, ";border-radius:8px;box-shadow:", styles/* theme.elevation.md */.rS.elevation.md, ";transform:translateX(-50%);" + ( true ? "" : 0));
var MenuDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e2vloxy2"
} : 0)("height:1px;margin:4px 0;background:", styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, ";" + ( true ? "" : 0));
var PresetItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e2vloxy1"
} : 0)("padding:6px 12px;border:none;background:", function (_ref) {
  var isActive = _ref.isActive;
  return isActive ? styles/* theme.colors.skyblue_50 */.rS.colors.skyblue_50 : styles/* theme.colors.white */.rS.colors.white;
}, ";border-radius:6px;color:", function (_ref2) {
  var isActive = _ref2.isActive;
  return isActive ? styles/* theme.colors.skyblue_500 */.rS.colors.skyblue_500 : styles/* theme.colors.zinc_700 */.rS.colors.zinc_700;
}, ";cursor:pointer;font-size:", styles/* theme.fontSize.md */.rS.fontSize.md, ";text-align:center;transition:0.15s ease-in-out;&:hover{background:", styles/* theme.colors.zinc_100 */.rS.colors.zinc_100, ";}" + ( true ? "" : 0));
/* 가로 맞춤/페이지 맞춤/전체화면 등 액션 메뉴 아이템 */

var ActionItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e2vloxy0"
} : 0)("display:flex;align-items:center;padding:6px 12px;border:none;background:", function (_ref3) {
  var isActive = _ref3.isActive;
  return isActive ? styles/* theme.colors.skyblue_50 */.rS.colors.skyblue_50 : styles/* theme.colors.white */.rS.colors.white;
}, ";border-radius:6px;color:", function (_ref4) {
  var isActive = _ref4.isActive;
  return isActive ? styles/* theme.colors.skyblue_500 */.rS.colors.skyblue_500 : styles/* theme.colors.zinc_700 */.rS.colors.zinc_700;
}, ";cursor:pointer;font-size:", styles/* theme.fontSize.md */.rS.fontSize.md, ";gap:8px;transition:0.15s ease-in-out;white-space:nowrap;&:hover{background:", styles/* theme.colors.zinc_100 */.rS.colors.zinc_100, ";}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/Toolbar/ZoomControls/index.tsx













/**
 * V2 줌 컨트롤. V1 ZoomButton과 동일한 pds Button 알약([＋][비율][－])을
 * 유지하되, 가운데 비율 표시는 드롭다운 트리거로서 기본 숨김 상태에서
 * 호버(또는 메뉴 열림) 시에만 노출된다. 드롭다운에는 배율 프리셋과
 * 가로 맞춤/페이지 맞춤/전체화면을 그룹핑한다.
 */
var ZoomControls = function ZoomControls(_ref) {
  var fitWidthZoom = _ref.fitWidthZoom,
      isFullscreenActive = _ref.isFullscreenActive,
      toggleFullscreen = _ref.toggleFullscreen,
      translateKoToEn = _ref.translateKoToEn;

  var _useAtom = (0,react/* useAtom */.KO)(v2ZoomAtom),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      zoom = _useAtom2[0],
      setZoom = _useAtom2[1];

  var _useAtom3 = (0,react/* useAtom */.KO)(v2ZoomFitModeAtom),
      _useAtom4 = (0,slicedToArray/* default */.Z)(_useAtom3, 2),
      fitMode = _useAtom4[0],
      setFitMode = _useAtom4[1];

  var setZoomValue = (0,react/* useSetAtom */.b9)(v2ZoomAtom);
  var isDisableHelpers = (0,react/* useAtomValue */.Dv)(index_atom/* isDisableHelpersAtom */.Tn);

  var _useState = (0,node_modules_react.useState)(false),
      isMenuOpen = _useState[0],
      setIsMenuOpen = _useState[1];

  var pillRef = (0,node_modules_react.useRef)(null);
  hooks_useClickOutside([pillRef], function () {
    return setIsMenuOpen(false);
  });

  var applyCustomZoom = function applyCustomZoom(value) {
    setZoom(clampV2Zoom(value));
    setFitMode('custom');
  };

  var applyFitPage = function applyFitPage() {
    setZoomValue(1);
    setFitMode('fitPage');
  };

  var applyFitWidth = function applyFitWidth() {
    setZoomValue(clampV2Zoom(fitWidthZoom));
    setFitMode('fitWidth');
  };

  var closeMenu = function closeMenu() {
    return setIsMenuOpen(false);
  };

  var handleClickZoomIn = function handleClickZoomIn() {
    if (zoom >= V2_ZOOM_MAX) {
      return;
    }

    applyCustomZoom(getNextZoomStep(zoom, 'in'));
  };

  var handleClickZoomOut = function handleClickZoomOut() {
    if (zoom <= V2_ZOOM_MIN) {
      return;
    }

    applyCustomZoom(getNextZoomStep(zoom, 'out'));
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PillWrapper, {
    ref: pillRef,
    className: classnames_default()({
      'is-menu-open': isMenuOpen
    }),
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PillButton, {
      className: isDisableHelpers ? 'disable' : '',
      variant: "zinc_500",
      radius: 9999,
      paddingY: 16,
      "aria-label": translateKoToEn('zoom-in'),
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        direction: "row",
        gap: 16,
        justifyContent: "center",
        alignItems: "center",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PillIcon, {
          icon: "ph:magnifying-glass-plus",
          size: 19,
          color: zoom >= V2_ZOOM_MAX ? 'zinc_400' : 'black',
          onClick: handleClickZoomIn
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PercentArea, {
          className: "zoom-percent-area",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PercentTrigger, {
            role: "button",
            "aria-haspopup": "menu",
            "aria-expanded": isMenuOpen,
            onClick: function onClick(e) {
              e.stopPropagation();
              setIsMenuOpen(function (prev) {
                return !prev;
              });
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
              variant: "lg-medium",
              color: "black",
              children: [Math.round(zoom * 100), "%"]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
              icon: "ph:caret-down",
              size: 14,
              color: "zinc_400"
            })]
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PillIcon, {
          icon: "ph:magnifying-glass-minus",
          size: 19,
          color: zoom <= V2_ZOOM_MIN ? 'zinc_400' : 'black',
          onClick: handleClickZoomOut
        })]
      })
    }), isMenuOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_styles_Dropdown, {
      direction: "column",
      gap: 2,
      children: [V2_ZOOM_PRESETS.map(function (preset) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PresetItem, {
          type: "button",
          isActive: Math.abs(zoom - preset) < 0.01,
          onClick: function onClick(e) {
            e.stopPropagation();
            applyCustomZoom(preset);
            closeMenu();
          },
          children: [Math.round(preset * 100), "%"]
        }, preset);
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuDivider, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ActionItem, {
        type: "button",
        isActive: fitMode === 'fitWidth',
        onClick: function onClick(e) {
          e.stopPropagation();
          applyFitWidth();
          closeMenu();
        },
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:arrows-out-line-horizontal",
          size: 16,
          color: fitMode === 'fitWidth' ? 'skyblue_500' : 'zinc_700'
        }), translateKoToEn('fit-width')]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ActionItem, {
        type: "button",
        isActive: fitMode === 'fitPage',
        onClick: function onClick(e) {
          e.stopPropagation();
          applyFitPage();
          closeMenu();
        },
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:frame-corners",
          size: 16,
          color: fitMode === 'fitPage' ? 'skyblue_500' : 'zinc_700'
        }), translateKoToEn('fit-page')]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuDivider, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ActionItem, {
        type: "button",
        onClick: function onClick(e) {
          e.stopPropagation();
          toggleFullscreen();
          closeMenu();
        },
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: isFullscreenActive ? 'ph:arrows-in' : 'ph:arrows-out',
          size: 16,
          color: "zinc_700"
        }), isFullscreenActive ? translateKoToEn('exit-fullscreen') : translateKoToEn('fullscreen')]
      })]
    })]
  });
};

/* harmony default export */ var Toolbar_ZoomControls = (ZoomControls);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/Toolbar/index.styles.ts


function Toolbar_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



/*
 * V1과 동일한 배치: 배경 바 없이 슬라이드 영역(MainColumn) 위에
 * 좌상단/우상단/하단 중앙으로 흩어진 플로팅 컨트롤.
 * isDisableHelpers 시 반투명 처리(V1 파리티).
 */

var helperDim = "\n  transition: opacity 0.15s ease-in-out;\n\n  &.disabled {\n    cursor: initial;\n    opacity: 0.25;\n  }\n";
var TopRightWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eash7kf2"
} : 0)("position:absolute;z-index:", constants/* VIEWER_Z_INDEX.desktopLayer */.G.desktopLayer, ";top:0;right:0;display:flex;align-items:center;padding:32px 48px;gap:8px;", helperDim, ";" + ( true ? "" : 0));
/* V1 DesktopPageNavigationButton과 동일한 반투명 블러 필 */

var BottomNavWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eash7kf1"
} : 0)("position:absolute;z-index:", constants/* VIEWER_Z_INDEX.desktopLayer */.G.desktopLayer, ";bottom:32px;left:50%;display:flex;align-items:center;border:1px solid ", styles/* theme.colors.zinc_500 */.rS.colors.zinc_500, ";backdrop-filter:blur(8px);background:rgb(255 255 255 / 50%);border-radius:9999px;transform:translateX(-50%);", helperDim, ";" + ( true ? "" : 0));
/* V1 DesktopPageMoveButton과 동일한 투명 화살표 버튼 */

var NavArrowButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "eash7kf0"
} : 0)( true ? {
  name: "1u0naes",
  styles: "display:flex;align-items:center;justify-content:center;padding:8px 16px;border:none;background:transparent;cursor:pointer;transition:opacity 0.15s ease-in-out;&:disabled{cursor:initial;opacity:0.25;}"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/Toolbar/index.tsx















/**
 * V2 데스크톱 플로팅 컨트롤. V1과 동일하게 배경 바 없이
 * 좌상단(목록), 우상단(줌/언어/다운로드/공유/V1 전환), 하단 중앙(페이지 이동)으로
 * 배치하고, 화면 클릭으로 토글되는 isDisableHelpers 상태에 따라 반투명 처리한다.
 */
var Toolbar = function Toolbar(_ref) {
  var document = _ref.document,
      isBulk = _ref.isBulk,
      domain = _ref.domain,
      ctaFormPage = _ref.ctaFormPage,
      isRedirectCtaFormAppropriate = _ref.isRedirectCtaFormAppropriate,
      currentPage = _ref.currentPage,
      goToPage = _ref.goToPage,
      goToPrevPage = _ref.goToPrevPage,
      goToNextPage = _ref.goToNextPage,
      isNextPageDisabled = _ref.isNextPageDisabled,
      fitWidthZoom = _ref.fitWidthZoom,
      isFullscreenActive = _ref.isFullscreenActive,
      toggleFullscreen = _ref.toggleFullscreen,
      translateKoToEn = _ref.translateKoToEn;

  var _useAtom = (0,react/* useAtom */.KO)(index_atom/* isDisableHelpersAtom */.Tn),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      isDisableHelpers = _useAtom2[0],
      setIsDisableHelpers = _useAtom2[1]; // const { setVersion } = useViewerVersion();


  var dimmedClassName = classnames_default()({
    disabled: isDisableHelpers
  });
  /* 흐려진 상태의 첫 클릭은 기능 실행 없이 컨트롤을 다시 켠다(V1 파리티) */

  var handleGuardClickCapture = function handleGuardClickCapture(e) {
    if (!isDisableHelpers) {
      return;
    }

    e.stopPropagation();
    setIsDisableHelpers(false);
  };
  /* 컨트롤 영역 클릭이 뷰어의 헬퍼 토글로 전파되지 않게 한다 */


  var stopClickPropagation = function stopClickPropagation(e) {
    e.stopPropagation();
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TopRightWrapper, {
      className: dimmedClassName,
      onClickCapture: handleGuardClickCapture,
      onClick: stopClickPropagation,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toolbar_ZoomControls, {
        fitWidthZoom: fitWidthZoom,
        isFullscreenActive: isFullscreenActive,
        toggleFullscreen: toggleFullscreen,
        translateKoToEn: translateKoToEn
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LanguageButton_Desktop, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PdfDownloadButton_Desktop, {
        translateKoToEn: translateKoToEn,
        fileName: document.name,
        isDownloadEnabled: document.isDownloadEnabled,
        ctaFormPage: ctaFormPage,
        isRedirectCtaFormAppropriate: isRedirectCtaFormAppropriate,
        isBulk: isBulk
      }), document.isShareable && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShareButton_Desktop, {
        translateKoToEn: translateKoToEn,
        domain: domain,
        isBulk: isBulk
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BottomNavWrapper, {
      className: dimmedClassName,
      onClickCapture: handleGuardClickCapture,
      onClick: stopClickPropagation,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavArrowButton, {
        type: "button",
        "aria-label": translateKoToEn('prev-page'),
        title: translateKoToEn('prev-page'),
        disabled: currentPage <= 1,
        onClick: function onClick(e) {
          e.stopPropagation();
          goToPrevPage();
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:caret-left",
          size: 24,
          color: "black"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toolbar_PageIndicator, {
        currentPage: currentPage,
        totalPages: document.totalPages,
        goToPage: goToPage,
        translateKoToEn: translateKoToEn
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavArrowButton, {
        type: "button",
        "aria-label": translateKoToEn('next-page'),
        title: translateKoToEn('next-page'),
        disabled: currentPage >= document.totalPages || isNextPageDisabled,
        onClick: function onClick(e) {
          e.stopPropagation();
          goToNextPage();
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:caret-right",
          size: 24,
          color: "black"
        })
      })]
    })]
  });
};

/* harmony default export */ var v2_Toolbar = (Toolbar);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/DefaultViewerLayer/PdfDownloadButton/Mobile/index.tsx











var Mobile_MobilePdfDownloadButton = function MobilePdfDownloadButton(_ref) {
  var fileName = _ref.fileName,
      _ref$isBulk = _ref.isBulk,
      isBulk = _ref$isBulk === void 0 ? false : _ref$isBulk,
      _ref$isDownloadEnable = _ref.isDownloadEnabled,
      isDownloadEnabled = _ref$isDownloadEnable === void 0 ? false : _ref$isDownloadEnable,
      ctaFormPage = _ref.ctaFormPage,
      isRedirectCtaFormAppropriate = _ref.isRedirectCtaFormAppropriate,
      translateKoToEn = _ref.translateKoToEn;
  var toast = (0,src/* useToast */.pm)();

  var _useDownloadPdfFile = hooks_useDownloadPdfFile(),
      downloadPdfFile = _useDownloadPdfFile.downloadPdfFile,
      isLoading = _useDownloadPdfFile.isLoading;

  var _useFileDownload = file_useFileDownload(isBulk),
      mutateFileDownload = _useFileDownload.mutate;

  var _useUpdateViewerPageS = hooks_useUpdateViewerPageState(),
      updateCurrentPage = _useUpdateViewerPageS.updateCurrentPage;

  var _useGetFileDownloadLi = hooks_useGetFileDownloadLink({
    handleGetDownloadSuccess: function () {
      var _handleGetDownloadSuccess = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(downloadUrl) {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return downloadPdfFile(downloadUrl, fileName, mutateFileDownload);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function handleGetDownloadSuccess(_x) {
        return _handleGetDownloadSuccess.apply(this, arguments);
      }

      return handleGetDownloadSuccess;
    }()
  }),
      getDownloadLink = _useGetFileDownloadLi.getDownloadLink;

  var handleClick = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(e) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              e.stopPropagation();
              /*유저가 폼을 제출 하기 전에 다운로드 버튼을 클릭한 경우 
              경고 메세지를 보여주고 해당 페이지로 이동시킨다 */

              if (!(isRedirectCtaFormAppropriate && ctaFormPage)) {
                _context2.next = 5;
                break;
              }

              toast("".concat(translateKoToEn('download-alert')));
              updateCurrentPage(ctaFormPage);
              return _context2.abrupt("return");

            case 5:
              getDownloadLink();

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleClick(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  if (!isDownloadEnabled) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileButton, {
    id: googleEventId_GOOGLE_EVENT_ID.download,
    variant: "zinc_500",
    radius: 9999,
    onClick: handleClick,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Spinner, {
      id: googleEventId_GOOGLE_EVENT_ID.download,
      isLoading: isLoading,
      icon: isLoading ? 'ph:circle-notch' : 'ph:download-simple',
      size: 19,
      color: isLoading ? 'zinc_400' : 'black'
    })
  });
};

/* harmony default export */ var PdfDownloadButton_Mobile = (Mobile_MobilePdfDownloadButton);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/DefaultViewerLayer/ShareButton/Mobile/index.styles.ts



var Mobile_index_styles_Button = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "e15kgql0"
} : 0)("z-index:", constants/* VIEWER_Z_INDEX.mobileLayer */.G.mobileLayer, ";width:43px;height:43px;padding:8px;box-shadow:none;transition:opacity 0.15s ease-in-out;&.disable{cursor:initial;opacity:0;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/DefaultViewerLayer/ShareButton/Mobile/index.tsx









var Mobile_MobileShareButton = function MobileShareButton(_ref) {
  var fileName = _ref.fileName,
      domain = _ref.domain,
      translateKoToEn = _ref.translateKoToEn,
      isBulk = _ref.isBulk;

  var _useViewerRoute = ViewerRoute_useViewerRoute(),
      historyId = _useViewerRoute.historyId,
      getShareUrl = _useViewerRoute.getShareUrl;

  var toast = (0,src/* useToast */.pm)();

  var _useFileHistoryShare = file_useFileHistoryShare(isBulk),
      mutateFileHistoryShare = _useFileHistoryShare.mutate;

  var handleClickLinkCopyButton = function handleClickLinkCopyButton(e) {
    e.stopPropagation();
    var url = getShareUrl({
      domain: domain,
      isBulk: isBulk
    });

    if (navigator.share) {
      try {
        navigator.share({
          title: fileName,
          url: url
        });
      } catch (_unused) {
        copyClipboard(url);
      }
    } else {
      copyClipboard(url);
    }

    mutateFileHistoryShare({
      historyId: historyId
    });
  };

  var copyClipboard = function copyClipboard(url) {
    copy_to_clipboard_default()(url);
    toast("".concat(translateKoToEn('link-copy')));
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mobile_index_styles_Button, {
    id: googleEventId_GOOGLE_EVENT_ID.share,
    variant: "zinc_500",
    radius: 9999,
    onClick: handleClickLinkCopyButton,
    leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
      icon: "ph:share-network",
      size: 19,
      color: "black"
    })
  });
};

/* harmony default export */ var ShareButton_Mobile = (Mobile_MobileShareButton);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/DefaultViewerLayer/LanguageButton/Mobile/index.styles.ts


function LanguageButton_Mobile_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var LanguageButton_Mobile_index_styles_Button = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "e125bref3"
} : 0)("z-index:", constants/* VIEWER_Z_INDEX.mobileLayer */.G.mobileLayer, ";width:43px;height:43px;padding:8px;box-shadow:none;transition:opacity 0.15s ease-in-out;&.disable{cursor:initial;opacity:0;}" + ( true ? "" : 0));
var LanguageButton_Mobile_index_styles_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e125bref2"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);
var Mobile_index_styles_Dropdown = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e125bref1"
} : 0)("position:absolute;bottom:calc(100% + 8px);right:0;background-color:", styles/* theme.colors.white */.rS.colors.white, ";border:1px solid ", styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, ";border-radius:12px;padding:8px;min-width:140px;max-height:280px;overflow-y:auto;box-shadow:0 4px 16px rgba(0, 0, 0, 0.12);z-index:", constants/* VIEWER_Z_INDEX.ctaFormLayer */.G.ctaFormLayer, ";" + ( true ? "" : 0));
var index_styles_LanguageItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e125bref0"
} : 0)("width:100%;padding:8px 12px;border:none;border-radius:8px;background-color:", function (_ref) {
  var isActive = _ref.isActive;
  return isActive ? styles/* theme.colors.zinc_100 */.rS.colors.zinc_100 : 'transparent';
}, ";color:", function (_ref2) {
  var isActive = _ref2.isActive;
  return isActive ? styles/* theme.colors.zinc_900 */.rS.colors.zinc_900 : styles/* theme.colors.zinc_600 */.rS.colors.zinc_600;
}, ";font-size:13px;font-weight:", function (_ref3) {
  var isActive = _ref3.isActive;
  return isActive ? 600 : 400;
}, ";cursor:pointer;text-align:left;white-space:nowrap;transition:background-color 0.1s ease-in-out;&:hover{background-color:", styles/* theme.colors.zinc_100 */.rS.colors.zinc_100, ";color:", styles/* theme.colors.zinc_900 */.rS.colors.zinc_900, ";}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/DefaultViewerLayer/LanguageButton/Mobile/index.tsx








var Mobile_LOCALE_NAMES = {
  ko: '한국어',
  en: 'English',
  ja: '日本語',
  'zh-CN': '中文(简体)',
  'zh-TW': '中文(繁體)',
  'zh-HK': '中文(香港)',
  de: 'Deutsch',
  es: 'Español',
  fr: 'Français',
  pt: 'Português',
  ru: 'Русский',
  hi: 'हिन्दी',
  id: 'Indonesia',
  ms: 'Melayu',
  th: 'ภาษาไทย',
  tr: 'Türkçe',
  vi: 'Tiếng Việt'
};

var Mobile_MobileLanguageButton = function MobileLanguageButton() {
  var _router$locales, _router$locale;

  var router = (0,next_router.useRouter)();
  var isDisableHelpers = (0,react/* useAtomValue */.Dv)(index_atom/* isDisableHelpersAtom */.Tn);

  var _useState = (0,node_modules_react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var wrapperRef = (0,node_modules_react.useRef)(null);
  var locales = (_router$locales = router.locales) !== null && _router$locales !== void 0 ? _router$locales : [];
  var currentLocale = (_router$locale = router.locale) !== null && _router$locale !== void 0 ? _router$locale : 'ko';
  (0,node_modules_react.useEffect)(function () {
    var handleClickOutside = function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      return document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  (0,node_modules_react.useEffect)(function () {
    if (isDisableHelpers) {
      setIsOpen(false);
    }
  }, [isDisableHelpers]);

  var handleButtonClick = function handleButtonClick(e) {
    e.stopPropagation();

    if (isDisableHelpers) {
      return;
    }

    setIsOpen(function (prev) {
      return !prev;
    });
  };

  var handleLocaleSelect = function handleLocaleSelect(e, locale) {
    e.stopPropagation();
    var basePath = router.asPath;
    var newPath = locale === router.defaultLocale ? basePath : "/".concat(locale).concat(basePath);
    window.location.href = newPath;
    setIsOpen(false);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LanguageButton_Mobile_index_styles_Wrapper, {
    ref: wrapperRef,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LanguageButton_Mobile_index_styles_Button, {
      // className={isDisableHelpers ? 'disable' : ''}
      variant: "zinc_500",
      radius: 9999,
      onClick: handleButtonClick,
      leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
        icon: "ph:globe",
        size: 19,
        color: "black"
      })
    }), isOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mobile_index_styles_Dropdown, {
      direction: "column",
      gap: 2,
      children: locales.map(function (locale) {
        var _LOCALE_NAMES$locale;

        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_styles_LanguageItem, {
          isActive: locale === currentLocale,
          onClick: function onClick(e) {
            return handleLocaleSelect(e, locale);
          },
          children: (_LOCALE_NAMES$locale = Mobile_LOCALE_NAMES[locale]) !== null && _LOCALE_NAMES$locale !== void 0 ? _LOCALE_NAMES$locale : locale
        }, locale);
      })
    })]
  });
};

/* harmony default export */ var LanguageButton_Mobile = (Mobile_MobileLanguageButton);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/MobileBottomBar/index.styles.ts


function MobileBottomBar_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





/*
 * bottomOffset: 기본 16px + 하단 썸네일 스트립(148px) 열림 시 그만큼 상승.
 * env(safe-area-inset-bottom)로 iOS Safari 주소창/홈 인디케이터 영역을 피한다.
 */

/* V1 MobilePageNavigationButton과 동일한 하단 중앙 반투명 블러 필 */

var NavPill = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e1flb0w19"
} : 0)("position:fixed;z-index:", constants/* VIEWER_Z_INDEX.mobileLayer */.G.mobileLayer, ";bottom:calc(\n    ", function (_ref) {
  var bottomOffset = _ref.bottomOffset;
  return bottomOffset;
}, "px + env(safe-area-inset-bottom, 0px)\n  );left:50%;width:auto;height:auto;border:1px solid ", styles/* theme.colors.zinc_500 */.rS.colors.zinc_500, ";backdrop-filter:blur(8px);background-color:rgb(255 255 255 / 50%);border-radius:9999px;transform:translate(-50%, 0);transition:opacity 0.15s ease-in-out,bottom 0.15s ease-in-out;&.disabled{cursor:initial;opacity:0;}" + ( true ? "" : 0));
/* V1 MobilePageMoveButton과 동일한 투명 화살표 버튼 */

var index_styles_NavArrowButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e1flb0w18"
} : 0)( true ? {
  name: "1un2sid",
  styles: "display:flex;align-items:center;justify-content:center;padding:8px 12px;border:none;background:transparent;cursor:pointer;transition:opacity 0.15s ease-in-out;&:disabled{cursor:initial;opacity:0.25;}"
} : 0);
/* V1 MobilePageIndicator와 동일한 높이의 인디케이터 영역 */

var IndicatorWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e1flb0w17"
} : 0)( true ? {
  name: "17p3tbr",
  styles: "width:auto;height:43px;flex:0 0 0px;background-color:transparent"
} : 0);
var CurrentPageBox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e1flb0w16"
} : 0)("width:auto;min-width:32px;height:23px;padding:4px;background:", styles/* theme.colors.zinc_100 */.rS.colors.zinc_100, ";border-radius:4px;color:", styles/* theme.colors.black */.rS.colors.black, ";" + ( true ? "" : 0));
/*
 * V1 MobileViewerLayer(PositionWrapper)와 동일한 접이식 드로어.
 * 세로: 우하단에서 위로 확장 / 가로(landscape): 우상단에서 옆으로 확장.
 */

var DrawerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e1flb0w15"
} : 0)("position:fixed;z-index:", constants/* VIEWER_Z_INDEX.mobileLayer */.G.mobileLayer, ";right:16px;width:auto;height:auto;background-color:transparent;transition:opacity 0.15s ease-in-out,bottom 0.15s ease-in-out;", function (_ref2) {
  var isMobileLandscape = _ref2.isMobileLandscape,
      bottomOffset = _ref2.bottomOffset;
  return isMobileLandscape ? "top: 16px;" : "bottom: calc(".concat(bottomOffset, "px + env(safe-area-inset-bottom, 0px));");
}, " &.disabled{cursor:initial;opacity:0;}" + ( true ? "" : 0));
var DrawerToggleButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "e1flb0w14"
} : 0)("z-index:", constants/* VIEWER_Z_INDEX.mobileLayer */.G.mobileLayer, ";width:43px;height:43px;padding:8px;border:1px solid ", styles/* theme.colors.zinc_300 */.rS.colors.zinc_300, ";box-shadow:none;transition:opacity 0.15s ease-in-out;&.backgroundOpacity{opacity:0.5;}" + ( true ? "" : 0));
var MotionDrawer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dom_motion/* motion.div */.E.div,  true ? {
  target: "e1flb0w13"
} : 0)("display:flex;flex-direction:", function (_ref3) {
  var isFlexRow = _ref3.isFlexRow;
  return isFlexRow ? 'row' : 'column';
}, ";gap:8px;" + ( true ? "" : 0));
/* V1 MobileZoomButton과 동일한 줌 컨트롤(세로: 위아래 / 가로: 좌우) */

var ZoomPillButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "e1flb0w12"
} : 0)("z-index:", constants/* VIEWER_Z_INDEX.mobileLayer */.G.mobileLayer, ";width:43px;height:auto;padding:8px;box-shadow:none;transition:opacity 0.15s ease-in-out;&.isLandscape{width:auto;height:43px;}" + ( true ? "" : 0));
var ZoomIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Icon */.JO,  true ? {
  target: "e1flb0w11"
} : 0)( true ? {
  name: "137pcyc",
  styles: "margin:4px"
} : 0);
/* V1 MobileButton과 동일한 43px 원형 아이콘 버튼(전체화면/V1 전환용) */

var RoundIconButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "e1flb0w10"
} : 0)("z-index:", constants/* VIEWER_Z_INDEX.desktopLayer */.G.desktopLayer, ";width:43px;height:43px;padding:8px;box-shadow:none;transition:opacity 0.15s ease-in-out;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/MobileBottomBar/index.tsx












/* 하단 썸네일 스트립 높이(ThumbnailPanel 모바일 분기와 동일) */




var THUMBNAIL_STRIP_HEIGHT = 148;

/**
 * V2 모바일 플로팅 컨트롤. V1과 동일하게 배경 바 없이
 * 하단 중앙 반투명 네비 필([◀][목록·페이지][▶])과
 * 접이식 드로어(다운로드/공유/줌/언어/전체화면/V1 전환)로 배치한다.
 * - 세로: 드로어가 우하단에서 위로, 가로: 우상단에서 옆으로 확장(V1 파리티)
 * - 화면 탭으로 토글되는 isDisableHelpers 상태에 따라 숨김 처리
 * - 썸네일 스트립이 열리면 하단 컨트롤이 스트립 위로 올라간다
 */
var MobileBottomBar = function MobileBottomBar(_ref) {
  var document = _ref.document,
      isBulk = _ref.isBulk,
      domain = _ref.domain,
      ctaFormPage = _ref.ctaFormPage,
      isRedirectCtaFormAppropriate = _ref.isRedirectCtaFormAppropriate,
      currentPage = _ref.currentPage,
      goToPrevPage = _ref.goToPrevPage,
      goToNextPage = _ref.goToNextPage,
      isNextPageDisabled = _ref.isNextPageDisabled,
      isFullscreenActive = _ref.isFullscreenActive,
      toggleFullscreen = _ref.toggleFullscreen,
      translateKoToEn = _ref.translateKoToEn,
      isMobileLandscape = _ref.isMobileLandscape;

  var _useAtom = (0,react/* useAtom */.KO)(v2IsThumbnailPanelOpenAtom),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      isThumbnailPanelOpen = _useAtom2[0],
      setIsThumbnailPanelOpen = _useAtom2[1];

  var _useAtom3 = (0,react/* useAtom */.KO)(index_atom/* isDisableHelpersAtom */.Tn),
      _useAtom4 = (0,slicedToArray/* default */.Z)(_useAtom3, 2),
      isDisableHelpers = _useAtom4[0],
      setIsDisableHelpers = _useAtom4[1];

  var _useAtom5 = (0,react/* useAtom */.KO)(v2ZoomAtom),
      _useAtom6 = (0,slicedToArray/* default */.Z)(_useAtom5, 2),
      zoom = _useAtom6[0],
      setZoom = _useAtom6[1];

  var setFitMode = (0,react/* useSetAtom */.b9)(v2ZoomFitModeAtom); // const { setVersion } = useViewerVersion();

  var _useState = (0,node_modules_react.useState)(false),
      isDrawerOpen = _useState[0],
      setIsDrawerOpen = _useState[1];
  /* 헬퍼 숨김 시 드로어도 닫는다(V1 파리티) */


  (0,node_modules_react.useEffect)(function () {
    if (isDisableHelpers) {
      setIsDrawerOpen(false);
    }
  }, [isDisableHelpers]);
  var dimmedClassName = classnames_default()({
    disabled: isDisableHelpers
  });
  var bottomOffset = 16 + (isThumbnailPanelOpen ? THUMBNAIL_STRIP_HEIGHT : 0);
  /* 숨겨진 상태의 첫 탭은 기능 실행 없이 컨트롤을 다시 켠다(V1 파리티) */

  var handleGuardClickCapture = function handleGuardClickCapture(e) {
    if (!isDisableHelpers) {
      return;
    }

    e.stopPropagation();
    setIsDisableHelpers(false);
  };
  /* 컨트롤 영역 탭이 뷰어의 헬퍼 토글로 전파되지 않게 한다 */


  var stopClickPropagation = function stopClickPropagation(e) {
    e.stopPropagation();
  };

  var handleClickZoomIn = function handleClickZoomIn() {
    if (zoom >= V2_ZOOM_MAX) {
      return;
    }

    setZoom(getNextZoomStep(zoom, 'in'));
    setFitMode('custom');
  };

  var handleClickZoomOut = function handleClickZoomOut() {
    if (zoom <= V2_ZOOM_MIN) {
      return;
    }

    setZoom(getNextZoomStep(zoom, 'out'));
    setFitMode('custom');
  };
  /* V1 파리티: 세로는 위/아래 캐럿, 가로는 좌/우 캐럿 */


  var caretIcon = isMobileLandscape ? {
    open: 'ph:caret-right',
    close: 'ph:caret-left'
  } : {
    open: 'ph:caret-down',
    close: 'ph:caret-up'
  };
  var drawerVariants = isMobileLandscape ? {
    open: {
      width: 'auto'
    },
    closed: {
      width: 0
    }
  } : {
    open: {
      height: 'auto'
    },
    closed: {
      height: 0
    }
  };
  var initialMotion = isMobileLandscape ? {
    width: 0
  } : {
    height: 0
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DrawerWrapper, {
      className: dimmedClassName,
      isMobileLandscape: isMobileLandscape,
      bottomOffset: bottomOffset,
      gap: 16,
      justifyContent: "flex-end",
      onClickCapture: handleGuardClickCapture,
      onClick: stopClickPropagation,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        gap: isDrawerOpen ? 8 : 0,
        direction: isMobileLandscape ? 'row' : 'column',
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DrawerToggleButton, {
          className: classnames_default()({
            backgroundOpacity: isMobileLandscape && !isDrawerOpen
          }),
          variant: "zinc_300",
          radius: 9999,
          leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
            icon: isDrawerOpen ? caretIcon.open : caretIcon.close,
            size: 19,
            color: "black"
          }),
          onClick: function onClick(e) {
            e.stopPropagation();
            setIsDrawerOpen(function (prev) {
              return !prev;
            });
          },
          innerStyle: {
            backgroundColor: isMobileLandscape && !isDrawerOpen ? 'transparent' : ''
          }
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MotionDrawer, {
          isFlexRow: isMobileLandscape,
          initial: initialMotion,
          animate: isDrawerOpen ? drawerVariants.open : drawerVariants.closed,
          transition: {
            duration: 0.15
          },
          children: !isDisableHelpers && isDrawerOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PdfDownloadButton_Mobile, {
              fileName: document.name,
              isBulk: isBulk,
              isDownloadEnabled: document.isDownloadEnabled,
              ctaFormPage: ctaFormPage,
              translateKoToEn: translateKoToEn,
              isRedirectCtaFormAppropriate: isRedirectCtaFormAppropriate
            }), document.isShareable && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShareButton_Mobile, {
              domain: domain,
              fileName: document.name,
              translateKoToEn: translateKoToEn,
              isBulk: isBulk
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ZoomPillButton, {
              className: classnames_default()({
                isLandscape: isMobileLandscape
              }),
              variant: "zinc_500",
              radius: 9999,
              onClick: function onClick(e) {
                e.preventDefault();
                e.stopPropagation();
              },
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
                direction: isMobileLandscape ? 'row' : 'column',
                gap: 16,
                justifyContent: "center",
                alignItems: "center",
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ZoomIcon, {
                  icon: "ph:magnifying-glass-plus",
                  size: 19,
                  color: zoom >= V2_ZOOM_MAX ? 'zinc_400' : 'black',
                  onClick: handleClickZoomIn
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ZoomIcon, {
                  icon: "ph:magnifying-glass-minus",
                  size: 19,
                  color: zoom <= V2_ZOOM_MIN ? 'zinc_400' : 'black',
                  onClick: handleClickZoomOut
                })]
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoundIconButton, {
              variant: "zinc_500",
              radius: 9999,
              "aria-label": isFullscreenActive ? translateKoToEn('exit-fullscreen') : translateKoToEn('fullscreen'),
              leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
                icon: isFullscreenActive ? 'ph:arrows-in' : 'ph:arrows-out',
                size: 19,
                color: "black"
              }),
              onClick: function onClick(e) {
                e.stopPropagation();
                toggleFullscreen();
                setIsDrawerOpen(false);
              }
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LanguageButton_Mobile, {})]
          })
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavPill, {
      className: dimmedClassName,
      bottomOffset: bottomOffset,
      onClickCapture: handleGuardClickCapture,
      onClick: stopClickPropagation,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_styles_NavArrowButton, {
        type: "button",
        "aria-label": translateKoToEn('prev-page'),
        disabled: currentPage <= 1,
        onClick: function onClick(e) {
          e.stopPropagation();
          goToPrevPage();
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:caret-left",
          size: 24,
          color: "black"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(IndicatorWrapper, {
        alignItems: "center",
        gap: 8,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          style: {
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
            icon: "ph:list-dashes",
            size: 19,
            color: isThumbnailPanelOpen ? 'skyblue_500' : 'black',
            onClick: function onClick(e) {
              e.stopPropagation();
              setIsThumbnailPanelOpen(function (prev) {
                return !prev;
              });
            }
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CurrentPageBox, {
          alignContent: "center",
          justifyContent: "center",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "sm-medium",
            color: "black",
            lineHeight: "15px",
            children: currentPage
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
          variant: "sm-medium",
          color: "black",
          style: {
            width: 'max-content'
          },
          children: ["/ ", document.totalPages]
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_styles_NavArrowButton, {
        type: "button",
        "aria-label": translateKoToEn('next-page'),
        disabled: currentPage >= document.totalPages || isNextPageDisabled,
        onClick: function onClick(e) {
          e.stopPropagation();
          goToNextPage();
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:caret-right",
          size: 24,
          color: "black"
        })
      })]
    })]
  });
};

/* harmony default export */ var v2_MobileBottomBar = (MobileBottomBar);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/ThumbnailPanel/index.styles.ts


function ThumbnailPanel_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var Panel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1c4a39q11"
} : 0)("display:flex;flex-shrink:0;background:", styles/* theme.colors.white */.rS.colors.white, ";", function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? "\n    flex-direction: row;\n    align-items: flex-start;\n    gap: 12px;\n    width: 100%;\n    height: 148px;\n    padding: 12px 16px;\n    overflow-x: auto;\n    border-top: 1px solid ".concat(styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, ";\n  ") : "\n    flex-direction: column;\n    width: 200px;\n    height: 100%;\n    border-right: 1px solid ".concat(styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, ";\n  ");
}, ";" + ( true ? "" : 0));
var PanelHeader = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1c4a39q10"
} : 0)("display:flex;flex-direction:column;flex-shrink:0;padding:16px 16px 12px;border-bottom:1px solid ", styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, ";gap:4px;" + ( true ? "" : 0));
var PanelHeaderRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1c4a39q9"
} : 0)( true ? {
  name: "vsx0m1",
  styles: "display:flex;align-items:flex-start;justify-content:space-between;gap:8px"
} : 0);
var PanelCloseButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e1c4a39q8"
} : 0)("display:flex;flex-shrink:0;align-items:center;justify-content:center;padding:4px;border:none;background:transparent;border-radius:6px;cursor:pointer;transition:0.15s ease-in-out;&:hover{background:", styles/* theme.colors.zinc_100 */.rS.colors.zinc_100, ";}" + ( true ? "" : 0));
var PanelTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Text */.xv,  true ? {
  target: "e1c4a39q7"
} : 0)( true ? {
  name: "a0z5qp",
  styles: "display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical;-webkit-line-clamp:2;word-break:break-all"
} : 0);
var PanelScroll = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1c4a39q6"
} : 0)( true ? {
  name: "u0okme",
  styles: "display:flex;min-height:0;flex:1;flex-direction:column;padding:16px;gap:12px;overflow-y:auto"
} : 0);
var Item = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e1c4a39q5"
} : 0)("display:flex;max-width:168px;flex-direction:column;flex-shrink:0;", function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? 'width: auto;' : 'width: 100%;';
}, " padding:4px;border:none;background:transparent;border-radius:8px;cursor:pointer;gap:4px;transition:0.15s ease-in-out;&:hover{background:", styles/* theme.colors.zinc_100 */.rS.colors.zinc_100, ";}&:focus-visible{outline:2px solid ", styles/* theme.colors.skyblue_400 */.rS.colors.skyblue_400, ";outline-offset:2px;}&.is-current>div:first-of-type{border-color:", styles/* theme.colors.skyblue_400 */.rS.colors.skyblue_400, ";}" + ( true ? "" : 0));
var ThumbBox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1c4a39q4"
} : 0)("position:relative;", function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? 'height: 96px;' : 'margin: 0 auto;';
}, " overflow:hidden;border:2px solid ", styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, ";background:", styles/* theme.colors.zinc_100 */.rS.colors.zinc_100, ";border-radius:6px;transition:0.15s ease-in-out;" + ( true ? "" : 0));
var PanelThumbImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(_common_PdfThumbImage,  true ? {
  target: "e1c4a39q3"
} : 0)( true ? {
  name: "1oy9n6h",
  styles: "&.is-blind{filter:blur(6px);}"
} : 0);
var LegacyThumbImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e1c4a39q2"
} : 0)( true ? {
  name: "rtkrvt",
  styles: "position:absolute;top:0;left:0;width:100%;height:100%;object-fit:contain;user-select:none;&.is-blind{filter:blur(6px);}"
} : 0);
/* 페이지 썸네일 위에 임베드 위치/크기를 비율 그대로 보여주는 미리보기 */

/* 가림/잠금 페이지에서는 페이지 이미지와 동일하게 블러 처리된다 */

var EmbedOverlay = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1c4a39q1"
} : 0)("position:absolute;display:flex;overflow:hidden;align-items:center;justify-content:center;background-color:", styles/* theme.colors.zinc_900 */.rS.colors.zinc_900, ";border-radius:2px;color:", styles/* theme.colors.white */.rS.colors.white, ";pointer-events:none;img{width:100%;height:100%;object-fit:cover;}&.is-blind{filter:blur(6px);}" + ( true ? "" : 0));
var LockOverlay = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e1c4a39q0"
} : 0)( true ? {
  name: "euv07g",
  styles: "position:absolute;background:rgb(79 88 96 / 50%);inset:0"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/ThumbnailPanel/index.tsx








var ThumbnailItem = function ThumbnailItem(_ref) {
  var _pageData$imageSource;

  var pageData = _ref.pageData,
      isCurrent = _ref.isCurrent,
      isLocked = _ref.isLocked,
      isBlind = _ref.isBlind,
      isMobile = _ref.isMobile,
      embeds = _ref.embeds,
      onSelect = _ref.onSelect;
  var itemRef = (0,node_modules_react.useRef)(null);
  (0,node_modules_react.useEffect)(function () {
    if (isCurrent) {
      var _itemRef$current;

      (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 ? void 0 : _itemRef$current.scrollIntoView({
        block: 'nearest',
        inline: 'nearest'
      });
    }
  }, [isCurrent]);
  var aspect = pageData.originalWidth / pageData.originalHeight || 1;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Item, {
    ref: itemRef,
    type: "button",
    isMobile: isMobile,
    className: classnames_default()({
      'is-current': isCurrent
    }),
    "aria-current": isCurrent ? 'page' : undefined,
    onClick: function onClick(e) {
      e.stopPropagation();
      onSelect();
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ThumbBox, {
      isMobile: isMobile,
      style: isMobile ? {
        aspectRatio: "".concat(aspect)
      } : {
        aspectRatio: "".concat(aspect),
        width: "min(100%, calc(120px * ".concat(aspect, "))")
      },
      children: [(_pageData$imageSource = pageData.imageSources) !== null && _pageData$imageSource !== void 0 && _pageData$imageSource.thumb ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PanelThumbImage, {
        className: classnames_default()({
          'is-blind': isBlind || isLocked
        }),
        thumb: pageData.imageSources.thumb,
        alt: "pdf thumbnail ".concat(pageData.page, "page"),
        fill: true
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LegacyThumbImage, {
        className: classnames_default()({
          'is-blind': isBlind || isLocked
        }),
        src: pageData.src,
        alt: "pdf thumbnail ".concat(pageData.page, "page"),
        loading: "lazy",
        decoding: "async",
        draggable: false
      }), embeds === null || embeds === void 0 ? void 0 : embeds.map(function (embed) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbedOverlay, {
          className: classnames_default()({
            'is-blind': isBlind || isLocked
          }),
          style: {
            left: "".concat(embed.rect_x * 100, "%"),
            top: "".concat(embed.rect_y * 100, "%"),
            width: "".concat(embed.rect_w * 100, "%"),
            height: "".concat(embed.rect_h * 100, "%")
          },
          children: embed.thumbnailUrl ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: embed.thumbnailUrl,
            alt: ""
          }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
            icon: "ph:play-fill",
            size: 12
          })
        }, embed.id);
      }), isLocked && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LockOverlay, {
        alignItems: "center",
        justifyContent: "center",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:lock-simple",
          size: 20,
          color: "white"
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: "sm-medium",
      color: isCurrent ? 'skyblue_500' : 'zinc_400',
      textAlign: "center",
      children: pageData.page
    })]
  });
};
/**
 * V2 페이지 목록 패널. 데스크톱은 좌측 패널, 모바일은 하단 가로 스트립.
 * 전체 페이지 목록 기반 + 네이티브 지연 로딩으로 V1의 증분 하이드레이션
 * 빈 슬롯 문제를 제거한다. 게이트 너머 페이지는 잠금 표시한다.
 */


var ThumbnailPanel = function ThumbnailPanel(_ref2) {
  var document = _ref2.document,
      currentPage = _ref2.currentPage,
      goToPage = _ref2.goToPage,
      blindPages = _ref2.blindPages,
      isGateActive = _ref2.isGateActive,
      ctaFormPage = _ref2.ctaFormPage,
      embedItems = _ref2.embedItems,
      isMobile = _ref2.isMobile,
      translateKoToEn = _ref2.translateKoToEn,
      onClose = _ref2.onClose;
  var items = document.pages.map(function (pageData) {
    var _embedItems$find;

    var isLocked = isGateActive && ctaFormPage !== undefined && pageData.page > ctaFormPage;
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ThumbnailItem, {
      pageData: pageData,
      isCurrent: pageData.page === currentPage,
      isLocked: isLocked,
      isBlind: Boolean(blindPages === null || blindPages === void 0 ? void 0 : blindPages.includes(pageData.page)),
      isMobile: isMobile,
      embeds: embedItems === null || embedItems === void 0 ? void 0 : (_embedItems$find = embedItems.find(function (item) {
        return item.page === pageData.page;
      })) === null || _embedItems$find === void 0 ? void 0 : _embedItems$find.embed,
      onSelect: function onSelect() {
        return goToPage(pageData.page);
      }
    }, pageData.page);
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Panel, {
    isMobile: isMobile,
    role: "listbox",
    "aria-label": translateKoToEn('thumbnails'),
    children: isMobile ? items : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PanelHeader, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PanelHeaderRow, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PanelTitle, {
            variant: "sm-semibold",
            color: "zinc_700",
            children: document.name
          }), onClose && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PanelCloseButton, {
            type: "button",
            "aria-label": translateKoToEn('desktop-pageList-close'),
            title: translateKoToEn('desktop-pageList-close'),
            onClick: function onClick(e) {
              e.stopPropagation();
              onClose();
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
              icon: "ph:caret-double-left",
              size: 16,
              color: "zinc_400"
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "xs-medium",
          color: "zinc_400",
          children: translateKoToEn('total-page-count').replace('{{count}}', String(document.totalPages))
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PanelScroll, {
        children: items
      })]
    })
  });
};

/* harmony default export */ var v2_ThumbnailPanel = (ThumbnailPanel);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/ProgressBar/index.styles.ts



var Track = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e99lmyz1"
} : 0)("position:fixed;top:0;left:0;z-index:", constants/* VIEWER_Z_INDEX.desktopLayer */.G.desktopLayer, ";width:100%;height:3px;background:", styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, ";" + ( true ? "" : 0));
var Fill = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e99lmyz0"
} : 0)("height:100%;background:", styles/* theme.colors.skyblue_400 */.rS.colors.skyblue_400, ";transition:width 0.15s ease-in-out;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/ProgressBar/index.tsx



/** 화면 상단 2px 읽기 진행률 바 */
var ProgressBar = function ProgressBar(_ref) {
  var currentPage = _ref.currentPage,
      totalPages = _ref.totalPages;
  var progress = totalPages > 0 ? currentPage / totalPages * 100 : 0;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Track, {
    role: "progressbar",
    "aria-valuemin": 1,
    "aria-valuemax": totalPages,
    "aria-valuenow": currentPage,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Fill, {
      style: {
        width: "".concat(progress, "%")
      }
    })
  });
};

/* harmony default export */ var v2_ProgressBar = (ProgressBar);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/FitWidthHint/index.styles.ts


function FitWidthHint_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





/*
 * 슬라이드 영역(ContentWrapper) 기준 플로팅 힌트 칩의 배치 앵커.
 * - 데스크톱: 좌상단. 우상단 툴바(TopRightWrapper), 하단 네비(BottomNavWrapper),
 *   CTA 버튼 레이어, 좌측 엣지 핸들(top 50%)과 모두 겹치지 않는 빈 코너다.
 * - 모바일: 상단 중앙. 하단 고정 컨트롤(NavPill/DrawerWrapper)과 썸네일 스트립
 *   개폐에 따른 bottomOffset 변화의 영향을 받지 않는다. 가로 모드에서 우상단으로
 *   올라오는 드로어를 피하도록 max-width를 제한한다.
 * - 배치 요소와 애니메이션 요소를 분리한다. framer-motion이 inline transform을
 *   소유하므로 translateX(-50%)를 motion 요소에 두면 덮어써진다.
 */

var ChipAnchor = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ezzxuhv4"
} : 0)("position:absolute;z-index:", constants/* VIEWER_Z_INDEX.hintChip */.G.hintChip, ";display:flex;justify-content:center;pointer-events:none;", function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? "\n        top: 12px;\n        left: 50%;\n        max-width: calc(100% - 120px);\n        transform: translateX(-50%);\n      " : "\n        top: 24px;\n        left: 24px;\n        max-width: calc(100% - 48px);\n      ";
}, ";" + ( true ? "" : 0));
var Chip = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dom_motion/* motion.div */.E.div,  true ? {
  target: "ezzxuhv3"
} : 0)("display:flex;min-width:0;align-items:center;padding:4px;border:1px solid ", styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, ";background:", styles/* theme.colors.white */.rS.colors.white, ";border-radius:9999px;box-shadow:", styles/* theme.elevation.sm */.rS.elevation.sm, ";gap:4px;pointer-events:auto;&.disabled{cursor:initial;}" + ( true ? "" : 0));
var ChipAction = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "ezzxuhv2"
} : 0)("display:flex;min-width:0;align-items:center;padding:4px 8px;border:none;background:transparent;border-radius:9999px;cursor:pointer;gap:6px;transition:0.15s ease-in-out;&:hover{background:", styles/* theme.colors.zinc_100 */.rS.colors.zinc_100, ";}" + ( true ? "" : 0));
var ChipLabel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Text */.xv,  true ? {
  target: "ezzxuhv1"
} : 0)( true ? {
  name: "1h52dri",
  styles: "overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
} : 0);
var ChipClose = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "ezzxuhv0"
} : 0)("display:flex;width:24px;height:24px;flex-shrink:0;align-items:center;justify-content:center;border:none;background:transparent;border-radius:9999px;cursor:pointer;transition:0.15s ease-in-out;&:hover{background:", styles/* theme.colors.zinc_100 */.rS.colors.zinc_100, ";}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/FitWidthHint/index.tsx










/**
 * 세로로 긴 슬라이드에서 가로 맞춤을 권유하는 플로팅 힌트 칩.
 * 화면을 가리는 딤 없이 슬라이드 영역 위에 얹히며,
 * 다른 플로팅 컨트롤과 동일하게 isDisableHelpers에 따라 흐려진다.
 */
var FitWidthHint = function FitWidthHint(_ref) {
  var isVisible = _ref.isVisible,
      isMobile = _ref.isMobile,
      onApply = _ref.onApply,
      onDismiss = _ref.onDismiss,
      translateKoToEn = _ref.translateKoToEn;

  var _useAtom = (0,react/* useAtom */.KO)(index_atom/* isDisableHelpersAtom */.Tn),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      isDisableHelpers = _useAtom2[0],
      setIsDisableHelpers = _useAtom2[1];
  /* 흐려진 상태의 첫 클릭은 기능 실행 없이 컨트롤을 다시 켠다(V1 파리티) */


  var handleGuardClickCapture = function handleGuardClickCapture(e) {
    if (!isDisableHelpers) {
      return;
    }

    e.stopPropagation();
    setIsDisableHelpers(false);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChipAnchor, {
    isMobile: isMobile,
    onClickCapture: handleGuardClickCapture
    /* 칩 클릭이 뷰어의 헬퍼 토글로 전파되지 않게 한다 */
    ,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
      children: isVisible && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Chip, {
        className: classnames_default()({
          disabled: isDisableHelpers
        }),
        initial: {
          opacity: 0
        }
        /*
         * framer-motion이 inline opacity를 소유하므로 흐림 처리를
         * CSS 클래스가 아니라 animate로 준다(모바일은 완전 숨김).
         */
        ,
        animate: {
          opacity: isDisableHelpers ? isMobile ? 0 : 0.25 : 1
        },
        exit: {
          opacity: 0
        },
        transition: {
          duration: 0.15,
          ease: 'easeInOut'
        },
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ChipAction, {
          type: "button",
          onClick: function onClick(e) {
            e.stopPropagation();
            onApply();
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
            icon: "ph:arrows-out-line-horizontal",
            size: 16,
            color: "skyblue_500"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChipLabel, {
            variant: "sm-medium",
            color: "zinc_700",
            children: translateKoToEn('fit-width-hint')
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChipClose, {
          type: "button",
          "aria-label": translateKoToEn('close'),
          title: translateKoToEn('close'),
          onClick: function onClick(e) {
            e.stopPropagation();
            onDismiss();
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
            icon: "ph:x",
            size: 14,
            color: "zinc_500"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var v2_FitWidthHint = (FitWidthHint);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/v2/useV2Swipe.ts




/* 줌 상태 엣지 오버스크롤 스와이프 임계값(px). 오조작 방지를 위해 넉넉히 잡는다 */

var EDGE_SWIPE_THRESHOLD = 60;
var EDGE_TOLERANCE = 1;

/**
 * V2 페이지 모드 스와이프 내비게이션.
 * - 기본(줌 100% 이하): V1 useSwipe와 동일한 ±10px 임계값.
 * - 줌 상태(>100%): 콘텐츠를 가로 끝까지 스크롤한 뒤 같은 방향으로
 *   한 번 더 크게(±60px) 스와이프하면 페이지를 넘긴다(엣지 오버스크롤).
 */
var useV2Swipe = function useV2Swipe(_ref) {
  var totalPage = _ref.totalPage,
      isNextSwipeDisabled = _ref.isNextSwipeDisabled,
      onPageChange = _ref.onPageChange,
      currentPage = _ref.currentPage,
      scrollRef = _ref.scrollRef;
  var zoom = (0,react/* useAtomValue */.Dv)(v2ZoomAtom);
  var isCtaModalOpen = (0,react/* useAtomValue */.Dv)(index_atom/* isCtaModalOpenAtom */.D5);
  var touchStartRef = (0,node_modules_react.useRef)(0);
  var edgeStateRef = (0,node_modules_react.useRef)({
    atLeftEdge: false,
    atRightEdge: false
  });
  /*
   * 핀치 세션 플래그. 두 손가락이 닿은 순간부터 마지막 손가락이 떨어질 때까지
   * 스와이프 판정을 전부 무시한다. 2→1 손가락 전환 후 남은 손가락의 이동이
   * 스와이프로 오인돼 페이지가 넘어가는 것을 막는다.
   */

  var isPinchSessionRef = (0,node_modules_react.useRef)(false);

  var _useState = (0,node_modules_react.useState)(null),
      value = _useState[0],
      setValue = _useState[1];

  var getEdgeState = function getEdgeState() {
    var scrollEl = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current;

    if (!scrollEl) {
      return {
        atLeftEdge: false,
        atRightEdge: false
      };
    }

    return {
      atLeftEdge: scrollEl.scrollLeft <= EDGE_TOLERANCE,
      atRightEdge: scrollEl.scrollLeft >= scrollEl.scrollWidth - scrollEl.clientWidth - EDGE_TOLERANCE
    };
  };

  var handleTouchStart = function handleTouchStart(event) {
    if (event.touches.length > 1) {
      isPinchSessionRef.current = true;
      setValue(null);
      return;
    }

    touchStartRef.current = event.touches[0].clientX;
    /* 제스처 시작 시점에 이미 엣지에 있어야 오버스크롤로 인정한다 */

    edgeStateRef.current = getEdgeState();
  };

  var handleTouchMove = function handleTouchMove(event) {
    /* 핀치 전환 시 첫 손가락이 래치한 스와이프를 무효화한다 */
    if (event.touches.length > 1) {
      isPinchSessionRef.current = true;
      setValue(null);
      return;
    }

    if (isPinchSessionRef.current) {
      return;
    }

    if (isCtaModalOpen) {
      return;
    }

    var touchDiff = event.touches[0].clientX - touchStartRef.current;

    if (zoom > 1) {
      /* 줌 상태: 시작·현재 모두 엣지일 때만 큰 스와이프로 페이지 이동 */
      var currentEdge = getEdgeState();

      if (touchDiff > EDGE_SWIPE_THRESHOLD && edgeStateRef.current.atLeftEdge && currentEdge.atLeftEdge) {
        setValue('prev');
      } else if (touchDiff < -EDGE_SWIPE_THRESHOLD && edgeStateRef.current.atRightEdge && currentEdge.atRightEdge) {
        setValue('next');
      } else {
        setValue(null);
      }

      return;
    }

    if (touchDiff > 10) {
      setValue('prev');
    } else if (touchDiff < -10) {
      setValue('next');
    }
  };

  var handleTouchEnd = function handleTouchEnd(event) {
    if (isPinchSessionRef.current) {
      /* 마지막 손가락이 떨어져야 핀치 세션이 끝난다 */
      if (event.touches.length === 0) {
        isPinchSessionRef.current = false;
      }

      setValue(null);
      return;
    }

    if (!value || isCtaModalOpen) {
      return;
    }

    if (value === 'next') {
      setValue(null);

      if (currentPage === totalPage || isNextSwipeDisabled) {
        return;
      }

      onPageChange(currentPage + 1, currentPage);
    } else if (value === 'prev') {
      setValue(null);

      if (currentPage === 1) {
        return;
      }

      onPageChange(currentPage - 1, currentPage);
    }
  };

  return {
    handleTouchStart: handleTouchStart,
    handleTouchMove: handleTouchMove,
    handleTouchEnd: handleTouchEnd
  };
};

/* harmony default export */ var v2_useV2Swipe = (useV2Swipe);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/v2/usePinchZoom.ts





var getDistance = function getDistance(touches) {
  var _ref = [touches[0], touches[1]],
      first = _ref[0],
      second = _ref[1];
  return Math.hypot(second.clientX - first.clientX, second.clientY - first.clientY);
};

var getMidpoint = function getMidpoint(touches) {
  var _ref2 = [touches[0], touches[1]],
      first = _ref2[0],
      second = _ref2[1];
  return {
    x: (first.clientX + second.clientX) / 2,
    y: (first.clientY + second.clientY) / 2
  };
};

/**
 * 모바일 핀치줌.
 * 제스처 중에는 리렌더 없이 CSS transform(핀치 중점 origin)으로만
 * 미리보기하고, 손가락을 뗄 때 한 번만 실제 배율을 커밋한다.
 * 커밋 시 스크롤 보정은 useAnchoredZoom이 담당한다.
 */
var usePinchZoom = function usePinchZoom(_ref3) {
  var scrollRef = _ref3.scrollRef,
      transformTargetRef = _ref3.transformTargetRef,
      zoomAtPoint = _ref3.zoomAtPoint;
  var zoom = (0,react/* useAtomValue */.Dv)(v2ZoomAtom);
  var zoomRef = (0,node_modules_react.useRef)(zoom);
  zoomRef.current = zoom;
  (0,node_modules_react.useEffect)(function () {
    var target = scrollRef.current;

    if (!target) {
      return;
    }

    var startDistance = null;
    var startZoom = 1;
    var startMidX = 0;
    var startMidY = 0;
    var nextZoom = 1;
    var panX = 0;
    var panY = 0;
    var rafId = null;

    var clearGestureStyle = function clearGestureStyle() {
      var el = transformTargetRef.current;

      if (el) {
        el.style.transform = '';
        el.style.transformOrigin = '';
        el.style.willChange = '';
      }
    };

    var handleTouchStart = function handleTouchStart(event) {
      if (event.touches.length !== 2) {
        return;
      }
      /* 브라우저가 팬/스크롤로 제스처를 선점(touchcancel)하지 못하게 막는다 */


      event.preventDefault();
      startDistance = getDistance(event.touches);
      startZoom = zoomRef.current;
      nextZoom = startZoom;
      var midpoint = getMidpoint(event.touches);
      startMidX = midpoint.x;
      startMidY = midpoint.y;
      panX = 0;
      panY = 0;
      var el = transformTargetRef.current;

      if (el) {
        var rect = el.getBoundingClientRect();
        el.style.transformOrigin = "".concat(startMidX - rect.left, "px ").concat(startMidY - rect.top, "px");
        el.style.willChange = 'transform';
      }
    };

    var handleTouchMove = function handleTouchMove(event) {
      if (event.touches.length !== 2 || startDistance === null) {
        return;
      }
      /* 브라우저 기본 핀치줌(페이지 확대)을 막는다 */


      event.preventDefault();
      var ratio = getDistance(event.touches) / startDistance;
      nextZoom = clampV2Zoom(startZoom * ratio);
      var midpoint = getMidpoint(event.touches);
      panX = midpoint.x - startMidX;
      panY = midpoint.y - startMidY;

      if (rafId === null) {
        rafId = requestAnimationFrame(function () {
          rafId = null;
          var el = transformTargetRef.current;

          if (el && startDistance !== null) {
            el.style.transform = "translate(".concat(panX, "px, ").concat(panY, "px) scale(").concat(nextZoom / startZoom, ")");
          }
        });
      }
    };

    var handleTouchEnd = function handleTouchEnd(event) {
      if (event.touches.length >= 2 || startDistance === null) {
        return;
      }

      startDistance = null;

      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      /* 커밋 전 원복해야 앵커 계산이 변형 전 레이아웃 기준으로 이뤄진다 */


      clearGestureStyle();

      if (nextZoom !== startZoom || panX !== 0 || panY !== 0) {
        /*
         * UX상 5% 단위(100% 근접 시 100%)로 스냅해 커밋한다.
         * 프리뷰 transform 원복 직후이므로 immediate 커밋으로
         * 이전 레이아웃이 한 프레임 노출되는 것을 막는다.
         */
        zoomAtPoint(snapV2PinchZoom(nextZoom), startMidX, startMidY, {
          x: panX,
          y: panY
        }, {
          immediate: true
        });
      }
    };

    target.addEventListener('touchstart', handleTouchStart, {
      passive: false
    });
    target.addEventListener('touchmove', handleTouchMove, {
      passive: false
    });
    target.addEventListener('touchend', handleTouchEnd, {
      passive: true
    });
    target.addEventListener('touchcancel', handleTouchEnd, {
      passive: true
    });
    return function () {
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
      }

      clearGestureStyle();
      target.removeEventListener('touchstart', handleTouchStart);
      target.removeEventListener('touchmove', handleTouchMove);
      target.removeEventListener('touchend', handleTouchEnd);
      target.removeEventListener('touchcancel', handleTouchEnd);
    };
  }, [scrollRef, transformTargetRef, zoomAtPoint]);
};

/* harmony default export */ var v2_usePinchZoom = (usePinchZoom);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/v2/useDoubleTapZoom.ts




/** 두 탭 사이 최대 간격(ms) */

var DOUBLE_TAP_INTERVAL = 300;
/** 탭으로 인정하는 손가락 이동 허용치(px) */

var TAP_MOVE_TOLERANCE = 10;
/** 두 탭 지점 사이 최대 거리(px) */

var DOUBLE_TAP_DISTANCE = 30;
/** 줌 전환 프리뷰 애니메이션 시간(ms) */

var TRANSITION_MS = 180;
/** 탭 대상이 버튼/링크 등 조작 요소면 더블 탭 줌을 발동하지 않는다 */

var isInteractiveTarget = function isInteractiveTarget(target) {
  return target instanceof Element && Boolean(target.closest('a, button, input, textarea, select, [role="button"]'));
};

/**
 * 모바일 더블 탭 줌 토글.
 * 100% 이하에서는 탭 지점을 앵커로 V2_DOUBLE_TAP_ZOOM까지 확대하고,
 * 확대 상태에서는 100%로 복귀한다. 핀치줌과 동일하게 제스처 프리뷰는
 * CSS transform으로 애니메이션한 뒤 종료 시 한 번만 배율을 커밋한다.
 */
var useDoubleTapZoom = function useDoubleTapZoom(_ref) {
  var scrollRef = _ref.scrollRef,
      transformTargetRef = _ref.transformTargetRef,
      zoomAtPoint = _ref.zoomAtPoint;
  var zoom = (0,react/* useAtomValue */.Dv)(v2ZoomAtom);
  var zoomRef = (0,node_modules_react.useRef)(zoom);
  zoomRef.current = zoom;
  var zoomAtPointRef = (0,node_modules_react.useRef)(zoomAtPoint);
  zoomAtPointRef.current = zoomAtPoint;
  (0,node_modules_react.useEffect)(function () {
    var target = scrollRef.current;

    if (!target) {
      return;
    }

    var lastTap = null;
    var tapStart = null;
    var isAnimating = false;
    var fallbackTimer = null;
    var cleanupTransition = null;

    var triggerZoom = function triggerZoom(clientX, clientY) {
      var currentZoom = zoomRef.current;
      /* 확대 상태(>100%)면 100% 복귀, 아니면 목표 배율로 확대 */

      var nextZoom = currentZoom > 1.01 ? 1 : clampV2Zoom(V2_DOUBLE_TAP_ZOOM);
      var el = transformTargetRef.current;

      if (!el) {
        zoomAtPointRef.current(nextZoom, clientX, clientY);
        return;
      }

      isAnimating = true;
      var rect = el.getBoundingClientRect();
      el.style.transformOrigin = "".concat(clientX - rect.left, "px ").concat(clientY - rect.top, "px");
      el.style.willChange = 'transform';
      el.style.transition = "transform ".concat(TRANSITION_MS, "ms ease-in-out");
      /* 리플로 강제: transition이 초기 상태부터 적용되게 한다 */

      void el.getBoundingClientRect();
      el.style.transform = "scale(".concat(nextZoom / currentZoom, ")");

      var finish = function finish() {
        if (!isAnimating) {
          return;
        }

        isAnimating = false;
        cleanupTransition = null;
        el.removeEventListener('transitionend', finish);

        if (fallbackTimer !== null) {
          clearTimeout(fallbackTimer);
          fallbackTimer = null;
        }
        /*
         * 커밋 전 원복해야 앵커 계산이 변형 전 레이아웃 기준으로 이뤄진다.
         * immediate 커밋으로 같은 태스크에서 배율까지 반영해, 원복된
         * 이전 레이아웃이 한 프레임 노출(플래시)되는 것을 막는다.
         */


        el.style.transition = '';
        el.style.transform = '';
        el.style.transformOrigin = '';
        el.style.willChange = '';
        zoomAtPointRef.current(nextZoom, clientX, clientY, undefined, {
          immediate: true
        });
      };

      cleanupTransition = finish;
      el.addEventListener('transitionend', finish);
      fallbackTimer = window.setTimeout(finish, TRANSITION_MS + 100);
    };

    var handleTouchStart = function handleTouchStart(event) {
      if (event.touches.length !== 1 || isInteractiveTarget(event.target)) {
        /* 멀티 터치(핀치)나 조작 요소 탭은 더블 탭 후보에서 제외한다 */
        tapStart = null;
        lastTap = null;
        return;
      }

      var touch = event.touches[0];
      tapStart = {
        x: touch.clientX,
        y: touch.clientY
      };
    };

    var handleTouchMove = function handleTouchMove(event) {
      if (!tapStart || event.touches.length !== 1) {
        tapStart = null;
        return;
      }

      var touch = event.touches[0];

      if (Math.hypot(touch.clientX - tapStart.x, touch.clientY - tapStart.y) > TAP_MOVE_TOLERANCE) {
        tapStart = null;
      }
    };

    var handleTouchEnd = function handleTouchEnd(event) {
      if (event.touches.length > 0 || !tapStart || isAnimating) {
        tapStart = null;
        return;
      }

      var _tapStart = tapStart,
          x = _tapStart.x,
          y = _tapStart.y;
      tapStart = null;
      var now = Date.now();

      if (lastTap && now - lastTap.time <= DOUBLE_TAP_INTERVAL && Math.hypot(x - lastTap.x, y - lastTap.y) <= DOUBLE_TAP_DISTANCE) {
        lastTap = null;
        triggerZoom(x, y);
        return;
      }

      lastTap = {
        x: x,
        y: y,
        time: now
      };
    };

    var handleTouchCancel = function handleTouchCancel() {
      tapStart = null;
    };

    target.addEventListener('touchstart', handleTouchStart, {
      passive: true
    });
    target.addEventListener('touchmove', handleTouchMove, {
      passive: true
    });
    target.addEventListener('touchend', handleTouchEnd, {
      passive: true
    });
    target.addEventListener('touchcancel', handleTouchCancel, {
      passive: true
    });
    return function () {
      var _cleanupTransition;

      if (fallbackTimer !== null) {
        clearTimeout(fallbackTimer);
      }

      (_cleanupTransition = cleanupTransition) === null || _cleanupTransition === void 0 ? void 0 : _cleanupTransition();
      target.removeEventListener('touchstart', handleTouchStart);
      target.removeEventListener('touchmove', handleTouchMove);
      target.removeEventListener('touchend', handleTouchEnd);
      target.removeEventListener('touchcancel', handleTouchCancel);
    };
  }, [scrollRef, transformTargetRef]);
};

/* harmony default export */ var v2_useDoubleTapZoom = (useDoubleTapZoom);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/v2/useAnchoredZoom.ts








/** 포인터와 세로로 가장 가까운 [data-zoom-anchor] 요소를 찾는다 */
var findAnchorEl = function findAnchorEl(scrollEl, clientX, clientY) {
  var best = null;
  var bestDistance = Infinity;
  scrollEl.querySelectorAll('[data-zoom-anchor]').forEach(function (el) {
    var rect = el.getBoundingClientRect();

    if (rect.width <= 0 || rect.height <= 0) {
      return;
    }

    var distance = clientY < rect.top ? rect.top - clientY : clientY > rect.bottom ? clientY - rect.bottom : 0;

    if (distance < bestDistance) {
      bestDistance = distance;
      best = el;
    }
  });
  return best;
};
/**
 * 포인터 위치를 앵커로 유지하는 줌.
 * - 줌은 레이아웃(크기) 기반이므로, 커밋 직후 layout effect에서
 *   앵커 지점의 화면상 이동량만큼 스크롤을 보정해 포인터 아래
 *   콘텐츠가 고정된 것처럼 보이게 한다.
 * - Ctrl/Cmd + 휠은 연속 배율로 처리해 부드럽게 확대/축소한다.
 * - 앵커가 없는 줌 변경(툴바 ±/프리셋 등)은 보정하지 않는다(기본 동작 유지).
 */


var useAnchoredZoom = function useAnchoredZoom(_ref) {
  var scrollRef = _ref.scrollRef;

  var _useAtom = (0,react/* useAtom */.KO)(v2ZoomAtom),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      zoom = _useAtom2[0],
      setZoom = _useAtom2[1];

  var setFitMode = (0,react/* useSetAtom */.b9)(v2ZoomFitModeAtom);
  var zoomRef = (0,node_modules_react.useRef)(zoom);
  zoomRef.current = zoom;
  var pendingAnchorRef = (0,node_modules_react.useRef)(null);
  var pendingZoomRef = (0,node_modules_react.useRef)(null);
  var rafIdRef = (0,node_modules_react.useRef)(null);
  var zoomAtPoint = (0,node_modules_react.useCallback)(function (nextZoom, clientX, clientY, pan, options) {
    var scrollEl = scrollRef.current;

    if (!scrollEl) {
      return;
    }

    var clampedZoom = clampV2Zoom(nextZoom);
    /* 배율 변화가 없으면 리렌더가 없으므로 팬만 즉시 반영한다 */

    if (clampedZoom === zoomRef.current && pendingZoomRef.current === null) {
      if (pan) {
        scrollEl.scrollLeft -= pan.x;
        scrollEl.scrollTop -= pan.y;
      }

      return;
    }

    var anchorEl = findAnchorEl(scrollEl, clientX, clientY);

    if (anchorEl) {
      var _pan$x, _pan$y;

      var rect = anchorEl.getBoundingClientRect();
      pendingAnchorRef.current = {
        el: anchorEl,
        ratioX: (clientX - rect.left) / rect.width,
        ratioY: (clientY - rect.top) / rect.height,
        clientX: clientX,
        clientY: clientY,
        panX: (_pan$x = pan === null || pan === void 0 ? void 0 : pan.x) !== null && _pan$x !== void 0 ? _pan$x : 0,
        panY: (_pan$y = pan === null || pan === void 0 ? void 0 : pan.y) !== null && _pan$y !== void 0 ? _pan$y : 0
      };
    }

    pendingZoomRef.current = clampedZoom;

    var commit = function commit() {
      if (pendingZoomRef.current === null) {
        return;
      }

      setZoom(pendingZoomRef.current);
      setFitMode('custom');
      pendingZoomRef.current = null;
    };

    if (options !== null && options !== void 0 && options.immediate) {
      if (rafIdRef.current !== null) {
        cancelAnimationFrame(rafIdRef.current);
        rafIdRef.current = null;
      }
      /*
       * transitionend/touchend 같은 비이산 이벤트의 업데이트는 React가
       * 다음 태스크로 미뤄 그 사이 한 프레임이 그려질 수 있다.
       * 동기 렌더로 강제해 이전 레이아웃이 페인트되지 않게 한다.
       */


      (0,react_dom.flushSync)(commit);
      return;
    }
    /* 휠 연타를 프레임당 1회 커밋으로 배칭한다 */


    if (rafIdRef.current === null) {
      rafIdRef.current = requestAnimationFrame(function () {
        rafIdRef.current = null;
        commit();
      });
    }
  }, [scrollRef, setZoom, setFitMode]);
  /* 줌 커밋 직후(페인트 전) 앵커 드리프트만큼 스크롤을 보정한다 */

  (0,react_hooks/* useIsomorphicLayoutEffect */.LI)(function () {
    var anchor = pendingAnchorRef.current;
    var scrollEl = scrollRef.current;

    if (!anchor || !scrollEl) {
      return;
    }

    pendingAnchorRef.current = null;
    var rect = anchor.el.getBoundingClientRect();

    if (rect.width <= 0 || rect.height <= 0) {
      return;
    }

    scrollEl.scrollLeft += rect.left + anchor.ratioX * rect.width - anchor.clientX - anchor.panX;
    scrollEl.scrollTop += rect.top + anchor.ratioY * rect.height - anchor.clientY - anchor.panY;
  }, [zoom, scrollRef]);
  /* Ctrl/Cmd + 휠 연속 줌(브라우저 페이지 줌 대체) */

  (0,node_modules_react.useEffect)(function () {
    var scrollEl = scrollRef.current;

    if (!scrollEl) {
      return;
    }

    var handleWheel = function handleWheel(event) {
      var _pendingZoomRef$curre;

      if (!event.ctrlKey && !event.metaKey) {
        return;
      }

      event.preventDefault();
      var baseZoom = (_pendingZoomRef$curre = pendingZoomRef.current) !== null && _pendingZoomRef$curre !== void 0 ? _pendingZoomRef$curre : zoomRef.current;
      zoomAtPoint(baseZoom * Math.exp(-event.deltaY * V2_WHEEL_ZOOM_INTENSITY), event.clientX, event.clientY);
    };

    scrollEl.addEventListener('wheel', handleWheel, {
      passive: false
    });
    return function () {
      scrollEl.removeEventListener('wheel', handleWheel);
    };
  }, [scrollRef, zoomAtPoint]);
  (0,node_modules_react.useEffect)(function () {
    return function () {
      if (rafIdRef.current !== null) {
        cancelAnimationFrame(rafIdRef.current);
      }
    };
  }, []);
  return {
    zoomAtPoint: zoomAtPoint
  };
};

/* harmony default export */ var v2_useAnchoredZoom = (useAnchoredZoom);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/V2PageImage/index.styles.ts


function V2PageImage_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var LegacyPageImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e1d3fq640"
} : 0)( true ? {
  name: "13tj34s",
  styles: "position:absolute;top:0;left:0;width:100%;height:100%;object-fit:contain;-webkit-user-drag:none;user-select:none;&.is-blind{filter:blur(8px);}"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/V2PageImage/index.tsx





/** WebP srcset(imageSources) 우선, 없으면 레거시 단일 이미지로 렌더한다 */
var V2PageImage = function V2PageImage(_ref) {
  var _pageData$imageSource;

  var pageData = _ref.pageData,
      sizes = _ref.sizes,
      isBlind = _ref.isBlind,
      loading = _ref.loading,
      onLoad = _ref.onLoad;

  if ((_pageData$imageSource = pageData.imageSources) !== null && _pageData$imageSource !== void 0 && _pageData$imageSource.viewer) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_common_PdfPageImage, {
      viewer: pageData.imageSources.viewer,
      alt: "pdf".concat(pageData.page, "page"),
      sizes: sizes,
      isBlind: isBlind,
      loading: loading,
      onLoad: onLoad
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LegacyPageImage, {
    className: classnames_default()({
      'is-blind': isBlind
    }),
    src: pageData.src,
    alt: "pdf".concat(pageData.page, "page"),
    decoding: "async",
    loading: loading,
    draggable: false,
    onLoad: onLoad
  });
};

/* harmony default export */ var v2_V2PageImage = (V2PageImage);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/PageAnnotations/index.tsx







/**
 * 페이지 박스(정확히 렌더된 페이지 크기의 relative 컨테이너) 내부에서
 * 메세지박스/하이퍼링크를 렌더한다. 페이지 박스 기준이므로 margin은 0이다.
 */
var PageAnnotations = function PageAnnotations(_ref) {
  var _pageData$hyperlink;

  var pageData = _ref.pageData,
      renderedWidth = _ref.renderedWidth,
      renderedHeight = _ref.renderedHeight,
      messageBoxItems = _ref.messageBoxItems,
      embedItems = _ref.embedItems,
      ctaForm = _ref.ctaForm,
      isFormSubmitted = _ref.isFormSubmitted,
      _ref$isBlind = _ref.isBlind,
      isBlind = _ref$isBlind === void 0 ? false : _ref$isBlind,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
  var resizedImageSize = {
    width: renderedWidth,
    height: renderedHeight,
    widthRatio: renderedWidth / pageData.originalWidth,
    heightRatio: renderedHeight / pageData.originalHeight,
    xMargin: 0,
    yMargin: 0
  };
  var blindMode = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.blind;

  var getFormNotSubmitPage = function getFormNotSubmitPage(moveTargetPage) {
    if (!isFormSubmitted && blindMode === 'startFrom' && ctaForm !== null && ctaForm !== void 0 && ctaForm.page && moveTargetPage >= ctaForm.page) {
      return ctaForm.page;
    }

    return null;
  };
  /**
   * 가림막(startFrom)이 활성인 미제출 양식 페이지 — 가림이 해제되기 전까지
   * 재생(자동재생 포함)하지 않는다. blind가 'none'이면 페이지가 가려지지 않으므로
   * 임베드도 정상 동작해야 한다.
   */


  var isFormGatePage = Boolean(ctaForm && blindMode === 'startFrom' && !isFormSubmitted && pageData.page === ctaForm.page);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layer_EmbedLayer, {
      page: pageData.page,
      resizedImageSize: resizedImageSize,
      embedItems: embedItems,
      isCovered: isBlind || isFormGatePage
    }), !isBlind && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layer_MessageBoxLayer, {
        page: pageData.page,
        resizedImageSize: resizedImageSize,
        messageBoxItems: messageBoxItems,
        getFormNotSubmitPage: ctaForm ? getFormNotSubmitPage : undefined,
        size: isMobile ? 'sm' : 'default'
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HyperLinkLayer_Desktop, {
        hyperlinkList: (_pageData$hyperlink = pageData.hyperlink) !== null && _pageData$hyperlink !== void 0 ? _pageData$hyperlink : [],
        resizedImageSize: resizedImageSize,
        isPreview: false,
        getFormNotSubmitPage: ctaForm ? getFormNotSubmitPage : undefined
      })]
    })]
  });
};

/* harmony default export */ var v2_PageAnnotations = (PageAnnotations);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/FreeBadge/Slide/index.styles.ts




var Slide_index_styles_Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e73tajh0"
} : 0)("position:absolute;z-index:", constants/* VIEWER_Z_INDEX.freeBadge */.G.freeBadge, ";right:16px;bottom:16px;background-color:", styles/* theme.colors.skyblue_600 */.rS.colors.skyblue_600, ";border-radius:8px;opacity:0.8;transition:all ease-in-out 150ms;&:hover{cursor:pointer;opacity:1;}&.is-mobile{right:8px;bottom:8px;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/FreeBadge/Slide/index.tsx







/*
 * Free 플랜 배지.
 * 뷰어 배경(콘텐츠 영역)이 아니라 슬라이드(페이지 박스) 기준으로 배치되어야 하므로
 * 반드시 페이지 요소 내부에서 렌더한다.
 */
var SlideFreeBadge = function SlideFreeBadge(_ref) {
  var userSubscriptionPlan = _ref.userSubscriptionPlan,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;

  if (userSubscriptionPlan !== 'Free') {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Tooltip */.u, {
    content: "\uC138\uC77C\uC988\uD074\uB8E8\uB85C \uACF5\uC720\uB41C \uBB38\uC11C\uC785\uB2C8\uB2E4",
    side: "top",
    align: "end",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Slide_index_styles_Container, {
      className: isMobile ? 'is-mobile' : '',
      gap: isMobile ? 6 : 8,
      padding: isMobile ? {
        x: 12,
        y: 8
      } : {
        x: 16,
        y: 12
      },
      alignItems: "center",
      width: "fit-content",
      onClick: function onClick(e) {
        e.stopPropagation();
        utils_handleFreeBadgeLinkOpen();
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: isMobile ? 'sm-semibold' : 'lg-semibold',
        color: "skyblue_100",
        children: "Powered by"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
        src: "/images/salesclue_logo_black_mono.png",
        width: isMobile ? 75 : 94,
        height: isMobile ? 17 : 21,
        alt: 'SalesClue',
        unoptimized: true
      })]
    })
  });
};

/* harmony default export */ var Slide = (SlideFreeBadge);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/PagedViewer/index.styles.ts


function PagedViewer_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var ContentArea = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e5jcxso3"
} : 0)( true ? {
  name: "mersmk",
  styles: "display:flex;width:100%;height:100%;overflow:auto;touch-action:pan-x pan-y"
} : 0);
/*
 * 핀치/더블 탭 프리뷰 transform 전용 래퍼.
 * framer-motion(MotionPageBox)이 inline transform을 소유하므로,
 * 제스처 프리뷰는 반드시 이 일반 div에 걸어야 리렌더 시 지워지지 않는다.
 */

var PinchLayer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e5jcxso2"
} : 0)( true ? {
  name: "1pm3qlf",
  styles: "position:relative;display:flex;flex-shrink:0;margin:auto"
} : 0);
var MotionPageBox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dom_motion/* motion.div */.E.div,  true ? {
  target: "e5jcxso1"
} : 0)( true ? {
  name: "sfltnx",
  styles: "position:relative;flex-shrink:0"
} : 0);
var PreloadBox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e5jcxso0"
} : 0)( true ? {
  name: "1838yh8",
  styles: "position:absolute;width:1px;height:1px;overflow:hidden;visibility:hidden;pointer-events:none"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/PagedViewer/index.tsx



















/** V2 페이지 단위 보기 모드 */
var PagedViewer = function PagedViewer(_ref) {
  var _pageData$originalWid, _pageData$originalHei;

  var document = _ref.document,
      currentPage = _ref.currentPage,
      goToPage = _ref.goToPage,
      goToPrevPage = _ref.goToPrevPage,
      goToNextPage = _ref.goToNextPage,
      isNextPageDisabled = _ref.isNextPageDisabled,
      blindPages = _ref.blindPages,
      messageBoxItems = _ref.messageBoxItems,
      embedItems = _ref.embedItems,
      ctaForm = _ref.ctaForm,
      isFormSubmitted = _ref.isFormSubmitted,
      isMobile = _ref.isMobile;
  var zoom = (0,react/* useAtomValue */.Dv)(v2ZoomAtom);
  var prevPage = (0,react/* useAtomValue */.Dv)(index_atom/* prevPageAtom */.Nv);
  var isCtaModalOpen = (0,react/* useAtomValue */.Dv)(index_atom/* isCtaModalOpenAtom */.D5);
  var contentRef = (0,node_modules_react.useRef)(null);
  var pinchLayerRef = (0,node_modules_react.useRef)(null);
  var pageData = document.pages[currentPage - 1];
  var prevPageData = document.pages[currentPage - 2];
  var nextPageData = document.pages[currentPage];

  var _useFitZoom = v2_useFitZoom({
    originalWidth: (_pageData$originalWid = pageData === null || pageData === void 0 ? void 0 : pageData.originalWidth) !== null && _pageData$originalWid !== void 0 ? _pageData$originalWid : 1,
    originalHeight: (_pageData$originalHei = pageData === null || pageData === void 0 ? void 0 : pageData.originalHeight) !== null && _pageData$originalHei !== void 0 ? _pageData$originalHei : 1
  }),
      renderedWidth = _useFitZoom.renderedWidth,
      renderedHeight = _useFitZoom.renderedHeight;

  var _useAnchoredZoom = v2_useAnchoredZoom({
    scrollRef: contentRef
  }),
      zoomAtPoint = _useAnchoredZoom.zoomAtPoint;

  v2_usePinchZoom({
    scrollRef: contentRef,
    transformTargetRef: pinchLayerRef,
    zoomAtPoint: zoomAtPoint
  });
  v2_useDoubleTapZoom({
    scrollRef: contentRef,
    transformTargetRef: pinchLayerRef,
    zoomAtPoint: zoomAtPoint
  });

  var _useV2Swipe = v2_useV2Swipe({
    totalPage: document.totalPages,
    isNextSwipeDisabled: isNextPageDisabled,
    currentPage: currentPage,
    onPageChange: function onPageChange(page) {
      return goToPage(page);
    },
    scrollRef: contentRef
  }),
      handleTouchStart = _useV2Swipe.handleTouchStart,
      handleTouchMove = _useV2Swipe.handleTouchMove,
      handleTouchEnd = _useV2Swipe.handleTouchEnd;

  var navigationRef = (0,node_modules_react.useRef)({
    goToPrevPage: goToPrevPage,
    goToNextPage: goToNextPage
  });
  navigationRef.current = {
    goToPrevPage: goToPrevPage,
    goToNextPage: goToNextPage
  };
  /* V1 useWheel과 동일한 감도(500ms 스로틀, ±10px 임계값)로 페이지를 넘긴다 */

  var throttledWheelNavigate = (0,node_modules_react.useRef)(lodash_throttle_default()(function (deltaX, deltaY) {
    if (Math.abs(deltaY) <= 10 && Math.abs(deltaX) <= 10) {
      return;
    }

    if (deltaY < 0 || deltaX < 0) {
      navigationRef.current.goToPrevPage();
    } else {
      navigationRef.current.goToNextPage();
    }
  }, 500));

  var handleWheel = function handleWheel(e) {
    /* Ctrl/Cmd + 휠은 useAnchoredZoom의 줌으로 처리한다 */
    if (e.ctrlKey || e.metaKey) {
      return;
    }
    /* 줌 상태나 CTA 모달에서는 네이티브 스크롤/조작에 맡긴다 */


    if (zoom > 1 || isCtaModalOpen) {
      return;
    }

    throttledWheelNavigate.current(e.deltaX, e.deltaY);
  };

  if (!pageData) {
    return null;
  }

  var direction = currentPage >= prevPage ? 1 : -1;
  var slideOffset = isMobile ? 40 * direction : 0;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContentArea, {
    ref: contentRef,
    onWheel: handleWheel,
    onTouchStart: handleTouchStart,
    onTouchMove: handleTouchMove,
    onTouchEnd: handleTouchEnd,
    onContextMenu: function onContextMenu(e) {
      return e.preventDefault();
    },
    onDragStart: function onDragStart(e) {
      return e.preventDefault();
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PinchLayer, {
      ref: pinchLayerRef,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
        mode: "popLayout",
        initial: false,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MotionPageBox, {
          "data-zoom-anchor": true,
          initial: {
            opacity: 0,
            x: slideOffset
          },
          animate: {
            opacity: 1,
            x: 0
          },
          exit: {
            opacity: 0,
            x: -slideOffset
          },
          transition: {
            duration: 0.15,
            ease: 'easeInOut'
          },
          style: {
            width: renderedWidth,
            height: renderedHeight
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v2_V2PageImage, {
            pageData: pageData,
            sizes: quantizeImageSizes(renderedWidth),
            isBlind: blindPages === null || blindPages === void 0 ? void 0 : blindPages.includes(currentPage),
            loading: "eager"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v2_PageAnnotations, {
            pageData: pageData,
            renderedWidth: renderedWidth,
            renderedHeight: renderedHeight,
            messageBoxItems: messageBoxItems,
            embedItems: embedItems,
            ctaForm: ctaForm,
            isFormSubmitted: isFormSubmitted,
            isBlind: blindPages === null || blindPages === void 0 ? void 0 : blindPages.includes(currentPage),
            isMobile: isMobile
          })]
        }, currentPage)
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Slide, {
        userSubscriptionPlan: document.plan,
        isMobile: isMobile
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PreloadBox, {
      "aria-hidden": true,
      children: [isMobile && zoom < V2_DOUBLE_TAP_ZOOM && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v2_V2PageImage, {
        pageData: pageData,
        sizes: quantizeImageSizes(renderedWidth / zoom * V2_DOUBLE_TAP_ZOOM),
        loading: "eager"
      }), prevPageData && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v2_V2PageImage, {
        pageData: prevPageData,
        sizes: quantizeImageSizes(renderedWidth),
        loading: "eager"
      }), nextPageData && !isNextPageDisabled && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v2_V2PageImage, {
        pageData: nextPageData,
        sizes: quantizeImageSizes(renderedWidth),
        loading: "eager"
      })]
    })]
  });
};

/* harmony default export */ var v2_PagedViewer = (PagedViewer);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/v2/useScrollCurrentPage.ts


var COMMIT_DEBOUNCE_MS = 200;

/**
 * 연속 스크롤 모드에서 "현재 페이지"를 감지해 currentPageAtom을 갱신한다.
 * rootMargin으로 뷰포트를 세로 중앙선으로 수축시켜, 중앙선을 지나는 페이지
 * 정확히 1개만 intersecting 상태가 되도록 한다. 200ms 디바운스로 빠른
 * 플링 시 스쳐 지나간 페이지가 체류시간에 기록되는 것을 방지한다.
 */
var useScrollCurrentPage = function useScrollCurrentPage(_ref) {
  var rootRef = _ref.rootRef,
      isProgrammaticScrollRef = _ref.isProgrammaticScrollRef,
      totalPages = _ref.totalPages;

  var _useUpdateViewerPageS = hooks_useUpdateViewerPageState(),
      updateCurrentPage = _useUpdateViewerPageS.updateCurrentPage;

  var updateCurrentPageRef = (0,node_modules_react.useRef)(updateCurrentPage);
  updateCurrentPageRef.current = updateCurrentPage;
  var observerRef = (0,node_modules_react.useRef)(null);
  var commitTimeoutRef = (0,node_modules_react.useRef)(null);
  var lastCommittedPageRef = (0,node_modules_react.useRef)(null);
  (0,node_modules_react.useEffect)(function () {
    var root = rootRef.current;

    if (!root || totalPages === 0) {
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      var intersecting = entries.find(function (entry) {
        return entry.isIntersecting;
      });

      if (!intersecting) {
        return;
      }

      var page = Number(intersecting.target.dataset.page);

      if (!page || page === lastCommittedPageRef.current) {
        return;
      }

      if (commitTimeoutRef.current) {
        clearTimeout(commitTimeoutRef.current);
      }

      commitTimeoutRef.current = setTimeout(function () {
        if (isProgrammaticScrollRef.current) {
          return;
        }

        lastCommittedPageRef.current = page;
        updateCurrentPageRef.current(page);
      }, COMMIT_DEBOUNCE_MS);
    }, {
      root: root,

      /* 뷰포트를 세로 중앙선으로 수축 → 중앙선을 지나는 페이지 1개만 교차 */
      rootMargin: '-50% 0px -50% 0px',
      threshold: 0
    });
    observerRef.current = observer;
    var pageElements = root.querySelectorAll('[data-page]');
    pageElements.forEach(function (element) {
      return observer.observe(element);
    });
    return function () {
      if (commitTimeoutRef.current) {
        clearTimeout(commitTimeoutRef.current);
      }

      observer.disconnect();
      observerRef.current = null;
    };
  }, [rootRef, isProgrammaticScrollRef, totalPages]);
  /** 프로그래매틱 이동 후 커밋 기준점을 갱신해 유령 커밋을 방지한다 */

  var syncCommittedPage = function syncCommittedPage(page) {
    lastCommittedPageRef.current = page;
  };

  return {
    syncCommittedPage: syncCommittedPage
  };
};

/* harmony default export */ var v2_useScrollCurrentPage = (useScrollCurrentPage);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/ScrollViewer/GateStopper/index.styles.ts



var Overlay = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e1yykliz0"
} : 0)("position:absolute;inset:0;z-index:", constants/* VIEWER_Z_INDEX.link */.G.link, ";padding:24px;background:rgb(79 88 96 / 50%);" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/ScrollViewer/GateStopper/index.tsx





/** 스크롤 모드에서 CTA 폼 게이트 페이지 위에 표시되는 안내 오버레이 */
var GateStopper = function GateStopper(_ref) {
  var openForm = _ref.openForm,
      translateKoToEn = _ref.translateKoToEn;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Overlay, {
    direction: "column",
    gap: 16,
    alignItems: "center",
    justifyContent: "center",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
      icon: "ph:lock-simple",
      size: 32,
      color: "white"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: "lg-semibold",
      color: "white",
      textAlign: "center",
      children: translateKoToEn('form-gate-continue')
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
      variant: "skyblue_400_fill",
      radius: 9999,
      paddingX: 24,
      paddingY: 12,
      onClick: function onClick(e) {
        e.stopPropagation();
        openForm();
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "lg-medium",
        color: "white",
        children: translateKoToEn('form-gate-open')
      })
    })]
  });
};

/* harmony default export */ var ScrollViewer_GateStopper = (GateStopper);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/ScrollViewer/index.styles.ts


function ScrollViewer_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var ScrollArea = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1wa0qut2"
} : 0)("overflow:", function (_ref) {
  var isScrollLocked = _ref.isScrollLocked;
  return isScrollLocked ? 'hidden' : 'auto';
}, ";width:100%;height:100%;touch-action:pan-x pan-y;" + ( true ? "" : 0));
/*
 * 스크롤 컨테이너와 분리된 콘텐츠 래퍼.
 * - 핀치 제스처 중 CSS transform 프리뷰의 단일 타깃
 * - width: max-content + margin auto로 가로 오버플로 시에도
 *   좌측이 잘리지 않게 중앙 정렬한다
 */

var ScrollContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1wa0qut1"
} : 0)( true ? {
  name: "138sb54",
  styles: "display:flex;width:max-content;min-width:100%;flex-direction:column;align-items:center;padding:16px 0;margin:0 auto;gap:16px"
} : 0);
var PageSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1wa0qut0"
} : 0)( true ? {
  name: "sfltnx",
  styles: "position:relative;flex-shrink:0"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/ScrollViewer/index.tsx



















/**
 * V2 연속 스크롤 보기 모드.
 * - 세로 중앙선 IntersectionObserver가 currentPageAtom을 갱신해
 *   페이지별 체류시간 분석이 V1과 동일하게 동작한다.
 * - startFrom 게이트 활성 시 게이트 페이지까지만 렌더(클램프)하고,
 *   게이트 페이지는 블러 + GateStopper 오버레이로 막는다.
 */
var ScrollViewer = function ScrollViewer(_ref) {
  var _document$pages$0$ori, _document$pages$, _document$pages$0$ori2, _document$pages$2;

  var document = _ref.document,
      currentPage = _ref.currentPage,
      blindPages = _ref.blindPages,
      isGateActive = _ref.isGateActive,
      ctaFormPage = _ref.ctaFormPage,
      messageBoxItems = _ref.messageBoxItems,
      embedItems = _ref.embedItems,
      ctaForm = _ref.ctaForm,
      isFormSubmitted = _ref.isFormSubmitted,
      isMobile = _ref.isMobile,
      translateKoToEn = _ref.translateKoToEn;
  var zoom = (0,react/* useAtomValue */.Dv)(v2ZoomAtom);

  var _useAtom = (0,react/* useAtom */.KO)(index_atom/* isCtaModalOpenAtom */.D5),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      isCtaModalOpen = _useAtom2[0],
      setIsCtaModalOpen = _useAtom2[1];

  var _useAtom3 = (0,react/* useAtom */.KO)(v2ScrollTargetPageAtom),
      _useAtom4 = (0,slicedToArray/* default */.Z)(_useAtom3, 2),
      scrollTargetPage = _useAtom4[0],
      setScrollTargetPage = _useAtom4[1];

  var scrollRef = (0,node_modules_react.useRef)(null);
  var scrollContentRef = (0,node_modules_react.useRef)(null);
  var isProgrammaticScrollRef = (0,node_modules_react.useRef)(false);

  var _useAnchoredZoom = v2_useAnchoredZoom({
    scrollRef: scrollRef
  }),
      zoomAtPoint = _useAnchoredZoom.zoomAtPoint;

  v2_usePinchZoom({
    scrollRef: scrollRef,
    transformTargetRef: scrollContentRef,
    zoomAtPoint: zoomAtPoint
  });
  v2_useDoubleTapZoom({
    scrollRef: scrollRef,
    transformTargetRef: scrollContentRef,
    zoomAtPoint: zoomAtPoint
  });
  /* 게이트 활성 시 게이트 페이지까지만 렌더한다 */

  var visiblePages = isGateActive && ctaFormPage ? document.pages.slice(0, ctaFormPage) : document.pages;

  var _useFitZoom = v2_useFitZoom({
    originalWidth: (_document$pages$0$ori = (_document$pages$ = document.pages[0]) === null || _document$pages$ === void 0 ? void 0 : _document$pages$.originalWidth) !== null && _document$pages$0$ori !== void 0 ? _document$pages$0$ori : 1,
    originalHeight: (_document$pages$0$ori2 = (_document$pages$2 = document.pages[0]) === null || _document$pages$2 === void 0 ? void 0 : _document$pages$2.originalHeight) !== null && _document$pages$0$ori2 !== void 0 ? _document$pages$0$ori2 : 1
  }),
      fitPageWidth = _useFitZoom.fitPageWidth;

  var renderedWidth = fitPageWidth * zoom;

  var _useScrollCurrentPage = v2_useScrollCurrentPage({
    rootRef: scrollRef,
    isProgrammaticScrollRef: isProgrammaticScrollRef,
    totalPages: visiblePages.length
  }),
      syncCommittedPage = _useScrollCurrentPage.syncCommittedPage; // eslint-disable-next-line no-undef


  var scrollToPage = function scrollToPage(page) {
    var behavior = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'auto';
    var root = scrollRef.current;
    var target = root === null || root === void 0 ? void 0 : root.querySelector("[data-page=\"".concat(page, "\"]"));

    if (!root || !target) {
      return;
    }

    isProgrammaticScrollRef.current = true;
    target.scrollIntoView({
      block: 'start',
      behavior: behavior
    });
    syncCommittedPage(page);
    setTimeout(function () {
      isProgrammaticScrollRef.current = false;
    }, 150);
  };
  /* 마운트 시(모드 전환 포함) 현재 페이지 위치로 복원한다 */


  (0,node_modules_react.useEffect)(function () {
    if (currentPage > 1) {
      scrollToPage(currentPage);
    }
  }, []);
  /* 썸네일 클릭/페이지 입력 등 외부 이동 요청 처리 */

  (0,node_modules_react.useEffect)(function () {
    if (scrollTargetPage === null) {
      return;
    }

    scrollToPage(scrollTargetPage);
    setScrollTargetPage(null);
  }, [scrollTargetPage]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ScrollArea, {
    ref: scrollRef,
    isScrollLocked: isCtaModalOpen,
    onContextMenu: function onContextMenu(e) {
      return e.preventDefault();
    },
    onDragStart: function onDragStart(e) {
      return e.preventDefault();
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ScrollContent, {
      ref: scrollContentRef,
      children: visiblePages.map(function (pageData) {
        var aspect = pageData.originalWidth / pageData.originalHeight || 1;
        var pageHeight = renderedWidth / aspect;
        var isGatePage = isGateActive && pageData.page === ctaFormPage;
        var isBlind = isGatePage || Boolean(blindPages === null || blindPages === void 0 ? void 0 : blindPages.includes(pageData.page));
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PageSlot, {
          "data-page": pageData.page,
          "data-zoom-anchor": true,
          style: {
            width: renderedWidth,
            height: pageHeight
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v2_V2PageImage, {
            pageData: pageData,
            sizes: quantizeImageSizes(renderedWidth),
            isBlind: isBlind,
            loading: pageData.page <= 2 ? 'eager' : 'lazy'
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v2_PageAnnotations, {
            pageData: pageData,
            renderedWidth: renderedWidth,
            renderedHeight: pageHeight,
            messageBoxItems: messageBoxItems,
            embedItems: embedItems,
            ctaForm: ctaForm,
            isFormSubmitted: isFormSubmitted,
            isBlind: isBlind,
            isMobile: isMobile
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Slide, {
            userSubscriptionPlan: document.plan,
            isMobile: isMobile
          }), isGatePage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ScrollViewer_GateStopper, {
            openForm: function openForm() {
              return setIsCtaModalOpen(true);
            },
            translateKoToEn: translateKoToEn
          })]
        }, pageData.page);
      })
    })
  });
};

/* harmony default export */ var v2_ScrollViewer = (ScrollViewer);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/V2ViewerShell/index.styles.ts


function V2ViewerShell_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var ShellRoot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eet3ktg7"
} : 0)("position:relative;display:flex;overflow:hidden;width:100vw;height:100vh;height:100dvh;height:var(--doc-height, 100dvh);flex-direction:column;background:", styles/* theme.colors.zinc_100 */.rS.colors.zinc_100, ";" + ( true ? "" : 0));
/* 데스크톱: 좌측 페이지 목록(풀 높이) + 우측 툴바/슬라이드 컬럼 */

var LayoutRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eet3ktg6"
} : 0)( true ? {
  name: "uvy5ss",
  styles: "display:flex;width:100%;min-height:0;flex:1"
} : 0);
var MainColumn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eet3ktg5"
} : 0)( true ? {
  name: "4mp0fy",
  styles: "position:relative;display:flex;min-width:0;min-height:0;flex:1;flex-direction:column"
} : 0);
/* 페이지 목록이 닫혔을 때 좌측 엣지 세로 중앙에 붙는 열기 핸들 */

var PanelEdgeHandle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "eet3ktg4"
} : 0)("position:absolute;z-index:", constants/* VIEWER_Z_INDEX.desktopLayer */.G.desktopLayer, ";top:50%;left:0;display:flex;width:28px;height:96px;align-items:center;justify-content:center;border:1px solid ", styles/* theme.colors.zinc_300 */.rS.colors.zinc_300, ";border-left:none;background:", styles/* theme.colors.white */.rS.colors.white, ";border-radius:0 10px 10px 0;box-shadow:", styles/* theme.elevation.md */.rS.elevation.md, ";cursor:pointer;transform:translateY(-50%);transition:0.15s ease-in-out;&:hover{width:32px;background:", styles/* theme.colors.zinc_100 */.rS.colors.zinc_100, ";}&.disabled{cursor:initial;opacity:0.25;}" + ( true ? "" : 0));
/* 모바일: 상단 프로그레스 바(3px, fixed) 아래 문서 제목 영역 */

var MobileTitleBar = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eet3ktg3"
} : 0)("flex-shrink:0;padding:11px 16px 8px;border-bottom:1px solid ", styles/* theme.colors.zinc_200 */.rS.colors.zinc_200, ";background:", styles/* theme.colors.white */.rS.colors.white, ";" + ( true ? "" : 0));
var MobileTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eet3ktg2"
} : 0)( true ? {
  name: "e03b9o",
  styles: "overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:calc(100vw - 60px)"
} : 0);
var Body = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eet3ktg1"
} : 0)("display:flex;width:100%;min-height:0;flex:1;flex-direction:", function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? 'column' : 'row';
}, ";" + ( true ? "" : 0));
var ContentWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eet3ktg0"
} : 0)( true ? {
  name: "kbvm4c",
  styles: "position:relative;min-width:0;min-height:0;flex:1"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/V2ViewerShell/index.tsx




































/** V2 뷰어 레이아웃 루트. 툴바/패널/뷰어/공유 오버레이를 합성한다. */
var V2ViewerShell_V2ViewerShell = function V2ViewerShell(_ref) {
  var _pdfDocument$pages, _currentPageData$orig, _currentPageData$orig2;

  var pdfDocument = _ref.document,
      isBulk = _ref.isBulk,
      domain = _ref.domain,
      messageBoxItems = _ref.messageBoxItems,
      embedItems = _ref.embedItems,
      cta = _ref.cta,
      translateKoToEn = _ref.translateKoToEn,
      _ref$isScrollModeEnab = _ref.isScrollModeEnabled,
      isScrollModeEnabled = _ref$isScrollModeEnab === void 0 ? true : _ref$isScrollModeEnab,
      _ref$isPreview = _ref.isPreview,
      isPreview = _ref$isPreview === void 0 ? false : _ref$isPreview;
  var userAgent =  true ? window.navigator.userAgent : 0;
  var isMobile = (0,react_responsive.useMediaQuery)({
    maxWidth: 767
  }) || /iPhone|Android/.test(userAgent);
  var isMobileLandscape = (0,react_responsive.useMediaQuery)({
    query: '(orientation: landscape)'
  }) && isMobile;
  var shellRef = (0,node_modules_react.useRef)(null);
  var contentRef = (0,node_modules_react.useRef)(null);
  var setPdfViewerMode = (0,react/* useSetAtom */.b9)(index_atom/* pdfViewerModeAtom */.yf);
  var setContainerSize = (0,react/* useSetAtom */.b9)(v2ContainerSizeAtom);

  var _useAtom = (0,react/* useAtom */.KO)(v2ViewModeAtom),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      viewMode = _useAtom2[0],
      setViewMode = _useAtom2[1];

  var setZoom = (0,react/* useSetAtom */.b9)(v2ZoomAtom);
  var fitMode = (0,react/* useAtomValue */.Dv)(v2ZoomFitModeAtom);

  var _useAtom3 = (0,react/* useAtom */.KO)(v2IsThumbnailPanelOpenAtom),
      _useAtom4 = (0,slicedToArray/* default */.Z)(_useAtom3, 2),
      isThumbnailPanelOpen = _useAtom4[0],
      setIsThumbnailPanelOpen = _useAtom4[1];

  var _useAtom5 = (0,react/* useAtom */.KO)(v2IsImmersiveAtom),
      _useAtom6 = (0,slicedToArray/* default */.Z)(_useAtom5, 2),
      isImmersive = _useAtom6[0],
      setIsImmersive = _useAtom6[1];

  var _useAtom7 = (0,react/* useAtom */.KO)(index_atom/* isDisableHelpersAtom */.Tn),
      _useAtom8 = (0,slicedToArray/* default */.Z)(_useAtom7, 2),
      isDisableHelpers = _useAtom8[0],
      setIsDisableHelpers = _useAtom8[1];

  var isCtaModalOpen = (0,react/* useAtomValue */.Dv)(index_atom/* isCtaModalOpenAtom */.D5);
  var isPreviewFormSubmitted = (0,react/* useAtomValue */.Dv)(index_atom_isPreviewFormSubmittedAtom);

  var _useFullscreen = v2_useFullscreen(shellRef),
      isFullscreenActive = _useFullscreen.isFullscreenActive,
      toggleFullscreen = _useFullscreen.toggleFullscreen;
  /*
   * 데스크톱은 페이지 목록을 기본 오픈한다(최초 1회, 이후 사용자 토글 우선).
   * useMediaQuery는 하이드레이션 직후 false를 반환할 수 있어
   * 이펙트 시점에 matchMedia로 직접 판별한다(모바일 기본 닫힘 보장).
   */


  var isPanelDefaultAppliedRef = (0,node_modules_react.useRef)(false);
  (0,react_hooks/* useIsomorphicLayoutEffect */.LI)(function () {
    if (isPanelDefaultAppliedRef.current) {
      return;
    }

    isPanelDefaultAppliedRef.current = true;
    var isMobileEnvironment = window.matchMedia('(max-width: 767px)').matches || /iPhone|Android/.test(window.navigator.userAgent);

    if (!isMobileEnvironment) {
      setIsThumbnailPanelOpen(true);
    }
  }, [setIsThumbnailPanelOpen]);
  /* V1 RootLayout과 동일한 모드 등록 + 바디 스크롤 잠금 + 모바일 높이 보정 */

  (0,react_hooks/* useIsomorphicLayoutEffect */.LI)(function () {
    setPdfViewerMode(isMobile ? 'mobile' : 'desktop');
    var _document = document,
        body = _document.body;
    (0,bodyScrollLock_esm/* disableBodyScroll */.Qp)(body, {
      allowTouchMove: function allowTouchMove() {
        return true;
      }
    });
    return function () {
      (0,bodyScrollLock_esm/* enableBodyScroll */.tG)(body);
    };
  }, [isMobile, setPdfViewerMode]);
  (0,react_hooks/* useIsomorphicLayoutEffect */.LI)(function () {
    var _window$visualViewpor3;

    var documentHeight = function documentHeight() {
      var _window$visualViewpor, _window$visualViewpor2;

      /*
       * iOS Safari/인앱 브라우저는 주소창 표시·숨김 시 window resize가
       * 늦거나 오지 않는다. visualViewport가 실제 보이는 영역을 추적한다.
       */
      var height = (_window$visualViewpor = (_window$visualViewpor2 = window.visualViewport) === null || _window$visualViewpor2 === void 0 ? void 0 : _window$visualViewpor2.height) !== null && _window$visualViewpor !== void 0 ? _window$visualViewpor : window.innerHeight;
      document.documentElement.style.setProperty('--doc-height', "".concat(height, "px"));
    };

    documentHeight();
    window.addEventListener('resize', documentHeight);
    (_window$visualViewpor3 = window.visualViewport) === null || _window$visualViewpor3 === void 0 ? void 0 : _window$visualViewpor3.addEventListener('resize', documentHeight);
    return function () {
      var _window$visualViewpor4;

      window.removeEventListener('resize', documentHeight);
      (_window$visualViewpor4 = window.visualViewport) === null || _window$visualViewpor4 === void 0 ? void 0 : _window$visualViewpor4.removeEventListener('resize', documentHeight);
    };
  }, []);
  /* 콘텐츠 영역 측정 → fit 줌 계산의 기준 */

  (0,dist_module/* default */.Z)(contentRef, function (_ref2) {
    var _ref2$contentRect = _ref2.contentRect,
        width = _ref2$contentRect.width,
        height = _ref2$contentRect.height;
    return setContainerSize({
      width: width,
      height: height
    });
  });
  /* 스크롤 모드 비활성 시 paged 강제 */

  (0,node_modules_react.useEffect)(function () {
    if (!isScrollModeEnabled && viewMode === 'scroll') {
      setViewMode('paged');
    }
  }, [isScrollModeEnabled, viewMode, setViewMode]);
  var ctaForm = cta === null || cta === void 0 ? void 0 : cta.ctaForm;
  var ctaFormPage = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.page;
  var blindMode = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.blind;
  /* 미리보기에서는 프리뷰 폼 제출 상태(atom)를 실제 제출로 간주한다(V1 파리티) */

  var isFormSubmitted = (cta === null || cta === void 0 ? void 0 : cta.isFormSubmitted) || isPreview && isPreviewFormSubmitted;
  var isGateActive = Boolean(blindMode === 'startFrom' && !isFormSubmitted && ctaFormPage);
  var blindPages = isFormSubmitted ? null : index_util_getBlindPages({
    blindStatus: blindMode,
    blindPage: ctaFormPage,
    totalPages: pdfDocument.totalPages
  });
  var isRedirectCtaFormAppropriate = Boolean(cta && !(blindMode === 'none') && !isFormSubmitted);
  var navigation = v2_useV2PageNavigation({
    totalPages: pdfDocument.totalPages,
    ctaFormPage: ctaFormPage,
    isGateActive: isGateActive
  });
  var currentPage = navigation.currentPage,
      goToPage = navigation.goToPage,
      goToPrevPage = navigation.goToPrevPage,
      goToNextPage = navigation.goToNextPage;
  v2_useV2KeyPress({
    goToPrevPage: goToPrevPage,
    goToNextPage: goToNextPage
  });
  var currentPageData = (_pdfDocument$pages = pdfDocument.pages[currentPage - 1]) !== null && _pdfDocument$pages !== void 0 ? _pdfDocument$pages : pdfDocument.pages[0];

  var _useFitZoom = v2_useFitZoom({
    originalWidth: (_currentPageData$orig = currentPageData === null || currentPageData === void 0 ? void 0 : currentPageData.originalWidth) !== null && _currentPageData$orig !== void 0 ? _currentPageData$orig : 1,
    originalHeight: (_currentPageData$orig2 = currentPageData === null || currentPageData === void 0 ? void 0 : currentPageData.originalHeight) !== null && _currentPageData$orig2 !== void 0 ? _currentPageData$orig2 : 1
  }),
      fitWidthZoom = _useFitZoom.fitWidthZoom;
  /*
   * 세로로 긴 문서라도 배율은 자동으로 바꾸지 않는다.
   * 대신 가로 맞춤 힌트 칩으로 전환을 권유하고 선택은 사용자에게 맡긴다.
   */


  var _useFitWidthHint = v2_useFitWidthHint({
    fitWidthZoom: fitWidthZoom
  }),
      isHintVisible = _useFitWidthHint.isHintVisible,
      applyFitWidth = _useFitWidthHint.applyFitWidth,
      dismissHint = _useFitWidthHint.dismissHint;
  /* fit-width 모드는 리사이즈/페이지 변경 시 배율을 추적한다(fit-page는 zoom=1 고정) */


  (0,node_modules_react.useEffect)(function () {
    if (fitMode === 'fitWidth') {
      setZoom(clampV2Zoom(fitWidthZoom));
    }

    if (fitMode === 'fitPage') {
      setZoom(1);
    }
  }, [fitMode, fitWidthZoom, setZoom]);
  /* 벌크: 게이트 페이지 1페이지 설정 시 폼 제출 전 인트로 숨김(V1 파리티) */

  var isIntroVisible = cta ? ctaFormPage === 1 && blindMode === 'startFrom' ? Boolean(isFormSubmitted) : true : true;
  var isChromeVisible = !(isMobile && isImmersive);
  /*
   * 문의양식 딤/모달이 덮는 동안에는 힌트 칩을 렌더하지 않는다.
   * CtaFormLayer는 이펙트에서 isCtaModalOpenAtom을 켜므로 원자값만 보면
   * 모달이 붙기 전 한 커밋 동안 칩이 보였다가 딤에 가려진다.
   * 모달이 열릴 조건을 같은 기준(currentPageAtom)으로 동기 계산해 깜빡임을 막는다.
   */

  var isCtaOverlayVisible = isCtaModalOpen || Boolean(ctaFormPage === currentPage && blindMode !== 'none' && !isFormSubmitted);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ShellRoot, {
    ref: shellRef,
    as: "main",
    children: [isIntroVisible && (isMobile ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Intro_Mobile, {
      translateKoToEn: translateKoToEn
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Desktop, {
      translateKoToEn: translateKoToEn
    })), isMobile && isChromeVisible && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v2_ProgressBar, {
        currentPage: currentPage,
        totalPages: pdfDocument.totalPages
      }), !isMobileLandscape && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileTitleBar, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "sm-semibold",
          color: "zinc_700",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileTitle, {
            children: pdfDocument.name
          })
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LayoutRow, {
      children: [!isMobile && isThumbnailPanelOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v2_ThumbnailPanel, {
        document: pdfDocument,
        currentPage: currentPage,
        goToPage: goToPage,
        blindPages: blindPages,
        isGateActive: isGateActive,
        ctaFormPage: ctaFormPage,
        embedItems: embedItems,
        isMobile: false,
        translateKoToEn: translateKoToEn,
        onClose: function onClose() {
          return setIsThumbnailPanelOpen(false);
        }
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MainColumn, {
        children: [!isMobile && !isThumbnailPanelOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PanelEdgeHandle, {
          type: "button",
          className: isDisableHelpers ? 'disabled' : '',
          "aria-label": translateKoToEn('thumbnails'),
          title: translateKoToEn('thumbnails'),
          onClick: function onClick(e) {
            e.stopPropagation();
            /* 흐려진 상태의 첫 클릭은 컨트롤 표시만 복구한다(V1 파리티) */

            if (isDisableHelpers) {
              setIsDisableHelpers(false);
              return;
            }

            setIsThumbnailPanelOpen(true);
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
            icon: "ph:caret-double-right",
            size: 16,
            color: "black"
          })
        }), !isMobile && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v2_Toolbar, {
          document: pdfDocument,
          isBulk: isBulk,
          domain: domain,
          isPreview: isPreview,
          ctaFormPage: ctaFormPage,
          isRedirectCtaFormAppropriate: isRedirectCtaFormAppropriate,
          isScrollModeEnabled: isScrollModeEnabled,
          currentPage: currentPage,
          goToPage: goToPage,
          goToPrevPage: goToPrevPage,
          goToNextPage: goToNextPage,
          isNextPageDisabled: navigation.isNextPageDisabled,
          fitWidthZoom: fitWidthZoom,
          isFullscreenActive: isFullscreenActive,
          toggleFullscreen: toggleFullscreen,
          translateKoToEn: translateKoToEn
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Body, {
          isMobile: isMobile,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContentWrapper, {
            ref: contentRef,
            onClick: function onClick() {
              if (isMobile && isImmersive) {
                setIsImmersive(false);
                return;
              }
              /* V1 파리티: 슬라이드 영역 클릭/탭으로 플로팅 컨트롤 표시 토글 */


              setIsDisableHelpers(function (prev) {
                return !prev;
              });
            },
            children: [viewMode === 'scroll' && isScrollModeEnabled ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v2_ScrollViewer, {
              document: pdfDocument,
              currentPage: currentPage,
              blindPages: blindMode === 'specific' ? blindPages : null,
              isGateActive: isGateActive,
              ctaFormPage: ctaFormPage,
              messageBoxItems: messageBoxItems,
              embedItems: embedItems,
              ctaForm: ctaForm,
              isFormSubmitted: isFormSubmitted,
              isMobile: isMobile,
              translateKoToEn: translateKoToEn
            }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v2_PagedViewer, {
              document: pdfDocument,
              currentPage: currentPage,
              goToPage: goToPage,
              goToPrevPage: goToPrevPage,
              goToNextPage: goToNextPage,
              isNextPageDisabled: navigation.isNextPageDisabled,
              blindPages: blindPages,
              messageBoxItems: messageBoxItems,
              embedItems: embedItems,
              ctaForm: ctaForm,
              isFormSubmitted: isFormSubmitted,
              isMobile: isMobile
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v2_FitWidthHint
            /*
             * 모바일 몰입 모드·문의양식 오버레이 중에는 함께 숨긴다.
             * 양식 제출로 오버레이가 걷히면 그때 자연스럽게 나타난다.
             */
            , {
              isVisible: isHintVisible && isChromeVisible && !isCtaOverlayVisible,
              isMobile: isMobile,
              onApply: applyFitWidth,
              onDismiss: dismissHint,
              translateKoToEn: translateKoToEn
            }), isBulk && cta && !isMobile && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Desktop_CtaFormLayer, {
                ctaForm: ctaForm,
                isPreview: isPreview,
                isEmailVerificationEnabled: cta.isEmailVerificationEnabled,
                isFormSubmitted: isFormSubmitted,
                translateKoToEn: translateKoToEn,
                userSubscriptionPlan: pdfDocument.plan
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Desktop_CtaButtonLayer, {
                ctaButtonList: cta.ctaButtonList
              })]
            })]
          }), isMobile && isThumbnailPanelOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v2_ThumbnailPanel, {
            document: pdfDocument,
            currentPage: currentPage,
            goToPage: goToPage,
            blindPages: blindPages,
            isGateActive: isGateActive,
            ctaFormPage: ctaFormPage,
            embedItems: embedItems,
            isMobile: true,
            translateKoToEn: translateKoToEn
          })]
        })]
      })]
    }), isMobile && isChromeVisible && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v2_MobileBottomBar, {
      document: pdfDocument,
      isBulk: isBulk,
      domain: domain,
      isPreview: isPreview,
      ctaFormPage: ctaFormPage,
      isRedirectCtaFormAppropriate: isRedirectCtaFormAppropriate,
      isScrollModeEnabled: isScrollModeEnabled,
      currentPage: currentPage,
      goToPrevPage: goToPrevPage,
      goToNextPage: goToNextPage,
      isNextPageDisabled: navigation.isNextPageDisabled,
      isFullscreenActive: isFullscreenActive,
      toggleFullscreen: toggleFullscreen,
      translateKoToEn: translateKoToEn,
      isMobileLandscape: isMobileLandscape
    }), isBulk && cta && isMobile && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mobile_CtaFormLayer, {
        ctaForm: ctaForm,
        isPreview: isPreview,
        totalPage: pdfDocument.totalPages,
        isNextPageButtonDisabled: navigation.isNextPageDisabled,
        isEmailVerificationEnabled: cta.isEmailVerificationEnabled,
        isFormSubmitted: isFormSubmitted,
        translateKoToEn: translateKoToEn,
        userSubscriptionPlan: pdfDocument.plan,
        isMobileLandscape: isMobileLandscape
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mobile_CtaButtonLayer, {
        ctaButtonList: cta.ctaButtonList,
        isMobileLandscape: isMobileLandscape
      })]
    })]
  });
};

/* harmony default export */ var v2_V2ViewerShell = (V2ViewerShell_V2ViewerShell);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/V2OneToOneViewer/index.tsx




/** 1:1 공유 PDF의 V2 뷰어 진입점 */
var V2OneToOneViewer_V2OneToOneViewer = function V2OneToOneViewer(_ref) {
  var data = _ref.data,
      domain = _ref.domain,
      messageBoxItems = _ref.messageBoxItems,
      embedItems = _ref.embedItems,
      translateKoToEn = _ref.translateKoToEn;
  return _jsx(V2ViewerShell, {
    document: adaptOneToOneDocument(data),
    isBulk: false,
    domain: domain,
    messageBoxItems: messageBoxItems,
    embedItems: embedItems,
    translateKoToEn: translateKoToEn
  });
};

/* harmony default export */ var v2_V2OneToOneViewer = ((/* unused pure expression or super */ null && (V2OneToOneViewer_V2OneToOneViewer)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/ZoomableViewer/index.styles.ts


function ZoomableViewer_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var ZoomWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1j8z0b31"
} : 0)( true ? {
  name: "qlwcmg",
  styles: "width:100%;height:100%;overflow:auto;display:flex;justify-content:center;align-items:center"
} : 0);
var ViewerContainer = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "e1j8z0b30"
} : 0)("position:relative;width:100%;height:100%;transform:scale(", function (props) {
  return props.zoomLevel;
}, ");transform-origin:", function (props) {
  return props.zoomLevel <= 1 ? 'center' : props.isMobile ? 'left center' : 'left top';
}, ";" + ( true ? "" : 0))));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/ZoomableViewer/index.tsx





var ZoomableViewer_ZoomableViwer = function ZoomableViwer(_ref) {
  var _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
      children = _ref.children;
  var zoomLevel = useAtomValue(zoomLevelAtom);
  return _jsx(Styled.ZoomWrapper, {
    children: _jsx(Styled.ViewerContainer, {
      zoomLevel: zoomLevel,
      isMobile: isMobile,
      children: children
    })
  });
};

/* harmony default export */ var _common_ZoomableViewer = ((/* unused pure expression or super */ null && (ZoomableViewer_ZoomableViwer)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/FreeBadge/Desktop/index.styles.ts




var FreeBadge_Desktop_index_styles_Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e1mwrub00"
} : 0)("position:absolute;z-index:", constants/* VIEWER_Z_INDEX.freeBadge */.G.freeBadge, ";right:48px;bottom:32px;background-color:", styles/* theme.colors.skyblue_600 */.rS.colors.skyblue_600, ";border-radius:8px;opacity:0;transition:all ease-in-out 150ms;visibility:hidden;&:hover{cursor:pointer;}&.is-visible{opacity:0.8;visibility:visible;&:hover{opacity:1;}}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/FreeBadge/Desktop/index.tsx







var Desktop_DesktopFreeBadge = function DesktopFreeBadge(_ref) {
  var userSubscriptionPlan = _ref.userSubscriptionPlan;

  var isFreeBadgeVisible = function isFreeBadgeVisible() {
    return userSubscriptionPlan === 'Free';
  };

  return _jsxs(Styled.Container, {
    gap: 8,
    className: isFreeBadgeVisible() ? 'is-visible' : '',
    padding: {
      x: 24,
      y: 16
    },
    alignItems: "center",
    width: "fit-content",
    style: {
      transform: 'scale(1.2) translate(-18px, -5px)'
    },
    onClick: function onClick() {
      handleFreeBadgeLinkOpen();
    },
    children: [_jsx(Text, {
      variant: "lg-semibold",
      color: "skyblue_100",
      children: "Powered by"
    }), _jsx(Image, {
      src: "/images/salesclue_logo_black_mono.png",
      width: 94,
      height: 21,
      alt: 'SalesClue',
      unoptimized: true
    })]
  });
};

/* harmony default export */ var FreeBadge_Desktop = ((/* unused pure expression or super */ null && (Desktop_DesktopFreeBadge)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/PdfViewer/Redirect/Page/Desktop/index.tsx














var Desktop_Desktop = function Desktop(_ref) {
  var data = _ref.data,
      domain = _ref.domain,
      messageBoxItems = _ref.messageBoxItems,
      translateKoToEn = _ref.translateKoToEn,
      updateNextThumbnails = _ref.updateNextThumbnails,
      updatePrevThumbnails = _ref.updatePrevThumbnails,
      _ref$isBulk = _ref.isBulk,
      isBulk = _ref$isBulk === void 0 ? false : _ref$isBulk;
  var thumbnails = useAtomValue(thumbnailsAtom);
  var isDownloadEnabled = data.isDownloadEnabled,
      name = data.name,
      thumnail = data.thumnail,
      pages = data.pages,
      userSubscriptionPlan = data.userSubscriptionPlan;
  return _jsxs(_Fragment, {
    children: [_jsx(DesktopIntro, {
      translateKoToEn: translateKoToEn
    }), _jsxs(DesktopPageWrapper, {
      totalPage: data.pages,
      children: [_jsx(DesktopViewerLayer, {
        translateKoToEn: translateKoToEn,
        fileName: name,
        domain: domain,
        isBulk: isBulk,
        isDownloadEnabled: isDownloadEnabled
      }), _jsxs(ZoomableViwer, {
        children: [_jsx(DesktopPage, {
          thumnails: thumbnails === null || thumbnails === void 0 ? void 0 : thumbnails.map(function (value) {
            if (value !== null && value !== void 0 && value.thumnail) {
              return {
                src: value.thumnail,
                imageSources: value.imageSources
              };
            }

            return null;
          })
        }), thumnail && _jsx(DesktopAnnotationLayer, {
          thumnail: thumnail,
          messageBoxItems: messageBoxItems
        })]
      }), _jsx(DesktopPageNavigationButton, {
        totalPage: Number(pages),
        updatePrevThumbnails: updatePrevThumbnails,
        updateNextThumbnails: updateNextThumbnails,
        isMoveCtaFormPageRequirements: true
      }), _jsx(DesktopFreeBadge, {
        userSubscriptionPlan: userSubscriptionPlan
      })]
    })]
  });
};

/* harmony default export */ var Page_Desktop = ((/* unused pure expression or super */ null && (Desktop_Desktop)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/FreeBadge/Mobile/index.styles.ts




var FreeBadge_Mobile_index_styles_Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e118g8360"
} : 0)("position:absolute;z-index:", constants/* VIEWER_Z_INDEX.freeBadge */.G.freeBadge, ";top:16px;left:16px;background-color:", styles/* theme.colors.skyblue_600 */.rS.colors.skyblue_600, ";border-radius:8px;opacity:0;transition:all ease-in-out 150ms;visibility:hidden;&:hover{cursor:pointer;}&.is-visible{opacity:0.8;visibility:visible;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/FreeBadge/Mobile/index.tsx







var Mobile_MobileFreeBadge = function MobileFreeBadge(_ref) {
  var userSubscriptionPlan = _ref.userSubscriptionPlan,
      _ref$y = _ref.y,
      y = _ref$y === void 0 ? 0 : _ref$y;

  var isFreeBadgeVisible = function isFreeBadgeVisible() {
    return userSubscriptionPlan === 'Free';
  };

  return _jsxs(Styled.Container, {
    gap: 8,
    padding: {
      x: 16,
      y: 12
    },
    className: isFreeBadgeVisible() ? 'is-visible' : '',
    alignItems: "center",
    width: "fit-content",
    style: {
      transform: "scale(1.2) translate(8px, ".concat(y, "px)")
    },
    onClick: function onClick() {
      handleFreeBadgeLinkOpen();
    },
    children: [_jsx(Text, {
      variant: "sm-semibold",
      color: "skyblue_100",
      children: "Powered by"
    }), _jsx(Image, {
      src: "/images/salesclue_logo_black_mono.png",
      width: 75,
      height: 17,
      alt: 'SalesClue',
      unoptimized: true
    })]
  });
};

/* harmony default export */ var FreeBadge_Mobile = ((/* unused pure expression or super */ null && (Mobile_MobileFreeBadge)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/DefaultViewerLayer/ZoomButton/Mobile/index.styles.ts


function ZoomButton_Mobile_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var ZoomButton_Mobile_index_styles_Button = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "e1szu2rw1"
} : 0)("z-index:", constants/* VIEWER_Z_INDEX.mobileLayer */.G.mobileLayer, ";width:43px;height:auto;padding:8px;box-shadow:none;transition:opacity 0.15s ease-in-out;&.disable{cursor:initial;opacity:0;}&.isLandscape{width:auto;height:43px;}" + ( true ? "" : 0));
var Mobile_index_styles_Icon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Icon */.JO,  true ? {
  target: "e1szu2rw0"
} : 0)( true ? {
  name: "137pcyc",
  styles: "margin:4px"
} : 0);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/DefaultViewerLayer/ZoomButton/Mobile/index.tsx









var Mobile_MobileZoomButton = function MobileZoomButton(_ref) {
  var isMobileLandscape = _ref.isMobileLandscape;

  var _useAtom = useAtom(zoomLevelAtom),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      zoomLevel = _useAtom2[0],
      setZoomLevel = _useAtom2[1];

  var isDisableHelpers = useAtomValue(isDisableHelpersAtom);

  var handleClickZoomIn = function handleClickZoomIn() {
    if (zoomLevel < 1.5) {
      setZoomLevel(function (prev) {
        return prev + 0.25;
      });
    }
  };

  var handleClickZoomOut = function handleClickZoomOut() {
    if (zoomLevel > 0.5) {
      setZoomLevel(function (prev) {
        return prev - 0.25;
      });
    }
  };

  return _jsx(Styled.Button, {
    className: cn({
      disable: isDisableHelpers,
      isLandscape: isMobileLandscape
    }),
    variant: "zinc_500",
    radius: 9999,
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    children: _jsxs(Stack, {
      direction: isMobileLandscape ? 'row' : 'column',
      gap: 16,
      justifyContent: "center",
      alignItems: "center",
      children: [_jsx(Styled.Icon, {
        icon: "ph:magnifying-glass-plus",
        size: 19,
        color: zoomLevel === 1.5 ? 'zinc_400' : 'black',
        onClick: handleClickZoomIn
      }), _jsx(Styled.Icon, {
        icon: "ph:magnifying-glass-minus",
        size: 19,
        color: zoomLevel === 0.5 ? 'zinc_400' : 'black',
        onClick: handleClickZoomOut
      })]
    })
  });
};

/* harmony default export */ var ZoomButton_Mobile = ((/* unused pure expression or super */ null && (Mobile_MobileZoomButton)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/DefaultViewerLayer/Mobile/index.styles.ts





var PositionWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e1s5d3ka2"
} : 0)("position:fixed;z-index:", constants/* VIEWER_Z_INDEX.mobileLayer */.G.mobileLayer, ";", function (_ref) {
  var isMobileLandscape = _ref.isMobileLandscape;
  return isMobileLandscape ? "\n        top: 16px;\n        " : "\n        bottom: 16px;\n    ";
}, " right:16px;width:auto;height:auto;" + ( true ? "" : 0));
var Mobile_index_styles_ArrowButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "e1s5d3ka1"
} : 0)("z-index:", constants/* VIEWER_Z_INDEX.mobileLayer */.G.mobileLayer, ";width:43px;height:43px;padding:8px;border:1px solid ", styles/* theme.colors.zinc_300 */.rS.colors.zinc_300, ";box-shadow:none;transition:opacity 0.15s ease-in-out;&.backgroundOpacity{opacity:0.5;}&.disable{cursor:initial;opacity:0;}" + ( true ? "" : 0));
var MotionDiv = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled(motion.div,  true ? {
  target: "e1s5d3ka0"
} : 0)("display:flex;flex-direction:", function (_ref2) {
  var isFlexRow = _ref2.isFlexRow;
  return isFlexRow ? 'row' : 'column';
}, ";gap:8px;" + ( true ? "" : 0))));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/@common/Layer/DefaultViewerLayer/Mobile/index.tsx














var Mobile_MobileViewerLayer = function MobileViewerLayer(_ref) {
  var fileName = _ref.fileName,
      domain = _ref.domain,
      isBulk = _ref.isBulk,
      isDownloadEnabled = _ref.isDownloadEnabled,
      ctaFormPage = _ref.ctaFormPage,
      translateKoToEn = _ref.translateKoToEn,
      isRedirectCtaFormAppropriate = _ref.isRedirectCtaFormAppropriate,
      isMobileLandscape = _ref.isMobileLandscape;
  var isHepersDisabled = useAtomValue(isDisableHelpersAtom);

  var _useState = useState(false),
      isDrawerOpen = _useState[0],
      setIsDrawerOpen = _useState[1];

  var toggleDrawer = function toggleDrawer(e) {
    e.stopPropagation();
    setIsDrawerOpen(function (prev) {
      return !prev;
    });
  };

  useEffect(function () {
    if (isHepersDisabled) {
      setIsDrawerOpen(false);
    }
  }, [isHepersDisabled]);
  var mappingCaretIcon = {
    landscape: {
      open: 'ph:caret-right',
      close: 'ph:caret-left'
    },
    "default": {
      open: 'ph:caret-down',
      close: 'ph:caret-up'
    }
  };
  var drawerVariantsMap = {
    landscape: {
      open: {
        width: 'auto'
      },
      closed: {
        width: 0
      }
    },
    "default": {
      open: {
        height: 'auto'
      },
      closed: {
        height: 0
      }
    }
  };
  var caretIcon = isMobileLandscape ? mappingCaretIcon.landscape : mappingCaretIcon["default"];
  var drawerVariants = isMobileLandscape ? drawerVariantsMap.landscape : drawerVariantsMap["default"];
  var initialMotion = isMobileLandscape ? {
    width: 0
  } : {
    height: 0
  };
  return _jsx(Styled.PositionWrapper, {
    gap: 16,
    justifyContent: "flex-end",
    isMobileLandscape: isMobileLandscape,
    children: _jsxs(Stack, {
      gap: isDrawerOpen ? 8 : 0,
      direction: isMobileLandscape ? 'row' : 'column',
      children: [_jsx(Styled.ArrowButton, {
        className: cn({
          disable: isHepersDisabled,
          backgroundOpacity: isMobileLandscape && !isDrawerOpen
        }),
        variant: "zinc_300",
        radius: 9999,
        leftIcon: _jsx(Icon, {
          icon: isDrawerOpen ? caretIcon.open : caretIcon.close,
          size: 19,
          color: "black"
        }),
        onClick: toggleDrawer,
        innerStyle: {
          backgroundColor: isMobileLandscape && !isDrawerOpen ? 'transparent' : ''
        }
      }), _jsx(Styled.MotionDiv, {
        isFlexRow: isMobileLandscape,
        initial: initialMotion,
        animate: isDrawerOpen ? drawerVariants.open : drawerVariants.closed,
        transition: {
          duration: 0.15
        },
        children: !isHepersDisabled && isDrawerOpen && _jsxs(_Fragment, {
          children: [_jsx(MobilePdfDownloadButton, {
            fileName: fileName,
            isBulk: isBulk,
            isDownloadEnabled: isDownloadEnabled,
            ctaFormPage: ctaFormPage,
            translateKoToEn: translateKoToEn,
            isRedirectCtaFormAppropriate: isRedirectCtaFormAppropriate
          }), _jsx(MobileShareButton, {
            domain: domain,
            fileName: fileName,
            translateKoToEn: translateKoToEn,
            isBulk: isBulk
          }), _jsx(MobileZoomButton, {
            isMobileLandscape: isMobileLandscape
          }), _jsx(MobileLanguageButton, {})]
        })
      })]
    })
  });
};

/* harmony default export */ var DefaultViewerLayer_Mobile = ((/* unused pure expression or super */ null && (Mobile_MobileViewerLayer)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/PdfViewer/Redirect/Page/Mobile/index.tsx















var Mobile_Mobile = function Mobile(_ref) {
  var data = _ref.data,
      domain = _ref.domain,
      translateKoToEn = _ref.translateKoToEn,
      setIsMobileDrawerOpen = _ref.setIsMobileDrawerOpen,
      _ref$isBulk = _ref.isBulk,
      isBulk = _ref$isBulk === void 0 ? false : _ref$isBulk,
      isMobileLandscape = _ref.isMobileLandscape,
      updateNextThumbnails = _ref.updateNextThumbnails,
      updatePrevThumbnails = _ref.updatePrevThumbnails;
  var currentPage = useAtomValue(currentPageAtom);
  var thumbnails = useAtomValue(thumbnailsAtom);

  if (!data) {
    return null;
  }

  var isDownloadEnabled = data.isDownloadEnabled,
      name = data.name,
      thumnail = data.thumnail,
      pages = data.pages,
      userSubscriptionPlan = data.userSubscriptionPlan;
  var isNextPageButtonDisabled = currentPage >= (thumnail === null || thumnail === void 0 ? void 0 : thumnail.length);
  return _jsxs(_Fragment, {
    children: [_jsx(MobileIntro, {
      translateKoToEn: translateKoToEn
    }), _jsxs(MobilePageWrapper, {
      totalPage: data.pages,
      updateNextThumbnails: updateNextThumbnails,
      updatePrevThumbnails: updatePrevThumbnails,
      children: [_jsx(MobilePage, {
        thumnails: thumbnails === null || thumbnails === void 0 ? void 0 : thumbnails.map(function (value) {
          if (value !== null && value !== void 0 && value.thumnail) {
            return {
              src: value.thumnail,
              imageSources: value.imageSources
            };
          }

          return null;
        }),
        isMobileLandscape: isMobileLandscape
      }), _jsx(MobilePageChangeEffectLayer, {}), _jsx(MobilePageNavigationButton, {
        totalPage: Number(pages),
        isNextPageButtonDisabled: isNextPageButtonDisabled,
        isMoveCtaFormPageRequirements: true,
        openDrawer: function openDrawer() {
          return setIsMobileDrawerOpen(true);
        },
        updateNextThumbnails: updateNextThumbnails,
        updatePrevThumbnails: updatePrevThumbnails,
        isMobileLandscape: isMobileLandscape
      }), _jsx(MobileFreeBadge, {
        userSubscriptionPlan: userSubscriptionPlan
      }), _jsx(MobileViewerLayer, {
        domain: domain,
        fileName: name,
        isBulk: isBulk,
        translateKoToEn: translateKoToEn,
        isDownloadEnabled: isDownloadEnabled,
        isMobileLandscape: isMobileLandscape
      }), thumnail && _jsx(MobileAnnotationLayer, {
        thumnail: thumnail
      })]
    })]
  });
};

/* harmony default export */ var Page_Mobile = ((/* unused pure expression or super */ null && (Mobile_Mobile)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/PdfViewer/Redirect/index.tsx















var PdfRedirectPage = function PdfRedirectPage(_ref) {
  var data = _ref.data,
      domain = _ref.domain,
      messageBoxItems = _ref.messageBoxItems,
      embedItems = _ref.embedItems,
      useWindowUnload = _ref.useWindowUnload,
      translateKoToEn = _ref.translateKoToEn;

  var _useViewerRoute = useViewerRoute(),
      isBulk = _useViewerRoute.isBulk,
      isShareRoute = _useViewerRoute.isShareRoute;

  var userAgent =  true ? window.navigator.userAgent : 0;

  var _useState = useState(false),
      isMobileDrawerOpen = _useState[0],
      setIsMobileDrawerOpen = _useState[1];

  useWindowUnload();
  var isMobile = useMediaQuery({
    maxWidth: 767
  }) || /iPhone|Android/.test(userAgent);
  useViewerIntervalRequest({
    isMobile: isMobile
  });
  var isMobileLandscape = useMediaQuery({
    query: '(orientation: landscape)'
  }) && isMobile;

  var _useUpdateOneToOneRen = useUpdateOneToOneRenderThumbnails({
    defaultThumbnails: data === null || data === void 0 ? void 0 : data.thumnail
  }),
      updateNextThumbnails = _useUpdateOneToOneRen.updateNextThumbnails,
      updatePrevThumbnails = _useUpdateOneToOneRen.updatePrevThumbnails; // const { version } = useViewerVersion();


  var version = 'v2';
  /* 버전 해석 전 단일 프레임: V1 플래시를 막기 위해 렌더를 보류한다 */

  if (isShareRoute && version === null) {
    return null;
  }

  if (isShareRoute && version === 'v2' && data) {
    return _jsx(V2OneToOneViewer, {
      data: data,
      domain: domain,
      messageBoxItems: messageBoxItems,
      embedItems: embedItems,
      translateKoToEn: translateKoToEn
    });
  }

  return _jsx(_Fragment, {
    children: isMobile ? _jsx(RootLayout, {
      mode: "mobile",
      children: data && _jsxs(_Fragment, {
        children: [_jsx(MobilePage, {
          data: data,
          domain: domain,
          isBulk: isBulk,
          translateKoToEn: translateKoToEn,
          updateNextThumbnails: updateNextThumbnails,
          updatePrevThumbnails: updatePrevThumbnails,
          setIsMobileDrawerOpen: setIsMobileDrawerOpen,
          isMobileLandscape: isMobileLandscape
        }), _jsx(MobilePageNavigation, {
          translateKoToEn: translateKoToEn,
          pages: data === null || data === void 0 ? void 0 : data.thumnail,
          setIsMobileDrawerOpen: setIsMobileDrawerOpen,
          isMobileDrawerOpen: isMobileDrawerOpen,
          isMobileLandscape: isMobileLandscape
        })]
      })
    }) : _jsx(RootLayout, {
      mode: "desktop",
      children: data && _jsxs(_Fragment, {
        children: [_jsx(DesktopPageNavigation, {
          translateKoToEn: translateKoToEn,
          fileName: data === null || data === void 0 ? void 0 : data.name,
          pages: data === null || data === void 0 ? void 0 : data.thumnail
        }), _jsx(DesktopPage, {
          data: data,
          domain: domain,
          isBulk: isBulk,
          translateKoToEn: translateKoToEn,
          updateNextThumbnails: updateNextThumbnails,
          updatePrevThumbnails: updatePrevThumbnails,
          messageBoxItems: messageBoxItems
        })]
      })
    })
  });
};

/* harmony default export */ var Redirect = ((/* unused pure expression or super */ null && (PdfRedirectPage)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/hooks/useUpdateRenderThumbnails.ts






var useUpdateRenderThumbnails_useUpdateRenderThumbnails = function useUpdateRenderThumbnails(_ref) {
  var defaultThumbnails = _ref.defaultThumbnails;
  var currentPage = useAtomValue(currentPageAtom);

  var _useAtom = useAtom(thumbnailsAtom),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      thumbnails = _useAtom2[0],
      setThumbnails = _useAtom2[1];

  var updateThumbnails = function updateThumbnails(page, startIndex, endIndex) {
    if (!thumbnails || !defaultThumbnails) {
      return;
    }

    var renderThumbnails = _toConsumableArray(thumbnails);

    for (var i = startIndex; i <= endIndex; i++) {
      renderThumbnails[page + i] = defaultThumbnails[page + i];
    }

    setThumbnails(renderThumbnails);
  };

  var updatePrevThumbnails = function updatePrevThumbnails(page) {
    if (currentPage - 1 < 0) {
      return;
    }

    updateThumbnails(page, -5, -1);
  };

  var updateNextThumbnails = function updateNextThumbnails(page) {
    if (defaultThumbnails && currentPage + 1 > defaultThumbnails.length) {
      return;
    }

    updateThumbnails(page, 1, 8);
  };

  useEffect(function () {
    if (defaultThumbnails) {
      var _thumbnails = defaultThumbnails.map(function (_, index) {
        return {
          page: index + 1,
          thumbnail: '',
          originalWidth: 0,
          originalHeight: 0,
          hyperlink: []
        };
      });

      _thumbnails[0] = defaultThumbnails[0];
      _thumbnails[1] = defaultThumbnails[1];
      _thumbnails[2] = defaultThumbnails[2];
      setThumbnails(_thumbnails);
    }
  }, []);
  useEffect(function () {
    if (!thumbnails || !defaultThumbnails) {
      return;
    }

    updateThumbnails(currentPage, -3, 1);
  }, [currentPage]);
  return {
    updatePrevThumbnails: updatePrevThumbnails,
    updateNextThumbnails: updateNextThumbnails
  };
};

/* harmony default export */ var hooks_useUpdateRenderThumbnails = ((/* unused pure expression or super */ null && (useUpdateRenderThumbnails_useUpdateRenderThumbnails)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/V2BulkViewer/index.tsx




/** 벌크 공유 PDF(CTA 포함)의 V2 뷰어 진입점 */
var V2BulkViewer_V2BulkViewer = function V2BulkViewer(_ref) {
  var data = _ref.data,
      messageBoxItems = _ref.messageBoxItems,
      embedItems = _ref.embedItems,
      ctaButtonList = _ref.ctaButtonList,
      ctaForm = _ref.ctaForm,
      translateKoToEn = _ref.translateKoToEn;
  return _jsx(V2ViewerShell, {
    document: adaptBulkDocument(data),
    isBulk: true,
    domain: data.user.domain,
    messageBoxItems: messageBoxItems,
    embedItems: embedItems,
    cta: {
      ctaForm: ctaForm,
      ctaButtonList: ctaButtonList,
      isEmailVerificationEnabled: data.file.isEmailVerificationEnabled,
      isFormSubmitted: data.file.isFormSubmitted
    },
    translateKoToEn: translateKoToEn
  });
};

/* harmony default export */ var v2_V2BulkViewer = ((/* unused pure expression or super */ null && (V2BulkViewer_V2BulkViewer)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/Desktop/AnnotationLayer/index.tsx









var AnnotationLayer_AnnotationLayer = function AnnotationLayer(_ref) {
  var _ref$isPreview = _ref.isPreview,
      isPreview = _ref$isPreview === void 0 ? false : _ref$isPreview,
      thumbnails = _ref.thumbnails,
      ctaForm = _ref.ctaForm,
      messageBoxItems = _ref.messageBoxItems,
      isFormSubmitted = _ref.isFormSubmitted;
  var currentPage = useAtomValue(currentPageAtom);
  var blindMode = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.blind;
  var _thumbnails = thumbnails[currentPage - 1],
      hyperlink = _thumbnails.hyperlink,
      originalHeight = _thumbnails.originalHeight,
      originalWidth = _thumbnails.originalWidth;

  var _useHandleResizedImag = useHandleResizedImage({
    originalWidth: originalWidth,
    originalHeight: originalHeight
  }),
      resizedImageSize = _useHandleResizedImag.resizedImageSize;

  var getFormNotSubmitPage = function getFormNotSubmitPage(moveTargetPage) {
    if (!isFormSubmitted && blindMode === 'startFrom' && ctaForm !== null && ctaForm !== void 0 && ctaForm.page && moveTargetPage >= (ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.page)) {
      return ctaForm.page;
    }

    return null;
  };

  return _jsxs(_Fragment, {
    children: [_jsx(MessageBoxLayer, {
      resizedImageSize: resizedImageSize,
      isPreview: isPreview,
      messageBoxItems: messageBoxItems,
      getFormNotSubmitPage: getFormNotSubmitPage
    }), _jsx(DesktopHyperLinkLayer, {
      hyperlinkList: hyperlink,
      resizedImageSize: resizedImageSize,
      isPreview: isPreview,
      getFormNotSubmitPage: getFormNotSubmitPage
    })]
  });
};

/* harmony default export */ var Desktop_AnnotationLayer = ((/* unused pure expression or super */ null && (AnnotationLayer_AnnotationLayer)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/Desktop/index.tsx

















var Desktop_BulkDesktopViewer = function BulkDesktopViewer(_ref) {
  var file = _ref.file,
      user = _ref.user,
      ctaButtonList = _ref.ctaButtonList,
      ctaForm = _ref.ctaForm,
      messageBoxItems = _ref.messageBoxItems,
      translateKoToEn = _ref.translateKoToEn,
      updateNextThumbnails = _ref.updateNextThumbnails,
      updatePrevThumbnails = _ref.updatePrevThumbnails,
      blindPages = _ref.blindPages,
      _ref$isPreview = _ref.isPreview,
      isPreview = _ref$isPreview === void 0 ? false : _ref$isPreview;
  var currentPage = useAtomValue(currentPageAtom);
  var isCtaModalOpen = useAtomValue(isCtaModalOpenAtom);
  var zoomLevel = useAtomValue(zoomLevelAtom);
  var isPreviewFormSubmitted = useAtomValue(isPreviewFormSubmittedAtom);
  var thumbnails = useAtomValue(thumbnailsAtom);
  var isLanguageDropdownOpen = useAtomValue(isLanguageDropdownOpenAtom);
  var domain = user.domain,
      plan = user.plan;
  var name = file.name,
      isDownloadEnabled = file.isDownloadEnabled,
      isEmailVerificationEnabled = file.isEmailVerificationEnabled,
      isFormSubmitted = file.isFormSubmitted,
      pages = file.pages;
  var ctaFormPage = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.page;
  var blindMode = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.blind;
  var isNextPageButtonDisabled = currentPage >= Number(ctaFormPage) && blindMode === 'startFrom' && (isPreview ? !isPreviewFormSubmitted : !isFormSubmitted);
  var isRedirectCtaFormAppropriate = Boolean(!(blindMode === 'none') && !isFormSubmitted);
  /*첫 번째 페이지에 폼이 설정되어 있는 경우에 폼 제출 이후에 보여지도록 한다 */

  var isIntroVisible = ctaFormPage === 1 && blindMode === 'startFrom' ? isFormSubmitted : true;
  return _jsxs(_Fragment, {
    children: [isIntroVisible && _jsx(DesktopIntro, {
      translateKoToEn: translateKoToEn
    }), _jsxs(DesktopPageWrapper, {
      totalPage: Number(pages),
      updateNextThumbnails: updateNextThumbnails,
      updatePrevThumbnails: updatePrevThumbnails,
      isWheelDisabled: isNextPageButtonDisabled || isCtaModalOpen || zoomLevel !== 1 || isLanguageDropdownOpen,
      children: [_jsx(DesktopViewerLayer, {
        fileName: name,
        domain: domain,
        isDownloadEnabled: isPreview ? false : isDownloadEnabled,
        ctaFormPage: ctaFormPage,
        translateKoToEn: translateKoToEn,
        isRedirectCtaFormAppropriate: isRedirectCtaFormAppropriate,
        isShareable: !isPreview,
        isBulk: true
      }), _jsxs(ZoomableViewer, {
        children: [_jsx(DesktopPage, {
          thumnails: thumbnails === null || thumbnails === void 0 ? void 0 : thumbnails.map(function (value) {
            if (value !== null && value !== void 0 && value.thumbnail) {
              return {
                src: value.thumbnail,
                imageSources: value.imageSources
              };
            }

            return null;
          }),
          blindPages: blindPages
        }), thumbnails && _jsx(AnnotationLayer, {
          thumbnails: thumbnails,
          messageBoxItems: messageBoxItems,
          ctaForm: ctaForm,
          isPreview: isPreview,
          isFormSubmitted: isFormSubmitted
        })]
      }), _jsx(CtaFormLayer, {
        ctaForm: ctaForm,
        isPreview: isPreview,
        isEmailVerificationEnabled: isEmailVerificationEnabled,
        isFormSubmitted: isFormSubmitted,
        translateKoToEn: translateKoToEn,
        userSubscriptionPlan: plan
      }), _jsx(CtaButtonLayer, {
        ctaButtonList: ctaButtonList,
        isPreview: isPreview
      }), _jsx(DesktopPageNavigationButton, {
        totalPage: Number(pages),
        updatePrevThumbnails: updatePrevThumbnails,
        isNextPageButtonDisabled: isNextPageButtonDisabled,
        updateNextThumbnails: updateNextThumbnails,
        ctaFormPage: ctaFormPage,
        isMoveCtaFormPageRequirements: blindMode === 'startFrom' && !isFormSubmitted
      }), _jsx(DesktopFreeBadge, {
        userSubscriptionPlan: plan
      })]
    })]
  });
};

/* harmony default export */ var BulkViewer_Desktop = ((/* unused pure expression or super */ null && (Desktop_BulkDesktopViewer)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/Mobile/AnnotationLayer/index.tsx









var Mobile_AnnotationLayer_AnnotationLayer = function AnnotationLayer(_ref) {
  var ctaForm = _ref.ctaForm,
      _ref$isPreview = _ref.isPreview,
      isPreview = _ref$isPreview === void 0 ? false : _ref$isPreview,
      thumbnails = _ref.thumbnails,
      messageBoxItems = _ref.messageBoxItems,
      isFormSubmitted = _ref.isFormSubmitted;
  var currentPage = useAtomValue(currentPageAtom);
  var blindMode = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.blind;
  var _thumbnails = thumbnails[currentPage - 1],
      hyperlink = _thumbnails.hyperlink,
      originalHeight = _thumbnails.originalHeight,
      originalWidth = _thumbnails.originalWidth;

  var _useHandleResizedImag = useHandleResizedImage({
    originalHeight: originalHeight,
    originalWidth: originalWidth
  }),
      resizedImageSize = _useHandleResizedImag.resizedImageSize;

  var getFormNotSubmitPage = function getFormNotSubmitPage(moveTargetPage) {
    if (!isFormSubmitted && blindMode === 'startFrom' && ctaForm !== null && ctaForm !== void 0 && ctaForm.page && moveTargetPage >= (ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.page)) {
      return ctaForm.page;
    }

    return null;
  };

  return _jsxs(_Fragment, {
    children: [_jsx(MessageBoxLayer, {
      resizedImageSize: resizedImageSize,
      isPreview: isPreview,
      messageBoxItems: messageBoxItems,
      getFormNotSubmitPage: getFormNotSubmitPage,
      size: 'sm'
    }), _jsx(MobileHyperLinkLayer, {
      hyperlinkList: hyperlink,
      resizedImageSize: resizedImageSize,
      isPreview: isPreview,
      getFormNotSubmitPage: getFormNotSubmitPage
    })]
  });
};

/* harmony default export */ var Mobile_AnnotationLayer = ((/* unused pure expression or super */ null && (Mobile_AnnotationLayer_AnnotationLayer)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/Mobile/index.tsx

















var Mobile_BulkMobileViewer = function BulkMobileViewer(_ref) {
  var file = _ref.file,
      user = _ref.user,
      ctaForm = _ref.ctaForm,
      ctaButtonList = _ref.ctaButtonList,
      messageBoxItems = _ref.messageBoxItems,
      translateKoToEn = _ref.translateKoToEn,
      setIsMobileDrawerOpen = _ref.setIsMobileDrawerOpen,
      updateNextThumbnails = _ref.updateNextThumbnails,
      updatePrevThumbnails = _ref.updatePrevThumbnails,
      _ref$isPreview = _ref.isPreview,
      isPreview = _ref$isPreview === void 0 ? false : _ref$isPreview,
      isMobileLandscape = _ref.isMobileLandscape;
  var currentPage = useAtomValue(currentPageAtom);
  var thumbnails = useAtomValue(thumbnailsAtom);
  var domain = user.domain,
      plan = user.plan;
  var name = file.name,
      isDownloadEnabled = file.isDownloadEnabled,
      isEmailVerificationEnabled = file.isEmailVerificationEnabled,
      isFormSubmitted = file.isFormSubmitted,
      pages = file.pages;
  var ctaFormPage = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.page;
  var blindMode = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.blind;
  var isNextPageButtonDisabled = currentPage >= Number(ctaFormPage) && blindMode === 'startFrom' && !isFormSubmitted;
  var isRedirectCtaFormAppropriate = Boolean(!(blindMode === 'none') && !isFormSubmitted);
  /*첫 번째 페이지에 폼이 설정되어 있는 경우에 폼 제출 이후에 보여지도록 한다 */

  var isIntroVisible = ctaFormPage === 1 && blindMode === 'startFrom' ? isFormSubmitted : true;
  return _jsxs(_Fragment, {
    children: [isIntroVisible && _jsx(MobileIntro, {
      translateKoToEn: translateKoToEn
    }), _jsxs(MobilePageWrapper, {
      totalPage: Number(pages),
      isNextPageButtonDisabled: isNextPageButtonDisabled,
      updateNextThumbnails: updateNextThumbnails,
      updatePrevThumbnails: updatePrevThumbnails,
      children: [!isPreview && _jsx(MobileViewerLayer, {
        fileName: name,
        domain: domain,
        isBulk: true,
        isDownloadEnabled: isDownloadEnabled,
        ctaFormPage: ctaFormPage,
        translateKoToEn: translateKoToEn,
        isRedirectCtaFormAppropriate: isRedirectCtaFormAppropriate,
        isMobileLandscape: isMobileLandscape
      }), _jsxs(ZoomableViewer, {
        isMobile: true,
        children: [_jsx(MobilePage, {
          thumnails: thumbnails === null || thumbnails === void 0 ? void 0 : thumbnails.map(function (value) {
            if (value !== null && value !== void 0 && value.thumbnail) {
              return {
                src: value.thumbnail,
                imageSources: value.imageSources
              };
            }

            return null;
          }),
          isMobileLandscape: isMobileLandscape
        }), _jsx(MobilePageChangeEffectLayer, {}), thumbnails && _jsx(AnnotationLayer, {
          thumbnails: thumbnails,
          ctaForm: ctaForm,
          messageBoxItems: messageBoxItems,
          isPreview: isPreview,
          isFormSubmitted: isFormSubmitted
        })]
      }), _jsx(MobilePageNavigationButton, {
        totalPage: Number(pages),
        ctaFormPage: ctaFormPage,
        isNextPageButtonDisabled: isNextPageButtonDisabled,
        isMoveCtaFormPageRequirements: blindMode === 'startFrom' && !isFormSubmitted,
        updateNextThumbnails: updateNextThumbnails,
        updatePrevThumbnails: updatePrevThumbnails,
        openDrawer: function openDrawer() {
          return setIsMobileDrawerOpen(true);
        },
        isMobileLandscape: isMobileLandscape
      }), _jsx(CtaFormLayer, {
        ctaForm: ctaForm,
        isPreview: isPreview,
        totalPage: Number(pages),
        isNextPageButtonDisabled: isNextPageButtonDisabled,
        isEmailVerificationEnabled: isEmailVerificationEnabled,
        isFormSubmitted: isFormSubmitted,
        translateKoToEn: translateKoToEn,
        userSubscriptionPlan: plan
      }), _jsx(CtaButtonLayer, {
        ctaButtonList: ctaButtonList,
        isPreview: isPreview
      }), _jsx(MobileFreeBadge, {
        userSubscriptionPlan: plan
      })]
    })]
  });
};

/* harmony default export */ var BulkViewer_Mobile = ((/* unused pure expression or super */ null && (Mobile_BulkMobileViewer)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkViewer/index.tsx


















var BulkRedirectViewer = function BulkRedirectViewer(_ref) {
  var _data$file$thumbnails, _data$file, _data$file2;

  var data = _ref.data,
      messageBoxItems = _ref.messageBoxItems,
      embedItems = _ref.embedItems,
      ctaButtonList = _ref.ctaButtonList,
      ctaForm = _ref.ctaForm,
      useWindowUnload = _ref.useWindowUnload,
      translateKoToEn = _ref.translateKoToEn;
  var userAgent =  true ? window.navigator.userAgent : 0;

  var _useState = useState(false),
      isMobileDrawerOpen = _useState[0],
      setIsMobileDrawerOpen = _useState[1];

  var isCtaModalOpen = useAtomValue(isCtaModalOpenAtom);
  var currentPage = useAtomValue(currentPageAtom);
  var setIsAnimationPlayed = useSetAtom(isAnimationPlayedAtom);
  useWindowUnload();
  var isMobile = useMediaQuery({
    maxWidth: 767
  }) || /iPhone|Android/.test(userAgent);
  useViewerIntervalRequest({
    isMobile: isMobile
  });
  var isMobileLandscape = useMediaQuery({
    query: '(orientation: landscape)'
  }) && isMobile;
  useEffect(function () {
    setIsAnimationPlayed(false);
  }, []);
  var pageNavigationInfo = data === null || data === void 0 ? void 0 : (_data$file$thumbnails = data.file.thumbnails) === null || _data$file$thumbnails === void 0 ? void 0 : _data$file$thumbnails.map(function (_ref2) {
    var page = _ref2.page,
        thumbnail = _ref2.thumbnail,
        originalHeight = _ref2.originalHeight,
        originalWidth = _ref2.originalWidth,
        imageSources = _ref2.imageSources;
    return {
      page: page,
      thumnail: thumbnail,
      originalHeight: originalHeight,
      originalWidth: originalWidth,
      imageSources: imageSources
    };
  });
  var isFormSubmitted = data === null || data === void 0 ? void 0 : (_data$file = data.file) === null || _data$file === void 0 ? void 0 : _data$file.isFormSubmitted;
  var blindStatus = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.blind;
  var blindPage = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.page;
  var blindPages = isFormSubmitted ? [] : getBlindPages({
    blindStatus: blindStatus,
    blindPage: blindPage,
    totalPages: pageNavigationInfo === null || pageNavigationInfo === void 0 ? void 0 : pageNavigationInfo.length
  });
  var isActiveHelpers = isCtaModalOpen && currentPage === Number(blindPage);

  var _useUpdateRenderThumb = useUpdateRenderThumbnails({
    defaultThumbnails: data === null || data === void 0 ? void 0 : (_data$file2 = data.file) === null || _data$file2 === void 0 ? void 0 : _data$file2.thumbnails
  }),
      updateNextThumbnails = _useUpdateRenderThumb.updateNextThumbnails,
      updatePrevThumbnails = _useUpdateRenderThumb.updatePrevThumbnails; // const { version } = useViewerVersion();


  var version = 'v2';

  var _useViewerRoute = useViewerRoute(),
      isShareRoute = _useViewerRoute.isShareRoute;
  /* 버전 해석 전 단일 프레임: V1 플래시를 막기 위해 렌더를 보류한다 */


  if (isShareRoute && version === null) {
    return null;
  }

  if (isShareRoute && version === 'v2' && data) {
    return _jsx(V2BulkViewer, {
      data: data,
      messageBoxItems: messageBoxItems,
      embedItems: embedItems,
      ctaButtonList: ctaButtonList,
      ctaForm: ctaForm,
      translateKoToEn: translateKoToEn
    });
  }

  if (isMobile) {
    return _jsx(RootLayout, {
      mode: "mobile",
      children: data && _jsxs(_Fragment, {
        children: [_jsx(BulkMobileViewer, {
          file: data.file,
          user: data.user,
          translateKoToEn: translateKoToEn,
          ctaForm: ctaForm,
          messageBoxItems: messageBoxItems,
          ctaButtonList: ctaButtonList,
          updateNextThumbnails: updateNextThumbnails,
          updatePrevThumbnails: updatePrevThumbnails,
          setIsMobileDrawerOpen: setIsMobileDrawerOpen,
          isMobileLandscape: isMobileLandscape
        }), _jsx(MobilePageNavigation, {
          translateKoToEn: translateKoToEn,
          pages: pageNavigationInfo,
          blindPages: blindPages,
          isMobileDrawerOpen: isMobileDrawerOpen,
          setIsMobileDrawerOpen: setIsMobileDrawerOpen,
          isMobileLandscape: isMobileLandscape
        })]
      })
    });
  }

  return _jsx(RootLayout, {
    mode: "desktop",
    isActiveHelpers: isActiveHelpers,
    children: data && _jsxs(_Fragment, {
      children: [_jsx(DesktopPageNavigation, {
        fileName: data === null || data === void 0 ? void 0 : data.file.name,
        pages: pageNavigationInfo,
        translateKoToEn: translateKoToEn,
        blindPages: blindPages
      }), _jsx(BulkDesktopViewer, {
        file: data.file,
        user: data.user,
        ctaForm: ctaForm,
        messageBoxItems: messageBoxItems,
        ctaButtonList: ctaButtonList,
        blindPages: blindPages,
        translateKoToEn: translateKoToEn,
        updateNextThumbnails: updateNextThumbnails,
        updatePrevThumbnails: updatePrevThumbnails
      })]
    })
  });
};

/* harmony default export */ var BulkViewer = ((/* unused pure expression or super */ null && (BulkRedirectViewer)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkPdfPreview/Desktop/index.tsx










var Desktop_DesktopPdfPreview = function DesktopPdfPreview(_ref) {
  var _data$file, _data$file2;

  var data = _ref.data,
      messageBoxItems = _ref.messageBoxItems,
      ctaButtonList = _ref.ctaButtonList,
      ctaForm = _ref.ctaForm,
      translateKoToEn = _ref.translateKoToEn;

  if (!data) {
    return null;
  }

  var isSubmitted = useAtomValue(isPreviewFormSubmittedAtom);
  var pageNavigationInfo = data === null || data === void 0 ? void 0 : (_data$file = data.file) === null || _data$file === void 0 ? void 0 : _data$file.thumbnails.map(function (_ref2) {
    var page = _ref2.page,
        thumbnail = _ref2.thumbnail,
        originalHeight = _ref2.originalHeight,
        originalWidth = _ref2.originalWidth,
        imageSources = _ref2.imageSources;
    return {
      page: page,
      thumnail: thumbnail,
      originalHeight: originalHeight,
      originalWidth: originalWidth,
      imageSources: imageSources
    };
  });
  var file = data.file,
      user = data.user;
  var blindStatus = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.blind;
  var blindPage = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.page;
  var blindPages = isSubmitted ? [] : getBlindPages({
    blindStatus: blindStatus,
    blindPage: blindPage,
    totalPages: pageNavigationInfo === null || pageNavigationInfo === void 0 ? void 0 : pageNavigationInfo.length
  });

  var _useUpdateRenderThumb = useUpdateRenderThumbnails({
    defaultThumbnails: data === null || data === void 0 ? void 0 : (_data$file2 = data.file) === null || _data$file2 === void 0 ? void 0 : _data$file2.thumbnails
  }),
      updateNextThumbnails = _useUpdateRenderThumb.updateNextThumbnails,
      updatePrevThumbnails = _useUpdateRenderThumb.updatePrevThumbnails;

  return _jsxs(RootLayout, {
    mode: "desktop",
    children: [_jsx(DesktopPageNavigation, {
      fileName: data === null || data === void 0 ? void 0 : data.file.name,
      pages: pageNavigationInfo,
      translateKoToEn: translateKoToEn,
      blindPages: blindPages
    }), _jsx(BulkDesktopViewer, {
      file: file,
      user: {
        domain: user.domain,
        plan: user.plan,
        company: user.company
      },
      ctaForm: ctaForm,
      messageBoxItems: messageBoxItems,
      ctaButtonList: ctaButtonList,
      translateKoToEn: translateKoToEn,
      blindPages: blindPages,
      updateNextThumbnails: updateNextThumbnails,
      updatePrevThumbnails: updatePrevThumbnails,
      isPreview: true
    })]
  });
};

/* harmony default export */ var BulkPdfPreview_Desktop = ((/* unused pure expression or super */ null && (Desktop_DesktopPdfPreview)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/BulkPdfPreview/Mobile/index.tsx












var Mobile_MobilePdfPreview = function MobilePdfPreview(_ref) {
  var _data$file, _data$file2;

  var ctaForm = _ref.ctaForm,
      data = _ref.data,
      ctaButtonList = _ref.ctaButtonList,
      messageBoxItems = _ref.messageBoxItems,
      translateKoToEn = _ref.translateKoToEn;

  if (!data) {
    return null;
  }

  var _useState = useState(false),
      isMobileDrawerOpen = _useState[0],
      setIsMobileDrawerOpen = _useState[1];

  var isSubmitted = useAtomValue(isPreviewFormSubmittedAtom);
  var pageNavigationInfo = data === null || data === void 0 ? void 0 : (_data$file = data.file) === null || _data$file === void 0 ? void 0 : _data$file.thumbnails.map(function (_ref2) {
    var page = _ref2.page,
        thumbnail = _ref2.thumbnail,
        originalHeight = _ref2.originalHeight,
        originalWidth = _ref2.originalWidth,
        imageSources = _ref2.imageSources;
    return {
      page: page,
      thumnail: thumbnail,
      originalWidth: originalWidth,
      originalHeight: originalHeight,
      imageSources: imageSources
    };
  });
  /** NOTE: 렌더링하는 곳에서 user agent 체킹하므로 landscape만 체크 */

  var isMobileLandscape = useMediaQuery({
    query: '(orientation: landscape)'
  });
  var file = data.file,
      user = data.user;
  var blindStatus = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.blind;
  var blindPage = ctaForm === null || ctaForm === void 0 ? void 0 : ctaForm.page;
  var blindPages = isSubmitted ? [] : getBlindPages({
    blindStatus: blindStatus,
    blindPage: blindPage,
    totalPages: pageNavigationInfo === null || pageNavigationInfo === void 0 ? void 0 : pageNavigationInfo.length
  });

  var _useUpdateRenderThumb = useUpdateRenderThumbnails({
    defaultThumbnails: data === null || data === void 0 ? void 0 : (_data$file2 = data.file) === null || _data$file2 === void 0 ? void 0 : _data$file2.thumbnails
  }),
      updateNextThumbnails = _useUpdateRenderThumb.updateNextThumbnails,
      updatePrevThumbnails = _useUpdateRenderThumb.updatePrevThumbnails;

  return _jsxs(RootLayout, {
    mode: "mobile",
    children: [_jsx(BulkMobileViewer, {
      file: file,
      user: user,
      translateKoToEn: translateKoToEn,
      ctaButtonList: ctaButtonList,
      messageBoxItems: messageBoxItems,
      updateNextThumbnails: updateNextThumbnails,
      updatePrevThumbnails: updatePrevThumbnails,
      setIsMobileDrawerOpen: setIsMobileDrawerOpen,
      isPreview: true,
      isMobileLandscape: isMobileLandscape
    }), _jsx(MobilePageNavigation, {
      translateKoToEn: translateKoToEn,
      isMobileDrawerOpen: isMobileDrawerOpen,
      setIsMobileDrawerOpen: setIsMobileDrawerOpen,
      pages: pageNavigationInfo,
      blindPages: blindPages,
      isMobileLandscape: isMobileLandscape
    })]
  });
};

/* harmony default export */ var BulkPdfPreview_Mobile = ((/* unused pure expression or super */ null && (Mobile_MobilePdfPreview)));
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/index.types.ts
var index_types_adaptOneToOneDocument = function adaptOneToOneDocument(data) {
  return {
    name: data.name,
    totalPages: Number(data.pages),
    pages: data.thumnail.map(function (item) {
      return {
        page: item.page,
        src: item.thumnail,
        originalWidth: item.originalWidth,
        originalHeight: item.originalHeight,
        hyperlink: item.hyperlink,
        imageSources: item.imageSources
      };
    }),
    isDownloadEnabled: data.isDownloadEnabled,
    isShareable: false,
    plan: data.userSubscriptionPlan
  };
};
/** 관리자 미리보기용 1:1 문서 어댑터(다운로드/공유 비활성) */

var adaptOneToOnePreviewDocument = function adaptOneToOnePreviewDocument(data) {
  return {
    name: data.name,
    totalPages: Number(data.pages),
    pages: data.thumnail.map(function (item) {
      return {
        page: item.page,
        src: item.thumnail,
        originalWidth: item.originalWidth,
        originalHeight: item.originalHeight,
        hyperlink: item.hyperlink,
        imageSources: item.imageSources
      };
    }),
    isDownloadEnabled: false,
    isShareable: false,
    plan: data.userSubscriptionPlan
  };
};
/** 관리자 미리보기용 벌크 문서 어댑터(다운로드/공유 비활성) */

var adaptBulkPreviewDocument = function adaptBulkPreviewDocument(data) {
  return {
    name: data.file.name,
    totalPages: Number(data.file.pages),
    pages: data.file.thumbnails.map(function (item) {
      return {
        page: item.page,
        src: item.thumbnail,
        originalWidth: item.originalWidth,
        originalHeight: item.originalHeight,
        hyperlink: item.hyperlink,
        imageSources: item.imageSources
      };
    }),
    isDownloadEnabled: false,
    isShareable: false,
    plan: data.user.plan
  };
};
var index_types_adaptBulkDocument = function adaptBulkDocument(data) {
  return {
    name: data.file.name,
    totalPages: Number(data.file.pages),
    pages: data.file.thumbnails.map(function (item) {
      return {
        page: item.page,
        src: item.thumbnail,
        originalWidth: item.originalWidth,
        originalHeight: item.originalHeight,
        hyperlink: item.hyperlink,
        imageSources: item.imageSources
      };
    }),
    isDownloadEnabled: data.file.isDownloadEnabled,
    isShareable: true,
    plan: data.user.plan
  };
};
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/V2BulkPreview/index.tsx




/** 벌크 공유 PDF의 V2 관리자 미리보기 진입점(수신자 화면과 동일 UI) */
var V2BulkPreview = function V2BulkPreview(_ref) {
  var data = _ref.data,
      messageBoxItems = _ref.messageBoxItems,
      embedItems = _ref.embedItems,
      ctaButtonList = _ref.ctaButtonList,
      ctaForm = _ref.ctaForm,
      translateKoToEn = _ref.translateKoToEn;

  if (!data) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v2_V2ViewerShell, {
    document: adaptBulkPreviewDocument(data),
    isBulk: true,
    isPreview: true,
    domain: data.user.domain,
    messageBoxItems: messageBoxItems,
    embedItems: embedItems,
    cta: {
      ctaForm: ctaForm,
      ctaButtonList: ctaButtonList,
      isEmailVerificationEnabled: data.file.isEmailVerificationEnabled,
      isFormSubmitted: false
    },
    translateKoToEn: translateKoToEn
  });
};

/* harmony default export */ var v2_V2BulkPreview = (V2BulkPreview);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/components/v2/V2OneToOnePreview/index.tsx




/** 1:1 공유 PDF의 V2 관리자 미리보기 진입점(수신자 화면과 동일 UI) */
var V2OneToOnePreview = function V2OneToOnePreview(_ref) {
  var file = _ref.file,
      messageBoxItems = _ref.messageBoxItems,
      embedItems = _ref.embedItems,
      translateKoToEn = _ref.translateKoToEn;

  if (!file) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v2_V2ViewerShell, {
    document: adaptOneToOnePreviewDocument(file),
    isBulk: false,
    isPreview: true,
    messageBoxItems: messageBoxItems,
    embedItems: embedItems,
    translateKoToEn: translateKoToEn
  });
};

/* harmony default export */ var v2_V2OneToOnePreview = (V2OneToOnePreview);
;// CONCATENATED MODULE: ../../packages/next-pdf-viewer/src/index.ts
//desktop






 // mobile

 // else



 // compounded components





 // v2 preview


 //context

 //store

 //utils


 //type





/***/ }),

/***/ 86437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D5": function() { return /* binding */ isCtaModalOpenAtom; },
/* harmony export */   "Nv": function() { return /* binding */ prevPageAtom; },
/* harmony export */   "Qd": function() { return /* binding */ currentMessageBoxIdAtom; },
/* harmony export */   "Tn": function() { return /* binding */ isDisableHelpersAtom; },
/* harmony export */   "To": function() { return /* binding */ isAnimationPlayedAtom; },
/* harmony export */   "ZL": function() { return /* binding */ isLanguageDropdownOpenAtom; },
/* harmony export */   "bw": function() { return /* binding */ isFirstPageImageLoadedAtom; },
/* harmony export */   "ef": function() { return /* binding */ currentPageAtom; },
/* harmony export */   "lU": function() { return /* binding */ isOpenDrawerAtom; },
/* harmony export */   "nD": function() { return /* binding */ isLeftClickAtom; },
/* harmony export */   "nO": function() { return /* binding */ zoomLevelAtom; },
/* harmony export */   "oj": function() { return /* binding */ isRightClickAtom; },
/* harmony export */   "p5": function() { return /* binding */ pageWrapperSizeAtom; },
/* harmony export */   "yf": function() { return /* binding */ pdfViewerModeAtom; }
/* harmony export */ });
/* unused harmony exports thumbnailsAtom, pageTimeAtom */
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65058);


/** 뷰어 Layer(Download, ShareButton, ZoomButton, PageDrawerButton, PageMoveButton) 활성화 관련 Atom */
var isDisableHelpersAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(false);
/** 현재 페이지 관련 값에 대한 Atom */

var currentPageAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(1);
/** 뷰어 Size 관련 값에 대한 Atom */

var pageWrapperSizeAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
  width: 0,
  height: 0
});
/** 뷰어 모드(mobile, desktop)을 구분하는 Atom */

var pdfViewerModeAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)('desktop');
/** 뷰어 interval 요청에 사용되는 이전 페이지 관련 Atom */

var prevPageAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(1);
/** Page Drawer Open 관련 Atom */

var isOpenDrawerAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(false);
/** 뷰어에서 첫 번째 이미지가 렌더링됐는지 판별하는 Atom */

var isFirstPageImageLoadedAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(false);
/** 현재 MessageBox 값을 저장하는 Atom */

var currentMessageBoxIdAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(null);
/** 뷰어 Zoom 관련 Atom */

var zoomLevelAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(1);
/** 모바일 Page 이동할 때 보여지는 효과를 위한 Atom */

var isLeftClickAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(false);
var isRightClickAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(false);
/** 문의양식 Modal이 열러있는지에 관한 값
 * wheel(desktop), swipe(mobile)에 대한 이벤트를 막기 위한 Atom
 */

var isCtaModalOpenAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(false);
/** Cta Button 애니메이션이 작동 되었는지 여부를 저장하는 Atom */

var isAnimationPlayedAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(false);
/** Bulk용 Thumbnail을 저장하고 렌더링하는 Atom */

var thumbnailsAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(null);
var pageTimeAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(null);
var isLanguageDropdownOpenAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(false);

/***/ }),

/***/ 89608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* reexport */ domain_namespaceObject; },
  "G": function() { return /* reexport */ VIEWER_Z_INDEX; }
});

// NAMESPACE OBJECT: ../../packages/sheard/constants/domain.ts
var domain_namespaceObject = {};
__webpack_require__.r(domain_namespaceObject);
__webpack_require__.d(domain_namespaceObject, {
  "I": function() { return CLIENT; },
  "a": function() { return VIEWER; }
});

;// CONCATENATED MODULE: ../../packages/sheard/constants/zIndex.ts
const VIEWER_Z_INDEX = {
  root: 1,
  layer: 1,
  link: 10,
  ctaButton: 18,
  pageListButton: 2,
  /* NOTE: 영상 임베드 - dot/messageBox보다 아래에 위치해야 한다 */
  embed: 15,
  dotButton: 102,
  messageBoxButton: 102,
  mobileDrawerDimmer: 104,
  mobileDrawer: 105,
  mobileCloseButton: 106,
  /*
   * NOTE: 첫 방문 도움말 오버레이
   * 페이지 위에 얹히는 요소(link/embed/ctaButton/freeBadge/dot/모바일 버튼)를 모두 덮고,
   * 툴바·문의양식 모달·모바일 드로어(104 이상)보다는 아래에 있어야 한다.
   * ctaFormDimmer와는 값이 같지만 DOM 순서상 dimmer가 뒤에 있어 dimmer가 위로 그려진다.
   */
  previewLayer: 103,
  /*
   * NOTE: V2 가로 맞춤 힌트 칩
   * 페이지 위에 얹히는 요소(link/embed/ctaButton/freeBadge)보다는 위,
   * 첫 방문 도움말 오버레이·문의양식 딤/모달·툴바(103 이상)보다는 아래에 있어야 한다.
   * dotButton/messageBoxButton과 값은 같지만 DOM 순서상 칩이 뒤에 있어 칩이 위로 그려진다.
   */
  hintChip: 102,
  freeBadge: 101,
  /* NOTE: 모바일 페이지 이동 및 다운로드 등 버튼 z-index */
  mobileLayer: 30,
  /* NOTE: Desktop 페이지 이동 및 다운로드 등 버튼 z-index */
  desktopLayer: 104,
  ctaFormDimmer: 103,
  ctaFormLayer: 104,
  /* messageBox z-index */
  messageBox: 9999,
};

;// CONCATENATED MODULE: ../../packages/sheard/constants/domain.ts
const CLIENT = {
  local: 'local.salesclue',
  dev: 'dev.salesclue',
  release: 'alpha.salesclue',
  main: 'app.salesclue',
};

const VIEWER = {
  local: 'localhost',
  dev: 'dev.sclu.io',
  release: 'alpha.sclu.io',
  main: 'sclu.io',
};

;// CONCATENATED MODULE: ../../packages/sheard/constants/index.ts




/***/ })

}]);